!(function () {
	var e = {
			7895: function () {
				;(function () {
					var e,
						t,
						n,
						r,
						i = {}.hasOwnProperty
					;((r = (function () {
						function e() {
							;(this.options_index = 0), (this.parsed = [])
						}
						return (
							(e.prototype.add_node = function (e) {
								return 'OPTGROUP' === e.nodeName.toUpperCase()
									? this.add_group(e)
									: this.add_option(e)
							}),
							(e.prototype.add_group = function (e) {
								var t, n, r, i, o, s
								for (
									t = this.parsed.length,
										this.parsed.push({
											array_index: t,
											group: !0,
											label: e.label,
											title: e.title ? e.title : void 0,
											children: 0,
											disabled: e.disabled,
											classes: e.className
										}),
										s = [],
										n = 0,
										r = (o = e.childNodes).length;
									n < r;
									n++
								)
									(i = o[n]),
										s.push(this.add_option(i, t, e.disabled))
								return s
							}),
							(e.prototype.add_option = function (e, t, n) {
								if ('OPTION' === e.nodeName.toUpperCase())
									return (
										'' !== e.text
											? (null != t && (this.parsed[t].children += 1),
											  this.parsed.push({
													array_index: this.parsed.length,
													options_index: this.options_index,
													value: e.value,
													text: e.text,
													html: e.innerHTML,
													title: e.title ? e.title : void 0,
													selected: e.selected,
													disabled: !0 === n ? n : e.disabled,
													group_array_index: t,
													group_label:
														null != t ? this.parsed[t].label : null,
													classes: e.className,
													style: e.style.cssText
											  }))
											: this.parsed.push({
													array_index: this.parsed.length,
													options_index: this.options_index,
													empty: !0
											  }),
										(this.options_index += 1)
									)
							}),
							e
						)
					})()).select_to_array = function (e) {
						var t, n, i, o, s
						for (
							o = new r(), n = 0, i = (s = e.childNodes).length;
							n < i;
							n++
						)
							(t = s[n]), o.add_node(t)
						return o.parsed
					}),
						(t = (function () {
							function e(t, n) {
								var r, i
								;(this.form_field = t),
									(this.options = null != n ? n : {}),
									(this.label_click_handler =
										((r = this.label_click_handler),
										(i = this),
										function () {
											return r.apply(i, arguments)
										})),
									e.browser_is_supported() &&
										((this.is_multiple = this.form_field.multiple),
										this.set_default_text(),
										this.set_default_values(),
										this.setup(),
										this.set_up_html(),
										this.register_observers(),
										this.on_ready())
							}
							return (
								(e.prototype.set_default_values = function () {
									var e
									return (
										(this.click_test_action =
											((e = this),
											function (t) {
												return e.test_active_click(t)
											})),
										(this.activate_action = (function (e) {
											return function (t) {
												return e.activate_field(t)
											}
										})(this)),
										(this.active_field = !1),
										(this.mouse_on_container = !1),
										(this.results_showing = !1),
										(this.result_highlighted = null),
										(this.is_rtl =
											this.options.rtl ||
											/\bchosen-rtl\b/.test(
												this.form_field.className
											)),
										(this.allow_single_deselect =
											null != this.options.allow_single_deselect &&
											null != this.form_field.options[0] &&
											'' === this.form_field.options[0].text &&
											this.options.allow_single_deselect),
										(this.disable_search_threshold =
											this.options.disable_search_threshold || 0),
										(this.disable_search =
											this.options.disable_search || !1),
										(this.enable_split_word_search =
											null == this.options.enable_split_word_search ||
											this.options.enable_split_word_search),
										(this.group_search =
											null == this.options.group_search ||
											this.options.group_search),
										(this.search_contains =
											this.options.search_contains || !1),
										(this.single_backstroke_delete =
											null == this.options.single_backstroke_delete ||
											this.options.single_backstroke_delete),
										(this.max_selected_options =
											this.options.max_selected_options || 1 / 0),
										(this.inherit_select_classes =
											this.options.inherit_select_classes || !1),
										(this.display_selected_options =
											null == this.options.display_selected_options ||
											this.options.display_selected_options),
										(this.display_disabled_options =
											null == this.options.display_disabled_options ||
											this.options.display_disabled_options),
										(this.include_group_label_in_selected =
											this.options.include_group_label_in_selected ||
											!1),
										(this.max_shown_results =
											this.options.max_shown_results ||
											Number.POSITIVE_INFINITY),
										(this.case_sensitive_search =
											this.options.case_sensitive_search || !1),
										(this.hide_results_on_select =
											null == this.options.hide_results_on_select ||
											this.options.hide_results_on_select)
									)
								}),
								(e.prototype.set_default_text = function () {
									return (
										this.form_field.getAttribute('data-placeholder')
											? (this.default_text =
													this.form_field.getAttribute(
														'data-placeholder'
													))
											: this.is_multiple
											? (this.default_text =
													this.options.placeholder_text_multiple ||
													this.options.placeholder_text ||
													e.default_multiple_text)
											: (this.default_text =
													this.options.placeholder_text_single ||
													this.options.placeholder_text ||
													e.default_single_text),
										(this.default_text = this.escape_html(
											this.default_text
										)),
										(this.results_none_found =
											this.form_field.getAttribute(
												'data-no_results_text'
											) ||
											this.options.no_results_text ||
											e.default_no_result_text)
									)
								}),
								(e.prototype.choice_label = function (e) {
									return this.include_group_label_in_selected &&
										null != e.group_label
										? "<b class='group-name'>" +
												this.escape_html(e.group_label) +
												'</b>' +
												e.html
										: e.html
								}),
								(e.prototype.mouse_enter = function () {
									return (this.mouse_on_container = !0)
								}),
								(e.prototype.mouse_leave = function () {
									return (this.mouse_on_container = !1)
								}),
								(e.prototype.input_focus = function (e) {
									if (this.is_multiple) {
										if (!this.active_field)
											return setTimeout(
												((t = this),
												function () {
													return t.container_mousedown()
												}),
												50
											)
									} else if (!this.active_field)
										return this.activate_field()
									var t
								}),
								(e.prototype.input_blur = function (e) {
									if (!this.mouse_on_container)
										return (
											(this.active_field = !1),
											setTimeout(
												((t = this),
												function () {
													return t.blur_test()
												}),
												100
											)
										)
									var t
								}),
								(e.prototype.label_click_handler = function (e) {
									return this.is_multiple
										? this.container_mousedown(e)
										: this.activate_field()
								}),
								(e.prototype.results_option_build = function (e) {
									var t, n, r, i, o, s, a
									for (
										t = '',
											a = 0,
											i = 0,
											o = (s = this.results_data).length;
										i < o &&
										((r = ''),
										'' !==
											(r = (n = s[i]).group
												? this.result_add_group(n)
												: this.result_add_option(n)) &&
											(a++, (t += r)),
										(null != e ? e.first : void 0) &&
											(n.selected && this.is_multiple
												? this.choice_build(n)
												: n.selected &&
												  !this.is_multiple &&
												  this.single_set_selected_text(
														this.choice_label(n)
												  )),
										!(a >= this.max_shown_results));
										i++
									);
									return t
								}),
								(e.prototype.result_add_option = function (e) {
									var t, n
									return e.search_match &&
										this.include_option_in_results(e)
										? ((t = []),
										  e.disabled ||
												(e.selected && this.is_multiple) ||
												t.push('active-result'),
										  !e.disabled ||
												(e.selected && this.is_multiple) ||
												t.push('disabled-result'),
										  e.selected && t.push('result-selected'),
										  null != e.group_array_index &&
												t.push('group-option'),
										  '' !== e.classes && t.push(e.classes),
										  ((n = document.createElement('li')).className =
												t.join(' ')),
										  e.style && (n.style.cssText = e.style),
										  n.setAttribute(
												'data-option-array-index',
												e.array_index
										  ),
										  (n.innerHTML = e.highlighted_html || e.html),
										  e.title && (n.title = e.title),
										  this.outerHTML(n))
										: ''
								}),
								(e.prototype.result_add_group = function (e) {
									var t, n
									return (e.search_match || e.group_match) &&
										e.active_options > 0
										? ((t = []).push('group-result'),
										  e.classes && t.push(e.classes),
										  ((n = document.createElement('li')).className =
												t.join(' ')),
										  (n.innerHTML =
												e.highlighted_html ||
												this.escape_html(e.label)),
										  e.title && (n.title = e.title),
										  this.outerHTML(n))
										: ''
								}),
								(e.prototype.results_update_field = function () {
									if (
										(this.set_default_text(),
										this.is_multiple || this.results_reset_cleanup(),
										this.result_clear_highlight(),
										this.results_build(),
										this.results_showing)
									)
										return this.winnow_results()
								}),
								(e.prototype.reset_single_select_options =
									function () {
										var e, t, n, r, i
										for (
											i = [],
												e = 0,
												t = (n = this.results_data).length;
											e < t;
											e++
										)
											(r = n[e]).selected
												? i.push((r.selected = !1))
												: i.push(void 0)
										return i
									}),
								(e.prototype.results_toggle = function () {
									return this.results_showing
										? this.results_hide()
										: this.results_show()
								}),
								(e.prototype.results_search = function (e) {
									return this.results_showing
										? this.winnow_results()
										: this.results_show()
								}),
								(e.prototype.winnow_results = function (e) {
									var t, n, r, i, o, s, a, l, u, c, d, p, f, h, v
									for (
										this.no_results_clear(),
											c = 0,
											t = (a = this.get_search_text()).replace(
												/[-[\]{}()*+?.,\\^$|#\s]/g,
												'\\$&'
											),
											u = this.get_search_regex(t),
											r = 0,
											i = (l = this.results_data).length;
										r < i;
										r++
									)
										((o = l[r]).search_match = !1),
											(d = null),
											(p = null),
											(o.highlighted_html = ''),
											this.include_option_in_results(o) &&
												(o.group &&
													((o.group_match = !1),
													(o.active_options = 0)),
												null != o.group_array_index &&
													this.results_data[o.group_array_index] &&
													(0 ===
														(d =
															this.results_data[o.group_array_index])
															.active_options &&
														d.search_match &&
														(c += 1),
													(d.active_options += 1)),
												(v = o.group ? o.label : o.text),
												(o.group && !this.group_search) ||
													((p = this.search_string_match(v, u)),
													(o.search_match = null != p),
													o.search_match && !o.group && (c += 1),
													o.search_match
														? (a.length &&
																((f = p.index),
																(s = v.slice(0, f)),
																(n = v.slice(f, f + a.length)),
																(h = v.slice(f + a.length)),
																(o.highlighted_html =
																	this.escape_html(s) +
																	'<em>' +
																	this.escape_html(n) +
																	'</em>' +
																	this.escape_html(h))),
														  null != d && (d.group_match = !0))
														: null != o.group_array_index &&
														  this.results_data[o.group_array_index]
																.search_match &&
														  (o.search_match = !0)))
									return (
										this.result_clear_highlight(),
										c < 1 && a.length
											? (this.update_results_content(''),
											  this.no_results(a))
											: (this.update_results_content(
													this.results_option_build()
											  ),
											  (null != e ? e.skip_highlight : void 0)
													? void 0
													: this.winnow_results_set_highlight())
									)
								}),
								(e.prototype.get_search_regex = function (e) {
									var t, n
									return (
										(n = this.search_contains
											? e
											: '(^|\\s|\\b)' + e + '[^\\s]*'),
										this.enable_split_word_search ||
											this.search_contains ||
											(n = '^' + n),
										(t = this.case_sensitive_search ? '' : 'i'),
										new RegExp(n, t)
									)
								}),
								(e.prototype.search_string_match = function (e, t) {
									var n
									return (
										(n = t.exec(e)),
										!this.search_contains &&
											(null != n ? n[1] : void 0) &&
											(n.index += 1),
										n
									)
								}),
								(e.prototype.choices_count = function () {
									var e, t, n
									if (null != this.selected_option_count)
										return this.selected_option_count
									for (
										this.selected_option_count = 0,
											e = 0,
											t = (n = this.form_field.options).length;
										e < t;
										e++
									)
										n[e].selected && (this.selected_option_count += 1)
									return this.selected_option_count
								}),
								(e.prototype.choices_click = function (e) {
									if (
										(e.preventDefault(),
										this.activate_field(),
										!this.results_showing && !this.is_disabled)
									)
										return this.results_show()
								}),
								(e.prototype.keydown_checker = function (e) {
									var t, n
									switch (
										((n = null != (t = e.which) ? t : e.keyCode),
										this.search_field_scale(),
										8 !== n &&
											this.pending_backstroke &&
											this.clear_backstroke(),
										n)
									) {
										case 8:
											this.backstroke_length =
												this.get_search_field_value().length
											break
										case 9:
											this.results_showing &&
												!this.is_multiple &&
												this.result_select(e),
												(this.mouse_on_container = !1)
											break
										case 13:
										case 27:
											this.results_showing && e.preventDefault()
											break
										case 32:
											this.disable_search && e.preventDefault()
											break
										case 38:
											e.preventDefault(), this.keyup_arrow()
											break
										case 40:
											e.preventDefault(), this.keydown_arrow()
									}
								}),
								(e.prototype.keyup_checker = function (e) {
									var t, n
									switch (
										((n = null != (t = e.which) ? t : e.keyCode),
										this.search_field_scale(),
										n)
									) {
										case 8:
											this.is_multiple &&
											this.backstroke_length < 1 &&
											this.choices_count() > 0
												? this.keydown_backstroke()
												: this.pending_backstroke ||
												  (this.result_clear_highlight(),
												  this.results_search())
											break
										case 13:
											e.preventDefault(),
												this.results_showing && this.result_select(e)
											break
										case 27:
											this.results_showing && this.results_hide()
											break
										case 9:
										case 16:
										case 17:
										case 18:
										case 38:
										case 40:
										case 91:
											break
										default:
											this.results_search()
									}
								}),
								(e.prototype.clipboard_event_checker = function (e) {
									var t
									if (!this.is_disabled)
										return setTimeout(
											((t = this),
											function () {
												return t.results_search()
											}),
											50
										)
								}),
								(e.prototype.container_width = function () {
									return null != this.options.width
										? this.options.width
										: this.form_field.offsetWidth + 'px'
								}),
								(e.prototype.include_option_in_results = function (
									e
								) {
									return (
										!(
											this.is_multiple &&
											!this.display_selected_options &&
											e.selected
										) &&
										!(!this.display_disabled_options && e.disabled) &&
										!e.empty
									)
								}),
								(e.prototype.search_results_touchstart = function (
									e
								) {
									return (
										(this.touch_started = !0),
										this.search_results_mouseover(e)
									)
								}),
								(e.prototype.search_results_touchmove = function (e) {
									return (
										(this.touch_started = !1),
										this.search_results_mouseout(e)
									)
								}),
								(e.prototype.search_results_touchend = function (e) {
									if (this.touch_started)
										return this.search_results_mouseup(e)
								}),
								(e.prototype.outerHTML = function (e) {
									var t
									return e.outerHTML
										? e.outerHTML
										: ((t =
												document.createElement('div')).appendChild(e),
										  t.innerHTML)
								}),
								(e.prototype.get_single_html = function () {
									return (
										'<a class="chosen-single chosen-default">\n  <span>' +
										this.default_text +
										'</span>\n  <div><b></b></div>\n</a>\n<div class="chosen-drop">\n  <div class="chosen-search">\n    <input class="chosen-search-input" type="text" autocomplete="off" />\n  </div>\n  <ul class="chosen-results"></ul>\n</div>'
									)
								}),
								(e.prototype.get_multi_html = function () {
									return (
										'<ul class="chosen-choices">\n  <li class="search-field">\n    <input class="chosen-search-input" type="text" autocomplete="off" value="' +
										this.default_text +
										'" />\n  </li>\n</ul>\n<div class="chosen-drop">\n  <ul class="chosen-results"></ul>\n</div>'
									)
								}),
								(e.prototype.get_no_results_html = function (e) {
									return (
										'<li class="no-results">\n  ' +
										this.results_none_found +
										' <span>' +
										this.escape_html(e) +
										'</span>\n</li>'
									)
								}),
								(e.browser_is_supported = function () {
									return 'Microsoft Internet Explorer' ===
										window.navigator.appName
										? document.documentMode >= 8
										: !(
												/iP(od|hone)/i.test(
													window.navigator.userAgent
												) ||
												/IEMobile/i.test(
													window.navigator.userAgent
												) ||
												/Windows Phone/i.test(
													window.navigator.userAgent
												) ||
												/BlackBerry/i.test(
													window.navigator.userAgent
												) ||
												/BB10/i.test(window.navigator.userAgent) ||
												/Android.*Mobile/i.test(
													window.navigator.userAgent
												)
										  )
								}),
								(e.default_multiple_text = 'Select Some Options'),
								(e.default_single_text = 'Select an Option'),
								(e.default_no_result_text = 'No results match'),
								e
							)
						})()),
						(e = jQuery).fn.extend({
							chosen: function (r) {
								return t.browser_is_supported()
									? this.each(function (t) {
											var i, o
											;(o = (i = e(this)).data('chosen')),
												'destroy' !== r
													? o instanceof n ||
													  i.data('chosen', new n(this, r))
													: o instanceof n && o.destroy()
									  })
									: this
							}
						}),
						(n = (function (t) {
							function n() {
								return n.__super__.constructor.apply(this, arguments)
							}
							return (
								(function (e, t) {
									for (var n in t) i.call(t, n) && (e[n] = t[n])
									function r() {
										this.constructor = e
									}
									;(r.prototype = t.prototype),
										(e.prototype = new r()),
										(e.__super__ = t.prototype)
								})(n, t),
								(n.prototype.setup = function () {
									return (
										(this.form_field_jq = e(this.form_field)),
										(this.current_selectedIndex =
											this.form_field.selectedIndex)
									)
								}),
								(n.prototype.set_up_html = function () {
									var t, n
									return (
										(t = ['chosen-container']).push(
											'chosen-container-' +
												(this.is_multiple ? 'multi' : 'single')
										),
										this.inherit_select_classes &&
											this.form_field.className &&
											t.push(this.form_field.className),
										this.is_rtl && t.push('chosen-rtl'),
										(n = {
											class: t.join(' '),
											title: this.form_field.title
										}),
										this.form_field.id.length &&
											(n.id =
												this.form_field.id.replace(/[^\w]/g, '_') +
												'_chosen'),
										(this.container = e('<div />', n)),
										this.container.width(this.container_width()),
										this.is_multiple
											? this.container.html(this.get_multi_html())
											: this.container.html(this.get_single_html()),
										this.form_field_jq.hide().after(this.container),
										(this.dropdown = this.container
											.find('div.chosen-drop')
											.first()),
										(this.search_field = this.container
											.find('input')
											.first()),
										(this.search_results = this.container
											.find('ul.chosen-results')
											.first()),
										this.search_field_scale(),
										(this.search_no_results = this.container
											.find('li.no-results')
											.first()),
										this.is_multiple
											? ((this.search_choices = this.container
													.find('ul.chosen-choices')
													.first()),
											  (this.search_container = this.container
													.find('li.search-field')
													.first()))
											: ((this.search_container = this.container
													.find('div.chosen-search')
													.first()),
											  (this.selected_item = this.container
													.find('.chosen-single')
													.first())),
										this.results_build(),
										this.set_tab_index(),
										this.set_label_behavior()
									)
								}),
								(n.prototype.on_ready = function () {
									return this.form_field_jq.trigger('chosen:ready', {
										chosen: this
									})
								}),
								(n.prototype.register_observers = function () {
									var e
									return (
										this.container.on(
											'touchstart.chosen',
											((e = this),
											function (t) {
												e.container_mousedown(t)
											})
										),
										this.container.on(
											'touchend.chosen',
											(function (e) {
												return function (t) {
													e.container_mouseup(t)
												}
											})(this)
										),
										this.container.on(
											'mousedown.chosen',
											(function (e) {
												return function (t) {
													e.container_mousedown(t)
												}
											})(this)
										),
										this.container.on(
											'mouseup.chosen',
											(function (e) {
												return function (t) {
													e.container_mouseup(t)
												}
											})(this)
										),
										this.container.on(
											'mouseenter.chosen',
											(function (e) {
												return function (t) {
													e.mouse_enter(t)
												}
											})(this)
										),
										this.container.on(
											'mouseleave.chosen',
											(function (e) {
												return function (t) {
													e.mouse_leave(t)
												}
											})(this)
										),
										this.search_results.on(
											'mouseup.chosen',
											(function (e) {
												return function (t) {
													e.search_results_mouseup(t)
												}
											})(this)
										),
										this.search_results.on(
											'mouseover.chosen',
											(function (e) {
												return function (t) {
													e.search_results_mouseover(t)
												}
											})(this)
										),
										this.search_results.on(
											'mouseout.chosen',
											(function (e) {
												return function (t) {
													e.search_results_mouseout(t)
												}
											})(this)
										),
										this.search_results.on(
											'mousewheel.chosen DOMMouseScroll.chosen',
											(function (e) {
												return function (t) {
													e.search_results_mousewheel(t)
												}
											})(this)
										),
										this.search_results.on(
											'touchstart.chosen',
											(function (e) {
												return function (t) {
													e.search_results_touchstart(t)
												}
											})(this)
										),
										this.search_results.on(
											'touchmove.chosen',
											(function (e) {
												return function (t) {
													e.search_results_touchmove(t)
												}
											})(this)
										),
										this.search_results.on(
											'touchend.chosen',
											(function (e) {
												return function (t) {
													e.search_results_touchend(t)
												}
											})(this)
										),
										this.form_field_jq.on(
											'chosen:updated.chosen',
											(function (e) {
												return function (t) {
													e.results_update_field(t)
												}
											})(this)
										),
										this.form_field_jq.on(
											'chosen:activate.chosen',
											(function (e) {
												return function (t) {
													e.activate_field(t)
												}
											})(this)
										),
										this.form_field_jq.on(
											'chosen:open.chosen',
											(function (e) {
												return function (t) {
													e.container_mousedown(t)
												}
											})(this)
										),
										this.form_field_jq.on(
											'chosen:close.chosen',
											(function (e) {
												return function (t) {
													e.close_field(t)
												}
											})(this)
										),
										this.search_field.on(
											'blur.chosen',
											(function (e) {
												return function (t) {
													e.input_blur(t)
												}
											})(this)
										),
										this.search_field.on(
											'keyup.chosen',
											(function (e) {
												return function (t) {
													e.keyup_checker(t)
												}
											})(this)
										),
										this.search_field.on(
											'keydown.chosen',
											(function (e) {
												return function (t) {
													e.keydown_checker(t)
												}
											})(this)
										),
										this.search_field.on(
											'focus.chosen',
											(function (e) {
												return function (t) {
													e.input_focus(t)
												}
											})(this)
										),
										this.search_field.on(
											'cut.chosen',
											(function (e) {
												return function (t) {
													e.clipboard_event_checker(t)
												}
											})(this)
										),
										this.search_field.on(
											'paste.chosen',
											(function (e) {
												return function (t) {
													e.clipboard_event_checker(t)
												}
											})(this)
										),
										this.is_multiple
											? this.search_choices.on(
													'click.chosen',
													(function (e) {
														return function (t) {
															e.choices_click(t)
														}
													})(this)
											  )
											: this.container.on(
													'click.chosen',
													function (e) {
														e.preventDefault()
													}
											  )
									)
								}),
								(n.prototype.destroy = function () {
									return (
										e(this.container[0].ownerDocument).off(
											'click.chosen',
											this.click_test_action
										),
										this.form_field_label.length > 0 &&
											this.form_field_label.off('click.chosen'),
										this.search_field[0].tabIndex &&
											(this.form_field_jq[0].tabIndex =
												this.search_field[0].tabIndex),
										this.container.remove(),
										this.form_field_jq.removeData('chosen'),
										this.form_field_jq.show()
									)
								}),
								(n.prototype.search_field_disabled = function () {
									return (
										(this.is_disabled =
											this.form_field.disabled ||
											this.form_field_jq
												.parents('fieldset')
												.is(':disabled')),
										this.container.toggleClass(
											'chosen-disabled',
											this.is_disabled
										),
										(this.search_field[0].disabled =
											this.is_disabled),
										this.is_multiple ||
											this.selected_item.off(
												'focus.chosen',
												this.activate_field
											),
										this.is_disabled
											? this.close_field()
											: this.is_multiple
											? void 0
											: this.selected_item.on(
													'focus.chosen',
													this.activate_field
											  )
									)
								}),
								(n.prototype.container_mousedown = function (t) {
									var n
									if (!this.is_disabled)
										return (
											!t ||
												('mousedown' !== (n = t.type) &&
													'touchstart' !== n) ||
												this.results_showing ||
												t.preventDefault(),
											null != t &&
											e(t.target).hasClass('search-choice-close')
												? void 0
												: (this.active_field
														? this.is_multiple ||
														  !t ||
														  (e(t.target)[0] !==
																this.selected_item[0] &&
																!e(t.target).parents(
																	'a.chosen-single'
																).length) ||
														  (t.preventDefault(),
														  this.results_toggle())
														: (this.is_multiple &&
																this.search_field.val(''),
														  e(this.container[0].ownerDocument).on(
																'click.chosen',
																this.click_test_action
														  ),
														  this.results_show()),
												  this.activate_field())
										)
								}),
								(n.prototype.container_mouseup = function (e) {
									if (
										'ABBR' === e.target.nodeName &&
										!this.is_disabled
									)
										return this.results_reset(e)
								}),
								(n.prototype.search_results_mousewheel = function (
									e
								) {
									var t
									if (
										(e.originalEvent &&
											(t =
												e.originalEvent.deltaY ||
												-e.originalEvent.wheelDelta ||
												e.originalEvent.detail),
										null != t)
									)
										return (
											e.preventDefault(),
											'DOMMouseScroll' === e.type && (t *= 40),
											this.search_results.scrollTop(
												t + this.search_results.scrollTop()
											)
										)
								}),
								(n.prototype.blur_test = function (e) {
									if (
										!this.active_field &&
										this.container.hasClass('chosen-container-active')
									)
										return this.close_field()
								}),
								(n.prototype.close_field = function () {
									return (
										e(this.container[0].ownerDocument).off(
											'click.chosen',
											this.click_test_action
										),
										(this.active_field = !1),
										this.results_hide(),
										this.container.removeClass(
											'chosen-container-active'
										),
										this.clear_backstroke(),
										this.show_search_field_default(),
										this.search_field_scale(),
										this.search_field.blur()
									)
								}),
								(n.prototype.activate_field = function () {
									if (!this.is_disabled)
										return (
											this.container.addClass(
												'chosen-container-active'
											),
											(this.active_field = !0),
											this.search_field.val(this.search_field.val()),
											this.search_field.focus()
										)
								}),
								(n.prototype.test_active_click = function (t) {
									var n
									return (n = e(t.target).closest(
										'.chosen-container'
									)).length && this.container[0] === n[0]
										? (this.active_field = !0)
										: this.close_field()
								}),
								(n.prototype.results_build = function () {
									return (
										(this.parsing = !0),
										(this.selected_option_count = null),
										(this.results_data = r.select_to_array(
											this.form_field
										)),
										this.is_multiple
											? this.search_choices
													.find('li.search-choice')
													.remove()
											: (this.single_set_selected_text(),
											  this.disable_search ||
											  this.form_field.options.length <=
													this.disable_search_threshold
													? ((this.search_field[0].readOnly = !0),
													  this.container.addClass(
															'chosen-container-single-nosearch'
													  ))
													: ((this.search_field[0].readOnly = !1),
													  this.container.removeClass(
															'chosen-container-single-nosearch'
													  ))),
										this.update_results_content(
											this.results_option_build({ first: !0 })
										),
										this.search_field_disabled(),
										this.show_search_field_default(),
										this.search_field_scale(),
										(this.parsing = !1)
									)
								}),
								(n.prototype.result_do_highlight = function (e) {
									var t, n, r, i, o
									if (e.length) {
										if (
											(this.result_clear_highlight(),
											(this.result_highlight = e),
											this.result_highlight.addClass('highlighted'),
											(i =
												(r = parseInt(
													this.search_results.css('maxHeight'),
													10
												)) + (o = this.search_results.scrollTop())),
											(t =
												(n =
													this.result_highlight.position().top +
													this.search_results.scrollTop()) +
												this.result_highlight.outerHeight()) >= i)
										)
											return this.search_results.scrollTop(
												t - r > 0 ? t - r : 0
											)
										if (n < o) return this.search_results.scrollTop(n)
									}
								}),
								(n.prototype.result_clear_highlight = function () {
									return (
										this.result_highlight &&
											this.result_highlight.removeClass(
												'highlighted'
											),
										(this.result_highlight = null)
									)
								}),
								(n.prototype.results_show = function () {
									return this.is_multiple &&
										this.max_selected_options <= this.choices_count()
										? (this.form_field_jq.trigger(
												'chosen:maxselected',
												{ chosen: this }
										  ),
										  !1)
										: (this.container.addClass('chosen-with-drop'),
										  (this.results_showing = !0),
										  this.search_field.focus(),
										  this.search_field.val(
												this.get_search_field_value()
										  ),
										  this.winnow_results(),
										  this.form_field_jq.trigger(
												'chosen:showing_dropdown',
												{ chosen: this }
										  ))
								}),
								(n.prototype.update_results_content = function (e) {
									return this.search_results.html(e)
								}),
								(n.prototype.results_hide = function () {
									return (
										this.results_showing &&
											(this.result_clear_highlight(),
											this.container.removeClass('chosen-with-drop'),
											this.form_field_jq.trigger(
												'chosen:hiding_dropdown',
												{ chosen: this }
											)),
										(this.results_showing = !1)
									)
								}),
								(n.prototype.set_tab_index = function (e) {
									var t
									if (this.form_field.tabIndex)
										return (
											(t = this.form_field.tabIndex),
											(this.form_field.tabIndex = -1),
											(this.search_field[0].tabIndex = t)
										)
								}),
								(n.prototype.set_label_behavior = function () {
									if (
										((this.form_field_label =
											this.form_field_jq.parents('label')),
										!this.form_field_label.length &&
											this.form_field.id.length &&
											(this.form_field_label = e(
												"label[for='" + this.form_field.id + "']"
											)),
										this.set_search_field_label(),
										this.form_field_label.length > 0)
									)
										return this.form_field_label.on(
											'click.chosen',
											this.label_click_handler
										)
								}),
								(n.prototype.set_search_field_label = function () {
									var t = this.form_field.getAttribute('aria-label'),
										n = this.form_field.getAttribute('aria-labelledby'),
										r = n && document.getElementById(n)
									return (
										!t && r && (t = r.textContent),
										!t &&
											this.form_field_label.length > 0 &&
											(t = this.form_field_label.text()),
										(t = (t || '').replace(/\s+/g, ' ').trim().replace(/:$/, '')),
										t ? this.search_field.attr('aria-label', t) : void 0
									)
								}),
								(n.prototype.show_search_field_default = function () {
									return this.is_multiple &&
										this.choices_count() < 1 &&
										!this.active_field
										? (this.search_field.val(this.default_text),
										  this.search_field.addClass('default'))
										: (this.search_field.val(''),
										  this.search_field.removeClass('default'))
								}),
								(n.prototype.search_results_mouseup = function (t) {
									var n
									if (
										(n = e(t.target).hasClass('active-result')
											? e(t.target)
											: e(t.target).parents('.active-result').first())
											.length
									)
										return (
											(this.result_highlight = n),
											this.result_select(t),
											this.search_field.focus()
										)
								}),
								(n.prototype.search_results_mouseover = function (t) {
									var n
									if (
										(n = e(t.target).hasClass('active-result')
											? e(t.target)
											: e(t.target).parents('.active-result').first())
									)
										return this.result_do_highlight(n)
								}),
								(n.prototype.search_results_mouseout = function (t) {
									if (
										e(t.target).hasClass('active-result') ||
										e(t.target).parents('.active-result').first()
									)
										return this.result_clear_highlight()
								}),
								(n.prototype.choice_build = function (t) {
									var n, r, i
									return (
										(n = e('<li />', { class: 'search-choice' }).html(
											'<span>' + this.choice_label(t) + '</span>'
										)),
										t.disabled
											? n.addClass('search-choice-disabled')
											: ((r = e('<a />', {
													class: 'search-choice-close',
													'data-option-array-index': t.array_index
											  })).on(
													'click.chosen',
													((i = this),
													function (e) {
														return i.choice_destroy_link_click(e)
													})
											  ),
											  n.append(r)),
										this.search_container.before(n)
									)
								}),
								(n.prototype.choice_destroy_link_click = function (
									t
								) {
									if (
										(t.preventDefault(),
										t.stopPropagation(),
										!this.is_disabled)
									)
										return this.choice_destroy(e(t.target))
								}),
								(n.prototype.choice_destroy = function (e) {
									if (
										this.result_deselect(
											e[0].getAttribute('data-option-array-index')
										)
									)
										return (
											this.active_field
												? this.search_field.focus()
												: this.show_search_field_default(),
											this.is_multiple &&
												this.choices_count() > 0 &&
												this.get_search_field_value().length < 1 &&
												this.results_hide(),
											e.parents('li').first().remove(),
											this.search_field_scale()
										)
								}),
								(n.prototype.results_reset = function () {
									if (
										(this.reset_single_select_options(),
										(this.form_field.options[0].selected = !0),
										this.single_set_selected_text(),
										this.show_search_field_default(),
										this.results_reset_cleanup(),
										this.trigger_form_field_change(),
										this.active_field)
									)
										return this.results_hide()
								}),
								(n.prototype.results_reset_cleanup = function () {
									return (
										(this.current_selectedIndex =
											this.form_field.selectedIndex),
										this.selected_item.find('abbr').remove()
									)
								}),
								(n.prototype.result_select = function (e) {
									var t, n
									if (this.result_highlight)
										return (
											(t = this.result_highlight),
											this.result_clear_highlight(),
											this.is_multiple &&
											this.max_selected_options <=
												this.choices_count()
												? (this.form_field_jq.trigger(
														'chosen:maxselected',
														{ chosen: this }
												  ),
												  !1)
												: (this.is_multiple
														? t.removeClass('active-result')
														: this.reset_single_select_options(),
												  t.addClass('result-selected'),
												  ((n =
														this.results_data[
															t[0].getAttribute(
																'data-option-array-index'
															)
														]).selected = !0),
												  (this.form_field.options[
														n.options_index
												  ].selected = !0),
												  (this.selected_option_count = null),
												  this.is_multiple
														? this.choice_build(n)
														: this.single_set_selected_text(
																this.choice_label(n)
														  ),
												  this.is_multiple &&
												  (!this.hide_results_on_select ||
														e.metaKey ||
														e.ctrlKey)
														? e.metaKey || e.ctrlKey
															? this.winnow_results({
																	skip_highlight: !0
															  })
															: (this.search_field.val(''),
															  this.winnow_results())
														: (this.results_hide(),
														  this.show_search_field_default()),
												  (this.is_multiple ||
														this.form_field.selectedIndex !==
															this.current_selectedIndex) &&
														this.trigger_form_field_change({
															selected:
																this.form_field.options[
																	n.options_index
																].value
														}),
												  (this.current_selectedIndex =
														this.form_field.selectedIndex),
												  e.preventDefault(),
												  this.search_field_scale())
										)
								}),
								(n.prototype.single_set_selected_text = function (e) {
									return (
										null == e && (e = this.default_text),
										e === this.default_text
											? this.selected_item.addClass('chosen-default')
											: (this.single_deselect_control_build(),
											  this.selected_item.removeClass(
													'chosen-default'
											  )),
										this.selected_item.find('span').html(e)
									)
								}),
								(n.prototype.result_deselect = function (e) {
									var t
									return (
										(t = this.results_data[e]),
										!this.form_field.options[t.options_index]
											.disabled &&
											((t.selected = !1),
											(this.form_field.options[
												t.options_index
											].selected = !1),
											(this.selected_option_count = null),
											this.result_clear_highlight(),
											this.results_showing && this.winnow_results(),
											this.trigger_form_field_change({
												deselected:
													this.form_field.options[t.options_index]
														.value
											}),
											this.search_field_scale(),
											!0)
									)
								}),
								(n.prototype.single_deselect_control_build =
									function () {
										if (this.allow_single_deselect)
											return (
												this.selected_item.find('abbr').length ||
													this.selected_item
														.find('span')
														.first()
														.after(
															'<abbr class="search-choice-close"></abbr>'
														),
												this.selected_item.addClass(
													'chosen-single-with-deselect'
												)
											)
									}),
								(n.prototype.get_search_field_value = function () {
									return this.search_field.val()
								}),
								(n.prototype.get_search_text = function () {
									return e.trim(this.get_search_field_value())
								}),
								(n.prototype.escape_html = function (t) {
									return e('<div/>').text(t).html()
								}),
								(n.prototype.winnow_results_set_highlight =
									function () {
										var e, t
										if (
											null !=
											(e = (t = this.is_multiple
												? []
												: this.search_results.find(
														'.result-selected.active-result'
												  )).length
												? t.first()
												: this.search_results
														.find('.active-result')
														.first())
										)
											return this.result_do_highlight(e)
									}),
								(n.prototype.no_results = function (e) {
									var t
									return (
										(t = this.get_no_results_html(e)),
										this.search_results.append(t),
										this.form_field_jq.trigger('chosen:no_results', {
											chosen: this
										})
									)
								}),
								(n.prototype.no_results_clear = function () {
									return this.search_results
										.find('.no-results')
										.remove()
								}),
								(n.prototype.keydown_arrow = function () {
									var e
									return this.results_showing && this.result_highlight
										? (e = this.result_highlight
												.nextAll('li.active-result')
												.first())
											? this.result_do_highlight(e)
											: void 0
										: this.results_show()
								}),
								(n.prototype.keyup_arrow = function () {
									var e
									return this.results_showing || this.is_multiple
										? this.result_highlight
											? (e = this.result_highlight.prevAll(
													'li.active-result'
											  )).length
												? this.result_do_highlight(e.first())
												: (this.choices_count() > 0 &&
														this.results_hide(),
												  this.result_clear_highlight())
											: void 0
										: this.results_show()
								}),
								(n.prototype.keydown_backstroke = function () {
									var e
									return this.pending_backstroke
										? (this.choice_destroy(
												this.pending_backstroke.find('a').first()
										  ),
										  this.clear_backstroke())
										: (e = this.search_container
												.siblings('li.search-choice')
												.last()).length &&
										  !e.hasClass('search-choice-disabled')
										? ((this.pending_backstroke = e),
										  this.single_backstroke_delete
												? this.keydown_backstroke()
												: this.pending_backstroke.addClass(
														'search-choice-focus'
												  ))
										: void 0
								}),
								(n.prototype.clear_backstroke = function () {
									return (
										this.pending_backstroke &&
											this.pending_backstroke.removeClass(
												'search-choice-focus'
											),
										(this.pending_backstroke = null)
									)
								}),
								(n.prototype.search_field_scale = function () {
									var t, n, r, i, o, s, a
									if (this.is_multiple) {
										for (
											o = {
												position: 'absolute',
												left: '-1000px',
												top: '-1000px',
												display: 'none',
												whiteSpace: 'pre'
											},
												n = 0,
												r = (s = [
													'fontSize',
													'fontStyle',
													'fontWeight',
													'fontFamily',
													'lineHeight',
													'textTransform',
													'letterSpacing'
												]).length;
											n < r;
											n++
										)
											o[(i = s[n])] = this.search_field.css(i)
										return (
											(t = e('<div />').css(o)).text(
												this.get_search_field_value()
											),
											e('body').append(t),
											(a = t.width() + 25),
											t.remove(),
											this.container.is(':visible') &&
												(a = Math.min(
													this.container.outerWidth() - 10,
													a
												)),
											this.search_field.width(a)
										)
									}
								}),
								(n.prototype.trigger_form_field_change = function (
									e
								) {
									return (
										this.form_field_jq.trigger('input', e),
										this.form_field_jq.trigger('change', e)
									)
								}),
								n
							)
						})(t))
				}.call(this))
			},
			1950: function (e, t, n) {
				var r = n(4692),
					i = n(4160)
				;(i.$ = r), (i.jQuery = r), (e.exports = r)
			},
			4160: function (e, t, n) {
				'use strict'
				e.exports = (function () {
					if ('object' == typeof globalThis) return globalThis
					var e
					try {
						e = this || new Function('return this')()
					} catch (e) {
						if ('object' == typeof window) return window
						if ('object' == typeof self) return self
						if (void 0 !== n.g) return n.g
					}
					return e
				})()
			},
			4692: function (e, t) {
				var n
				!(function (t, n) {
					'use strict'
					'object' == typeof e.exports
						? (e.exports = t.document
								? n(t, !0)
								: function (e) {
										if (!e.document)
											throw new Error(
												'jQuery requires a window with a document'
											)
										return n(e)
								  })
						: n(t)
				})(
					'undefined' != typeof window ? window : this,
					function (r, i) {
						'use strict'
						var o = [],
							s = Object.getPrototypeOf,
							a = o.slice,
							l = o.flat
								? function (e) {
										return o.flat.call(e)
								  }
								: function (e) {
										return o.concat.apply([], e)
								  },
							u = o.push,
							c = o.indexOf,
							d = {},
							p = d.toString,
							f = d.hasOwnProperty,
							h = f.toString,
							v = h.call(Object),
							m = {},
							g = function (e) {
								return (
									'function' == typeof e &&
									'number' != typeof e.nodeType &&
									'function' != typeof e.item
								)
							},
							y = function (e) {
								return null != e && e === e.window
							},
							_ = r.document,
							b = { type: !0, src: !0, nonce: !0, noModule: !0 }
						function w(e, t, n) {
							var r,
								i,
								o = (n = n || _).createElement('script')
							if (((o.text = e), t))
								for (r in b)
									(i =
										t[r] || (t.getAttribute && t.getAttribute(r))) &&
										o.setAttribute(r, i)
							n.head.appendChild(o).parentNode.removeChild(o)
						}
						function x(e) {
							return null == e
								? e + ''
								: 'object' == typeof e || 'function' == typeof e
								? d[p.call(e)] || 'object'
								: typeof e
						}
						var T = '3.7.1',
							C = /HTML$/i,
							E = function (e, t) {
								return new E.fn.init(e, t)
							}
						function k(e) {
							var t = !!e && 'length' in e && e.length,
								n = x(e)
							return (
								!g(e) &&
								!y(e) &&
								('array' === n ||
									0 === t ||
									('number' == typeof t && t > 0 && t - 1 in e))
							)
						}
						function S(e, t) {
							return (
								e.nodeName &&
								e.nodeName.toLowerCase() === t.toLowerCase()
							)
						}
						;(E.fn = E.prototype =
							{
								jquery: T,
								constructor: E,
								length: 0,
								toArray: function () {
									return a.call(this)
								},
								get: function (e) {
									return null == e
										? a.call(this)
										: e < 0
										? this[e + this.length]
										: this[e]
								},
								pushStack: function (e) {
									var t = E.merge(this.constructor(), e)
									return (t.prevObject = this), t
								},
								each: function (e) {
									return E.each(this, e)
								},
								map: function (e) {
									return this.pushStack(
										E.map(this, function (t, n) {
											return e.call(t, n, t)
										})
									)
								},
								slice: function () {
									return this.pushStack(a.apply(this, arguments))
								},
								first: function () {
									return this.eq(0)
								},
								last: function () {
									return this.eq(-1)
								},
								even: function () {
									return this.pushStack(
										E.grep(this, function (e, t) {
											return (t + 1) % 2
										})
									)
								},
								odd: function () {
									return this.pushStack(
										E.grep(this, function (e, t) {
											return t % 2
										})
									)
								},
								eq: function (e) {
									var t = this.length,
										n = +e + (e < 0 ? t : 0)
									return this.pushStack(
										n >= 0 && n < t ? [this[n]] : []
									)
								},
								end: function () {
									return this.prevObject || this.constructor()
								},
								push: u,
								sort: o.sort,
								splice: o.splice
							}),
							(E.extend = E.fn.extend =
								function () {
									var e,
										t,
										n,
										r,
										i,
										o,
										s = arguments[0] || {},
										a = 1,
										l = arguments.length,
										u = !1
									for (
										'boolean' == typeof s &&
											((u = s), (s = arguments[a] || {}), a++),
											'object' == typeof s || g(s) || (s = {}),
											a === l && ((s = this), a--);
										a < l;
										a++
									)
										if (null != (e = arguments[a]))
											for (t in e)
												(r = e[t]),
													'__proto__' !== t &&
														s !== r &&
														(u &&
														r &&
														(E.isPlainObject(r) ||
															(i = Array.isArray(r)))
															? ((n = s[t]),
															  (o =
																	i && !Array.isArray(n)
																		? []
																		: i || E.isPlainObject(n)
																		? n
																		: {}),
															  (i = !1),
															  (s[t] = E.extend(u, o, r)))
															: void 0 !== r && (s[t] = r))
									return s
								}),
							E.extend({
								expando:
									'jQuery' + (T + Math.random()).replace(/\D/g, ''),
								isReady: !0,
								error: function (e) {
									throw new Error(e)
								},
								noop: function () {},
								isPlainObject: function (e) {
									var t, n
									return (
										!(!e || '[object Object]' !== p.call(e)) &&
										(!(t = s(e)) ||
											('function' ==
												typeof (n =
													f.call(t, 'constructor') &&
													t.constructor) &&
												h.call(n) === v))
									)
								},
								isEmptyObject: function (e) {
									var t
									for (t in e) return !1
									return !0
								},
								globalEval: function (e, t, n) {
									w(e, { nonce: t && t.nonce }, n)
								},
								each: function (e, t) {
									var n,
										r = 0
									if (k(e))
										for (
											n = e.length;
											r < n && !1 !== t.call(e[r], r, e[r]);
											r++
										);
									else
										for (r in e)
											if (!1 === t.call(e[r], r, e[r])) break
									return e
								},
								text: function (e) {
									var t,
										n = '',
										r = 0,
										i = e.nodeType
									if (!i) for (; (t = e[r++]); ) n += E.text(t)
									return 1 === i || 11 === i
										? e.textContent
										: 9 === i
										? e.documentElement.textContent
										: 3 === i || 4 === i
										? e.nodeValue
										: n
								},
								makeArray: function (e, t) {
									var n = t || []
									return (
										null != e &&
											(k(Object(e))
												? E.merge(n, 'string' == typeof e ? [e] : e)
												: u.call(n, e)),
										n
									)
								},
								inArray: function (e, t, n) {
									return null == t ? -1 : c.call(t, e, n)
								},
								isXMLDoc: function (e) {
									var t = e && e.namespaceURI,
										n = e && (e.ownerDocument || e).documentElement
									return !C.test(t || (n && n.nodeName) || 'HTML')
								},
								merge: function (e, t) {
									for (
										var n = +t.length, r = 0, i = e.length;
										r < n;
										r++
									)
										e[i++] = t[r]
									return (e.length = i), e
								},
								grep: function (e, t, n) {
									for (
										var r = [], i = 0, o = e.length, s = !n;
										i < o;
										i++
									)
										!t(e[i], i) !== s && r.push(e[i])
									return r
								},
								map: function (e, t, n) {
									var r,
										i,
										o = 0,
										s = []
									if (k(e))
										for (r = e.length; o < r; o++)
											null != (i = t(e[o], o, n)) && s.push(i)
									else
										for (o in e)
											null != (i = t(e[o], o, n)) && s.push(i)
									return l(s)
								},
								guid: 1,
								support: m
							}),
							'function' == typeof Symbol &&
								(E.fn[Symbol.iterator] = o[Symbol.iterator]),
							E.each(
								'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(
									' '
								),
								function (e, t) {
									d['[object ' + t + ']'] = t.toLowerCase()
								}
							)
						var M = o.pop,
							P = o.sort,
							L = o.splice,
							A = '[\\x20\\t\\r\\n\\f]',
							O = new RegExp(
								'^' + A + '+|((?:^|[^\\\\])(?:\\\\.)*)' + A + '+$',
								'g'
							)
						E.contains = function (e, t) {
							var n = t && t.parentNode
							return (
								e === n ||
								!(
									!n ||
									1 !== n.nodeType ||
									!(e.contains
										? e.contains(n)
										: e.compareDocumentPosition &&
										  16 & e.compareDocumentPosition(n))
								)
							)
						}
						var j = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g
						function $(e, t) {
							return t
								? '\0' === e
									? '�'
									: e.slice(0, -1) +
									  '\\' +
									  e.charCodeAt(e.length - 1).toString(16) +
									  ' '
								: '\\' + e
						}
						E.escapeSelector = function (e) {
							return (e + '').replace(j, $)
						}
						var D = _,
							N = u
						!(function () {
							var e,
								t,
								n,
								i,
								s,
								l,
								u,
								d,
								p,
								h,
								v = N,
								g = E.expando,
								y = 0,
								_ = 0,
								b = ee(),
								w = ee(),
								x = ee(),
								T = ee(),
								C = function (e, t) {
									return e === t && (s = !0), 0
								},
								k =
									'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
								j =
									'(?:\\\\[\\da-fA-F]{1,6}' +
									A +
									'?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
								$ =
									'\\[' +
									A +
									'*(' +
									j +
									')(?:' +
									A +
									'*([*^$|!~]?=)' +
									A +
									'*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
									j +
									'))|)' +
									A +
									'*\\]',
								I =
									':(' +
									j +
									')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
									$ +
									')*)|.*)\\)|)',
								q = new RegExp(A + '+', 'g'),
								H = new RegExp('^' + A + '*,' + A + '*'),
								B = new RegExp(
									'^' + A + '*([>+~]|' + A + ')' + A + '*'
								),
								F = new RegExp(A + '|>'),
								R = new RegExp(I),
								z = new RegExp('^' + j + '$'),
								W = {
									ID: new RegExp('^#(' + j + ')'),
									CLASS: new RegExp('^\\.(' + j + ')'),
									TAG: new RegExp('^(' + j + '|[*])'),
									ATTR: new RegExp('^' + $),
									PSEUDO: new RegExp('^' + I),
									CHILD: new RegExp(
										'^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
											A +
											'*(even|odd|(([+-]|)(\\d*)n|)' +
											A +
											'*(?:([+-]|)' +
											A +
											'*(\\d+)|))' +
											A +
											'*\\)|)',
										'i'
									),
									bool: new RegExp('^(?:' + k + ')$', 'i'),
									needsContext: new RegExp(
										'^' +
											A +
											'*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
											A +
											'*((?:-\\d)?\\d*)' +
											A +
											'*\\)|)(?=[^-]|$)',
										'i'
									)
								},
								V = /^(?:input|select|textarea|button)$/i,
								G = /^h\d$/i,
								U = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
								X = /[+~]/,
								Y = new RegExp(
									'\\\\[\\da-fA-F]{1,6}' + A + '?|\\\\([^\\r\\n\\f])',
									'g'
								),
								K = function (e, t) {
									var n = '0x' + e.slice(1) - 65536
									return (
										t ||
										(n < 0
											? String.fromCharCode(n + 65536)
											: String.fromCharCode(
													(n >> 10) | 55296,
													(1023 & n) | 56320
											  ))
									)
								},
								Q = function () {
									le()
								},
								J = pe(
									function (e) {
										return !0 === e.disabled && S(e, 'fieldset')
									},
									{ dir: 'parentNode', next: 'legend' }
								)
							try {
								v.apply((o = a.call(D.childNodes)), D.childNodes),
									o[D.childNodes.length].nodeType
							} catch (e) {
								v = {
									apply: function (e, t) {
										N.apply(e, a.call(t))
									},
									call: function (e) {
										N.apply(e, a.call(arguments, 1))
									}
								}
							}
							function Z(e, t, n, r) {
								var i,
									o,
									s,
									a,
									u,
									c,
									f,
									h = t && t.ownerDocument,
									y = t ? t.nodeType : 9
								if (
									((n = n || []),
									'string' != typeof e ||
										!e ||
										(1 !== y && 9 !== y && 11 !== y))
								)
									return n
								if (!r && (le(t), (t = t || l), d)) {
									if (11 !== y && (u = U.exec(e)))
										if ((i = u[1])) {
											if (9 === y) {
												if (!(s = t.getElementById(i))) return n
												if (s.id === i) return v.call(n, s), n
											} else if (
												h &&
												(s = h.getElementById(i)) &&
												Z.contains(t, s) &&
												s.id === i
											)
												return v.call(n, s), n
										} else {
											if (u[2])
												return (
													v.apply(n, t.getElementsByTagName(e)), n
												)
											if ((i = u[3]) && t.getElementsByClassName)
												return (
													v.apply(n, t.getElementsByClassName(i)), n
												)
										}
									if (!(T[e + ' '] || (p && p.test(e)))) {
										if (
											((f = e),
											(h = t),
											1 === y && (F.test(e) || B.test(e)))
										) {
											for (
												((h = (X.test(e) && ae(t.parentNode)) || t) ==
													t &&
													m.scope) ||
													((a = t.getAttribute('id'))
														? (a = E.escapeSelector(a))
														: t.setAttribute('id', (a = g))),
													o = (c = ce(e)).length;
												o--;

											)
												c[o] =
													(a ? '#' + a : ':scope') + ' ' + de(c[o])
											f = c.join(',')
										}
										try {
											return v.apply(n, h.querySelectorAll(f)), n
										} catch (t) {
											T(e, !0)
										} finally {
											a === g && t.removeAttribute('id')
										}
									}
								}
								return ye(e.replace(O, '$1'), t, n, r)
							}
							function ee() {
								var e = []
								return function n(r, i) {
									return (
										e.push(r + ' ') > t.cacheLength &&
											delete n[e.shift()],
										(n[r + ' '] = i)
									)
								}
							}
							function te(e) {
								return (e[g] = !0), e
							}
							function ne(e) {
								var t = l.createElement('fieldset')
								try {
									return !!e(t)
								} catch (e) {
									return !1
								} finally {
									t.parentNode && t.parentNode.removeChild(t),
										(t = null)
								}
							}
							function re(e) {
								return function (t) {
									return S(t, 'input') && t.type === e
								}
							}
							function ie(e) {
								return function (t) {
									return (
										(S(t, 'input') || S(t, 'button')) && t.type === e
									)
								}
							}
							function oe(e) {
								return function (t) {
									return 'form' in t
										? t.parentNode && !1 === t.disabled
											? 'label' in t
												? 'label' in t.parentNode
													? t.parentNode.disabled === e
													: t.disabled === e
												: t.isDisabled === e ||
												  (t.isDisabled !== !e && J(t) === e)
											: t.disabled === e
										: 'label' in t && t.disabled === e
								}
							}
							function se(e) {
								return te(function (t) {
									return (
										(t = +t),
										te(function (n, r) {
											for (
												var i, o = e([], n.length, t), s = o.length;
												s--;

											)
												n[(i = o[s])] && (n[i] = !(r[i] = n[i]))
										})
									)
								})
							}
							function ae(e) {
								return e && void 0 !== e.getElementsByTagName && e
							}
							function le(e) {
								var n,
									r = e ? e.ownerDocument || e : D
								return r != l && 9 === r.nodeType && r.documentElement
									? ((u = (l = r).documentElement),
									  (d = !E.isXMLDoc(l)),
									  (h =
											u.matches ||
											u.webkitMatchesSelector ||
											u.msMatchesSelector),
									  u.msMatchesSelector &&
											D != l &&
											(n = l.defaultView) &&
											n.top !== n &&
											n.addEventListener('unload', Q),
									  (m.getById = ne(function (e) {
											return (
												(u.appendChild(e).id = E.expando),
												!l.getElementsByName ||
													!l.getElementsByName(E.expando).length
											)
									  })),
									  (m.disconnectedMatch = ne(function (e) {
											return h.call(e, '*')
									  })),
									  (m.scope = ne(function () {
											return l.querySelectorAll(':scope')
									  })),
									  (m.cssHas = ne(function () {
											try {
												return l.querySelector(':has(*,:jqfake)'), !1
											} catch (e) {
												return !0
											}
									  })),
									  m.getById
											? ((t.filter.ID = function (e) {
													var t = e.replace(Y, K)
													return function (e) {
														return e.getAttribute('id') === t
													}
											  }),
											  (t.find.ID = function (e, t) {
													if (void 0 !== t.getElementById && d) {
														var n = t.getElementById(e)
														return n ? [n] : []
													}
											  }))
											: ((t.filter.ID = function (e) {
													var t = e.replace(Y, K)
													return function (e) {
														var n =
															void 0 !== e.getAttributeNode &&
															e.getAttributeNode('id')
														return n && n.value === t
													}
											  }),
											  (t.find.ID = function (e, t) {
													if (void 0 !== t.getElementById && d) {
														var n,
															r,
															i,
															o = t.getElementById(e)
														if (o) {
															if (
																(n = o.getAttributeNode('id')) &&
																n.value === e
															)
																return [o]
															for (
																i = t.getElementsByName(e), r = 0;
																(o = i[r++]);

															)
																if (
																	(n = o.getAttributeNode('id')) &&
																	n.value === e
																)
																	return [o]
														}
														return []
													}
											  })),
									  (t.find.TAG = function (e, t) {
											return void 0 !== t.getElementsByTagName
												? t.getElementsByTagName(e)
												: t.querySelectorAll(e)
									  }),
									  (t.find.CLASS = function (e, t) {
											if (void 0 !== t.getElementsByClassName && d)
												return t.getElementsByClassName(e)
									  }),
									  (p = []),
									  ne(function (e) {
											var t
											;(u.appendChild(e).innerHTML =
												"<a id='" +
												g +
												"' href='' disabled='disabled'></a><select id='" +
												g +
												"-\r\\' disabled='disabled'><option selected=''></option></select>"),
												e.querySelectorAll('[selected]').length ||
													p.push('\\[' + A + '*(?:value|' + k + ')'),
												e.querySelectorAll('[id~=' + g + '-]')
													.length || p.push('~='),
												e.querySelectorAll('a#' + g + '+*').length ||
													p.push('.#.+[+~]'),
												e.querySelectorAll(':checked').length ||
													p.push(':checked'),
												(t = l.createElement('input')).setAttribute(
													'type',
													'hidden'
												),
												e.appendChild(t).setAttribute('name', 'D'),
												(u.appendChild(e).disabled = !0),
												2 !==
													e.querySelectorAll(':disabled').length &&
													p.push(':enabled', ':disabled'),
												(t = l.createElement('input')).setAttribute(
													'name',
													''
												),
												e.appendChild(t),
												e.querySelectorAll("[name='']").length ||
													p.push(
														'\\[' +
															A +
															'*name' +
															A +
															'*=' +
															A +
															'*(?:\'\'|"")'
													)
									  }),
									  m.cssHas || p.push(':has'),
									  (p = p.length && new RegExp(p.join('|'))),
									  (C = function (e, t) {
											if (e === t) return (s = !0), 0
											var n =
												!e.compareDocumentPosition -
												!t.compareDocumentPosition
											return (
												n ||
												(1 &
													(n =
														(e.ownerDocument || e) ==
														(t.ownerDocument || t)
															? e.compareDocumentPosition(t)
															: 1) ||
												(!m.sortDetached &&
													t.compareDocumentPosition(e) === n)
													? e === l ||
													  (e.ownerDocument == D && Z.contains(D, e))
														? -1
														: t === l ||
														  (t.ownerDocument == D &&
																Z.contains(D, t))
														? 1
														: i
														? c.call(i, e) - c.call(i, t)
														: 0
													: 4 & n
													? -1
													: 1)
											)
									  }),
									  l)
									: l
							}
							for (e in ((Z.matches = function (e, t) {
								return Z(e, null, null, t)
							}),
							(Z.matchesSelector = function (e, t) {
								if ((le(e), d && !T[t + ' '] && (!p || !p.test(t))))
									try {
										var n = h.call(e, t)
										if (
											n ||
											m.disconnectedMatch ||
											(e.document && 11 !== e.document.nodeType)
										)
											return n
									} catch (e) {
										T(t, !0)
									}
								return Z(t, l, null, [e]).length > 0
							}),
							(Z.contains = function (e, t) {
								return (
									(e.ownerDocument || e) != l && le(e),
									E.contains(e, t)
								)
							}),
							(Z.attr = function (e, n) {
								;(e.ownerDocument || e) != l && le(e)
								var r = t.attrHandle[n.toLowerCase()],
									i =
										r && f.call(t.attrHandle, n.toLowerCase())
											? r(e, n, !d)
											: void 0
								return void 0 !== i ? i : e.getAttribute(n)
							}),
							(Z.error = function (e) {
								throw new Error(
									'Syntax error, unrecognized expression: ' + e
								)
							}),
							(E.uniqueSort = function (e) {
								var t,
									n = [],
									r = 0,
									o = 0
								if (
									((s = !m.sortStable),
									(i = !m.sortStable && a.call(e, 0)),
									P.call(e, C),
									s)
								) {
									for (; (t = e[o++]); ) t === e[o] && (r = n.push(o))
									for (; r--; ) L.call(e, n[r], 1)
								}
								return (i = null), e
							}),
							(E.fn.uniqueSort = function () {
								return this.pushStack(E.uniqueSort(a.apply(this)))
							}),
							(t = E.expr =
								{
									cacheLength: 50,
									createPseudo: te,
									match: W,
									attrHandle: {},
									find: {},
									relative: {
										'>': { dir: 'parentNode', first: !0 },
										' ': { dir: 'parentNode' },
										'+': { dir: 'previousSibling', first: !0 },
										'~': { dir: 'previousSibling' }
									},
									preFilter: {
										ATTR: function (e) {
											return (
												(e[1] = e[1].replace(Y, K)),
												(e[3] = (e[3] || e[4] || e[5] || '').replace(
													Y,
													K
												)),
												'~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
												e.slice(0, 4)
											)
										},
										CHILD: function (e) {
											return (
												(e[1] = e[1].toLowerCase()),
												'nth' === e[1].slice(0, 3)
													? (e[3] || Z.error(e[0]),
													  (e[4] = +(e[4]
															? e[5] + (e[6] || 1)
															: 2 *
															  ('even' === e[3] || 'odd' === e[3]))),
													  (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
													: e[3] && Z.error(e[0]),
												e
											)
										},
										PSEUDO: function (e) {
											var t,
												n = !e[6] && e[2]
											return W.CHILD.test(e[0])
												? null
												: (e[3]
														? (e[2] = e[4] || e[5] || '')
														: n &&
														  R.test(n) &&
														  (t = ce(n, !0)) &&
														  (t =
																n.indexOf(')', n.length - t) -
																n.length) &&
														  ((e[0] = e[0].slice(0, t)),
														  (e[2] = n.slice(0, t))),
												  e.slice(0, 3))
										}
									},
									filter: {
										TAG: function (e) {
											var t = e.replace(Y, K).toLowerCase()
											return '*' === e
												? function () {
														return !0
												  }
												: function (e) {
														return S(e, t)
												  }
										},
										CLASS: function (e) {
											var t = b[e + ' ']
											return (
												t ||
												((t = new RegExp(
													'(^|' + A + ')' + e + '(' + A + '|$)'
												)) &&
													b(e, function (e) {
														return t.test(
															('string' == typeof e.className &&
																e.className) ||
																(void 0 !== e.getAttribute &&
																	e.getAttribute('class')) ||
																''
														)
													}))
											)
										},
										ATTR: function (e, t, n) {
											return function (r) {
												var i = Z.attr(r, e)
												return null == i
													? '!=' === t
													: !t ||
															((i += ''),
															'=' === t
																? i === n
																: '!=' === t
																? i !== n
																: '^=' === t
																? n && 0 === i.indexOf(n)
																: '*=' === t
																? n && i.indexOf(n) > -1
																: '$=' === t
																? n && i.slice(-n.length) === n
																: '~=' === t
																? (
																		' ' +
																		i.replace(q, ' ') +
																		' '
																  ).indexOf(n) > -1
																: '|=' === t &&
																  (i === n ||
																		i.slice(0, n.length + 1) ===
																			n + '-'))
											}
										},
										CHILD: function (e, t, n, r, i) {
											var o = 'nth' !== e.slice(0, 3),
												s = 'last' !== e.slice(-4),
												a = 'of-type' === t
											return 1 === r && 0 === i
												? function (e) {
														return !!e.parentNode
												  }
												: function (t, n, l) {
														var u,
															c,
															d,
															p,
															f,
															h =
																o !== s
																	? 'nextSibling'
																	: 'previousSibling',
															v = t.parentNode,
															m = a && t.nodeName.toLowerCase(),
															_ = !l && !a,
															b = !1
														if (v) {
															if (o) {
																for (; h; ) {
																	for (d = t; (d = d[h]); )
																		if (
																			a ? S(d, m) : 1 === d.nodeType
																		)
																			return !1
																	f = h =
																		'only' === e &&
																		!f &&
																		'nextSibling'
																}
																return !0
															}
															if (
																((f = [
																	s ? v.firstChild : v.lastChild
																]),
																s && _)
															) {
																for (
																	b =
																		(p =
																			(u =
																				(c = v[g] || (v[g] = {}))[
																					e
																				] || [])[0] === y && u[1]) &&
																		u[2],
																		d = p && v.childNodes[p];
																	(d =
																		(++p && d && d[h]) ||
																		(b = p = 0) ||
																		f.pop());

																)
																	if (
																		1 === d.nodeType &&
																		++b &&
																		d === t
																	) {
																		c[e] = [y, p, b]
																		break
																	}
															} else if (
																(_ &&
																	(b = p =
																		(u =
																			(c = t[g] || (t[g] = {}))[e] ||
																			[])[0] === y && u[1]),
																!1 === b)
															)
																for (
																	;
																	(d =
																		(++p && d && d[h]) ||
																		(b = p = 0) ||
																		f.pop()) &&
																	(!(a
																		? S(d, m)
																		: 1 === d.nodeType) ||
																		!++b ||
																		(_ &&
																			((c = d[g] || (d[g] = {}))[e] =
																				[y, b]),
																		d !== t));

																);
															return (
																(b -= i) === r ||
																(b % r == 0 && b / r >= 0)
															)
														}
												  }
										},
										PSEUDO: function (e, n) {
											var r,
												i =
													t.pseudos[e] ||
													t.setFilters[e.toLowerCase()] ||
													Z.error('unsupported pseudo: ' + e)
											return i[g]
												? i(n)
												: i.length > 1
												? ((r = [e, e, '', n]),
												  t.setFilters.hasOwnProperty(e.toLowerCase())
														? te(function (e, t) {
																for (
																	var r, o = i(e, n), s = o.length;
																	s--;

																)
																	e[(r = c.call(e, o[s]))] = !(t[r] =
																		o[s])
														  })
														: function (e) {
																return i(e, 0, r)
														  })
												: i
										}
									},
									pseudos: {
										not: te(function (e) {
											var t = [],
												n = [],
												r = ge(e.replace(O, '$1'))
											return r[g]
												? te(function (e, t, n, i) {
														for (
															var o,
																s = r(e, null, i, []),
																a = e.length;
															a--;

														)
															(o = s[a]) && (e[a] = !(t[a] = o))
												  })
												: function (e, i, o) {
														return (
															(t[0] = e),
															r(t, null, o, n),
															(t[0] = null),
															!n.pop()
														)
												  }
										}),
										has: te(function (e) {
											return function (t) {
												return Z(e, t).length > 0
											}
										}),
										contains: te(function (e) {
											return (
												(e = e.replace(Y, K)),
												function (t) {
													return (
														(t.textContent || E.text(t)).indexOf(e) >
														-1
													)
												}
											)
										}),
										lang: te(function (e) {
											return (
												z.test(e || '') ||
													Z.error('unsupported lang: ' + e),
												(e = e.replace(Y, K).toLowerCase()),
												function (t) {
													var n
													do {
														if (
															(n = d
																? t.lang
																: t.getAttribute('xml:lang') ||
																  t.getAttribute('lang'))
														)
															return (
																(n = n.toLowerCase()) === e ||
																0 === n.indexOf(e + '-')
															)
													} while (
														(t = t.parentNode) &&
														1 === t.nodeType
													)
													return !1
												}
											)
										}),
										target: function (e) {
											var t = r.location && r.location.hash
											return t && t.slice(1) === e.id
										},
										root: function (e) {
											return e === u
										},
										focus: function (e) {
											return (
												e ===
													(function () {
														try {
															return l.activeElement
														} catch (e) {}
													})() &&
												l.hasFocus() &&
												!!(e.type || e.href || ~e.tabIndex)
											)
										},
										enabled: oe(!1),
										disabled: oe(!0),
										checked: function (e) {
											return (
												(S(e, 'input') && !!e.checked) ||
												(S(e, 'option') && !!e.selected)
											)
										},
										selected: function (e) {
											return (
												e.parentNode && e.parentNode.selectedIndex,
												!0 === e.selected
											)
										},
										empty: function (e) {
											for (e = e.firstChild; e; e = e.nextSibling)
												if (e.nodeType < 6) return !1
											return !0
										},
										parent: function (e) {
											return !t.pseudos.empty(e)
										},
										header: function (e) {
											return G.test(e.nodeName)
										},
										input: function (e) {
											return V.test(e.nodeName)
										},
										button: function (e) {
											return (
												(S(e, 'input') && 'button' === e.type) ||
												S(e, 'button')
											)
										},
										text: function (e) {
											var t
											return (
												S(e, 'input') &&
												'text' === e.type &&
												(null == (t = e.getAttribute('type')) ||
													'text' === t.toLowerCase())
											)
										},
										first: se(function () {
											return [0]
										}),
										last: se(function (e, t) {
											return [t - 1]
										}),
										eq: se(function (e, t, n) {
											return [n < 0 ? n + t : n]
										}),
										even: se(function (e, t) {
											for (var n = 0; n < t; n += 2) e.push(n)
											return e
										}),
										odd: se(function (e, t) {
											for (var n = 1; n < t; n += 2) e.push(n)
											return e
										}),
										lt: se(function (e, t, n) {
											var r
											for (
												r = n < 0 ? n + t : n > t ? t : n;
												--r >= 0;

											)
												e.push(r)
											return e
										}),
										gt: se(function (e, t, n) {
											for (var r = n < 0 ? n + t : n; ++r < t; )
												e.push(r)
											return e
										})
									}
								}),
							(t.pseudos.nth = t.pseudos.eq),
							{
								radio: !0,
								checkbox: !0,
								file: !0,
								password: !0,
								image: !0
							}))
								t.pseudos[e] = re(e)
							for (e in { submit: !0, reset: !0 })
								t.pseudos[e] = ie(e)
							function ue() {}
							function ce(e, n) {
								var r,
									i,
									o,
									s,
									a,
									l,
									u,
									c = w[e + ' ']
								if (c) return n ? 0 : c.slice(0)
								for (a = e, l = [], u = t.preFilter; a; ) {
									for (s in ((r && !(i = H.exec(a))) ||
										(i && (a = a.slice(i[0].length) || a),
										l.push((o = []))),
									(r = !1),
									(i = B.exec(a)) &&
										((r = i.shift()),
										o.push({ value: r, type: i[0].replace(O, ' ') }),
										(a = a.slice(r.length))),
									t.filter))
										!(i = W[s].exec(a)) ||
											(u[s] && !(i = u[s](i))) ||
											((r = i.shift()),
											o.push({ value: r, type: s, matches: i }),
											(a = a.slice(r.length)))
									if (!r) break
								}
								return n
									? a.length
									: a
									? Z.error(e)
									: w(e, l).slice(0)
							}
							function de(e) {
								for (var t = 0, n = e.length, r = ''; t < n; t++)
									r += e[t].value
								return r
							}
							function pe(e, t, n) {
								var r = t.dir,
									i = t.next,
									o = i || r,
									s = n && 'parentNode' === o,
									a = _++
								return t.first
									? function (t, n, i) {
											for (; (t = t[r]); )
												if (1 === t.nodeType || s) return e(t, n, i)
											return !1
									  }
									: function (t, n, l) {
											var u,
												c,
												d = [y, a]
											if (l) {
												for (; (t = t[r]); )
													if ((1 === t.nodeType || s) && e(t, n, l))
														return !0
											} else
												for (; (t = t[r]); )
													if (1 === t.nodeType || s)
														if (
															((c = t[g] || (t[g] = {})),
															i && S(t, i))
														)
															t = t[r] || t
														else {
															if (
																(u = c[o]) &&
																u[0] === y &&
																u[1] === a
															)
																return (d[2] = u[2])
															if (((c[o] = d), (d[2] = e(t, n, l))))
																return !0
														}
											return !1
									  }
							}
							function fe(e) {
								return e.length > 1
									? function (t, n, r) {
											for (var i = e.length; i--; )
												if (!e[i](t, n, r)) return !1
											return !0
									  }
									: e[0]
							}
							function he(e, t, n, r, i) {
								for (
									var o, s = [], a = 0, l = e.length, u = null != t;
									a < l;
									a++
								)
									(o = e[a]) &&
										((n && !n(o, r, i)) ||
											(s.push(o), u && t.push(a)))
								return s
							}
							function ve(e, t, n, r, i, o) {
								return (
									r && !r[g] && (r = ve(r)),
									i && !i[g] && (i = ve(i, o)),
									te(function (o, s, a, l) {
										var u,
											d,
											p,
											f,
											h = [],
											m = [],
											g = s.length,
											y =
												o ||
												(function (e, t, n) {
													for (var r = 0, i = t.length; r < i; r++)
														Z(e, t[r], n)
													return n
												})(t || '*', a.nodeType ? [a] : a, []),
											_ = !e || (!o && t) ? y : he(y, h, e, a, l)
										if (
											(n
												? n(
														_,
														(f = i || (o ? e : g || r) ? [] : s),
														a,
														l
												  )
												: (f = _),
											r)
										)
											for (
												u = he(f, m), r(u, [], a, l), d = u.length;
												d--;

											)
												(p = u[d]) && (f[m[d]] = !(_[m[d]] = p))
										if (o) {
											if (i || e) {
												if (i) {
													for (u = [], d = f.length; d--; )
														(p = f[d]) && u.push((_[d] = p))
													i(null, (f = []), u, l)
												}
												for (d = f.length; d--; )
													(p = f[d]) &&
														(u = i ? c.call(o, p) : h[d]) > -1 &&
														(o[u] = !(s[u] = p))
											}
										} else (f = he(f === s ? f.splice(g, f.length) : f)), i ? i(null, s, f, l) : v.apply(s, f)
									})
								)
							}
							function me(e) {
								for (
									var r,
										i,
										o,
										s = e.length,
										a = t.relative[e[0].type],
										l = a || t.relative[' '],
										u = a ? 1 : 0,
										d = pe(
											function (e) {
												return e === r
											},
											l,
											!0
										),
										p = pe(
											function (e) {
												return c.call(r, e) > -1
											},
											l,
											!0
										),
										f = [
											function (e, t, i) {
												var o =
													(!a && (i || t != n)) ||
													((r = t).nodeType ? d(e, t, i) : p(e, t, i))
												return (r = null), o
											}
										];
									u < s;
									u++
								)
									if ((i = t.relative[e[u].type])) f = [pe(fe(f), i)]
									else {
										if (
											(i = t.filter[e[u].type].apply(
												null,
												e[u].matches
											))[g]
										) {
											for (
												o = ++u;
												o < s && !t.relative[e[o].type];
												o++
											);
											return ve(
												u > 1 && fe(f),
												u > 1 &&
													de(
														e
															.slice(0, u - 1)
															.concat({
																value:
																	' ' === e[u - 2].type ? '*' : ''
															})
													).replace(O, '$1'),
												i,
												u < o && me(e.slice(u, o)),
												o < s && me((e = e.slice(o))),
												o < s && de(e)
											)
										}
										f.push(i)
									}
								return fe(f)
							}
							function ge(e, r) {
								var i,
									o = [],
									s = [],
									a = x[e + ' ']
								if (!a) {
									for (r || (r = ce(e)), i = r.length; i--; )
										(a = me(r[i]))[g] ? o.push(a) : s.push(a)
									;(a = x(
										e,
										(function (e, r) {
											var i = r.length > 0,
												o = e.length > 0,
												s = function (s, a, u, c, p) {
													var f,
														h,
														m,
														g = 0,
														_ = '0',
														b = s && [],
														w = [],
														x = n,
														T = s || (o && t.find.TAG('*', p)),
														C = (y +=
															null == x ? 1 : Math.random() || 0.1),
														k = T.length
													for (
														p && (n = a == l || a || p);
														_ !== k && null != (f = T[_]);
														_++
													) {
														if (o && f) {
															for (
																h = 0,
																	a ||
																		f.ownerDocument == l ||
																		(le(f), (u = !d));
																(m = e[h++]);

															)
																if (m(f, a || l, u)) {
																	v.call(c, f)
																	break
																}
															p && (y = C)
														}
														i &&
															((f = !m && f) && g--, s && b.push(f))
													}
													if (((g += _), i && _ !== g)) {
														for (h = 0; (m = r[h++]); ) m(b, w, a, u)
														if (s) {
															if (g > 0)
																for (; _--; )
																	b[_] || w[_] || (w[_] = M.call(c))
															w = he(w)
														}
														v.apply(c, w),
															p &&
																!s &&
																w.length > 0 &&
																g + r.length > 1 &&
																E.uniqueSort(c)
													}
													return p && ((y = C), (n = x)), b
												}
											return i ? te(s) : s
										})(s, o)
									)),
										(a.selector = e)
								}
								return a
							}
							function ye(e, n, r, i) {
								var o,
									s,
									a,
									l,
									u,
									c = 'function' == typeof e && e,
									p = !i && ce((e = c.selector || e))
								if (((r = r || []), 1 === p.length)) {
									if (
										(s = p[0] = p[0].slice(0)).length > 2 &&
										'ID' === (a = s[0]).type &&
										9 === n.nodeType &&
										d &&
										t.relative[s[1].type]
									) {
										if (
											!(n = (t.find.ID(
												a.matches[0].replace(Y, K),
												n
											) || [])[0])
										)
											return r
										c && (n = n.parentNode),
											(e = e.slice(s.shift().value.length))
									}
									for (
										o = W.needsContext.test(e) ? 0 : s.length;
										o-- && ((a = s[o]), !t.relative[(l = a.type)]);

									)
										if (
											(u = t.find[l]) &&
											(i = u(
												a.matches[0].replace(Y, K),
												(X.test(s[0].type) && ae(n.parentNode)) || n
											))
										) {
											if ((s.splice(o, 1), !(e = i.length && de(s))))
												return v.apply(r, i), r
											break
										}
								}
								return (
									(c || ge(e, p))(
										i,
										n,
										!d,
										r,
										!n || (X.test(e) && ae(n.parentNode)) || n
									),
									r
								)
							}
							;(ue.prototype = t.filters = t.pseudos),
								(t.setFilters = new ue()),
								(m.sortStable = g.split('').sort(C).join('') === g),
								le(),
								(m.sortDetached = ne(function (e) {
									return (
										1 &
										e.compareDocumentPosition(
											l.createElement('fieldset')
										)
									)
								})),
								(E.find = Z),
								(E.expr[':'] = E.expr.pseudos),
								(E.unique = E.uniqueSort),
								(Z.compile = ge),
								(Z.select = ye),
								(Z.setDocument = le),
								(Z.tokenize = ce),
								(Z.escape = E.escapeSelector),
								(Z.getText = E.text),
								(Z.isXML = E.isXMLDoc),
								(Z.selectors = E.expr),
								(Z.support = E.support),
								(Z.uniqueSort = E.uniqueSort)
						})()
						var I = function (e, t, n) {
								for (
									var r = [], i = void 0 !== n;
									(e = e[t]) && 9 !== e.nodeType;

								)
									if (1 === e.nodeType) {
										if (i && E(e).is(n)) break
										r.push(e)
									}
								return r
							},
							q = function (e, t) {
								for (var n = []; e; e = e.nextSibling)
									1 === e.nodeType && e !== t && n.push(e)
								return n
							},
							H = E.expr.match.needsContext,
							B =
								/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i
						function F(e, t, n) {
							return g(t)
								? E.grep(e, function (e, r) {
										return !!t.call(e, r, e) !== n
								  })
								: t.nodeType
								? E.grep(e, function (e) {
										return (e === t) !== n
								  })
								: 'string' != typeof t
								? E.grep(e, function (e) {
										return c.call(t, e) > -1 !== n
								  })
								: E.filter(t, e, n)
						}
						;(E.filter = function (e, t, n) {
							var r = t[0]
							return (
								n && (e = ':not(' + e + ')'),
								1 === t.length && 1 === r.nodeType
									? E.find.matchesSelector(r, e)
										? [r]
										: []
									: E.find.matches(
											e,
											E.grep(t, function (e) {
												return 1 === e.nodeType
											})
									  )
							)
						}),
							E.fn.extend({
								find: function (e) {
									var t,
										n,
										r = this.length,
										i = this
									if ('string' != typeof e)
										return this.pushStack(
											E(e).filter(function () {
												for (t = 0; t < r; t++)
													if (E.contains(i[t], this)) return !0
											})
										)
									for (n = this.pushStack([]), t = 0; t < r; t++)
										E.find(e, i[t], n)
									return r > 1 ? E.uniqueSort(n) : n
								},
								filter: function (e) {
									return this.pushStack(F(this, e || [], !1))
								},
								not: function (e) {
									return this.pushStack(F(this, e || [], !0))
								},
								is: function (e) {
									return !!F(
										this,
										'string' == typeof e && H.test(e)
											? E(e)
											: e || [],
										!1
									).length
								}
							})
						var R,
							z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/
						;((E.fn.init = function (e, t, n) {
							var r, i
							if (!e) return this
							if (((n = n || R), 'string' == typeof e)) {
								if (
									!(r =
										'<' === e[0] &&
										'>' === e[e.length - 1] &&
										e.length >= 3
											? [null, e, null]
											: z.exec(e)) ||
									(!r[1] && t)
								)
									return !t || t.jquery
										? (t || n).find(e)
										: this.constructor(t).find(e)
								if (r[1]) {
									if (
										((t = t instanceof E ? t[0] : t),
										E.merge(
											this,
											E.parseHTML(
												r[1],
												t && t.nodeType ? t.ownerDocument || t : _,
												!0
											)
										),
										B.test(r[1]) && E.isPlainObject(t))
									)
										for (r in t)
											g(this[r]) ? this[r](t[r]) : this.attr(r, t[r])
									return this
								}
								return (
									(i = _.getElementById(r[2])) &&
										((this[0] = i), (this.length = 1)),
									this
								)
							}
							return e.nodeType
								? ((this[0] = e), (this.length = 1), this)
								: g(e)
								? void 0 !== n.ready
									? n.ready(e)
									: e(E)
								: E.makeArray(e, this)
						}).prototype = E.fn),
							(R = E(_))
						var W = /^(?:parents|prev(?:Until|All))/,
							V = { children: !0, contents: !0, next: !0, prev: !0 }
						function G(e, t) {
							for (; (e = e[t]) && 1 !== e.nodeType; );
							return e
						}
						E.fn.extend({
							has: function (e) {
								var t = E(e, this),
									n = t.length
								return this.filter(function () {
									for (var e = 0; e < n; e++)
										if (E.contains(this, t[e])) return !0
								})
							},
							closest: function (e, t) {
								var n,
									r = 0,
									i = this.length,
									o = [],
									s = 'string' != typeof e && E(e)
								if (!H.test(e))
									for (; r < i; r++)
										for (n = this[r]; n && n !== t; n = n.parentNode)
											if (
												n.nodeType < 11 &&
												(s
													? s.index(n) > -1
													: 1 === n.nodeType &&
													  E.find.matchesSelector(n, e))
											) {
												o.push(n)
												break
											}
								return this.pushStack(
									o.length > 1 ? E.uniqueSort(o) : o
								)
							},
							index: function (e) {
								return e
									? 'string' == typeof e
										? c.call(E(e), this[0])
										: c.call(this, e.jquery ? e[0] : e)
									: this[0] && this[0].parentNode
									? this.first().prevAll().length
									: -1
							},
							add: function (e, t) {
								return this.pushStack(
									E.uniqueSort(E.merge(this.get(), E(e, t)))
								)
							},
							addBack: function (e) {
								return this.add(
									null == e
										? this.prevObject
										: this.prevObject.filter(e)
								)
							}
						}),
							E.each(
								{
									parent: function (e) {
										var t = e.parentNode
										return t && 11 !== t.nodeType ? t : null
									},
									parents: function (e) {
										return I(e, 'parentNode')
									},
									parentsUntil: function (e, t, n) {
										return I(e, 'parentNode', n)
									},
									next: function (e) {
										return G(e, 'nextSibling')
									},
									prev: function (e) {
										return G(e, 'previousSibling')
									},
									nextAll: function (e) {
										return I(e, 'nextSibling')
									},
									prevAll: function (e) {
										return I(e, 'previousSibling')
									},
									nextUntil: function (e, t, n) {
										return I(e, 'nextSibling', n)
									},
									prevUntil: function (e, t, n) {
										return I(e, 'previousSibling', n)
									},
									siblings: function (e) {
										return q((e.parentNode || {}).firstChild, e)
									},
									children: function (e) {
										return q(e.firstChild)
									},
									contents: function (e) {
										return null != e.contentDocument &&
											s(e.contentDocument)
											? e.contentDocument
											: (S(e, 'template') && (e = e.content || e),
											  E.merge([], e.childNodes))
									}
								},
								function (e, t) {
									E.fn[e] = function (n, r) {
										var i = E.map(this, t, n)
										return (
											'Until' !== e.slice(-5) && (r = n),
											r &&
												'string' == typeof r &&
												(i = E.filter(r, i)),
											this.length > 1 &&
												(V[e] || E.uniqueSort(i),
												W.test(e) && i.reverse()),
											this.pushStack(i)
										)
									}
								}
							)
						var U = /[^\x20\t\r\n\f]+/g
						function X(e) {
							return e
						}
						function Y(e) {
							throw e
						}
						function K(e, t, n, r) {
							var i
							try {
								e && g((i = e.promise))
									? i.call(e).done(t).fail(n)
									: e && g((i = e.then))
									? i.call(e, t, n)
									: t.apply(void 0, [e].slice(r))
							} catch (e) {
								n.apply(void 0, [e])
							}
						}
						;(E.Callbacks = function (e) {
							e =
								'string' == typeof e
									? (function (e) {
											var t = {}
											return (
												E.each(e.match(U) || [], function (e, n) {
													t[n] = !0
												}),
												t
											)
									  })(e)
									: E.extend({}, e)
							var t,
								n,
								r,
								i,
								o = [],
								s = [],
								a = -1,
								l = function () {
									for (i = i || e.once, r = t = !0; s.length; a = -1)
										for (n = s.shift(); ++a < o.length; )
											!1 === o[a].apply(n[0], n[1]) &&
												e.stopOnFalse &&
												((a = o.length), (n = !1))
									e.memory || (n = !1),
										(t = !1),
										i && (o = n ? [] : '')
								},
								u = {
									add: function () {
										return (
											o &&
												(n && !t && ((a = o.length - 1), s.push(n)),
												(function t(n) {
													E.each(n, function (n, r) {
														g(r)
															? (e.unique && u.has(r)) || o.push(r)
															: r &&
															  r.length &&
															  'string' !== x(r) &&
															  t(r)
													})
												})(arguments),
												n && !t && l()),
											this
										)
									},
									remove: function () {
										return (
											E.each(arguments, function (e, t) {
												for (var n; (n = E.inArray(t, o, n)) > -1; )
													o.splice(n, 1), n <= a && a--
											}),
											this
										)
									},
									has: function (e) {
										return e ? E.inArray(e, o) > -1 : o.length > 0
									},
									empty: function () {
										return o && (o = []), this
									},
									disable: function () {
										return (i = s = []), (o = n = ''), this
									},
									disabled: function () {
										return !o
									},
									lock: function () {
										return (i = s = []), n || t || (o = n = ''), this
									},
									locked: function () {
										return !!i
									},
									fireWith: function (e, n) {
										return (
											i ||
												((n = [
													e,
													(n = n || []).slice ? n.slice() : n
												]),
												s.push(n),
												t || l()),
											this
										)
									},
									fire: function () {
										return u.fireWith(this, arguments), this
									},
									fired: function () {
										return !!r
									}
								}
							return u
						}),
							E.extend({
								Deferred: function (e) {
									var t = [
											[
												'notify',
												'progress',
												E.Callbacks('memory'),
												E.Callbacks('memory'),
												2
											],
											[
												'resolve',
												'done',
												E.Callbacks('once memory'),
												E.Callbacks('once memory'),
												0,
												'resolved'
											],
											[
												'reject',
												'fail',
												E.Callbacks('once memory'),
												E.Callbacks('once memory'),
												1,
												'rejected'
											]
										],
										n = 'pending',
										i = {
											state: function () {
												return n
											},
											always: function () {
												return o.done(arguments).fail(arguments), this
											},
											catch: function (e) {
												return i.then(null, e)
											},
											pipe: function () {
												var e = arguments
												return E.Deferred(function (n) {
													E.each(t, function (t, r) {
														var i = g(e[r[4]]) && e[r[4]]
														o[r[1]](function () {
															var e = i && i.apply(this, arguments)
															e && g(e.promise)
																? e
																		.promise()
																		.progress(n.notify)
																		.done(n.resolve)
																		.fail(n.reject)
																: n[r[0] + 'With'](
																		this,
																		i ? [e] : arguments
																  )
														})
													}),
														(e = null)
												}).promise()
											},
											then: function (e, n, i) {
												var o = 0
												function s(e, t, n, i) {
													return function () {
														var a = this,
															l = arguments,
															u = function () {
																var r, u
																if (!(e < o)) {
																	if (
																		(r = n.apply(a, l)) ===
																		t.promise()
																	)
																		throw new TypeError(
																			'Thenable self-resolution'
																		)
																	;(u =
																		r &&
																		('object' == typeof r ||
																			'function' == typeof r) &&
																		r.then),
																		g(u)
																			? i
																				? u.call(
																						r,
																						s(o, t, X, i),
																						s(o, t, Y, i)
																				  )
																				: (o++,
																				  u.call(
																						r,
																						s(o, t, X, i),
																						s(o, t, Y, i),
																						s(o, t, X, t.notifyWith)
																				  ))
																			: (n !== X &&
																					((a = void 0), (l = [r])),
																			  (i || t.resolveWith)(a, l))
																}
															},
															c = i
																? u
																: function () {
																		try {
																			u()
																		} catch (r) {
																			E.Deferred.exceptionHook &&
																				E.Deferred.exceptionHook(
																					r,
																					c.error
																				),
																				e + 1 >= o &&
																					(n !== Y &&
																						((a = void 0), (l = [r])),
																					t.rejectWith(a, l))
																		}
																  }
														e
															? c()
															: (E.Deferred.getErrorHook
																	? (c.error =
																			E.Deferred.getErrorHook())
																	: E.Deferred.getStackHook &&
																	  (c.error =
																			E.Deferred.getStackHook()),
															  r.setTimeout(c))
													}
												}
												return E.Deferred(function (r) {
													t[0][3].add(
														s(0, r, g(i) ? i : X, r.notifyWith)
													),
														t[1][3].add(s(0, r, g(e) ? e : X)),
														t[2][3].add(s(0, r, g(n) ? n : Y))
												}).promise()
											},
											promise: function (e) {
												return null != e ? E.extend(e, i) : i
											}
										},
										o = {}
									return (
										E.each(t, function (e, r) {
											var s = r[2],
												a = r[5]
											;(i[r[1]] = s.add),
												a &&
													s.add(
														function () {
															n = a
														},
														t[3 - e][2].disable,
														t[3 - e][3].disable,
														t[0][2].lock,
														t[0][3].lock
													),
												s.add(r[3].fire),
												(o[r[0]] = function () {
													return (
														o[r[0] + 'With'](
															this === o ? void 0 : this,
															arguments
														),
														this
													)
												}),
												(o[r[0] + 'With'] = s.fireWith)
										}),
										i.promise(o),
										e && e.call(o, o),
										o
									)
								},
								when: function (e) {
									var t = arguments.length,
										n = t,
										r = Array(n),
										i = a.call(arguments),
										o = E.Deferred(),
										s = function (e) {
											return function (n) {
												;(r[e] = this),
													(i[e] =
														arguments.length > 1
															? a.call(arguments)
															: n),
													--t || o.resolveWith(r, i)
											}
										}
									if (
										t <= 1 &&
										(K(e, o.done(s(n)).resolve, o.reject, !t),
										'pending' === o.state() || g(i[n] && i[n].then))
									)
										return o.then()
									for (; n--; ) K(i[n], s(n), o.reject)
									return o.promise()
								}
							})
						var Q =
							/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/
						;(E.Deferred.exceptionHook = function (e, t) {
							r.console &&
								r.console.warn &&
								e &&
								Q.test(e.name) &&
								r.console.warn(
									'jQuery.Deferred exception: ' + e.message,
									e.stack,
									t
								)
						}),
							(E.readyException = function (e) {
								r.setTimeout(function () {
									throw e
								})
							})
						var J = E.Deferred()
						function Z() {
							_.removeEventListener('DOMContentLoaded', Z),
								r.removeEventListener('load', Z),
								E.ready()
						}
						;(E.fn.ready = function (e) {
							return (
								J.then(e).catch(function (e) {
									E.readyException(e)
								}),
								this
							)
						}),
							E.extend({
								isReady: !1,
								readyWait: 1,
								ready: function (e) {
									;(!0 === e ? --E.readyWait : E.isReady) ||
										((E.isReady = !0),
										(!0 !== e && --E.readyWait > 0) ||
											J.resolveWith(_, [E]))
								}
							}),
							(E.ready.then = J.then),
							'complete' === _.readyState ||
							('loading' !== _.readyState &&
								!_.documentElement.doScroll)
								? r.setTimeout(E.ready)
								: (_.addEventListener('DOMContentLoaded', Z),
								  r.addEventListener('load', Z))
						var ee = function (e, t, n, r, i, o, s) {
								var a = 0,
									l = e.length,
									u = null == n
								if ('object' === x(n))
									for (a in ((i = !0), n)) ee(e, t, a, n[a], !0, o, s)
								else if (
									void 0 !== r &&
									((i = !0),
									g(r) || (s = !0),
									u &&
										(s
											? (t.call(e, r), (t = null))
											: ((u = t),
											  (t = function (e, t, n) {
													return u.call(E(e), n)
											  }))),
									t)
								)
									for (; a < l; a++)
										t(e[a], n, s ? r : r.call(e[a], a, t(e[a], n)))
								return i ? e : u ? t.call(e) : l ? t(e[0], n) : o
							},
							te = /^-ms-/,
							ne = /-([a-z])/g
						function re(e, t) {
							return t.toUpperCase()
						}
						function ie(e) {
							return e.replace(te, 'ms-').replace(ne, re)
						}
						var oe = function (e) {
							return (
								1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
							)
						}
						function se() {
							this.expando = E.expando + se.uid++
						}
						;(se.uid = 1),
							(se.prototype = {
								cache: function (e) {
									var t = e[this.expando]
									return (
										t ||
											((t = {}),
											oe(e) &&
												(e.nodeType
													? (e[this.expando] = t)
													: Object.defineProperty(e, this.expando, {
															value: t,
															configurable: !0
													  }))),
										t
									)
								},
								set: function (e, t, n) {
									var r,
										i = this.cache(e)
									if ('string' == typeof t) i[ie(t)] = n
									else for (r in t) i[ie(r)] = t[r]
									return i
								},
								get: function (e, t) {
									return void 0 === t
										? this.cache(e)
										: e[this.expando] && e[this.expando][ie(t)]
								},
								access: function (e, t, n) {
									return void 0 === t ||
										(t && 'string' == typeof t && void 0 === n)
										? this.get(e, t)
										: (this.set(e, t, n), void 0 !== n ? n : t)
								},
								remove: function (e, t) {
									var n,
										r = e[this.expando]
									if (void 0 !== r) {
										if (void 0 !== t) {
											n = (t = Array.isArray(t)
												? t.map(ie)
												: (t = ie(t)) in r
												? [t]
												: t.match(U) || []).length
											for (; n--; ) delete r[t[n]]
										}
										;(void 0 === t || E.isEmptyObject(r)) &&
											(e.nodeType
												? (e[this.expando] = void 0)
												: delete e[this.expando])
									}
								},
								hasData: function (e) {
									var t = e[this.expando]
									return void 0 !== t && !E.isEmptyObject(t)
								}
							})
						var ae = new se(),
							le = new se(),
							ue = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
							ce = /[A-Z]/g
						function de(e, t, n) {
							var r
							if (void 0 === n && 1 === e.nodeType)
								if (
									((r = 'data-' + t.replace(ce, '-$&').toLowerCase()),
									'string' == typeof (n = e.getAttribute(r)))
								) {
									try {
										n = (function (e) {
											return (
												'true' === e ||
												('false' !== e &&
													('null' === e
														? null
														: e === +e + ''
														? +e
														: ue.test(e)
														? JSON.parse(e)
														: e))
											)
										})(n)
									} catch (e) {}
									le.set(e, t, n)
								} else n = void 0
							return n
						}
						E.extend({
							hasData: function (e) {
								return le.hasData(e) || ae.hasData(e)
							},
							data: function (e, t, n) {
								return le.access(e, t, n)
							},
							removeData: function (e, t) {
								le.remove(e, t)
							},
							_data: function (e, t, n) {
								return ae.access(e, t, n)
							},
							_removeData: function (e, t) {
								ae.remove(e, t)
							}
						}),
							E.fn.extend({
								data: function (e, t) {
									var n,
										r,
										i,
										o = this[0],
										s = o && o.attributes
									if (void 0 === e) {
										if (
											this.length &&
											((i = le.get(o)),
											1 === o.nodeType && !ae.get(o, 'hasDataAttrs'))
										) {
											for (n = s.length; n--; )
												s[n] &&
													0 === (r = s[n].name).indexOf('data-') &&
													((r = ie(r.slice(5))), de(o, r, i[r]))
											ae.set(o, 'hasDataAttrs', !0)
										}
										return i
									}
									return 'object' == typeof e
										? this.each(function () {
												le.set(this, e)
										  })
										: ee(
												this,
												function (t) {
													var n
													if (o && void 0 === t)
														return void 0 !== (n = le.get(o, e)) ||
															void 0 !== (n = de(o, e))
															? n
															: void 0
													this.each(function () {
														le.set(this, e, t)
													})
												},
												null,
												t,
												arguments.length > 1,
												null,
												!0
										  )
								},
								removeData: function (e) {
									return this.each(function () {
										le.remove(this, e)
									})
								}
							}),
							E.extend({
								queue: function (e, t, n) {
									var r
									if (e)
										return (
											(t = (t || 'fx') + 'queue'),
											(r = ae.get(e, t)),
											n &&
												(!r || Array.isArray(n)
													? (r = ae.access(e, t, E.makeArray(n)))
													: r.push(n)),
											r || []
										)
								},
								dequeue: function (e, t) {
									t = t || 'fx'
									var n = E.queue(e, t),
										r = n.length,
										i = n.shift(),
										o = E._queueHooks(e, t)
									'inprogress' === i && ((i = n.shift()), r--),
										i &&
											('fx' === t && n.unshift('inprogress'),
											delete o.stop,
											i.call(
												e,
												function () {
													E.dequeue(e, t)
												},
												o
											)),
										!r && o && o.empty.fire()
								},
								_queueHooks: function (e, t) {
									var n = t + 'queueHooks'
									return (
										ae.get(e, n) ||
										ae.access(e, n, {
											empty: E.Callbacks('once memory').add(
												function () {
													ae.remove(e, [t + 'queue', n])
												}
											)
										})
									)
								}
							}),
							E.fn.extend({
								queue: function (e, t) {
									var n = 2
									return (
										'string' != typeof e &&
											((t = e), (e = 'fx'), n--),
										arguments.length < n
											? E.queue(this[0], e)
											: void 0 === t
											? this
											: this.each(function () {
													var n = E.queue(this, e, t)
													E._queueHooks(this, e),
														'fx' === e &&
															'inprogress' !== n[0] &&
															E.dequeue(this, e)
											  })
									)
								},
								dequeue: function (e) {
									return this.each(function () {
										E.dequeue(this, e)
									})
								},
								clearQueue: function (e) {
									return this.queue(e || 'fx', [])
								},
								promise: function (e, t) {
									var n,
										r = 1,
										i = E.Deferred(),
										o = this,
										s = this.length,
										a = function () {
											--r || i.resolveWith(o, [o])
										}
									for (
										'string' != typeof e && ((t = e), (e = void 0)),
											e = e || 'fx';
										s--;

									)
										(n = ae.get(o[s], e + 'queueHooks')) &&
											n.empty &&
											(r++, n.empty.add(a))
									return a(), i.promise(t)
								}
							})
						var pe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
							fe = new RegExp(
								'^(?:([+-])=|)(' + pe + ')([a-z%]*)$',
								'i'
							),
							he = ['Top', 'Right', 'Bottom', 'Left'],
							ve = _.documentElement,
							me = function (e) {
								return E.contains(e.ownerDocument, e)
							},
							ge = { composed: !0 }
						ve.getRootNode &&
							(me = function (e) {
								return (
									E.contains(e.ownerDocument, e) ||
									e.getRootNode(ge) === e.ownerDocument
								)
							})
						var ye = function (e, t) {
							return (
								'none' === (e = t || e).style.display ||
								('' === e.style.display &&
									me(e) &&
									'none' === E.css(e, 'display'))
							)
						}
						function _e(e, t, n, r) {
							var i,
								o,
								s = 20,
								a = r
									? function () {
											return r.cur()
									  }
									: function () {
											return E.css(e, t, '')
									  },
								l = a(),
								u = (n && n[3]) || (E.cssNumber[t] ? '' : 'px'),
								c =
									e.nodeType &&
									(E.cssNumber[t] || ('px' !== u && +l)) &&
									fe.exec(E.css(e, t))
							if (c && c[3] !== u) {
								for (l /= 2, u = u || c[3], c = +l || 1; s--; )
									E.style(e, t, c + u),
										(1 - o) * (1 - (o = a() / l || 0.5)) <= 0 &&
											(s = 0),
										(c /= o)
								;(c *= 2), E.style(e, t, c + u), (n = n || [])
							}
							return (
								n &&
									((c = +c || +l || 0),
									(i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
									r && ((r.unit = u), (r.start = c), (r.end = i))),
								i
							)
						}
						var be = {}
						function we(e) {
							var t,
								n = e.ownerDocument,
								r = e.nodeName,
								i = be[r]
							return (
								i ||
								((t = n.body.appendChild(n.createElement(r))),
								(i = E.css(t, 'display')),
								t.parentNode.removeChild(t),
								'none' === i && (i = 'block'),
								(be[r] = i),
								i)
							)
						}
						function xe(e, t) {
							for (var n, r, i = [], o = 0, s = e.length; o < s; o++)
								(r = e[o]).style &&
									((n = r.style.display),
									t
										? ('none' === n &&
												((i[o] = ae.get(r, 'display') || null),
												i[o] || (r.style.display = '')),
										  '' === r.style.display &&
												ye(r) &&
												(i[o] = we(r)))
										: 'none' !== n &&
										  ((i[o] = 'none'), ae.set(r, 'display', n)))
							for (o = 0; o < s; o++)
								null != i[o] && (e[o].style.display = i[o])
							return e
						}
						E.fn.extend({
							show: function () {
								return xe(this, !0)
							},
							hide: function () {
								return xe(this)
							},
							toggle: function (e) {
								return 'boolean' == typeof e
									? e
										? this.show()
										: this.hide()
									: this.each(function () {
											ye(this) ? E(this).show() : E(this).hide()
									  })
							}
						})
						var Te,
							Ce,
							Ee = /^(?:checkbox|radio)$/i,
							ke = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
							Se = /^$|^module$|\/(?:java|ecma)script/i
						;(Te = _.createDocumentFragment().appendChild(
							_.createElement('div')
						)),
							(Ce = _.createElement('input')).setAttribute(
								'type',
								'radio'
							),
							Ce.setAttribute('checked', 'checked'),
							Ce.setAttribute('name', 't'),
							Te.appendChild(Ce),
							(m.checkClone = Te.cloneNode(!0).cloneNode(
								!0
							).lastChild.checked),
							(Te.innerHTML = '<textarea>x</textarea>'),
							(m.noCloneChecked = !!Te.cloneNode(!0).lastChild
								.defaultValue),
							(Te.innerHTML = '<option></option>'),
							(m.option = !!Te.lastChild)
						var Me = {
							thead: [1, '<table>', '</table>'],
							col: [2, '<table><colgroup>', '</colgroup></table>'],
							tr: [2, '<table><tbody>', '</tbody></table>'],
							td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
							_default: [0, '', '']
						}
						function Pe(e, t) {
							var n
							return (
								(n =
									void 0 !== e.getElementsByTagName
										? e.getElementsByTagName(t || '*')
										: void 0 !== e.querySelectorAll
										? e.querySelectorAll(t || '*')
										: []),
								void 0 === t || (t && S(e, t)) ? E.merge([e], n) : n
							)
						}
						function Le(e, t) {
							for (var n = 0, r = e.length; n < r; n++)
								ae.set(
									e[n],
									'globalEval',
									!t || ae.get(t[n], 'globalEval')
								)
						}
						;(Me.tbody =
							Me.tfoot =
							Me.colgroup =
							Me.caption =
								Me.thead),
							(Me.th = Me.td),
							m.option ||
								(Me.optgroup = Me.option =
									[1, "<select multiple='multiple'>", '</select>'])
						var Ae = /<|&#?\w+;/
						function Oe(e, t, n, r, i) {
							for (
								var o,
									s,
									a,
									l,
									u,
									c,
									d = t.createDocumentFragment(),
									p = [],
									f = 0,
									h = e.length;
								f < h;
								f++
							)
								if ((o = e[f]) || 0 === o)
									if ('object' === x(o))
										E.merge(p, o.nodeType ? [o] : o)
									else if (Ae.test(o)) {
										for (
											s = s || d.appendChild(t.createElement('div')),
												a = (ke.exec(o) || ['', ''])[1].toLowerCase(),
												l = Me[a] || Me._default,
												s.innerHTML =
													l[1] + E.htmlPrefilter(o) + l[2],
												c = l[0];
											c--;

										)
											s = s.lastChild
										E.merge(p, s.childNodes),
											((s = d.firstChild).textContent = '')
									} else p.push(t.createTextNode(o))
							for (d.textContent = '', f = 0; (o = p[f++]); )
								if (r && E.inArray(o, r) > -1) i && i.push(o)
								else if (
									((u = me(o)),
									(s = Pe(d.appendChild(o), 'script')),
									u && Le(s),
									n)
								)
									for (c = 0; (o = s[c++]); )
										Se.test(o.type || '') && n.push(o)
							return d
						}
						var je = /^([^.]*)(?:\.(.+)|)/
						function $e() {
							return !0
						}
						function De() {
							return !1
						}
						function Ne(e, t, n, r, i, o) {
							var s, a
							if ('object' == typeof t) {
								for (a in ('string' != typeof n &&
									((r = r || n), (n = void 0)),
								t))
									Ne(e, a, n, r, t[a], o)
								return e
							}
							if (
								(null == r && null == i
									? ((i = n), (r = n = void 0))
									: null == i &&
									  ('string' == typeof n
											? ((i = r), (r = void 0))
											: ((i = r), (r = n), (n = void 0))),
								!1 === i)
							)
								i = De
							else if (!i) return e
							return (
								1 === o &&
									((s = i),
									(i = function (e) {
										return E().off(e), s.apply(this, arguments)
									}),
									(i.guid = s.guid || (s.guid = E.guid++))),
								e.each(function () {
									E.event.add(this, t, i, r, n)
								})
							)
						}
						function Ie(e, t, n) {
							n
								? (ae.set(e, t, !1),
								  E.event.add(e, t, {
										namespace: !1,
										handler: function (e) {
											var n,
												r = ae.get(this, t)
											if (1 & e.isTrigger && this[t]) {
												if (r)
													(E.event.special[t] || {}).delegateType &&
														e.stopPropagation()
												else if (
													((r = a.call(arguments)),
													ae.set(this, t, r),
													this[t](),
													(n = ae.get(this, t)),
													ae.set(this, t, !1),
													r !== n)
												)
													return (
														e.stopImmediatePropagation(),
														e.preventDefault(),
														n
													)
											} else
												r &&
													(ae.set(
														this,
														t,
														E.event.trigger(r[0], r.slice(1), this)
													),
													e.stopPropagation(),
													(e.isImmediatePropagationStopped = $e))
										}
								  }))
								: void 0 === ae.get(e, t) && E.event.add(e, t, $e)
						}
						;(E.event = {
							global: {},
							add: function (e, t, n, r, i) {
								var o,
									s,
									a,
									l,
									u,
									c,
									d,
									p,
									f,
									h,
									v,
									m = ae.get(e)
								if (oe(e))
									for (
										n.handler &&
											((n = (o = n).handler), (i = o.selector)),
											i && E.find.matchesSelector(ve, i),
											n.guid || (n.guid = E.guid++),
											(l = m.events) ||
												(l = m.events = Object.create(null)),
											(s = m.handle) ||
												(s = m.handle =
													function (t) {
														return void 0 !== E &&
															E.event.triggered !== t.type
															? E.event.dispatch.apply(e, arguments)
															: void 0
													}),
											u = (t = (t || '').match(U) || ['']).length;
										u--;

									)
										(f = v = (a = je.exec(t[u]) || [])[1]),
											(h = (a[2] || '').split('.').sort()),
											f &&
												((d = E.event.special[f] || {}),
												(f = (i ? d.delegateType : d.bindType) || f),
												(d = E.event.special[f] || {}),
												(c = E.extend(
													{
														type: f,
														origType: v,
														data: r,
														handler: n,
														guid: n.guid,
														selector: i,
														needsContext:
															i && E.expr.match.needsContext.test(i),
														namespace: h.join('.')
													},
													o
												)),
												(p = l[f]) ||
													(((p = l[f] = []).delegateCount = 0),
													(d.setup &&
														!1 !== d.setup.call(e, r, h, s)) ||
														(e.addEventListener &&
															e.addEventListener(f, s))),
												d.add &&
													(d.add.call(e, c),
													c.handler.guid ||
														(c.handler.guid = n.guid)),
												i
													? p.splice(p.delegateCount++, 0, c)
													: p.push(c),
												(E.event.global[f] = !0))
							},
							remove: function (e, t, n, r, i) {
								var o,
									s,
									a,
									l,
									u,
									c,
									d,
									p,
									f,
									h,
									v,
									m = ae.hasData(e) && ae.get(e)
								if (m && (l = m.events)) {
									for (
										u = (t = (t || '').match(U) || ['']).length;
										u--;

									)
										if (
											((f = v = (a = je.exec(t[u]) || [])[1]),
											(h = (a[2] || '').split('.').sort()),
											f)
										) {
											for (
												d = E.event.special[f] || {},
													p =
														l[
															(f =
																(r ? d.delegateType : d.bindType) ||
																f)
														] || [],
													a =
														a[2] &&
														new RegExp(
															'(^|\\.)' +
																h.join('\\.(?:.*\\.|)') +
																'(\\.|$)'
														),
													s = o = p.length;
												o--;

											)
												(c = p[o]),
													(!i && v !== c.origType) ||
														(n && n.guid !== c.guid) ||
														(a && !a.test(c.namespace)) ||
														(r &&
															r !== c.selector &&
															('**' !== r || !c.selector)) ||
														(p.splice(o, 1),
														c.selector && p.delegateCount--,
														d.remove && d.remove.call(e, c))
											s &&
												!p.length &&
												((d.teardown &&
													!1 !== d.teardown.call(e, h, m.handle)) ||
													E.removeEvent(e, f, m.handle),
												delete l[f])
										} else
											for (f in l)
												E.event.remove(e, f + t[u], n, r, !0)
									E.isEmptyObject(l) && ae.remove(e, 'handle events')
								}
							},
							dispatch: function (e) {
								var t,
									n,
									r,
									i,
									o,
									s,
									a = new Array(arguments.length),
									l = E.event.fix(e),
									u =
										(ae.get(this, 'events') || Object.create(null))[
											l.type
										] || [],
									c = E.event.special[l.type] || {}
								for (a[0] = l, t = 1; t < arguments.length; t++)
									a[t] = arguments[t]
								if (
									((l.delegateTarget = this),
									!c.preDispatch ||
										!1 !== c.preDispatch.call(this, l))
								) {
									for (
										s = E.event.handlers.call(this, l, u), t = 0;
										(i = s[t++]) && !l.isPropagationStopped();

									)
										for (
											l.currentTarget = i.elem, n = 0;
											(o = i.handlers[n++]) &&
											!l.isImmediatePropagationStopped();

										)
											(l.rnamespace &&
												!1 !== o.namespace &&
												!l.rnamespace.test(o.namespace)) ||
												((l.handleObj = o),
												(l.data = o.data),
												void 0 !==
													(r = (
														(E.event.special[o.origType] || {})
															.handle || o.handler
													).apply(i.elem, a)) &&
													!1 === (l.result = r) &&
													(l.preventDefault(), l.stopPropagation()))
									return (
										c.postDispatch && c.postDispatch.call(this, l),
										l.result
									)
								}
							},
							handlers: function (e, t) {
								var n,
									r,
									i,
									o,
									s,
									a = [],
									l = t.delegateCount,
									u = e.target
								if (
									l &&
									u.nodeType &&
									!('click' === e.type && e.button >= 1)
								)
									for (; u !== this; u = u.parentNode || this)
										if (
											1 === u.nodeType &&
											('click' !== e.type || !0 !== u.disabled)
										) {
											for (o = [], s = {}, n = 0; n < l; n++)
												void 0 ===
													s[(i = (r = t[n]).selector + ' ')] &&
													(s[i] = r.needsContext
														? E(i, this).index(u) > -1
														: E.find(i, this, null, [u]).length),
													s[i] && o.push(r)
											o.length && a.push({ elem: u, handlers: o })
										}
								return (
									(u = this),
									l < t.length &&
										a.push({ elem: u, handlers: t.slice(l) }),
									a
								)
							},
							addProp: function (e, t) {
								Object.defineProperty(E.Event.prototype, e, {
									enumerable: !0,
									configurable: !0,
									get: g(t)
										? function () {
												if (this.originalEvent)
													return t(this.originalEvent)
										  }
										: function () {
												if (this.originalEvent)
													return this.originalEvent[e]
										  },
									set: function (t) {
										Object.defineProperty(this, e, {
											enumerable: !0,
											configurable: !0,
											writable: !0,
											value: t
										})
									}
								})
							},
							fix: function (e) {
								return e[E.expando] ? e : new E.Event(e)
							},
							special: {
								load: { noBubble: !0 },
								click: {
									setup: function (e) {
										var t = this || e
										return (
											Ee.test(t.type) &&
												t.click &&
												S(t, 'input') &&
												Ie(t, 'click', !0),
											!1
										)
									},
									trigger: function (e) {
										var t = this || e
										return (
											Ee.test(t.type) &&
												t.click &&
												S(t, 'input') &&
												Ie(t, 'click'),
											!0
										)
									},
									_default: function (e) {
										var t = e.target
										return (
											(Ee.test(t.type) &&
												t.click &&
												S(t, 'input') &&
												ae.get(t, 'click')) ||
											S(t, 'a')
										)
									}
								},
								beforeunload: {
									postDispatch: function (e) {
										void 0 !== e.result &&
											e.originalEvent &&
											(e.originalEvent.returnValue = e.result)
									}
								}
							}
						}),
							(E.removeEvent = function (e, t, n) {
								e.removeEventListener && e.removeEventListener(t, n)
							}),
							(E.Event = function (e, t) {
								if (!(this instanceof E.Event))
									return new E.Event(e, t)
								e && e.type
									? ((this.originalEvent = e),
									  (this.type = e.type),
									  (this.isDefaultPrevented =
											e.defaultPrevented ||
											(void 0 === e.defaultPrevented &&
												!1 === e.returnValue)
												? $e
												: De),
									  (this.target =
											e.target && 3 === e.target.nodeType
												? e.target.parentNode
												: e.target),
									  (this.currentTarget = e.currentTarget),
									  (this.relatedTarget = e.relatedTarget))
									: (this.type = e),
									t && E.extend(this, t),
									(this.timeStamp = (e && e.timeStamp) || Date.now()),
									(this[E.expando] = !0)
							}),
							(E.Event.prototype = {
								constructor: E.Event,
								isDefaultPrevented: De,
								isPropagationStopped: De,
								isImmediatePropagationStopped: De,
								isSimulated: !1,
								preventDefault: function () {
									var e = this.originalEvent
									;(this.isDefaultPrevented = $e),
										e && !this.isSimulated && e.preventDefault()
								},
								stopPropagation: function () {
									var e = this.originalEvent
									;(this.isPropagationStopped = $e),
										e && !this.isSimulated && e.stopPropagation()
								},
								stopImmediatePropagation: function () {
									var e = this.originalEvent
									;(this.isImmediatePropagationStopped = $e),
										e &&
											!this.isSimulated &&
											e.stopImmediatePropagation(),
										this.stopPropagation()
								}
							}),
							E.each(
								{
									altKey: !0,
									bubbles: !0,
									cancelable: !0,
									changedTouches: !0,
									ctrlKey: !0,
									detail: !0,
									eventPhase: !0,
									metaKey: !0,
									pageX: !0,
									pageY: !0,
									shiftKey: !0,
									view: !0,
									char: !0,
									code: !0,
									charCode: !0,
									key: !0,
									keyCode: !0,
									button: !0,
									buttons: !0,
									clientX: !0,
									clientY: !0,
									offsetX: !0,
									offsetY: !0,
									pointerId: !0,
									pointerType: !0,
									screenX: !0,
									screenY: !0,
									targetTouches: !0,
									toElement: !0,
									touches: !0,
									which: !0
								},
								E.event.addProp
							),
							E.each(
								{ focus: 'focusin', blur: 'focusout' },
								function (e, t) {
									function n(e) {
										if (_.documentMode) {
											var n = ae.get(this, 'handle'),
												r = E.event.fix(e)
											;(r.type =
												'focusin' === e.type ? 'focus' : 'blur'),
												(r.isSimulated = !0),
												n(e),
												r.target === r.currentTarget && n(r)
										} else
											E.event.simulate(t, e.target, E.event.fix(e))
									}
									;(E.event.special[e] = {
										setup: function () {
											var r
											if ((Ie(this, e, !0), !_.documentMode))
												return !1
											;(r = ae.get(this, t)) ||
												this.addEventListener(t, n),
												ae.set(this, t, (r || 0) + 1)
										},
										trigger: function () {
											return Ie(this, e), !0
										},
										teardown: function () {
											var e
											if (!_.documentMode) return !1
											;(e = ae.get(this, t) - 1)
												? ae.set(this, t, e)
												: (this.removeEventListener(t, n),
												  ae.remove(this, t))
										},
										_default: function (t) {
											return ae.get(t.target, e)
										},
										delegateType: t
									}),
										(E.event.special[t] = {
											setup: function () {
												var r =
														this.ownerDocument ||
														this.document ||
														this,
													i = _.documentMode ? this : r,
													o = ae.get(i, t)
												o ||
													(_.documentMode
														? this.addEventListener(t, n)
														: r.addEventListener(e, n, !0)),
													ae.set(i, t, (o || 0) + 1)
											},
											teardown: function () {
												var r =
														this.ownerDocument ||
														this.document ||
														this,
													i = _.documentMode ? this : r,
													o = ae.get(i, t) - 1
												o
													? ae.set(i, t, o)
													: (_.documentMode
															? this.removeEventListener(t, n)
															: r.removeEventListener(e, n, !0),
													  ae.remove(i, t))
											}
										})
								}
							),
							E.each(
								{
									mouseenter: 'mouseover',
									mouseleave: 'mouseout',
									pointerenter: 'pointerover',
									pointerleave: 'pointerout'
								},
								function (e, t) {
									E.event.special[e] = {
										delegateType: t,
										bindType: t,
										handle: function (e) {
											var n,
												r = e.relatedTarget,
												i = e.handleObj
											return (
												(r && (r === this || E.contains(this, r))) ||
													((e.type = i.origType),
													(n = i.handler.apply(this, arguments)),
													(e.type = t)),
												n
											)
										}
									}
								}
							),
							E.fn.extend({
								on: function (e, t, n, r) {
									return Ne(this, e, t, n, r)
								},
								one: function (e, t, n, r) {
									return Ne(this, e, t, n, r, 1)
								},
								off: function (e, t, n) {
									var r, i
									if (e && e.preventDefault && e.handleObj)
										return (
											(r = e.handleObj),
											E(e.delegateTarget).off(
												r.namespace
													? r.origType + '.' + r.namespace
													: r.origType,
												r.selector,
												r.handler
											),
											this
										)
									if ('object' == typeof e) {
										for (i in e) this.off(i, t, e[i])
										return this
									}
									return (
										(!1 !== t && 'function' != typeof t) ||
											((n = t), (t = void 0)),
										!1 === n && (n = De),
										this.each(function () {
											E.event.remove(this, e, n, t)
										})
									)
								}
							})
						var qe = /<script|<style|<link/i,
							He = /checked\s*(?:[^=]|=\s*.checked.)/i,
							Be = /^\s*<!\[CDATA\[|\]\]>\s*$/g
						function Fe(e, t) {
							return (
								(S(e, 'table') &&
									S(11 !== t.nodeType ? t : t.firstChild, 'tr') &&
									E(e).children('tbody')[0]) ||
								e
							)
						}
						function Re(e) {
							return (
								(e.type =
									(null !== e.getAttribute('type')) + '/' + e.type),
								e
							)
						}
						function ze(e) {
							return (
								'true/' === (e.type || '').slice(0, 5)
									? (e.type = e.type.slice(5))
									: e.removeAttribute('type'),
								e
							)
						}
						function We(e, t) {
							var n, r, i, o, s, a
							if (1 === t.nodeType) {
								if (ae.hasData(e) && (a = ae.get(e).events))
									for (i in (ae.remove(t, 'handle events'), a))
										for (n = 0, r = a[i].length; n < r; n++)
											E.event.add(t, i, a[i][n])
								le.hasData(e) &&
									((o = le.access(e)),
									(s = E.extend({}, o)),
									le.set(t, s))
							}
						}
						function Ve(e, t) {
							var n = t.nodeName.toLowerCase()
							'input' === n && Ee.test(e.type)
								? (t.checked = e.checked)
								: ('input' !== n && 'textarea' !== n) ||
								  (t.defaultValue = e.defaultValue)
						}
						function Ge(e, t, n, r) {
							t = l(t)
							var i,
								o,
								s,
								a,
								u,
								c,
								d = 0,
								p = e.length,
								f = p - 1,
								h = t[0],
								v = g(h)
							if (
								v ||
								(p > 1 &&
									'string' == typeof h &&
									!m.checkClone &&
									He.test(h))
							)
								return e.each(function (i) {
									var o = e.eq(i)
									v && (t[0] = h.call(this, i, o.html())),
										Ge(o, t, n, r)
								})
							if (
								p &&
								((o = (i = Oe(t, e[0].ownerDocument, !1, e, r))
									.firstChild),
								1 === i.childNodes.length && (i = o),
								o || r)
							) {
								for (
									a = (s = E.map(Pe(i, 'script'), Re)).length;
									d < p;
									d++
								)
									(u = i),
										d !== f &&
											((u = E.clone(u, !0, !0)),
											a && E.merge(s, Pe(u, 'script'))),
										n.call(e[d], u, d)
								if (a)
									for (
										c = s[s.length - 1].ownerDocument,
											E.map(s, ze),
											d = 0;
										d < a;
										d++
									)
										(u = s[d]),
											Se.test(u.type || '') &&
												!ae.access(u, 'globalEval') &&
												E.contains(c, u) &&
												(u.src &&
												'module' !== (u.type || '').toLowerCase()
													? E._evalUrl &&
													  !u.noModule &&
													  E._evalUrl(
															u.src,
															{
																nonce:
																	u.nonce || u.getAttribute('nonce')
															},
															c
													  )
													: w(u.textContent.replace(Be, ''), u, c))
							}
							return e
						}
						function Ue(e, t, n) {
							for (
								var r, i = t ? E.filter(t, e) : e, o = 0;
								null != (r = i[o]);
								o++
							)
								n || 1 !== r.nodeType || E.cleanData(Pe(r)),
									r.parentNode &&
										(n && me(r) && Le(Pe(r, 'script')),
										r.parentNode.removeChild(r))
							return e
						}
						E.extend({
							htmlPrefilter: function (e) {
								return e
							},
							clone: function (e, t, n) {
								var r,
									i,
									o,
									s,
									a = e.cloneNode(!0),
									l = me(e)
								if (
									!(
										m.noCloneChecked ||
										(1 !== e.nodeType && 11 !== e.nodeType) ||
										E.isXMLDoc(e)
									)
								)
									for (
										s = Pe(a), r = 0, i = (o = Pe(e)).length;
										r < i;
										r++
									)
										Ve(o[r], s[r])
								if (t)
									if (n)
										for (
											o = o || Pe(e),
												s = s || Pe(a),
												r = 0,
												i = o.length;
											r < i;
											r++
										)
											We(o[r], s[r])
									else We(e, a)
								return (
									(s = Pe(a, 'script')).length > 0 &&
										Le(s, !l && Pe(e, 'script')),
									a
								)
							},
							cleanData: function (e) {
								for (
									var t, n, r, i = E.event.special, o = 0;
									void 0 !== (n = e[o]);
									o++
								)
									if (oe(n)) {
										if ((t = n[ae.expando])) {
											if (t.events)
												for (r in t.events)
													i[r]
														? E.event.remove(n, r)
														: E.removeEvent(n, r, t.handle)
											n[ae.expando] = void 0
										}
										n[le.expando] && (n[le.expando] = void 0)
									}
							}
						}),
							E.fn.extend({
								detach: function (e) {
									return Ue(this, e, !0)
								},
								remove: function (e) {
									return Ue(this, e)
								},
								text: function (e) {
									return ee(
										this,
										function (e) {
											return void 0 === e
												? E.text(this)
												: this.empty().each(function () {
														;(1 !== this.nodeType &&
															11 !== this.nodeType &&
															9 !== this.nodeType) ||
															(this.textContent = e)
												  })
										},
										null,
										e,
										arguments.length
									)
								},
								append: function () {
									return Ge(this, arguments, function (e) {
										;(1 !== this.nodeType &&
											11 !== this.nodeType &&
											9 !== this.nodeType) ||
											Fe(this, e).appendChild(e)
									})
								},
								prepend: function () {
									return Ge(this, arguments, function (e) {
										if (
											1 === this.nodeType ||
											11 === this.nodeType ||
											9 === this.nodeType
										) {
											var t = Fe(this, e)
											t.insertBefore(e, t.firstChild)
										}
									})
								},
								before: function () {
									return Ge(this, arguments, function (e) {
										this.parentNode &&
											this.parentNode.insertBefore(e, this)
									})
								},
								after: function () {
									return Ge(this, arguments, function (e) {
										this.parentNode &&
											this.parentNode.insertBefore(
												e,
												this.nextSibling
											)
									})
								},
								empty: function () {
									for (var e, t = 0; null != (e = this[t]); t++)
										1 === e.nodeType &&
											(E.cleanData(Pe(e, !1)), (e.textContent = ''))
									return this
								},
								clone: function (e, t) {
									return (
										(e = null != e && e),
										(t = null == t ? e : t),
										this.map(function () {
											return E.clone(this, e, t)
										})
									)
								},
								html: function (e) {
									return ee(
										this,
										function (e) {
											var t = this[0] || {},
												n = 0,
												r = this.length
											if (void 0 === e && 1 === t.nodeType)
												return t.innerHTML
											if (
												'string' == typeof e &&
												!qe.test(e) &&
												!Me[(ke.exec(e) || ['', ''])[1].toLowerCase()]
											) {
												e = E.htmlPrefilter(e)
												try {
													for (; n < r; n++)
														1 === (t = this[n] || {}).nodeType &&
															(E.cleanData(Pe(t, !1)),
															(t.innerHTML = e))
													t = 0
												} catch (e) {}
											}
											t && this.empty().append(e)
										},
										null,
										e,
										arguments.length
									)
								},
								replaceWith: function () {
									var e = []
									return Ge(
										this,
										arguments,
										function (t) {
											var n = this.parentNode
											E.inArray(this, e) < 0 &&
												(E.cleanData(Pe(this)),
												n && n.replaceChild(t, this))
										},
										e
									)
								}
							}),
							E.each(
								{
									appendTo: 'append',
									prependTo: 'prepend',
									insertBefore: 'before',
									insertAfter: 'after',
									replaceAll: 'replaceWith'
								},
								function (e, t) {
									E.fn[e] = function (e) {
										for (
											var n,
												r = [],
												i = E(e),
												o = i.length - 1,
												s = 0;
											s <= o;
											s++
										)
											(n = s === o ? this : this.clone(!0)),
												E(i[s])[t](n),
												u.apply(r, n.get())
										return this.pushStack(r)
									}
								}
							)
						var Xe = new RegExp('^(' + pe + ')(?!px)[a-z%]+$', 'i'),
							Ye = /^--/,
							Ke = function (e) {
								var t = e.ownerDocument.defaultView
								return (
									(t && t.opener) || (t = r), t.getComputedStyle(e)
								)
							},
							Qe = function (e, t, n) {
								var r,
									i,
									o = {}
								for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i])
								for (i in ((r = n.call(e)), t)) e.style[i] = o[i]
								return r
							},
							Je = new RegExp(he.join('|'), 'i')
						function Ze(e, t, n) {
							var r,
								i,
								o,
								s,
								a = Ye.test(t),
								l = e.style
							return (
								(n = n || Ke(e)) &&
									((s = n.getPropertyValue(t) || n[t]),
									a && s && (s = s.replace(O, '$1') || void 0),
									'' !== s || me(e) || (s = E.style(e, t)),
									!m.pixelBoxStyles() &&
										Xe.test(s) &&
										Je.test(t) &&
										((r = l.width),
										(i = l.minWidth),
										(o = l.maxWidth),
										(l.minWidth = l.maxWidth = l.width = s),
										(s = n.width),
										(l.width = r),
										(l.minWidth = i),
										(l.maxWidth = o))),
								void 0 !== s ? s + '' : s
							)
						}
						function et(e, t) {
							return {
								get: function () {
									if (!e())
										return (this.get = t).apply(this, arguments)
									delete this.get
								}
							}
						}
						!(function () {
							function e() {
								if (c) {
									;(u.style.cssText =
										'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
										(c.style.cssText =
											'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
										ve.appendChild(u).appendChild(c)
									var e = r.getComputedStyle(c)
									;(n = '1%' !== e.top),
										(l = 12 === t(e.marginLeft)),
										(c.style.right = '60%'),
										(s = 36 === t(e.right)),
										(i = 36 === t(e.width)),
										(c.style.position = 'absolute'),
										(o = 12 === t(c.offsetWidth / 3)),
										ve.removeChild(u),
										(c = null)
								}
							}
							function t(e) {
								return Math.round(parseFloat(e))
							}
							var n,
								i,
								o,
								s,
								a,
								l,
								u = _.createElement('div'),
								c = _.createElement('div')
							c.style &&
								((c.style.backgroundClip = 'content-box'),
								(c.cloneNode(!0).style.backgroundClip = ''),
								(m.clearCloneStyle =
									'content-box' === c.style.backgroundClip),
								E.extend(m, {
									boxSizingReliable: function () {
										return e(), i
									},
									pixelBoxStyles: function () {
										return e(), s
									},
									pixelPosition: function () {
										return e(), n
									},
									reliableMarginLeft: function () {
										return e(), l
									},
									scrollboxSize: function () {
										return e(), o
									},
									reliableTrDimensions: function () {
										var e, t, n, i
										return (
											null == a &&
												((e = _.createElement('table')),
												(t = _.createElement('tr')),
												(n = _.createElement('div')),
												(e.style.cssText =
													'position:absolute;left:-11111px;border-collapse:separate'),
												(t.style.cssText =
													'box-sizing:content-box;border:1px solid'),
												(t.style.height = '1px'),
												(n.style.height = '9px'),
												(n.style.display = 'block'),
												ve
													.appendChild(e)
													.appendChild(t)
													.appendChild(n),
												(i = r.getComputedStyle(t)),
												(a =
													parseInt(i.height, 10) +
														parseInt(i.borderTopWidth, 10) +
														parseInt(i.borderBottomWidth, 10) ===
													t.offsetHeight),
												ve.removeChild(e)),
											a
										)
									}
								}))
						})()
						var tt = ['Webkit', 'Moz', 'ms'],
							nt = _.createElement('div').style,
							rt = {}
						function it(e) {
							var t = E.cssProps[e] || rt[e]
							return (
								t ||
								(e in nt
									? e
									: (rt[e] =
											(function (e) {
												for (
													var t = e[0].toUpperCase() + e.slice(1),
														n = tt.length;
													n--;

												)
													if ((e = tt[n] + t) in nt) return e
											})(e) || e))
							)
						}
						var ot = /^(none|table(?!-c[ea]).+)/,
							st = {
								position: 'absolute',
								visibility: 'hidden',
								display: 'block'
							},
							at = { letterSpacing: '0', fontWeight: '400' }
						function lt(e, t, n) {
							var r = fe.exec(t)
							return r
								? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px')
								: t
						}
						function ut(e, t, n, r, i, o) {
							var s = 'width' === t ? 1 : 0,
								a = 0,
								l = 0,
								u = 0
							if (n === (r ? 'border' : 'content')) return 0
							for (; s < 4; s += 2)
								'margin' === n && (u += E.css(e, n + he[s], !0, i)),
									r
										? ('content' === n &&
												(l -= E.css(e, 'padding' + he[s], !0, i)),
										  'margin' !== n &&
												(l -= E.css(
													e,
													'border' + he[s] + 'Width',
													!0,
													i
												)))
										: ((l += E.css(e, 'padding' + he[s], !0, i)),
										  'padding' !== n
												? (l += E.css(
														e,
														'border' + he[s] + 'Width',
														!0,
														i
												  ))
												: (a += E.css(
														e,
														'border' + he[s] + 'Width',
														!0,
														i
												  )))
							return (
								!r &&
									o >= 0 &&
									(l +=
										Math.max(
											0,
											Math.ceil(
												e[
													'offset' + t[0].toUpperCase() + t.slice(1)
												] -
													o -
													l -
													a -
													0.5
											)
										) || 0),
								l + u
							)
						}
						function ct(e, t, n) {
							var r = Ke(e),
								i =
									(!m.boxSizingReliable() || n) &&
									'border-box' === E.css(e, 'boxSizing', !1, r),
								o = i,
								s = Ze(e, t, r),
								a = 'offset' + t[0].toUpperCase() + t.slice(1)
							if (Xe.test(s)) {
								if (!n) return s
								s = 'auto'
							}
							return (
								((!m.boxSizingReliable() && i) ||
									(!m.reliableTrDimensions() && S(e, 'tr')) ||
									'auto' === s ||
									(!parseFloat(s) &&
										'inline' === E.css(e, 'display', !1, r))) &&
									e.getClientRects().length &&
									((i =
										'border-box' === E.css(e, 'boxSizing', !1, r)),
									(o = a in e) && (s = e[a])),
								(s = parseFloat(s) || 0) +
									ut(e, t, n || (i ? 'border' : 'content'), o, r, s) +
									'px'
							)
						}
						function dt(e, t, n, r, i) {
							return new dt.prototype.init(e, t, n, r, i)
						}
						E.extend({
							cssHooks: {
								opacity: {
									get: function (e, t) {
										if (t) {
											var n = Ze(e, 'opacity')
											return '' === n ? '1' : n
										}
									}
								}
							},
							cssNumber: {
								animationIterationCount: !0,
								aspectRatio: !0,
								borderImageSlice: !0,
								columnCount: !0,
								flexGrow: !0,
								flexShrink: !0,
								fontWeight: !0,
								gridArea: !0,
								gridColumn: !0,
								gridColumnEnd: !0,
								gridColumnStart: !0,
								gridRow: !0,
								gridRowEnd: !0,
								gridRowStart: !0,
								lineHeight: !0,
								opacity: !0,
								order: !0,
								orphans: !0,
								scale: !0,
								widows: !0,
								zIndex: !0,
								zoom: !0,
								fillOpacity: !0,
								floodOpacity: !0,
								stopOpacity: !0,
								strokeMiterlimit: !0,
								strokeOpacity: !0
							},
							cssProps: {},
							style: function (e, t, n, r) {
								if (
									e &&
									3 !== e.nodeType &&
									8 !== e.nodeType &&
									e.style
								) {
									var i,
										o,
										s,
										a = ie(t),
										l = Ye.test(t),
										u = e.style
									if (
										(l || (t = it(a)),
										(s = E.cssHooks[t] || E.cssHooks[a]),
										void 0 === n)
									)
										return s &&
											'get' in s &&
											void 0 !== (i = s.get(e, !1, r))
											? i
											: u[t]
									'string' === (o = typeof n) &&
										(i = fe.exec(n)) &&
										i[1] &&
										((n = _e(e, t, i)), (o = 'number')),
										null != n &&
											n == n &&
											('number' !== o ||
												l ||
												(n +=
													(i && i[3]) ||
													(E.cssNumber[a] ? '' : 'px')),
											m.clearCloneStyle ||
												'' !== n ||
												0 !== t.indexOf('background') ||
												(u[t] = 'inherit'),
											(s &&
												'set' in s &&
												void 0 === (n = s.set(e, n, r))) ||
												(l ? u.setProperty(t, n) : (u[t] = n)))
								}
							},
							css: function (e, t, n, r) {
								var i,
									o,
									s,
									a = ie(t)
								return (
									Ye.test(t) || (t = it(a)),
									(s = E.cssHooks[t] || E.cssHooks[a]) &&
										'get' in s &&
										(i = s.get(e, !0, n)),
									void 0 === i && (i = Ze(e, t, r)),
									'normal' === i && t in at && (i = at[t]),
									'' === n || n
										? ((o = parseFloat(i)),
										  !0 === n || isFinite(o) ? o || 0 : i)
										: i
								)
							}
						}),
							E.each(['height', 'width'], function (e, t) {
								E.cssHooks[t] = {
									get: function (e, n, r) {
										if (n)
											return !ot.test(E.css(e, 'display')) ||
												(e.getClientRects().length &&
													e.getBoundingClientRect().width)
												? ct(e, t, r)
												: Qe(e, st, function () {
														return ct(e, t, r)
												  })
									},
									set: function (e, n, r) {
										var i,
											o = Ke(e),
											s =
												!m.scrollboxSize() &&
												'absolute' === o.position,
											a =
												(s || r) &&
												'border-box' === E.css(e, 'boxSizing', !1, o),
											l = r ? ut(e, t, r, a, o) : 0
										return (
											a &&
												s &&
												(l -= Math.ceil(
													e[
														'offset' + t[0].toUpperCase() + t.slice(1)
													] -
														parseFloat(o[t]) -
														ut(e, t, 'border', !1, o) -
														0.5
												)),
											l &&
												(i = fe.exec(n)) &&
												'px' !== (i[3] || 'px') &&
												((e.style[t] = n), (n = E.css(e, t))),
											lt(0, n, l)
										)
									}
								}
							}),
							(E.cssHooks.marginLeft = et(
								m.reliableMarginLeft,
								function (e, t) {
									if (t)
										return (
											(parseFloat(Ze(e, 'marginLeft')) ||
												e.getBoundingClientRect().left -
													Qe(e, { marginLeft: 0 }, function () {
														return e.getBoundingClientRect().left
													})) + 'px'
										)
								}
							)),
							E.each(
								{ margin: '', padding: '', border: 'Width' },
								function (e, t) {
									;(E.cssHooks[e + t] = {
										expand: function (n) {
											for (
												var r = 0,
													i = {},
													o =
														'string' == typeof n ? n.split(' ') : [n];
												r < 4;
												r++
											)
												i[e + he[r] + t] = o[r] || o[r - 2] || o[0]
											return i
										}
									}),
										'margin' !== e && (E.cssHooks[e + t].set = lt)
								}
							),
							E.fn.extend({
								css: function (e, t) {
									return ee(
										this,
										function (e, t, n) {
											var r,
												i,
												o = {},
												s = 0
											if (Array.isArray(t)) {
												for (r = Ke(e), i = t.length; s < i; s++)
													o[t[s]] = E.css(e, t[s], !1, r)
												return o
											}
											return void 0 !== n
												? E.style(e, t, n)
												: E.css(e, t)
										},
										e,
										t,
										arguments.length > 1
									)
								}
							}),
							(E.Tween = dt),
							(dt.prototype = {
								constructor: dt,
								init: function (e, t, n, r, i, o) {
									;(this.elem = e),
										(this.prop = n),
										(this.easing = i || E.easing._default),
										(this.options = t),
										(this.start = this.now = this.cur()),
										(this.end = r),
										(this.unit = o || (E.cssNumber[n] ? '' : 'px'))
								},
								cur: function () {
									var e = dt.propHooks[this.prop]
									return e && e.get
										? e.get(this)
										: dt.propHooks._default.get(this)
								},
								run: function (e) {
									var t,
										n = dt.propHooks[this.prop]
									return (
										this.options.duration
											? (this.pos = t =
													E.easing[this.easing](
														e,
														this.options.duration * e,
														0,
														1,
														this.options.duration
													))
											: (this.pos = t = e),
										(this.now =
											(this.end - this.start) * t + this.start),
										this.options.step &&
											this.options.step.call(
												this.elem,
												this.now,
												this
											),
										n && n.set
											? n.set(this)
											: dt.propHooks._default.set(this),
										this
									)
								}
							}),
							(dt.prototype.init.prototype = dt.prototype),
							(dt.propHooks = {
								_default: {
									get: function (e) {
										var t
										return 1 !== e.elem.nodeType ||
											(null != e.elem[e.prop] &&
												null == e.elem.style[e.prop])
											? e.elem[e.prop]
											: (t = E.css(e.elem, e.prop, '')) &&
											  'auto' !== t
											? t
											: 0
									},
									set: function (e) {
										E.fx.step[e.prop]
											? E.fx.step[e.prop](e)
											: 1 !== e.elem.nodeType ||
											  (!E.cssHooks[e.prop] &&
													null == e.elem.style[it(e.prop)])
											? (e.elem[e.prop] = e.now)
											: E.style(e.elem, e.prop, e.now + e.unit)
									}
								}
							}),
							(dt.propHooks.scrollTop = dt.propHooks.scrollLeft =
								{
									set: function (e) {
										e.elem.nodeType &&
											e.elem.parentNode &&
											(e.elem[e.prop] = e.now)
									}
								}),
							(E.easing = {
								linear: function (e) {
									return e
								},
								swing: function (e) {
									return 0.5 - Math.cos(e * Math.PI) / 2
								},
								_default: 'swing'
							}),
							(E.fx = dt.prototype.init),
							(E.fx.step = {})
						var pt,
							ft,
							ht = /^(?:toggle|show|hide)$/,
							vt = /queueHooks$/
						function mt() {
							ft &&
								(!1 === _.hidden && r.requestAnimationFrame
									? r.requestAnimationFrame(mt)
									: r.setTimeout(mt, E.fx.interval),
								E.fx.tick())
						}
						function gt() {
							return (
								r.setTimeout(function () {
									pt = void 0
								}),
								(pt = Date.now())
							)
						}
						function yt(e, t) {
							var n,
								r = 0,
								i = { height: e }
							for (t = t ? 1 : 0; r < 4; r += 2 - t)
								i['margin' + (n = he[r])] = i['padding' + n] = e
							return t && (i.opacity = i.width = e), i
						}
						function _t(e, t, n) {
							for (
								var r,
									i = (bt.tweeners[t] || []).concat(bt.tweeners['*']),
									o = 0,
									s = i.length;
								o < s;
								o++
							)
								if ((r = i[o].call(n, t, e))) return r
						}
						function bt(e, t, n) {
							var r,
								i,
								o = 0,
								s = bt.prefilters.length,
								a = E.Deferred().always(function () {
									delete l.elem
								}),
								l = function () {
									if (i) return !1
									for (
										var t = pt || gt(),
											n = Math.max(0, u.startTime + u.duration - t),
											r = 1 - (n / u.duration || 0),
											o = 0,
											s = u.tweens.length;
										o < s;
										o++
									)
										u.tweens[o].run(r)
									return (
										a.notifyWith(e, [u, r, n]),
										r < 1 && s
											? n
											: (s || a.notifyWith(e, [u, 1, 0]),
											  a.resolveWith(e, [u]),
											  !1)
									)
								},
								u = a.promise({
									elem: e,
									props: E.extend({}, t),
									opts: E.extend(
										!0,
										{ specialEasing: {}, easing: E.easing._default },
										n
									),
									originalProperties: t,
									originalOptions: n,
									startTime: pt || gt(),
									duration: n.duration,
									tweens: [],
									createTween: function (t, n) {
										var r = E.Tween(
											e,
											u.opts,
											t,
											n,
											u.opts.specialEasing[t] || u.opts.easing
										)
										return u.tweens.push(r), r
									},
									stop: function (t) {
										var n = 0,
											r = t ? u.tweens.length : 0
										if (i) return this
										for (i = !0; n < r; n++) u.tweens[n].run(1)
										return (
											t
												? (a.notifyWith(e, [u, 1, 0]),
												  a.resolveWith(e, [u, t]))
												: a.rejectWith(e, [u, t]),
											this
										)
									}
								}),
								c = u.props
							for (
								!(function (e, t) {
									var n, r, i, o, s
									for (n in e)
										if (
											((i = t[(r = ie(n))]),
											(o = e[n]),
											Array.isArray(o) &&
												((i = o[1]), (o = e[n] = o[0])),
											n !== r && ((e[r] = o), delete e[n]),
											(s = E.cssHooks[r]) && ('expand' in s))
										)
											for (n in ((o = s.expand(o)), delete e[r], o))
												(n in e) || ((e[n] = o[n]), (t[n] = i))
										else t[r] = i
								})(c, u.opts.specialEasing);
								o < s;
								o++
							)
								if ((r = bt.prefilters[o].call(u, e, c, u.opts)))
									return (
										g(r.stop) &&
											(E._queueHooks(u.elem, u.opts.queue).stop =
												r.stop.bind(r)),
										r
									)
							return (
								E.map(c, _t, u),
								g(u.opts.start) && u.opts.start.call(e, u),
								u
									.progress(u.opts.progress)
									.done(u.opts.done, u.opts.complete)
									.fail(u.opts.fail)
									.always(u.opts.always),
								E.fx.timer(
									E.extend(l, {
										elem: e,
										anim: u,
										queue: u.opts.queue
									})
								),
								u
							)
						}
						;(E.Animation = E.extend(bt, {
							tweeners: {
								'*': [
									function (e, t) {
										var n = this.createTween(e, t)
										return _e(n.elem, e, fe.exec(t), n), n
									}
								]
							},
							tweener: function (e, t) {
								g(e) ? ((t = e), (e = ['*'])) : (e = e.match(U))
								for (var n, r = 0, i = e.length; r < i; r++)
									(n = e[r]),
										(bt.tweeners[n] = bt.tweeners[n] || []),
										bt.tweeners[n].unshift(t)
							},
							prefilters: [
								function (e, t, n) {
									var r,
										i,
										o,
										s,
										a,
										l,
										u,
										c,
										d = 'width' in t || 'height' in t,
										p = this,
										f = {},
										h = e.style,
										v = e.nodeType && ye(e),
										m = ae.get(e, 'fxshow')
									for (r in (n.queue ||
										(null == (s = E._queueHooks(e, 'fx')).unqueued &&
											((s.unqueued = 0),
											(a = s.empty.fire),
											(s.empty.fire = function () {
												s.unqueued || a()
											})),
										s.unqueued++,
										p.always(function () {
											p.always(function () {
												s.unqueued--,
													E.queue(e, 'fx').length || s.empty.fire()
											})
										})),
									t))
										if (((i = t[r]), ht.test(i))) {
											if (
												(delete t[r],
												(o = o || 'toggle' === i),
												i === (v ? 'hide' : 'show'))
											) {
												if ('show' !== i || !m || void 0 === m[r])
													continue
												v = !0
											}
											f[r] = (m && m[r]) || E.style(e, r)
										}
									if (
										(l = !E.isEmptyObject(t)) ||
										!E.isEmptyObject(f)
									)
										for (r in (d &&
											1 === e.nodeType &&
											((n.overflow = [
												h.overflow,
												h.overflowX,
												h.overflowY
											]),
											null == (u = m && m.display) &&
												(u = ae.get(e, 'display')),
											'none' === (c = E.css(e, 'display')) &&
												(u
													? (c = u)
													: (xe([e], !0),
													  (u = e.style.display || u),
													  (c = E.css(e, 'display')),
													  xe([e]))),
											('inline' === c ||
												('inline-block' === c && null != u)) &&
												'none' === E.css(e, 'float') &&
												(l ||
													(p.done(function () {
														h.display = u
													}),
													null == u &&
														((c = h.display),
														(u = 'none' === c ? '' : c))),
												(h.display = 'inline-block'))),
										n.overflow &&
											((h.overflow = 'hidden'),
											p.always(function () {
												;(h.overflow = n.overflow[0]),
													(h.overflowX = n.overflow[1]),
													(h.overflowY = n.overflow[2])
											})),
										(l = !1),
										f))
											l ||
												(m
													? 'hidden' in m && (v = m.hidden)
													: (m = ae.access(e, 'fxshow', {
															display: u
													  })),
												o && (m.hidden = !v),
												v && xe([e], !0),
												p.done(function () {
													for (r in (v || xe([e]),
													ae.remove(e, 'fxshow'),
													f))
														E.style(e, r, f[r])
												})),
												(l = _t(v ? m[r] : 0, r, p)),
												r in m ||
													((m[r] = l.start),
													v && ((l.end = l.start), (l.start = 0)))
								}
							],
							prefilter: function (e, t) {
								t ? bt.prefilters.unshift(e) : bt.prefilters.push(e)
							}
						})),
							(E.speed = function (e, t, n) {
								var r =
									e && 'object' == typeof e
										? E.extend({}, e)
										: {
												complete: n || (!n && t) || (g(e) && e),
												duration: e,
												easing: (n && t) || (t && !g(t) && t)
										  }
								return (
									E.fx.off
										? (r.duration = 0)
										: 'number' != typeof r.duration &&
										  (r.duration in E.fx.speeds
												? (r.duration = E.fx.speeds[r.duration])
												: (r.duration = E.fx.speeds._default)),
									(null != r.queue && !0 !== r.queue) ||
										(r.queue = 'fx'),
									(r.old = r.complete),
									(r.complete = function () {
										g(r.old) && r.old.call(this),
											r.queue && E.dequeue(this, r.queue)
									}),
									r
								)
							}),
							E.fn.extend({
								fadeTo: function (e, t, n, r) {
									return this.filter(ye)
										.css('opacity', 0)
										.show()
										.end()
										.animate({ opacity: t }, e, n, r)
								},
								animate: function (e, t, n, r) {
									var i = E.isEmptyObject(e),
										o = E.speed(t, n, r),
										s = function () {
											var t = bt(this, E.extend({}, e), o)
											;(i || ae.get(this, 'finish')) && t.stop(!0)
										}
									return (
										(s.finish = s),
										i || !1 === o.queue
											? this.each(s)
											: this.queue(o.queue, s)
									)
								},
								stop: function (e, t, n) {
									var r = function (e) {
										var t = e.stop
										delete e.stop, t(n)
									}
									return (
										'string' != typeof e &&
											((n = t), (t = e), (e = void 0)),
										t && this.queue(e || 'fx', []),
										this.each(function () {
											var t = !0,
												i = null != e && e + 'queueHooks',
												o = E.timers,
												s = ae.get(this)
											if (i) s[i] && s[i].stop && r(s[i])
											else
												for (i in s)
													s[i] && s[i].stop && vt.test(i) && r(s[i])
											for (i = o.length; i--; )
												o[i].elem !== this ||
													(null != e && o[i].queue !== e) ||
													(o[i].anim.stop(n),
													(t = !1),
													o.splice(i, 1))
											;(!t && n) || E.dequeue(this, e)
										})
									)
								},
								finish: function (e) {
									return (
										!1 !== e && (e = e || 'fx'),
										this.each(function () {
											var t,
												n = ae.get(this),
												r = n[e + 'queue'],
												i = n[e + 'queueHooks'],
												o = E.timers,
												s = r ? r.length : 0
											for (
												n.finish = !0,
													E.queue(this, e, []),
													i && i.stop && i.stop.call(this, !0),
													t = o.length;
												t--;

											)
												o[t].elem === this &&
													o[t].queue === e &&
													(o[t].anim.stop(!0), o.splice(t, 1))
											for (t = 0; t < s; t++)
												r[t] && r[t].finish && r[t].finish.call(this)
											delete n.finish
										})
									)
								}
							}),
							E.each(['toggle', 'show', 'hide'], function (e, t) {
								var n = E.fn[t]
								E.fn[t] = function (e, r, i) {
									return null == e || 'boolean' == typeof e
										? n.apply(this, arguments)
										: this.animate(yt(t, !0), e, r, i)
								}
							}),
							E.each(
								{
									slideDown: yt('show'),
									slideUp: yt('hide'),
									slideToggle: yt('toggle'),
									fadeIn: { opacity: 'show' },
									fadeOut: { opacity: 'hide' },
									fadeToggle: { opacity: 'toggle' }
								},
								function (e, t) {
									E.fn[e] = function (e, n, r) {
										return this.animate(t, e, n, r)
									}
								}
							),
							(E.timers = []),
							(E.fx.tick = function () {
								var e,
									t = 0,
									n = E.timers
								for (pt = Date.now(); t < n.length; t++)
									(e = n[t])() || n[t] !== e || n.splice(t--, 1)
								n.length || E.fx.stop(), (pt = void 0)
							}),
							(E.fx.timer = function (e) {
								E.timers.push(e), E.fx.start()
							}),
							(E.fx.interval = 13),
							(E.fx.start = function () {
								ft || ((ft = !0), mt())
							}),
							(E.fx.stop = function () {
								ft = null
							}),
							(E.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
							(E.fn.delay = function (e, t) {
								return (
									(e = (E.fx && E.fx.speeds[e]) || e),
									(t = t || 'fx'),
									this.queue(t, function (t, n) {
										var i = r.setTimeout(t, e)
										n.stop = function () {
											r.clearTimeout(i)
										}
									})
								)
							}),
							(function () {
								var e = _.createElement('input'),
									t = _.createElement('select').appendChild(
										_.createElement('option')
									)
								;(e.type = 'checkbox'),
									(m.checkOn = '' !== e.value),
									(m.optSelected = t.selected),
									((e = _.createElement('input')).value = 't'),
									(e.type = 'radio'),
									(m.radioValue = 't' === e.value)
							})()
						var wt,
							xt = E.expr.attrHandle
						E.fn.extend({
							attr: function (e, t) {
								return ee(this, E.attr, e, t, arguments.length > 1)
							},
							removeAttr: function (e) {
								return this.each(function () {
									E.removeAttr(this, e)
								})
							}
						}),
							E.extend({
								attr: function (e, t, n) {
									var r,
										i,
										o = e.nodeType
									if (3 !== o && 8 !== o && 2 !== o)
										return void 0 === e.getAttribute
											? E.prop(e, t, n)
											: ((1 === o && E.isXMLDoc(e)) ||
													(i =
														E.attrHooks[t.toLowerCase()] ||
														(E.expr.match.bool.test(t)
															? wt
															: void 0)),
											  void 0 !== n
													? null === n
														? void E.removeAttr(e, t)
														: i &&
														  'set' in i &&
														  void 0 !== (r = i.set(e, n, t))
														? r
														: (e.setAttribute(t, n + ''), n)
													: i &&
													  'get' in i &&
													  null !== (r = i.get(e, t))
													? r
													: null == (r = E.find.attr(e, t))
													? void 0
													: r)
								},
								attrHooks: {
									type: {
										set: function (e, t) {
											if (
												!m.radioValue &&
												'radio' === t &&
												S(e, 'input')
											) {
												var n = e.value
												return (
													e.setAttribute('type', t),
													n && (e.value = n),
													t
												)
											}
										}
									}
								},
								removeAttr: function (e, t) {
									var n,
										r = 0,
										i = t && t.match(U)
									if (i && 1 === e.nodeType)
										for (; (n = i[r++]); ) e.removeAttribute(n)
								}
							}),
							(wt = {
								set: function (e, t, n) {
									return (
										!1 === t
											? E.removeAttr(e, n)
											: e.setAttribute(n, n),
										n
									)
								}
							}),
							E.each(
								E.expr.match.bool.source.match(/\w+/g),
								function (e, t) {
									var n = xt[t] || E.find.attr
									xt[t] = function (e, t, r) {
										var i,
											o,
											s = t.toLowerCase()
										return (
											r ||
												((o = xt[s]),
												(xt[s] = i),
												(i = null != n(e, t, r) ? s : null),
												(xt[s] = o)),
											i
										)
									}
								}
							)
						var Tt = /^(?:input|select|textarea|button)$/i,
							Ct = /^(?:a|area)$/i
						function Et(e) {
							return (e.match(U) || []).join(' ')
						}
						function kt(e) {
							return (e.getAttribute && e.getAttribute('class')) || ''
						}
						function St(e) {
							return Array.isArray(e)
								? e
								: ('string' == typeof e && e.match(U)) || []
						}
						E.fn.extend({
							prop: function (e, t) {
								return ee(this, E.prop, e, t, arguments.length > 1)
							},
							removeProp: function (e) {
								return this.each(function () {
									delete this[E.propFix[e] || e]
								})
							}
						}),
							E.extend({
								prop: function (e, t, n) {
									var r,
										i,
										o = e.nodeType
									if (3 !== o && 8 !== o && 2 !== o)
										return (
											(1 === o && E.isXMLDoc(e)) ||
												((t = E.propFix[t] || t),
												(i = E.propHooks[t])),
											void 0 !== n
												? i &&
												  'set' in i &&
												  void 0 !== (r = i.set(e, n, t))
													? r
													: (e[t] = n)
												: i &&
												  'get' in i &&
												  null !== (r = i.get(e, t))
												? r
												: e[t]
										)
								},
								propHooks: {
									tabIndex: {
										get: function (e) {
											var t = E.find.attr(e, 'tabindex')
											return t
												? parseInt(t, 10)
												: Tt.test(e.nodeName) ||
												  (Ct.test(e.nodeName) && e.href)
												? 0
												: -1
										}
									}
								},
								propFix: { for: 'htmlFor', class: 'className' }
							}),
							m.optSelected ||
								(E.propHooks.selected = {
									get: function (e) {
										var t = e.parentNode
										return (
											t && t.parentNode && t.parentNode.selectedIndex,
											null
										)
									},
									set: function (e) {
										var t = e.parentNode
										t &&
											(t.selectedIndex,
											t.parentNode && t.parentNode.selectedIndex)
									}
								}),
							E.each(
								[
									'tabIndex',
									'readOnly',
									'maxLength',
									'cellSpacing',
									'cellPadding',
									'rowSpan',
									'colSpan',
									'useMap',
									'frameBorder',
									'contentEditable'
								],
								function () {
									E.propFix[this.toLowerCase()] = this
								}
							),
							E.fn.extend({
								addClass: function (e) {
									var t, n, r, i, o, s
									return g(e)
										? this.each(function (t) {
												E(this).addClass(e.call(this, t, kt(this)))
										  })
										: (t = St(e)).length
										? this.each(function () {
												if (
													((r = kt(this)),
													(n =
														1 === this.nodeType && ' ' + Et(r) + ' '))
												) {
													for (o = 0; o < t.length; o++)
														(i = t[o]),
															n.indexOf(' ' + i + ' ') < 0 &&
																(n += i + ' ')
													;(s = Et(n)),
														r !== s && this.setAttribute('class', s)
												}
										  })
										: this
								},
								removeClass: function (e) {
									var t, n, r, i, o, s
									return g(e)
										? this.each(function (t) {
												E(this).removeClass(e.call(this, t, kt(this)))
										  })
										: arguments.length
										? (t = St(e)).length
											? this.each(function () {
													if (
														((r = kt(this)),
														(n =
															1 === this.nodeType &&
															' ' + Et(r) + ' '))
													) {
														for (o = 0; o < t.length; o++)
															for (
																i = t[o];
																n.indexOf(' ' + i + ' ') > -1;

															)
																n = n.replace(' ' + i + ' ', ' ')
														;(s = Et(n)),
															r !== s && this.setAttribute('class', s)
													}
											  })
											: this
										: this.attr('class', '')
								},
								toggleClass: function (e, t) {
									var n,
										r,
										i,
										o,
										s = typeof e,
										a = 'string' === s || Array.isArray(e)
									return g(e)
										? this.each(function (n) {
												E(this).toggleClass(
													e.call(this, n, kt(this), t),
													t
												)
										  })
										: 'boolean' == typeof t && a
										? t
											? this.addClass(e)
											: this.removeClass(e)
										: ((n = St(e)),
										  this.each(function () {
												if (a)
													for (o = E(this), i = 0; i < n.length; i++)
														(r = n[i]),
															o.hasClass(r)
																? o.removeClass(r)
																: o.addClass(r)
												else
													(void 0 !== e && 'boolean' !== s) ||
														((r = kt(this)) &&
															ae.set(this, '__className__', r),
														this.setAttribute &&
															this.setAttribute(
																'class',
																r || !1 === e
																	? ''
																	: ae.get(this, '__className__') ||
																			''
															))
										  }))
								},
								hasClass: function (e) {
									var t,
										n,
										r = 0
									for (t = ' ' + e + ' '; (n = this[r++]); )
										if (
											1 === n.nodeType &&
											(' ' + Et(kt(n)) + ' ').indexOf(t) > -1
										)
											return !0
									return !1
								}
							})
						var Mt = /\r/g
						E.fn.extend({
							val: function (e) {
								var t,
									n,
									r,
									i = this[0]
								return arguments.length
									? ((r = g(e)),
									  this.each(function (n) {
											var i
											1 === this.nodeType &&
												(null ==
												(i = r ? e.call(this, n, E(this).val()) : e)
													? (i = '')
													: 'number' == typeof i
													? (i += '')
													: Array.isArray(i) &&
													  (i = E.map(i, function (e) {
															return null == e ? '' : e + ''
													  })),
												((t =
													E.valHooks[this.type] ||
													E.valHooks[this.nodeName.toLowerCase()]) &&
													'set' in t &&
													void 0 !== t.set(this, i, 'value')) ||
													(this.value = i))
									  }))
									: i
									? (t =
											E.valHooks[i.type] ||
											E.valHooks[i.nodeName.toLowerCase()]) &&
									  'get' in t &&
									  void 0 !== (n = t.get(i, 'value'))
										? n
										: 'string' == typeof (n = i.value)
										? n.replace(Mt, '')
										: null == n
										? ''
										: n
									: void 0
							}
						}),
							E.extend({
								valHooks: {
									option: {
										get: function (e) {
											var t = E.find.attr(e, 'value')
											return null != t ? t : Et(E.text(e))
										}
									},
									select: {
										get: function (e) {
											var t,
												n,
												r,
												i = e.options,
												o = e.selectedIndex,
												s = 'select-one' === e.type,
												a = s ? null : [],
												l = s ? o + 1 : i.length
											for (r = o < 0 ? l : s ? o : 0; r < l; r++)
												if (
													((n = i[r]).selected || r === o) &&
													!n.disabled &&
													(!n.parentNode.disabled ||
														!S(n.parentNode, 'optgroup'))
												) {
													if (((t = E(n).val()), s)) return t
													a.push(t)
												}
											return a
										},
										set: function (e, t) {
											for (
												var n,
													r,
													i = e.options,
													o = E.makeArray(t),
													s = i.length;
												s--;

											)
												((r = i[s]).selected =
													E.inArray(E.valHooks.option.get(r), o) >
													-1) && (n = !0)
											return n || (e.selectedIndex = -1), o
										}
									}
								}
							}),
							E.each(['radio', 'checkbox'], function () {
								;(E.valHooks[this] = {
									set: function (e, t) {
										if (Array.isArray(t))
											return (e.checked =
												E.inArray(E(e).val(), t) > -1)
									}
								}),
									m.checkOn ||
										(E.valHooks[this].get = function (e) {
											return null === e.getAttribute('value')
												? 'on'
												: e.value
										})
							})
						var Pt = r.location,
							Lt = { guid: Date.now() },
							At = /\?/
						E.parseXML = function (e) {
							var t, n
							if (!e || 'string' != typeof e) return null
							try {
								t = new r.DOMParser().parseFromString(e, 'text/xml')
							} catch (e) {}
							return (
								(n = t && t.getElementsByTagName('parsererror')[0]),
								(t && !n) ||
									E.error(
										'Invalid XML: ' +
											(n
												? E.map(n.childNodes, function (e) {
														return e.textContent
												  }).join('\n')
												: e)
									),
								t
							)
						}
						var Ot = /^(?:focusinfocus|focusoutblur)$/,
							jt = function (e) {
								e.stopPropagation()
							}
						E.extend(E.event, {
							trigger: function (e, t, n, i) {
								var o,
									s,
									a,
									l,
									u,
									c,
									d,
									p,
									h = [n || _],
									v = f.call(e, 'type') ? e.type : e,
									m = f.call(e, 'namespace')
										? e.namespace.split('.')
										: []
								if (
									((s = p = a = n = n || _),
									3 !== n.nodeType &&
										8 !== n.nodeType &&
										!Ot.test(v + E.event.triggered) &&
										(v.indexOf('.') > -1 &&
											((m = v.split('.')), (v = m.shift()), m.sort()),
										(u = v.indexOf(':') < 0 && 'on' + v),
										((e = e[E.expando]
											? e
											: new E.Event(
													v,
													'object' == typeof e && e
											  )).isTrigger = i ? 2 : 3),
										(e.namespace = m.join('.')),
										(e.rnamespace = e.namespace
											? new RegExp(
													'(^|\\.)' +
														m.join('\\.(?:.*\\.|)') +
														'(\\.|$)'
											  )
											: null),
										(e.result = void 0),
										e.target || (e.target = n),
										(t = null == t ? [e] : E.makeArray(t, [e])),
										(d = E.event.special[v] || {}),
										i || !d.trigger || !1 !== d.trigger.apply(n, t)))
								) {
									if (!i && !d.noBubble && !y(n)) {
										for (
											l = d.delegateType || v,
												Ot.test(l + v) || (s = s.parentNode);
											s;
											s = s.parentNode
										)
											h.push(s), (a = s)
										a === (n.ownerDocument || _) &&
											h.push(a.defaultView || a.parentWindow || r)
									}
									for (
										o = 0;
										(s = h[o++]) && !e.isPropagationStopped();

									)
										(p = s),
											(e.type = o > 1 ? l : d.bindType || v),
											(c =
												(ae.get(s, 'events') || Object.create(null))[
													e.type
												] && ae.get(s, 'handle')) && c.apply(s, t),
											(c = u && s[u]) &&
												c.apply &&
												oe(s) &&
												((e.result = c.apply(s, t)),
												!1 === e.result && e.preventDefault())
									return (
										(e.type = v),
										i ||
											e.isDefaultPrevented() ||
											(d._default &&
												!1 !== d._default.apply(h.pop(), t)) ||
											!oe(n) ||
											(u &&
												g(n[v]) &&
												!y(n) &&
												((a = n[u]) && (n[u] = null),
												(E.event.triggered = v),
												e.isPropagationStopped() &&
													p.addEventListener(v, jt),
												n[v](),
												e.isPropagationStopped() &&
													p.removeEventListener(v, jt),
												(E.event.triggered = void 0),
												a && (n[u] = a))),
										e.result
									)
								}
							},
							simulate: function (e, t, n) {
								var r = E.extend(new E.Event(), n, {
									type: e,
									isSimulated: !0
								})
								E.event.trigger(r, null, t)
							}
						}),
							E.fn.extend({
								trigger: function (e, t) {
									return this.each(function () {
										E.event.trigger(e, t, this)
									})
								},
								triggerHandler: function (e, t) {
									var n = this[0]
									if (n) return E.event.trigger(e, t, n, !0)
								}
							})
						var $t = /\[\]$/,
							Dt = /\r?\n/g,
							Nt = /^(?:submit|button|image|reset|file)$/i,
							It = /^(?:input|select|textarea|keygen)/i
						function qt(e, t, n, r) {
							var i
							if (Array.isArray(t))
								E.each(t, function (t, i) {
									n || $t.test(e)
										? r(e, i)
										: qt(
												e +
													'[' +
													('object' == typeof i && null != i
														? t
														: '') +
													']',
												i,
												n,
												r
										  )
								})
							else if (n || 'object' !== x(t)) r(e, t)
							else for (i in t) qt(e + '[' + i + ']', t[i], n, r)
						}
						;(E.param = function (e, t) {
							var n,
								r = [],
								i = function (e, t) {
									var n = g(t) ? t() : t
									r[r.length] =
										encodeURIComponent(e) +
										'=' +
										encodeURIComponent(null == n ? '' : n)
								}
							if (null == e) return ''
							if (
								Array.isArray(e) ||
								(e.jquery && !E.isPlainObject(e))
							)
								E.each(e, function () {
									i(this.name, this.value)
								})
							else for (n in e) qt(n, e[n], t, i)
							return r.join('&')
						}),
							E.fn.extend({
								serialize: function () {
									return E.param(this.serializeArray())
								},
								serializeArray: function () {
									return this.map(function () {
										var e = E.prop(this, 'elements')
										return e ? E.makeArray(e) : this
									})
										.filter(function () {
											var e = this.type
											return (
												this.name &&
												!E(this).is(':disabled') &&
												It.test(this.nodeName) &&
												!Nt.test(e) &&
												(this.checked || !Ee.test(e))
											)
										})
										.map(function (e, t) {
											var n = E(this).val()
											return null == n
												? null
												: Array.isArray(n)
												? E.map(n, function (e) {
														return {
															name: t.name,
															value: e.replace(Dt, '\r\n')
														}
												  })
												: {
														name: t.name,
														value: n.replace(Dt, '\r\n')
												  }
										})
										.get()
								}
							})
						var Ht = /%20/g,
							Bt = /#.*$/,
							Ft = /([?&])_=[^&]*/,
							Rt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
							zt = /^(?:GET|HEAD)$/,
							Wt = /^\/\//,
							Vt = {},
							Gt = {},
							Ut = '*/'.concat('*'),
							Xt = _.createElement('a')
						function Yt(e) {
							return function (t, n) {
								'string' != typeof t && ((n = t), (t = '*'))
								var r,
									i = 0,
									o = t.toLowerCase().match(U) || []
								if (g(n))
									for (; (r = o[i++]); )
										'+' === r[0]
											? ((r = r.slice(1) || '*'),
											  (e[r] = e[r] || []).unshift(n))
											: (e[r] = e[r] || []).push(n)
							}
						}
						function Kt(e, t, n, r) {
							var i = {},
								o = e === Gt
							function s(a) {
								var l
								return (
									(i[a] = !0),
									E.each(e[a] || [], function (e, a) {
										var u = a(t, n, r)
										return 'string' != typeof u || o || i[u]
											? o
												? !(l = u)
												: void 0
											: (t.dataTypes.unshift(u), s(u), !1)
									}),
									l
								)
							}
							return s(t.dataTypes[0]) || (!i['*'] && s('*'))
						}
						function Qt(e, t) {
							var n,
								r,
								i = E.ajaxSettings.flatOptions || {}
							for (n in t)
								void 0 !== t[n] &&
									((i[n] ? e : r || (r = {}))[n] = t[n])
							return r && E.extend(!0, e, r), e
						}
						;(Xt.href = Pt.href),
							E.extend({
								active: 0,
								lastModified: {},
								etag: {},
								ajaxSettings: {
									url: Pt.href,
									type: 'GET',
									isLocal:
										/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
											Pt.protocol
										),
									global: !0,
									processData: !0,
									async: !0,
									contentType:
										'application/x-www-form-urlencoded; charset=UTF-8',
									accepts: {
										'*': Ut,
										text: 'text/plain',
										html: 'text/html',
										xml: 'application/xml, text/xml',
										json: 'application/json, text/javascript'
									},
									contents: {
										xml: /\bxml\b/,
										html: /\bhtml/,
										json: /\bjson\b/
									},
									responseFields: {
										xml: 'responseXML',
										text: 'responseText',
										json: 'responseJSON'
									},
									converters: {
										'* text': String,
										'text html': !0,
										'text json': JSON.parse,
										'text xml': E.parseXML
									},
									flatOptions: { url: !0, context: !0 }
								},
								ajaxSetup: function (e, t) {
									return t
										? Qt(Qt(e, E.ajaxSettings), t)
										: Qt(E.ajaxSettings, e)
								},
								ajaxPrefilter: Yt(Vt),
								ajaxTransport: Yt(Gt),
								ajax: function (e, t) {
									'object' == typeof e && ((t = e), (e = void 0)),
										(t = t || {})
									var n,
										i,
										o,
										s,
										a,
										l,
										u,
										c,
										d,
										p,
										f = E.ajaxSetup({}, t),
										h = f.context || f,
										v =
											f.context && (h.nodeType || h.jquery)
												? E(h)
												: E.event,
										m = E.Deferred(),
										g = E.Callbacks('once memory'),
										y = f.statusCode || {},
										b = {},
										w = {},
										x = 'canceled',
										T = {
											readyState: 0,
											getResponseHeader: function (e) {
												var t
												if (u) {
													if (!s)
														for (s = {}; (t = Rt.exec(o)); )
															s[t[1].toLowerCase() + ' '] = (
																s[t[1].toLowerCase() + ' '] || []
															).concat(t[2])
													t = s[e.toLowerCase() + ' ']
												}
												return null == t ? null : t.join(', ')
											},
											getAllResponseHeaders: function () {
												return u ? o : null
											},
											setRequestHeader: function (e, t) {
												return (
													null == u &&
														((e = w[e.toLowerCase()] =
															w[e.toLowerCase()] || e),
														(b[e] = t)),
													this
												)
											},
											overrideMimeType: function (e) {
												return null == u && (f.mimeType = e), this
											},
											statusCode: function (e) {
												var t
												if (e)
													if (u) T.always(e[T.status])
													else for (t in e) y[t] = [y[t], e[t]]
												return this
											},
											abort: function (e) {
												var t = e || x
												return n && n.abort(t), C(0, t), this
											}
										}
									if (
										(m.promise(T),
										(f.url = ((e || f.url || Pt.href) + '').replace(
											Wt,
											Pt.protocol + '//'
										)),
										(f.type =
											t.method || t.type || f.method || f.type),
										(f.dataTypes = (f.dataType || '*')
											.toLowerCase()
											.match(U) || ['']),
										null == f.crossDomain)
									) {
										l = _.createElement('a')
										try {
											;(l.href = f.url),
												(l.href = l.href),
												(f.crossDomain =
													Xt.protocol + '//' + Xt.host !=
													l.protocol + '//' + l.host)
										} catch (e) {
											f.crossDomain = !0
										}
									}
									if (
										(f.data &&
											f.processData &&
											'string' != typeof f.data &&
											(f.data = E.param(f.data, f.traditional)),
										Kt(Vt, f, t, T),
										u)
									)
										return T
									for (d in ((c = E.event && f.global) &&
										0 == E.active++ &&
										E.event.trigger('ajaxStart'),
									(f.type = f.type.toUpperCase()),
									(f.hasContent = !zt.test(f.type)),
									(i = f.url.replace(Bt, '')),
									f.hasContent
										? f.data &&
										  f.processData &&
										  0 ===
												(f.contentType || '').indexOf(
													'application/x-www-form-urlencoded'
												) &&
										  (f.data = f.data.replace(Ht, '+'))
										: ((p = f.url.slice(i.length)),
										  f.data &&
												(f.processData ||
													'string' == typeof f.data) &&
												((i += (At.test(i) ? '&' : '?') + f.data),
												delete f.data),
										  !1 === f.cache &&
												((i = i.replace(Ft, '$1')),
												(p =
													(At.test(i) ? '&' : '?') +
													'_=' +
													Lt.guid++ +
													p)),
										  (f.url = i + p)),
									f.ifModified &&
										(E.lastModified[i] &&
											T.setRequestHeader(
												'If-Modified-Since',
												E.lastModified[i]
											),
										E.etag[i] &&
											T.setRequestHeader('If-None-Match', E.etag[i])),
									((f.data && f.hasContent && !1 !== f.contentType) ||
										t.contentType) &&
										T.setRequestHeader('Content-Type', f.contentType),
									T.setRequestHeader(
										'Accept',
										f.dataTypes[0] && f.accepts[f.dataTypes[0]]
											? f.accepts[f.dataTypes[0]] +
													('*' !== f.dataTypes[0]
														? ', ' + Ut + '; q=0.01'
														: '')
											: f.accepts['*']
									),
									f.headers))
										T.setRequestHeader(d, f.headers[d])
									if (
										f.beforeSend &&
										(!1 === f.beforeSend.call(h, T, f) || u)
									)
										return T.abort()
									if (
										((x = 'abort'),
										g.add(f.complete),
										T.done(f.success),
										T.fail(f.error),
										(n = Kt(Gt, f, t, T)))
									) {
										if (
											((T.readyState = 1),
											c && v.trigger('ajaxSend', [T, f]),
											u)
										)
											return T
										f.async &&
											f.timeout > 0 &&
											(a = r.setTimeout(function () {
												T.abort('timeout')
											}, f.timeout))
										try {
											;(u = !1), n.send(b, C)
										} catch (e) {
											if (u) throw e
											C(-1, e)
										}
									} else C(-1, 'No Transport')
									function C(e, t, s, l) {
										var d,
											p,
											_,
											b,
											w,
											x = t
										u ||
											((u = !0),
											a && r.clearTimeout(a),
											(n = void 0),
											(o = l || ''),
											(T.readyState = e > 0 ? 4 : 0),
											(d = (e >= 200 && e < 300) || 304 === e),
											s &&
												(b = (function (e, t, n) {
													for (
														var r,
															i,
															o,
															s,
															a = e.contents,
															l = e.dataTypes;
														'*' === l[0];

													)
														l.shift(),
															void 0 === r &&
																(r =
																	e.mimeType ||
																	t.getResponseHeader('Content-Type'))
													if (r)
														for (i in a)
															if (a[i] && a[i].test(r)) {
																l.unshift(i)
																break
															}
													if (l[0] in n) o = l[0]
													else {
														for (i in n) {
															if (
																!l[0] ||
																e.converters[i + ' ' + l[0]]
															) {
																o = i
																break
															}
															s || (s = i)
														}
														o = o || s
													}
													if (o)
														return o !== l[0] && l.unshift(o), n[o]
												})(f, T, s)),
											!d &&
												E.inArray('script', f.dataTypes) > -1 &&
												E.inArray('json', f.dataTypes) < 0 &&
												(f.converters['text script'] =
													function () {}),
											(b = (function (e, t, n, r) {
												var i,
													o,
													s,
													a,
													l,
													u = {},
													c = e.dataTypes.slice()
												if (c[1])
													for (s in e.converters)
														u[s.toLowerCase()] = e.converters[s]
												for (o = c.shift(); o; )
													if (
														(e.responseFields[o] &&
															(n[e.responseFields[o]] = t),
														!l &&
															r &&
															e.dataFilter &&
															(t = e.dataFilter(t, e.dataType)),
														(l = o),
														(o = c.shift()))
													)
														if ('*' === o) o = l
														else if ('*' !== l && l !== o) {
															if (
																!(s = u[l + ' ' + o] || u['* ' + o])
															)
																for (i in u)
																	if (
																		(a = i.split(' '))[1] === o &&
																		(s =
																			u[l + ' ' + a[0]] ||
																			u['* ' + a[0]])
																	) {
																		!0 === s
																			? (s = u[i])
																			: !0 !== u[i] &&
																			  ((o = a[0]), c.unshift(a[1]))
																		break
																	}
															if (!0 !== s)
																if (s && e.throws) t = s(t)
																else
																	try {
																		t = s(t)
																	} catch (e) {
																		return {
																			state: 'parsererror',
																			error: s
																				? e
																				: 'No conversion from ' +
																				  l +
																				  ' to ' +
																				  o
																		}
																	}
														}
												return { state: 'success', data: t }
											})(f, b, T, d)),
											d
												? (f.ifModified &&
														((w =
															T.getResponseHeader('Last-Modified')) &&
															(E.lastModified[i] = w),
														(w = T.getResponseHeader('etag')) &&
															(E.etag[i] = w)),
												  204 === e || 'HEAD' === f.type
														? (x = 'nocontent')
														: 304 === e
														? (x = 'notmodified')
														: ((x = b.state),
														  (p = b.data),
														  (d = !(_ = b.error))))
												: ((_ = x),
												  (!e && x) ||
														((x = 'error'), e < 0 && (e = 0))),
											(T.status = e),
											(T.statusText = (t || x) + ''),
											d
												? m.resolveWith(h, [p, x, T])
												: m.rejectWith(h, [T, x, _]),
											T.statusCode(y),
											(y = void 0),
											c &&
												v.trigger(d ? 'ajaxSuccess' : 'ajaxError', [
													T,
													f,
													d ? p : _
												]),
											g.fireWith(h, [T, x]),
											c &&
												(v.trigger('ajaxComplete', [T, f]),
												--E.active || E.event.trigger('ajaxStop')))
									}
									return T
								},
								getJSON: function (e, t, n) {
									return E.get(e, t, n, 'json')
								},
								getScript: function (e, t) {
									return E.get(e, void 0, t, 'script')
								}
							}),
							E.each(['get', 'post'], function (e, t) {
								E[t] = function (e, n, r, i) {
									return (
										g(n) && ((i = i || r), (r = n), (n = void 0)),
										E.ajax(
											E.extend(
												{
													url: e,
													type: t,
													dataType: i,
													data: n,
													success: r
												},
												E.isPlainObject(e) && e
											)
										)
									)
								}
							}),
							E.ajaxPrefilter(function (e) {
								var t
								for (t in e.headers)
									'content-type' === t.toLowerCase() &&
										(e.contentType = e.headers[t] || '')
							}),
							(E._evalUrl = function (e, t, n) {
								return E.ajax({
									url: e,
									type: 'GET',
									dataType: 'script',
									cache: !0,
									async: !1,
									global: !1,
									converters: { 'text script': function () {} },
									dataFilter: function (e) {
										E.globalEval(e, t, n)
									}
								})
							}),
							E.fn.extend({
								wrapAll: function (e) {
									var t
									return (
										this[0] &&
											(g(e) && (e = e.call(this[0])),
											(t = E(e, this[0].ownerDocument)
												.eq(0)
												.clone(!0)),
											this[0].parentNode && t.insertBefore(this[0]),
											t
												.map(function () {
													for (var e = this; e.firstElementChild; )
														e = e.firstElementChild
													return e
												})
												.append(this)),
										this
									)
								},
								wrapInner: function (e) {
									return g(e)
										? this.each(function (t) {
												E(this).wrapInner(e.call(this, t))
										  })
										: this.each(function () {
												var t = E(this),
													n = t.contents()
												n.length ? n.wrapAll(e) : t.append(e)
										  })
								},
								wrap: function (e) {
									var t = g(e)
									return this.each(function (n) {
										E(this).wrapAll(t ? e.call(this, n) : e)
									})
								},
								unwrap: function (e) {
									return (
										this.parent(e)
											.not('body')
											.each(function () {
												E(this).replaceWith(this.childNodes)
											}),
										this
									)
								}
							}),
							(E.expr.pseudos.hidden = function (e) {
								return !E.expr.pseudos.visible(e)
							}),
							(E.expr.pseudos.visible = function (e) {
								return !!(
									e.offsetWidth ||
									e.offsetHeight ||
									e.getClientRects().length
								)
							}),
							(E.ajaxSettings.xhr = function () {
								try {
									return new r.XMLHttpRequest()
								} catch (e) {}
							})
						var Jt = { 0: 200, 1223: 204 },
							Zt = E.ajaxSettings.xhr()
						;(m.cors = !!Zt && 'withCredentials' in Zt),
							(m.ajax = Zt = !!Zt),
							E.ajaxTransport(function (e) {
								var t, n
								if (m.cors || (Zt && !e.crossDomain))
									return {
										send: function (i, o) {
											var s,
												a = e.xhr()
											if (
												(a.open(
													e.type,
													e.url,
													e.async,
													e.username,
													e.password
												),
												e.xhrFields)
											)
												for (s in e.xhrFields) a[s] = e.xhrFields[s]
											for (s in (e.mimeType &&
												a.overrideMimeType &&
												a.overrideMimeType(e.mimeType),
											e.crossDomain ||
												i['X-Requested-With'] ||
												(i['X-Requested-With'] = 'XMLHttpRequest'),
											i))
												a.setRequestHeader(s, i[s])
											;(t = function (e) {
												return function () {
													t &&
														((t =
															n =
															a.onload =
															a.onerror =
															a.onabort =
															a.ontimeout =
															a.onreadystatechange =
																null),
														'abort' === e
															? a.abort()
															: 'error' === e
															? 'number' != typeof a.status
																? o(0, 'error')
																: o(a.status, a.statusText)
															: o(
																	Jt[a.status] || a.status,
																	a.statusText,
																	'text' !==
																		(a.responseType || 'text') ||
																		'string' != typeof a.responseText
																		? { binary: a.response }
																		: { text: a.responseText },
																	a.getAllResponseHeaders()
															  ))
												}
											}),
												(a.onload = t()),
												(n = a.onerror = a.ontimeout = t('error')),
												void 0 !== a.onabort
													? (a.onabort = n)
													: (a.onreadystatechange = function () {
															4 === a.readyState &&
																r.setTimeout(function () {
																	t && n()
																})
													  }),
												(t = t('abort'))
											try {
												a.send((e.hasContent && e.data) || null)
											} catch (e) {
												if (t) throw e
											}
										},
										abort: function () {
											t && t()
										}
									}
							}),
							E.ajaxPrefilter(function (e) {
								e.crossDomain && (e.contents.script = !1)
							}),
							E.ajaxSetup({
								accepts: {
									script:
										'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript'
								},
								contents: { script: /\b(?:java|ecma)script\b/ },
								converters: {
									'text script': function (e) {
										return E.globalEval(e), e
									}
								}
							}),
							E.ajaxPrefilter('script', function (e) {
								void 0 === e.cache && (e.cache = !1),
									e.crossDomain && (e.type = 'GET')
							}),
							E.ajaxTransport('script', function (e) {
								var t, n
								if (e.crossDomain || e.scriptAttrs)
									return {
										send: function (r, i) {
											;(t = E('<script>')
												.attr(e.scriptAttrs || {})
												.prop({
													charset: e.scriptCharset,
													src: e.url
												})
												.on(
													'load error',
													(n = function (e) {
														t.remove(),
															(n = null),
															e &&
																i(
																	'error' === e.type ? 404 : 200,
																	e.type
																)
													})
												)),
												_.head.appendChild(t[0])
										},
										abort: function () {
											n && n()
										}
									}
							})
						var en,
							tn = [],
							nn = /(=)\?(?=&|$)|\?\?/
						E.ajaxSetup({
							jsonp: 'callback',
							jsonpCallback: function () {
								var e = tn.pop() || E.expando + '_' + Lt.guid++
								return (this[e] = !0), e
							}
						}),
							E.ajaxPrefilter('json jsonp', function (e, t, n) {
								var i,
									o,
									s,
									a =
										!1 !== e.jsonp &&
										(nn.test(e.url)
											? 'url'
											: 'string' == typeof e.data &&
											  0 ===
													(e.contentType || '').indexOf(
														'application/x-www-form-urlencoded'
													) &&
											  nn.test(e.data) &&
											  'data')
								if (a || 'jsonp' === e.dataTypes[0])
									return (
										(i = e.jsonpCallback =
											g(e.jsonpCallback)
												? e.jsonpCallback()
												: e.jsonpCallback),
										a
											? (e[a] = e[a].replace(nn, '$1' + i))
											: !1 !== e.jsonp &&
											  (e.url +=
													(At.test(e.url) ? '&' : '?') +
													e.jsonp +
													'=' +
													i),
										(e.converters['script json'] = function () {
											return s || E.error(i + ' was not called'), s[0]
										}),
										(e.dataTypes[0] = 'json'),
										(o = r[i]),
										(r[i] = function () {
											s = arguments
										}),
										n.always(function () {
											void 0 === o ? E(r).removeProp(i) : (r[i] = o),
												e[i] &&
													((e.jsonpCallback = t.jsonpCallback),
													tn.push(i)),
												s && g(o) && o(s[0]),
												(s = o = void 0)
										}),
										'script'
									)
							}),
							(m.createHTMLDocument =
								(((en =
									_.implementation.createHTMLDocument(
										''
									).body).innerHTML = '<form></form><form></form>'),
								2 === en.childNodes.length)),
							(E.parseHTML = function (e, t, n) {
								return 'string' != typeof e
									? []
									: ('boolean' == typeof t && ((n = t), (t = !1)),
									  t ||
											(m.createHTMLDocument
												? (((r = (t =
														_.implementation.createHTMLDocument(
															''
														)).createElement('base')).href =
														_.location.href),
												  t.head.appendChild(r))
												: (t = _)),
									  (o = !n && []),
									  (i = B.exec(e))
											? [t.createElement(i[1])]
											: ((i = Oe([e], t, o)),
											  o && o.length && E(o).remove(),
											  E.merge([], i.childNodes)))
								var r, i, o
							}),
							(E.fn.load = function (e, t, n) {
								var r,
									i,
									o,
									s = this,
									a = e.indexOf(' ')
								return (
									a > -1 &&
										((r = Et(e.slice(a))), (e = e.slice(0, a))),
									g(t)
										? ((n = t), (t = void 0))
										: t && 'object' == typeof t && (i = 'POST'),
									s.length > 0 &&
										E.ajax({
											url: e,
											type: i || 'GET',
											dataType: 'html',
											data: t
										})
											.done(function (e) {
												;(o = arguments),
													s.html(
														r
															? E('<div>')
																	.append(E.parseHTML(e))
																	.find(r)
															: e
													)
											})
											.always(
												n &&
													function (e, t) {
														s.each(function () {
															n.apply(
																this,
																o || [e.responseText, t, e]
															)
														})
													}
											),
									this
								)
							}),
							(E.expr.pseudos.animated = function (e) {
								return E.grep(E.timers, function (t) {
									return e === t.elem
								}).length
							}),
							(E.offset = {
								setOffset: function (e, t, n) {
									var r,
										i,
										o,
										s,
										a,
										l,
										u = E.css(e, 'position'),
										c = E(e),
										d = {}
									'static' === u && (e.style.position = 'relative'),
										(a = c.offset()),
										(o = E.css(e, 'top')),
										(l = E.css(e, 'left')),
										('absolute' === u || 'fixed' === u) &&
										(o + l).indexOf('auto') > -1
											? ((s = (r = c.position()).top), (i = r.left))
											: ((s = parseFloat(o) || 0),
											  (i = parseFloat(l) || 0)),
										g(t) && (t = t.call(e, n, E.extend({}, a))),
										null != t.top && (d.top = t.top - a.top + s),
										null != t.left && (d.left = t.left - a.left + i),
										'using' in t ? t.using.call(e, d) : c.css(d)
								}
							}),
							E.fn.extend({
								offset: function (e) {
									if (arguments.length)
										return void 0 === e
											? this
											: this.each(function (t) {
													E.offset.setOffset(this, e, t)
											  })
									var t,
										n,
										r = this[0]
									return r
										? r.getClientRects().length
											? ((t = r.getBoundingClientRect()),
											  (n = r.ownerDocument.defaultView),
											  {
													top: t.top + n.pageYOffset,
													left: t.left + n.pageXOffset
											  })
											: { top: 0, left: 0 }
										: void 0
								},
								position: function () {
									if (this[0]) {
										var e,
											t,
											n,
											r = this[0],
											i = { top: 0, left: 0 }
										if ('fixed' === E.css(r, 'position'))
											t = r.getBoundingClientRect()
										else {
											for (
												t = this.offset(),
													n = r.ownerDocument,
													e = r.offsetParent || n.documentElement;
												e &&
												(e === n.body || e === n.documentElement) &&
												'static' === E.css(e, 'position');

											)
												e = e.parentNode
											e &&
												e !== r &&
												1 === e.nodeType &&
												(((i = E(e).offset()).top += E.css(
													e,
													'borderTopWidth',
													!0
												)),
												(i.left += E.css(e, 'borderLeftWidth', !0)))
										}
										return {
											top: t.top - i.top - E.css(r, 'marginTop', !0),
											left:
												t.left - i.left - E.css(r, 'marginLeft', !0)
										}
									}
								},
								offsetParent: function () {
									return this.map(function () {
										for (
											var e = this.offsetParent;
											e && 'static' === E.css(e, 'position');

										)
											e = e.offsetParent
										return e || ve
									})
								}
							}),
							E.each(
								{
									scrollLeft: 'pageXOffset',
									scrollTop: 'pageYOffset'
								},
								function (e, t) {
									var n = 'pageYOffset' === t
									E.fn[e] = function (r) {
										return ee(
											this,
											function (e, r, i) {
												var o
												if (
													(y(e)
														? (o = e)
														: 9 === e.nodeType && (o = e.defaultView),
													void 0 === i)
												)
													return o ? o[t] : e[r]
												o
													? o.scrollTo(
															n ? o.pageXOffset : i,
															n ? i : o.pageYOffset
													  )
													: (e[r] = i)
											},
											e,
											r,
											arguments.length
										)
									}
								}
							),
							E.each(['top', 'left'], function (e, t) {
								E.cssHooks[t] = et(m.pixelPosition, function (e, n) {
									if (n)
										return (
											(n = Ze(e, t)),
											Xe.test(n) ? E(e).position()[t] + 'px' : n
										)
								})
							}),
							E.each(
								{ Height: 'height', Width: 'width' },
								function (e, t) {
									E.each(
										{
											padding: 'inner' + e,
											content: t,
											'': 'outer' + e
										},
										function (n, r) {
											E.fn[r] = function (i, o) {
												var s =
														arguments.length &&
														(n || 'boolean' != typeof i),
													a =
														n ||
														(!0 === i || !0 === o
															? 'margin'
															: 'border')
												return ee(
													this,
													function (t, n, i) {
														var o
														return y(t)
															? 0 === r.indexOf('outer')
																? t['inner' + e]
																: t.document.documentElement[
																		'client' + e
																  ]
															: 9 === t.nodeType
															? ((o = t.documentElement),
															  Math.max(
																	t.body['scroll' + e],
																	o['scroll' + e],
																	t.body['offset' + e],
																	o['offset' + e],
																	o['client' + e]
															  ))
															: void 0 === i
															? E.css(t, n, a)
															: E.style(t, n, i, a)
													},
													t,
													s ? i : void 0,
													s
												)
											}
										}
									)
								}
							),
							E.each(
								[
									'ajaxStart',
									'ajaxStop',
									'ajaxComplete',
									'ajaxError',
									'ajaxSuccess',
									'ajaxSend'
								],
								function (e, t) {
									E.fn[t] = function (e) {
										return this.on(t, e)
									}
								}
							),
							E.fn.extend({
								bind: function (e, t, n) {
									return this.on(e, null, t, n)
								},
								unbind: function (e, t) {
									return this.off(e, null, t)
								},
								delegate: function (e, t, n, r) {
									return this.on(t, e, n, r)
								},
								undelegate: function (e, t, n) {
									return 1 === arguments.length
										? this.off(e, '**')
										: this.off(t, e || '**', n)
								},
								hover: function (e, t) {
									return this.on('mouseenter', e).on(
										'mouseleave',
										t || e
									)
								}
							}),
							E.each(
								'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
									' '
								),
								function (e, t) {
									E.fn[t] = function (e, n) {
										return arguments.length > 0
											? this.on(t, null, e, n)
											: this.trigger(t)
									}
								}
							)
						var rn =
							/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g
						;(E.proxy = function (e, t) {
							var n, r, i
							if (
								('string' == typeof t &&
									((n = e[t]), (t = e), (e = n)),
								g(e))
							)
								return (
									(r = a.call(arguments, 2)),
									(i = function () {
										return e.apply(
											t || this,
											r.concat(a.call(arguments))
										)
									}),
									(i.guid = e.guid = e.guid || E.guid++),
									i
								)
						}),
							(E.holdReady = function (e) {
								e ? E.readyWait++ : E.ready(!0)
							}),
							(E.isArray = Array.isArray),
							(E.parseJSON = JSON.parse),
							(E.nodeName = S),
							(E.isFunction = g),
							(E.isWindow = y),
							(E.camelCase = ie),
							(E.type = x),
							(E.now = Date.now),
							(E.isNumeric = function (e) {
								var t = E.type(e)
								return (
									('number' === t || 'string' === t) &&
									!isNaN(e - parseFloat(e))
								)
							}),
							(E.trim = function (e) {
								return null == e ? '' : (e + '').replace(rn, '$1')
							}),
							void 0 ===
								(n = function () {
									return E
								}.apply(t, [])) || (e.exports = n)
						var on = r.jQuery,
							sn = r.$
						return (
							(E.noConflict = function (e) {
								return (
									r.$ === E && (r.$ = sn),
									e && r.jQuery === E && (r.jQuery = on),
									E
								)
							}),
							void 0 === i && (r.jQuery = r.$ = E),
							E
						)
					}
				)
			},
			4633: function (e, t, n) {
				var r = n(3738).default
				function i() {
					'use strict'
					;(e.exports = i =
						function () {
							return n
						}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports)
					var t,
						n = {},
						o = Object.prototype,
						s = o.hasOwnProperty,
						a =
							Object.defineProperty ||
							function (e, t, n) {
								e[t] = n.value
							},
						l = 'function' == typeof Symbol ? Symbol : {},
						u = l.iterator || '@@iterator',
						c = l.asyncIterator || '@@asyncIterator',
						d = l.toStringTag || '@@toStringTag'
					function p(e, t, n) {
						return (
							Object.defineProperty(e, t, {
								value: n,
								enumerable: !0,
								configurable: !0,
								writable: !0
							}),
							e[t]
						)
					}
					try {
						p({}, '')
					} catch (t) {
						p = function (e, t, n) {
							return (e[t] = n)
						}
					}
					function f(e, t, n, r) {
						var i = t && t.prototype instanceof b ? t : b,
							o = Object.create(i.prototype),
							s = new j(r || [])
						return a(o, '_invoke', { value: P(e, n, s) }), o
					}
					function h(e, t, n) {
						try {
							return { type: 'normal', arg: e.call(t, n) }
						} catch (e) {
							return { type: 'throw', arg: e }
						}
					}
					n.wrap = f
					var v = 'suspendedStart',
						m = 'suspendedYield',
						g = 'executing',
						y = 'completed',
						_ = {}
					function b() {}
					function w() {}
					function x() {}
					var T = {}
					p(T, u, function () {
						return this
					})
					var C = Object.getPrototypeOf,
						E = C && C(C($([])))
					E && E !== o && s.call(E, u) && (T = E)
					var k = (x.prototype = b.prototype = Object.create(T))
					function S(e) {
						;['next', 'throw', 'return'].forEach(function (t) {
							p(e, t, function (e) {
								return this._invoke(t, e)
							})
						})
					}
					function M(e, t) {
						function n(i, o, a, l) {
							var u = h(e[i], e, o)
							if ('throw' !== u.type) {
								var c = u.arg,
									d = c.value
								return d && 'object' == r(d) && s.call(d, '__await')
									? t.resolve(d.__await).then(
											function (e) {
												n('next', e, a, l)
											},
											function (e) {
												n('throw', e, a, l)
											}
									  )
									: t.resolve(d).then(
											function (e) {
												;(c.value = e), a(c)
											},
											function (e) {
												return n('throw', e, a, l)
											}
									  )
							}
							l(u.arg)
						}
						var i
						a(this, '_invoke', {
							value: function (e, r) {
								function o() {
									return new t(function (t, i) {
										n(e, r, t, i)
									})
								}
								return (i = i ? i.then(o, o) : o())
							}
						})
					}
					function P(e, n, r) {
						var i = v
						return function (o, s) {
							if (i === g) throw Error('Generator is already running')
							if (i === y) {
								if ('throw' === o) throw s
								return { value: t, done: !0 }
							}
							for (r.method = o, r.arg = s; ; ) {
								var a = r.delegate
								if (a) {
									var l = L(a, r)
									if (l) {
										if (l === _) continue
										return l
									}
								}
								if ('next' === r.method) r.sent = r._sent = r.arg
								else if ('throw' === r.method) {
									if (i === v) throw ((i = y), r.arg)
									r.dispatchException(r.arg)
								} else
									'return' === r.method && r.abrupt('return', r.arg)
								i = g
								var u = h(e, n, r)
								if ('normal' === u.type) {
									if (((i = r.done ? y : m), u.arg === _)) continue
									return { value: u.arg, done: r.done }
								}
								'throw' === u.type &&
									((i = y), (r.method = 'throw'), (r.arg = u.arg))
							}
						}
					}
					function L(e, n) {
						var r = n.method,
							i = e.iterator[r]
						if (i === t)
							return (
								(n.delegate = null),
								('throw' === r &&
									e.iterator.return &&
									((n.method = 'return'),
									(n.arg = t),
									L(e, n),
									'throw' === n.method)) ||
									('return' !== r &&
										((n.method = 'throw'),
										(n.arg = new TypeError(
											"The iterator does not provide a '" +
												r +
												"' method"
										)))),
								_
							)
						var o = h(i, e.iterator, n.arg)
						if ('throw' === o.type)
							return (
								(n.method = 'throw'),
								(n.arg = o.arg),
								(n.delegate = null),
								_
							)
						var s = o.arg
						return s
							? s.done
								? ((n[e.resultName] = s.value),
								  (n.next = e.nextLoc),
								  'return' !== n.method &&
										((n.method = 'next'), (n.arg = t)),
								  (n.delegate = null),
								  _)
								: s
							: ((n.method = 'throw'),
							  (n.arg = new TypeError(
									'iterator result is not an object'
							  )),
							  (n.delegate = null),
							  _)
					}
					function A(e) {
						var t = { tryLoc: e[0] }
						1 in e && (t.catchLoc = e[1]),
							2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
							this.tryEntries.push(t)
					}
					function O(e) {
						var t = e.completion || {}
						;(t.type = 'normal'), delete t.arg, (e.completion = t)
					}
					function j(e) {
						;(this.tryEntries = [{ tryLoc: 'root' }]),
							e.forEach(A, this),
							this.reset(!0)
					}
					function $(e) {
						if (e || '' === e) {
							var n = e[u]
							if (n) return n.call(e)
							if ('function' == typeof e.next) return e
							if (!isNaN(e.length)) {
								var i = -1,
									o = function n() {
										for (; ++i < e.length; )
											if (s.call(e, i))
												return (n.value = e[i]), (n.done = !1), n
										return (n.value = t), (n.done = !0), n
									}
								return (o.next = o)
							}
						}
						throw new TypeError(r(e) + ' is not iterable')
					}
					return (
						(w.prototype = x),
						a(k, 'constructor', { value: x, configurable: !0 }),
						a(x, 'constructor', { value: w, configurable: !0 }),
						(w.displayName = p(x, d, 'GeneratorFunction')),
						(n.isGeneratorFunction = function (e) {
							var t = 'function' == typeof e && e.constructor
							return (
								!!t &&
								(t === w ||
									'GeneratorFunction' === (t.displayName || t.name))
							)
						}),
						(n.mark = function (e) {
							return (
								Object.setPrototypeOf
									? Object.setPrototypeOf(e, x)
									: ((e.__proto__ = x), p(e, d, 'GeneratorFunction')),
								(e.prototype = Object.create(k)),
								e
							)
						}),
						(n.awrap = function (e) {
							return { __await: e }
						}),
						S(M.prototype),
						p(M.prototype, c, function () {
							return this
						}),
						(n.AsyncIterator = M),
						(n.async = function (e, t, r, i, o) {
							void 0 === o && (o = Promise)
							var s = new M(f(e, t, r, i), o)
							return n.isGeneratorFunction(t)
								? s
								: s.next().then(function (e) {
										return e.done ? e.value : s.next()
								  })
						}),
						S(k),
						p(k, d, 'Generator'),
						p(k, u, function () {
							return this
						}),
						p(k, 'toString', function () {
							return '[object Generator]'
						}),
						(n.keys = function (e) {
							var t = Object(e),
								n = []
							for (var r in t) n.push(r)
							return (
								n.reverse(),
								function e() {
									for (; n.length; ) {
										var r = n.pop()
										if (r in t) return (e.value = r), (e.done = !1), e
									}
									return (e.done = !0), e
								}
							)
						}),
						(n.values = $),
						(j.prototype = {
							constructor: j,
							reset: function (e) {
								if (
									((this.prev = 0),
									(this.next = 0),
									(this.sent = this._sent = t),
									(this.done = !1),
									(this.delegate = null),
									(this.method = 'next'),
									(this.arg = t),
									this.tryEntries.forEach(O),
									!e)
								)
									for (var n in this)
										't' === n.charAt(0) &&
											s.call(this, n) &&
											!isNaN(+n.slice(1)) &&
											(this[n] = t)
							},
							stop: function () {
								this.done = !0
								var e = this.tryEntries[0].completion
								if ('throw' === e.type) throw e.arg
								return this.rval
							},
							dispatchException: function (e) {
								if (this.done) throw e
								var n = this
								function r(r, i) {
									return (
										(a.type = 'throw'),
										(a.arg = e),
										(n.next = r),
										i && ((n.method = 'next'), (n.arg = t)),
										!!i
									)
								}
								for (
									var i = this.tryEntries.length - 1;
									i >= 0;
									--i
								) {
									var o = this.tryEntries[i],
										a = o.completion
									if ('root' === o.tryLoc) return r('end')
									if (o.tryLoc <= this.prev) {
										var l = s.call(o, 'catchLoc'),
											u = s.call(o, 'finallyLoc')
										if (l && u) {
											if (this.prev < o.catchLoc)
												return r(o.catchLoc, !0)
											if (this.prev < o.finallyLoc)
												return r(o.finallyLoc)
										} else if (l) {
											if (this.prev < o.catchLoc)
												return r(o.catchLoc, !0)
										} else {
											if (!u)
												throw Error(
													'try statement without catch or finally'
												)
											if (this.prev < o.finallyLoc)
												return r(o.finallyLoc)
										}
									}
								}
							},
							abrupt: function (e, t) {
								for (
									var n = this.tryEntries.length - 1;
									n >= 0;
									--n
								) {
									var r = this.tryEntries[n]
									if (
										r.tryLoc <= this.prev &&
										s.call(r, 'finallyLoc') &&
										this.prev < r.finallyLoc
									) {
										var i = r
										break
									}
								}
								i &&
									('break' === e || 'continue' === e) &&
									i.tryLoc <= t &&
									t <= i.finallyLoc &&
									(i = null)
								var o = i ? i.completion : {}
								return (
									(o.type = e),
									(o.arg = t),
									i
										? ((this.method = 'next'),
										  (this.next = i.finallyLoc),
										  _)
										: this.complete(o)
								)
							},
							complete: function (e, t) {
								if ('throw' === e.type) throw e.arg
								return (
									'break' === e.type || 'continue' === e.type
										? (this.next = e.arg)
										: 'return' === e.type
										? ((this.rval = this.arg = e.arg),
										  (this.method = 'return'),
										  (this.next = 'end'))
										: 'normal' === e.type && t && (this.next = t),
									_
								)
							},
							finish: function (e) {
								for (
									var t = this.tryEntries.length - 1;
									t >= 0;
									--t
								) {
									var n = this.tryEntries[t]
									if (n.finallyLoc === e)
										return (
											this.complete(n.completion, n.afterLoc), O(n), _
										)
								}
							},
							catch: function (e) {
								for (
									var t = this.tryEntries.length - 1;
									t >= 0;
									--t
								) {
									var n = this.tryEntries[t]
									if (n.tryLoc === e) {
										var r = n.completion
										if ('throw' === r.type) {
											var i = r.arg
											O(n)
										}
										return i
									}
								}
								throw Error('illegal catch attempt')
							},
							delegateYield: function (e, n, r) {
								return (
									(this.delegate = {
										iterator: $(e),
										resultName: n,
										nextLoc: r
									}),
									'next' === this.method && (this.arg = t),
									_
								)
							}
						}),
						n
					)
				}
				;(e.exports = i),
					(e.exports.__esModule = !0),
					(e.exports.default = e.exports)
			},
			3738: function (e) {
				function t(n) {
					return (
						(e.exports = t =
							'function' == typeof Symbol &&
							'symbol' == typeof Symbol.iterator
								? function (e) {
										return typeof e
								  }
								: function (e) {
										return e &&
											'function' == typeof Symbol &&
											e.constructor === Symbol &&
											e !== Symbol.prototype
											? 'symbol'
											: typeof e
								  }),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports),
						t(n)
					)
				}
				;(e.exports = t),
					(e.exports.__esModule = !0),
					(e.exports.default = e.exports)
			},
			4756: function (e, t, n) {
				var r = n(4633)()
				e.exports = r
				try {
					regeneratorRuntime = r
				} catch (e) {
					'object' == typeof globalThis
						? (globalThis.regeneratorRuntime = r)
						: Function('r', 'regeneratorRuntime = r')(r)
				}
			}
		},
		t = {}
	function n(r) {
		var i = t[r]
		if (void 0 !== i) return i.exports
		var o = (t[r] = { exports: {} })
		return e[r].call(o.exports, o, o.exports, n), o.exports
	}
	;(n.n = function (e) {
		var t =
			e && e.__esModule
				? function () {
						return e.default
				  }
				: function () {
						return e
				  }
		return n.d(t, { a: t }), t
	}),
		(n.d = function (e, t) {
			for (var r in t)
				n.o(t, r) &&
					!n.o(e, r) &&
					Object.defineProperty(e, r, { enumerable: !0, get: t[r] })
		}),
		(n.g = (function () {
			if ('object' == typeof globalThis) return globalThis
			try {
				return this || new Function('return this')()
			} catch (e) {
				if ('object' == typeof window) return window
			}
		})()),
		(n.o = function (e, t) {
			return Object.prototype.hasOwnProperty.call(e, t)
		}),
		(function () {
			'use strict'
			function e(e, t) {
				if (!(e instanceof t))
					throw new TypeError('Cannot call a class as a function')
			}
			function t(e) {
				return (
					(t =
						'function' == typeof Symbol &&
						'symbol' == typeof Symbol.iterator
							? function (e) {
									return typeof e
							  }
							: function (e) {
									return e &&
										'function' == typeof Symbol &&
										e.constructor === Symbol &&
										e !== Symbol.prototype
										? 'symbol'
										: typeof e
							  }),
					t(e)
				)
			}
			function r(e) {
				var n = (function (e, n) {
					if ('object' != t(e) || !e) return e
					var r = e[Symbol.toPrimitive]
					if (void 0 !== r) {
						var i = r.call(e, n || 'default')
						if ('object' != t(i)) return i
						throw new TypeError(
							'@@toPrimitive must return a primitive value.'
						)
					}
					return ('string' === n ? String : Number)(e)
				})(e, 'string')
				return 'symbol' == t(n) ? n : n + ''
			}
			function i(e, t) {
				for (var n = 0; n < t.length; n++) {
					var i = t[n]
					;(i.enumerable = i.enumerable || !1),
						(i.configurable = !0),
						'value' in i && (i.writable = !0),
						Object.defineProperty(e, r(i.key), i)
				}
			}
			function o(e, t, n) {
				return (
					t && i(e.prototype, t),
					n && i(e, n),
					Object.defineProperty(e, 'prototype', { writable: !1 }),
					e
				)
			}
			function s(e, n) {
				if (n && ('object' === t(n) || 'function' == typeof n))
					return n
				if (void 0 !== n)
					throw new TypeError(
						'Derived constructors may only return object or undefined'
					)
				return (function (e) {
					if (void 0 === e)
						throw new ReferenceError(
							"this hasn't been initialised - super() hasn't been called"
						)
					return e
				})(e)
			}
			function a(e) {
				return (
					(a = Object.setPrototypeOf
						? Object.getPrototypeOf.bind()
						: function (e) {
								return e.__proto__ || Object.getPrototypeOf(e)
						  }),
					a(e)
				)
			}
			function l(e, t) {
				return (
					(l = Object.setPrototypeOf
						? Object.setPrototypeOf.bind()
						: function (e, t) {
								return (e.__proto__ = t), e
						  }),
					l(e, t)
				)
			}
			function u(e, t) {
				if ('function' != typeof t && null !== t)
					throw new TypeError(
						'Super expression must either be null or a function'
					)
				;(e.prototype = Object.create(t && t.prototype, {
					constructor: { value: e, writable: !0, configurable: !0 }
				})),
					Object.defineProperty(e, 'prototype', { writable: !1 }),
					t && l(e, t)
			}
			function c() {
				try {
					var e = !Boolean.prototype.valueOf.call(
						Reflect.construct(Boolean, [], function () {})
					)
				} catch (e) {}
				return (c = function () {
					return !!e
				})()
			}
			function d(e) {
				var t = 'function' == typeof Map ? new Map() : void 0
				return (
					(d = function (e) {
						if (
							null === e ||
							!(function (e) {
								try {
									return (
										-1 !==
										Function.toString.call(e).indexOf('[native code]')
									)
								} catch (t) {
									return 'function' == typeof e
								}
							})(e)
						)
							return e
						if ('function' != typeof e)
							throw new TypeError(
								'Super expression must either be null or a function'
							)
						if (void 0 !== t) {
							if (t.has(e)) return t.get(e)
							t.set(e, n)
						}
						function n() {
							return (function (e, t, n) {
								if (c())
									return Reflect.construct.apply(null, arguments)
								var r = [null]
								r.push.apply(r, t)
								var i = new (e.bind.apply(e, r))()
								return n && l(i, n.prototype), i
							})(e, arguments, a(this).constructor)
						}
						return (
							(n.prototype = Object.create(e.prototype, {
								constructor: {
									value: n,
									enumerable: !1,
									writable: !0,
									configurable: !0
								}
							})),
							l(n, e)
						)
					}),
					d(e)
				)
			}
			!(function (e, n, r) {
				function i(e, n) {
					return t(e) === n
				}
				function o() {
					return 'function' != typeof n.createElement
						? n.createElement(arguments[0])
						: x
						? n.createElementNS.call(
								n,
								'http://www.w3.org/2000/svg',
								arguments[0]
						  )
						: n.createElement.apply(n, arguments)
				}
				function s(e, t) {
					return !!~('' + e).indexOf(t)
				}
				function a(e) {
					return e
						.replace(/([a-z])-([a-z])/g, function (e, t, n) {
							return t + n.toUpperCase()
						})
						.replace(/^-/, '')
				}
				function l(e, t, r, i) {
					var s,
						a,
						l,
						u,
						c = 'modernizr',
						d = o('div'),
						p = (function () {
							var e = n.body
							return e || ((e = o(x ? 'svg' : 'body')).fake = !0), e
						})()
					if (parseInt(r, 10))
						for (; r--; )
							((l = o('div')).id = i ? i[r] : c + (r + 1)),
								d.appendChild(l)
					return (
						((s = o('style')).type = 'text/css'),
						(s.id = 's' + c),
						(p.fake ? p : d).appendChild(s),
						p.appendChild(d),
						s.styleSheet
							? (s.styleSheet.cssText = e)
							: s.appendChild(n.createTextNode(e)),
						(d.id = c),
						p.fake &&
							((p.style.background = ''),
							(p.style.overflow = 'hidden'),
							(u = w.style.overflow),
							(w.style.overflow = 'hidden'),
							w.appendChild(p)),
						(a = t(d, e)),
						p.fake
							? (p.parentNode.removeChild(p),
							  (w.style.overflow = u),
							  w.offsetHeight)
							: d.parentNode.removeChild(d),
						!!a
					)
				}
				function u(e, t) {
					return function () {
						return e.apply(t, arguments)
					}
				}
				function c(e) {
					return e
						.replace(/([A-Z])/g, function (e, t) {
							return '-' + t.toLowerCase()
						})
						.replace(/^ms-/, '-ms-')
				}
				function d(t, n, r) {
					var i
					if ('getComputedStyle' in e) {
						i = getComputedStyle.call(e, t, n)
						var o = e.console
						if (null !== i) r && (i = i.getPropertyValue(r))
						else if (o) {
							o[o.error ? 'error' : 'log'].call(
								o,
								'getComputedStyle returning null, its possible modernizr test results are inaccurate'
							)
						}
					} else i = !n && t.currentStyle && t.currentStyle[r]
					return i
				}
				function p(t, n) {
					var i = t.length
					if ('CSS' in e && 'supports' in e.CSS) {
						for (; i--; ) if (e.CSS.supports(c(t[i]), n)) return !0
						return !1
					}
					if ('CSSSupportsRule' in e) {
						for (var o = []; i--; )
							o.push('(' + c(t[i]) + ':' + n + ')')
						return l(
							'@supports (' +
								(o = o.join(' or ')) +
								') { #modernizr { position: absolute; } }',
							function (e) {
								return 'absolute' == d(e, null, 'position')
							}
						)
					}
					return r
				}
				function f(e, t, n, l) {
					function u() {
						d && (delete L.style, delete L.modElem)
					}
					if (((l = !i(l, 'undefined') && l), !i(n, 'undefined'))) {
						var c = p(e, n)
						if (!i(c, 'undefined')) return c
					}
					for (
						var d, f, h, v, m, g = ['modernizr', 'tspan', 'samp'];
						!L.style && g.length;

					)
						(d = !0),
							(L.modElem = o(g.shift())),
							(L.style = L.modElem.style)
					for (h = e.length, f = 0; h > f; f++)
						if (
							((v = e[f]),
							(m = L.style[v]),
							s(v, '-') && (v = a(v)),
							L.style[v] !== r)
						) {
							if (l || i(n, 'undefined')) return u(), 'pfx' != t || v
							try {
								L.style[v] = n
							} catch (e) {}
							if (L.style[v] != m) return u(), 'pfx' != t || v
						}
					return u(), !1
				}
				function h(e, t, n, r, o) {
					var s = e.charAt(0).toUpperCase() + e.slice(1),
						a = (e + ' ' + S.join(s + ' ') + s).split(' ')
					return i(t, 'string') || i(t, 'undefined')
						? f(a, t, r, o)
						: (function (e, t, n) {
								var r
								for (var o in e)
									if (e[o] in t)
										return !1 === n
											? e[o]
											: i((r = t[e[o]]), 'function')
											? u(r, n || t)
											: r
								return !1
						  })(
								(a = (e + ' ' + C.join(s + ' ') + s).split(' ')),
								t,
								n
						  )
				}
				function v(e, t, n) {
					return h(e, r, r, t, n)
				}
				var m = [],
					g = [],
					y = {
						_version: '3.5.0',
						_config: {
							classPrefix: '',
							enableClasses: !0,
							enableJSClass: !0,
							usePrefixes: !0
						},
						_q: [],
						on: function (e, t) {
							var n = this
							setTimeout(function () {
								t(n[e])
							}, 0)
						},
						addTest: function (e, t, n) {
							g.push({ name: e, fn: t, options: n })
						},
						addAsyncTest: function (e) {
							g.push({ name: null, fn: e })
						}
					},
					_ = function () {}
				;(_.prototype = y),
					(_ = new _()).addTest(
						'svg',
						!!n.createElementNS &&
							!!n.createElementNS('http://www.w3.org/2000/svg', 'svg')
								.createSVGRect
					)
				var b = y._config.usePrefixes
					? ' -webkit- -moz- -o- -ms- '.split(' ')
					: ['', '']
				y._prefixes = b
				var w = n.documentElement,
					x = 'svg' === w.nodeName.toLowerCase(),
					T = 'Moz O ms Webkit',
					C = y._config.usePrefixes ? T.toLowerCase().split(' ') : []
				y._domPrefixes = C
				var E = 'CSS' in e && 'supports' in e.CSS,
					k = 'supportsCSS' in e
				_.addTest('supports', E || k),
					_.addTest(
						'placeholder',
						'placeholder' in o('input') &&
							'placeholder' in o('textarea')
					)
				var S = y._config.usePrefixes ? T.split(' ') : []
				y._cssomPrefixes = S
				var M = (y.testStyles = l)
				_.addTest('touchevents', function () {
					var t
					if (
						'ontouchstart' in e ||
						(e.DocumentTouch && n instanceof DocumentTouch)
					)
						t = !0
					else {
						var r = [
							'@media (',
							b.join('touch-enabled),('),
							'heartz',
							')',
							'{#modernizr{top:9px;position:absolute}}'
						].join('')
						M(r, function (e) {
							t = 9 === e.offsetTop
						})
					}
					return t
				})
				var P = { elem: o('modernizr') }
				_._q.push(function () {
					delete P.elem
				})
				var L = { style: P.elem.style }
				_._q.unshift(function () {
					delete L.style
				}),
					(y.testProp = function (e, t, n) {
						return f([e], r, t, n)
					}),
					(y.testAllProps = h),
					(y.testAllProps = v),
					_.addTest('flexbox', v('flexBasis', '1px', !0)),
					_.addTest('csstransforms', function () {
						return (
							-1 === navigator.userAgent.indexOf('Android 2.') &&
							v('transform', 'scale(1)', !0)
						)
					}),
					_.addTest('csstransforms3d', function () {
						var e = !!v('perspective', '1px', !0),
							t = _._config.usePrefixes
						if (e && (!t || 'webkitPerspective' in w.style)) {
							var n
							_.supports
								? (n = '@supports (perspective: 1px)')
								: ((n = '@media (transform-3d)'),
								  t && (n += ',(-webkit-transform-3d)')),
								M(
									'#modernizr{width:0;height:0}' +
										(n +=
											'{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}'),
									function (t) {
										e = 7 === t.offsetWidth && 18 === t.offsetHeight
									}
								)
						}
						return e
					}),
					_.addTest('csstransitions', v('transition', 'all', !0)),
					(function () {
						var e, t, n, r, o, s
						for (var a in g)
							if (g.hasOwnProperty(a)) {
								if (
									((e = []),
									(t = g[a]).name &&
										(e.push(t.name.toLowerCase()),
										t.options &&
											t.options.aliases &&
											t.options.aliases.length))
								)
									for (n = 0; n < t.options.aliases.length; n++)
										e.push(t.options.aliases[n].toLowerCase())
								for (
									r = i(t.fn, 'function') ? t.fn() : t.fn, o = 0;
									o < e.length;
									o++
								)
									1 === (s = e[o].split('.')).length
										? (_[s[0]] = r)
										: (!_[s[0]] ||
												_[s[0]] instanceof Boolean ||
												(_[s[0]] = new Boolean(_[s[0]])),
										  (_[s[0]][s[1]] = r)),
										m.push((r ? '' : 'no-') + s.join('-'))
							}
					})(),
					(function (e) {
						var t = w.className,
							n = _._config.classPrefix || ''
						if ((x && (t = t.baseVal), _._config.enableJSClass)) {
							var r = new RegExp('(^|\\s)' + n + 'no-js(\\s|$)')
							t = t.replace(r, '$1' + n + 'js$2')
						}
						_._config.enableClasses &&
							((t += ' ' + n + e.join(' ' + n)),
							x ? (w.className.baseVal = t) : (w.className = t))
					})(m),
					delete y.addTest,
					delete y.addAsyncTest
				for (var A = 0; A < _._q.length; A++) _._q[A]()
				e.Modernizr = _
			})(window, document)
			var p = n(1950),
				f = n.n(p)
			function h() {
				var e = f().Deferred()
				return (
					f().ajax({
						type: 'get',
						url: '/cart?view=json',
						success: function (t) {
							t = t.replace(/<\/?[^>]+>/gi, '')
							var n = JSON.parse(t)
							e.resolve(n)
						},
						error: function () {
							e.reject({ message: 'Could not retrieve cart items' })
						}
					}),
					e
				)
			}
			function v(e) {
				return (
					null !== e &&
					'object' == typeof e &&
					'constructor' in e &&
					e.constructor === Object
				)
			}
			function m(e, t) {
				void 0 === e && (e = {}),
					void 0 === t && (t = {}),
					Object.keys(t).forEach(function (n) {
						void 0 === e[n]
							? (e[n] = t[n])
							: v(t[n]) &&
							  v(e[n]) &&
							  Object.keys(t[n]).length > 0 &&
							  m(e[n], t[n])
					})
			}
			;(window.Verve = window.Verve || {}),
				(window.Verve.addItem = function (e, t) {
					var n = f().Deferred()
					return (
						f().ajax({
							type: 'post',
							dataType: 'json',
							url: '/cart/add.js',
							data: { items: [{ quantity: t, id: e }] },
							success: function (e) {
								var t = new Event('cartUpdateSuccess')
								window.dispatchEvent(t), n.resolve(e)
							},
							error: function () {
								var e = new Event('cartUpdateFail')
								window.dispatchEvent(e),
									n.reject({
										message:
											'The quantity you entered is not available.'
									})
							}
						}),
						n
					)
				})
			var g = {
				body: {},
				addEventListener: function () {},
				removeEventListener: function () {},
				activeElement: { blur: function () {}, nodeName: '' },
				querySelector: function () {
					return null
				},
				querySelectorAll: function () {
					return []
				},
				getElementById: function () {
					return null
				},
				createEvent: function () {
					return { initEvent: function () {} }
				},
				createElement: function () {
					return {
						children: [],
						childNodes: [],
						style: {},
						setAttribute: function () {},
						getElementsByTagName: function () {
							return []
						}
					}
				},
				createElementNS: function () {
					return {}
				},
				importNode: function () {
					return null
				},
				location: {
					hash: '',
					host: '',
					hostname: '',
					href: '',
					origin: '',
					pathname: '',
					protocol: '',
					search: ''
				}
			}
			function y() {
				var e = 'undefined' != typeof document ? document : {}
				return m(e, g), e
			}
			var _ = {
				document: g,
				navigator: { userAgent: '' },
				location: {
					hash: '',
					host: '',
					hostname: '',
					href: '',
					origin: '',
					pathname: '',
					protocol: '',
					search: ''
				},
				history: {
					replaceState: function () {},
					pushState: function () {},
					go: function () {},
					back: function () {}
				},
				CustomEvent: function () {
					return this
				},
				addEventListener: function () {},
				removeEventListener: function () {},
				getComputedStyle: function () {
					return {
						getPropertyValue: function () {
							return ''
						}
					}
				},
				Image: function () {},
				Date: function () {},
				screen: {},
				setTimeout: function () {},
				clearTimeout: function () {},
				matchMedia: function () {
					return {}
				},
				requestAnimationFrame: function (e) {
					return 'undefined' == typeof setTimeout
						? (e(), null)
						: setTimeout(e, 0)
				},
				cancelAnimationFrame: function (e) {
					'undefined' != typeof setTimeout && clearTimeout(e)
				}
			}
			function b() {
				var e = 'undefined' != typeof window ? window : {}
				return m(e, _), e
			}
			function w(e) {
				return (
					(w = Object.setPrototypeOf
						? Object.getPrototypeOf
						: function (e) {
								return e.__proto__ || Object.getPrototypeOf(e)
						  }),
					w(e)
				)
			}
			function x(e, t) {
				return (
					(x =
						Object.setPrototypeOf ||
						function (e, t) {
							return (e.__proto__ = t), e
						}),
					x(e, t)
				)
			}
			function T(e, t, n) {
				return (
					(T = (function () {
						if ('undefined' == typeof Reflect || !Reflect.construct)
							return !1
						if (Reflect.construct.sham) return !1
						if ('function' == typeof Proxy) return !0
						try {
							return (
								Date.prototype.toString.call(
									Reflect.construct(Date, [], function () {})
								),
								!0
							)
						} catch (e) {
							return !1
						}
					})()
						? Reflect.construct
						: function (e, t, n) {
								var r = [null]
								r.push.apply(r, t)
								var i = new (Function.bind.apply(e, r))()
								return n && x(i, n.prototype), i
						  }),
					T.apply(null, arguments)
				)
			}
			function C(e) {
				var t = 'function' == typeof Map ? new Map() : void 0
				return (
					(C = function (e) {
						if (
							null === e ||
							((n = e),
							-1 ===
								Function.toString.call(n).indexOf('[native code]'))
						)
							return e
						var n
						if ('function' != typeof e)
							throw new TypeError(
								'Super expression must either be null or a function'
							)
						if (void 0 !== t) {
							if (t.has(e)) return t.get(e)
							t.set(e, r)
						}
						function r() {
							return T(e, arguments, w(this).constructor)
						}
						return (
							(r.prototype = Object.create(e.prototype, {
								constructor: {
									value: r,
									enumerable: !1,
									writable: !0,
									configurable: !0
								}
							})),
							x(r, e)
						)
					}),
					C(e)
				)
			}
			var E = (function (e) {
				var t, n
				function r(t) {
					var n, r, i
					return (
						(n = e.call.apply(e, [this].concat(t)) || this),
						(r = (function (e) {
							if (void 0 === e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called"
								)
							return e
						})(n)),
						(i = r.__proto__),
						Object.defineProperty(r, '__proto__', {
							get: function () {
								return i
							},
							set: function (e) {
								i.__proto__ = e
							}
						}),
						n
					)
				}
				return (
					(n = e),
					((t = r).prototype = Object.create(n.prototype)),
					(t.prototype.constructor = t),
					(t.__proto__ = n),
					r
				)
			})(C(Array))
			function k(e) {
				void 0 === e && (e = [])
				var t = []
				return (
					e.forEach(function (e) {
						Array.isArray(e) ? t.push.apply(t, k(e)) : t.push(e)
					}),
					t
				)
			}
			function S(e, t) {
				return Array.prototype.filter.call(e, t)
			}
			function M(e, t) {
				var n = b(),
					r = y(),
					i = []
				if (!t && e instanceof E) return e
				if (!e) return new E(i)
				if ('string' == typeof e) {
					var o = e.trim()
					if (o.indexOf('<') >= 0 && o.indexOf('>') >= 0) {
						var s = 'div'
						0 === o.indexOf('<li') && (s = 'ul'),
							0 === o.indexOf('<tr') && (s = 'tbody'),
							(0 !== o.indexOf('<td') && 0 !== o.indexOf('<th')) ||
								(s = 'tr'),
							0 === o.indexOf('<tbody') && (s = 'table'),
							0 === o.indexOf('<option') && (s = 'select')
						var a = r.createElement(s)
						a.innerHTML = o
						for (var l = 0; l < a.childNodes.length; l += 1)
							i.push(a.childNodes[l])
					} else
						i = (function (e, t) {
							if ('string' != typeof e) return [e]
							for (
								var n = [], r = t.querySelectorAll(e), i = 0;
								i < r.length;
								i += 1
							)
								n.push(r[i])
							return n
						})(e.trim(), t || r)
				} else if (e.nodeType || e === n || e === r) i.push(e)
				else if (Array.isArray(e)) {
					if (e instanceof E) return e
					i = e
				}
				return new E(
					(function (e) {
						for (var t = [], n = 0; n < e.length; n += 1)
							-1 === t.indexOf(e[n]) && t.push(e[n])
						return t
					})(i)
				)
			}
			M.fn = E.prototype
			var P = 'resize scroll'.split(' ')
			function L(e) {
				return function () {
					for (
						var t = arguments.length, n = new Array(t), r = 0;
						r < t;
						r++
					)
						n[r] = arguments[r]
					if (void 0 === n[0]) {
						for (var i = 0; i < this.length; i += 1)
							P.indexOf(e) < 0 &&
								(e in this[i] ? this[i][e]() : M(this[i]).trigger(e))
						return this
					}
					return this.on.apply(this, [e].concat(n))
				}
			}
			L('click'),
				L('blur'),
				L('focus'),
				L('focusin'),
				L('focusout'),
				L('keyup'),
				L('keydown'),
				L('keypress'),
				L('submit'),
				L('change'),
				L('mousedown'),
				L('mousemove'),
				L('mouseup'),
				L('mouseenter'),
				L('mouseleave'),
				L('mouseout'),
				L('mouseover'),
				L('touchstart'),
				L('touchend'),
				L('touchmove'),
				L('resize'),
				L('scroll')
			var A = {
				addClass: function () {
					for (
						var e = arguments.length, t = new Array(e), n = 0;
						n < e;
						n++
					)
						t[n] = arguments[n]
					var r = k(
						t.map(function (e) {
							return e.split(' ')
						})
					)
					return (
						this.forEach(function (e) {
							var t
							;(t = e.classList).add.apply(t, r)
						}),
						this
					)
				},
				removeClass: function () {
					for (
						var e = arguments.length, t = new Array(e), n = 0;
						n < e;
						n++
					)
						t[n] = arguments[n]
					var r = k(
						t.map(function (e) {
							return e.split(' ')
						})
					)
					return (
						this.forEach(function (e) {
							var t
							;(t = e.classList).remove.apply(t, r)
						}),
						this
					)
				},
				hasClass: function () {
					for (
						var e = arguments.length, t = new Array(e), n = 0;
						n < e;
						n++
					)
						t[n] = arguments[n]
					var r = k(
						t.map(function (e) {
							return e.split(' ')
						})
					)
					return (
						S(this, function (e) {
							return (
								r.filter(function (t) {
									return e.classList.contains(t)
								}).length > 0
							)
						}).length > 0
					)
				},
				toggleClass: function () {
					for (
						var e = arguments.length, t = new Array(e), n = 0;
						n < e;
						n++
					)
						t[n] = arguments[n]
					var r = k(
						t.map(function (e) {
							return e.split(' ')
						})
					)
					this.forEach(function (e) {
						r.forEach(function (t) {
							e.classList.toggle(t)
						})
					})
				},
				attr: function (e, t) {
					if (1 === arguments.length && 'string' == typeof e)
						return this[0] ? this[0].getAttribute(e) : void 0
					for (var n = 0; n < this.length; n += 1)
						if (2 === arguments.length) this[n].setAttribute(e, t)
						else
							for (var r in e)
								(this[n][r] = e[r]), this[n].setAttribute(r, e[r])
					return this
				},
				removeAttr: function (e) {
					for (var t = 0; t < this.length; t += 1)
						this[t].removeAttribute(e)
					return this
				},
				transform: function (e) {
					for (var t = 0; t < this.length; t += 1)
						this[t].style.transform = e
					return this
				},
				transition: function (e) {
					for (var t = 0; t < this.length; t += 1)
						this[t].style.transitionDuration =
							'string' != typeof e ? e + 'ms' : e
					return this
				},
				on: function () {
					for (
						var e = arguments.length, t = new Array(e), n = 0;
						n < e;
						n++
					)
						t[n] = arguments[n]
					var r = t[0],
						i = t[1],
						o = t[2],
						s = t[3]
					function a(e) {
						var t = e.target
						if (t) {
							var n = e.target.dom7EventData || []
							if ((n.indexOf(e) < 0 && n.unshift(e), M(t).is(i)))
								o.apply(t, n)
							else
								for (
									var r = M(t).parents(), s = 0;
									s < r.length;
									s += 1
								)
									M(r[s]).is(i) && o.apply(r[s], n)
						}
					}
					function l(e) {
						var t = (e && e.target && e.target.dom7EventData) || []
						t.indexOf(e) < 0 && t.unshift(e), o.apply(this, t)
					}
					'function' == typeof t[1] &&
						((r = t[0]), (o = t[1]), (s = t[2]), (i = void 0)),
						s || (s = !1)
					for (
						var u, c = r.split(' '), d = 0;
						d < this.length;
						d += 1
					) {
						var p = this[d]
						if (i)
							for (u = 0; u < c.length; u += 1) {
								var f = c[u]
								p.dom7LiveListeners || (p.dom7LiveListeners = {}),
									p.dom7LiveListeners[f] ||
										(p.dom7LiveListeners[f] = []),
									p.dom7LiveListeners[f].push({
										listener: o,
										proxyListener: a
									}),
									p.addEventListener(f, a, s)
							}
						else
							for (u = 0; u < c.length; u += 1) {
								var h = c[u]
								p.dom7Listeners || (p.dom7Listeners = {}),
									p.dom7Listeners[h] || (p.dom7Listeners[h] = []),
									p.dom7Listeners[h].push({
										listener: o,
										proxyListener: l
									}),
									p.addEventListener(h, l, s)
							}
					}
					return this
				},
				off: function () {
					for (
						var e = arguments.length, t = new Array(e), n = 0;
						n < e;
						n++
					)
						t[n] = arguments[n]
					var r = t[0],
						i = t[1],
						o = t[2],
						s = t[3]
					'function' == typeof t[1] &&
						((r = t[0]), (o = t[1]), (s = t[2]), (i = void 0)),
						s || (s = !1)
					for (var a = r.split(' '), l = 0; l < a.length; l += 1)
						for (var u = a[l], c = 0; c < this.length; c += 1) {
							var d = this[c],
								p = void 0
							if (
								(!i && d.dom7Listeners
									? (p = d.dom7Listeners[u])
									: i &&
									  d.dom7LiveListeners &&
									  (p = d.dom7LiveListeners[u]),
								p && p.length)
							)
								for (var f = p.length - 1; f >= 0; f -= 1) {
									var h = p[f]
									;(o && h.listener === o) ||
									(o &&
										h.listener &&
										h.listener.dom7proxy &&
										h.listener.dom7proxy === o)
										? (d.removeEventListener(u, h.proxyListener, s),
										  p.splice(f, 1))
										: o ||
										  (d.removeEventListener(u, h.proxyListener, s),
										  p.splice(f, 1))
								}
						}
					return this
				},
				trigger: function () {
					for (
						var e = b(),
							t = arguments.length,
							n = new Array(t),
							r = 0;
						r < t;
						r++
					)
						n[r] = arguments[r]
					for (
						var i = n[0].split(' '), o = n[1], s = 0;
						s < i.length;
						s += 1
					)
						for (var a = i[s], l = 0; l < this.length; l += 1) {
							var u = this[l]
							if (e.CustomEvent) {
								var c = new e.CustomEvent(a, {
									detail: o,
									bubbles: !0,
									cancelable: !0
								})
								;(u.dom7EventData = n.filter(function (e, t) {
									return t > 0
								})),
									u.dispatchEvent(c),
									(u.dom7EventData = []),
									delete u.dom7EventData
							}
						}
					return this
				},
				transitionEnd: function (e) {
					var t = this
					return (
						e &&
							t.on('transitionend', function n(r) {
								r.target === this &&
									(e.call(this, r), t.off('transitionend', n))
							}),
						this
					)
				},
				outerWidth: function (e) {
					if (this.length > 0) {
						if (e) {
							var t = this.styles()
							return (
								this[0].offsetWidth +
								parseFloat(t.getPropertyValue('margin-right')) +
								parseFloat(t.getPropertyValue('margin-left'))
							)
						}
						return this[0].offsetWidth
					}
					return null
				},
				outerHeight: function (e) {
					if (this.length > 0) {
						if (e) {
							var t = this.styles()
							return (
								this[0].offsetHeight +
								parseFloat(t.getPropertyValue('margin-top')) +
								parseFloat(t.getPropertyValue('margin-bottom'))
							)
						}
						return this[0].offsetHeight
					}
					return null
				},
				styles: function () {
					var e = b()
					return this[0] ? e.getComputedStyle(this[0], null) : {}
				},
				offset: function () {
					if (this.length > 0) {
						var e = b(),
							t = y(),
							n = this[0],
							r = n.getBoundingClientRect(),
							i = t.body,
							o = n.clientTop || i.clientTop || 0,
							s = n.clientLeft || i.clientLeft || 0,
							a = n === e ? e.scrollY : n.scrollTop,
							l = n === e ? e.scrollX : n.scrollLeft
						return { top: r.top + a - o, left: r.left + l - s }
					}
					return null
				},
				css: function (e, t) {
					var n,
						r = b()
					if (1 === arguments.length) {
						if ('string' != typeof e) {
							for (n = 0; n < this.length; n += 1)
								for (var i in e) this[n].style[i] = e[i]
							return this
						}
						if (this[0])
							return r
								.getComputedStyle(this[0], null)
								.getPropertyValue(e)
					}
					if (2 === arguments.length && 'string' == typeof e) {
						for (n = 0; n < this.length; n += 1) this[n].style[e] = t
						return this
					}
					return this
				},
				each: function (e) {
					return e
						? (this.forEach(function (t, n) {
								e.apply(t, [t, n])
						  }),
						  this)
						: this
				},
				html: function (e) {
					if (void 0 === e) return this[0] ? this[0].innerHTML : null
					for (var t = 0; t < this.length; t += 1)
						this[t].innerHTML = e
					return this
				},
				text: function (e) {
					if (void 0 === e)
						return this[0] ? this[0].textContent.trim() : null
					for (var t = 0; t < this.length; t += 1)
						this[t].textContent = e
					return this
				},
				is: function (e) {
					var t,
						n,
						r = b(),
						i = y(),
						o = this[0]
					if (!o || void 0 === e) return !1
					if ('string' == typeof e) {
						if (o.matches) return o.matches(e)
						if (o.webkitMatchesSelector)
							return o.webkitMatchesSelector(e)
						if (o.msMatchesSelector) return o.msMatchesSelector(e)
						for (t = M(e), n = 0; n < t.length; n += 1)
							if (t[n] === o) return !0
						return !1
					}
					if (e === i) return o === i
					if (e === r) return o === r
					if (e.nodeType || e instanceof E) {
						for (
							t = e.nodeType ? [e] : e, n = 0;
							n < t.length;
							n += 1
						)
							if (t[n] === o) return !0
						return !1
					}
					return !1
				},
				index: function () {
					var e,
						t = this[0]
					if (t) {
						for (e = 0; null !== (t = t.previousSibling); )
							1 === t.nodeType && (e += 1)
						return e
					}
				},
				eq: function (e) {
					if (void 0 === e) return this
					var t = this.length
					if (e > t - 1) return M([])
					if (e < 0) {
						var n = t + e
						return M(n < 0 ? [] : [this[n]])
					}
					return M([this[e]])
				},
				append: function () {
					for (var e, t = y(), n = 0; n < arguments.length; n += 1) {
						e = n < 0 || arguments.length <= n ? void 0 : arguments[n]
						for (var r = 0; r < this.length; r += 1)
							if ('string' == typeof e) {
								var i = t.createElement('div')
								for (i.innerHTML = e; i.firstChild; )
									this[r].appendChild(i.firstChild)
							} else if (e instanceof E)
								for (var o = 0; o < e.length; o += 1)
									this[r].appendChild(e[o])
							else this[r].appendChild(e)
					}
					return this
				},
				prepend: function (e) {
					var t,
						n,
						r = y()
					for (t = 0; t < this.length; t += 1)
						if ('string' == typeof e) {
							var i = r.createElement('div')
							for (
								i.innerHTML = e, n = i.childNodes.length - 1;
								n >= 0;
								n -= 1
							)
								this[t].insertBefore(
									i.childNodes[n],
									this[t].childNodes[0]
								)
						} else if (e instanceof E)
							for (n = 0; n < e.length; n += 1)
								this[t].insertBefore(e[n], this[t].childNodes[0])
						else this[t].insertBefore(e, this[t].childNodes[0])
					return this
				},
				next: function (e) {
					return this.length > 0
						? e
							? this[0].nextElementSibling &&
							  M(this[0].nextElementSibling).is(e)
								? M([this[0].nextElementSibling])
								: M([])
							: this[0].nextElementSibling
							? M([this[0].nextElementSibling])
							: M([])
						: M([])
				},
				nextAll: function (e) {
					var t = [],
						n = this[0]
					if (!n) return M([])
					for (; n.nextElementSibling; ) {
						var r = n.nextElementSibling
						e ? M(r).is(e) && t.push(r) : t.push(r), (n = r)
					}
					return M(t)
				},
				prev: function (e) {
					if (this.length > 0) {
						var t = this[0]
						return e
							? t.previousElementSibling &&
							  M(t.previousElementSibling).is(e)
								? M([t.previousElementSibling])
								: M([])
							: t.previousElementSibling
							? M([t.previousElementSibling])
							: M([])
					}
					return M([])
				},
				prevAll: function (e) {
					var t = [],
						n = this[0]
					if (!n) return M([])
					for (; n.previousElementSibling; ) {
						var r = n.previousElementSibling
						e ? M(r).is(e) && t.push(r) : t.push(r), (n = r)
					}
					return M(t)
				},
				parent: function (e) {
					for (var t = [], n = 0; n < this.length; n += 1)
						null !== this[n].parentNode &&
							(e
								? M(this[n].parentNode).is(e) &&
								  t.push(this[n].parentNode)
								: t.push(this[n].parentNode))
					return M(t)
				},
				parents: function (e) {
					for (var t = [], n = 0; n < this.length; n += 1)
						for (var r = this[n].parentNode; r; )
							e ? M(r).is(e) && t.push(r) : t.push(r),
								(r = r.parentNode)
					return M(t)
				},
				closest: function (e) {
					var t = this
					return void 0 === e
						? M([])
						: (t.is(e) || (t = t.parents(e).eq(0)), t)
				},
				find: function (e) {
					for (var t = [], n = 0; n < this.length; n += 1)
						for (
							var r = this[n].querySelectorAll(e), i = 0;
							i < r.length;
							i += 1
						)
							t.push(r[i])
					return M(t)
				},
				children: function (e) {
					for (var t = [], n = 0; n < this.length; n += 1)
						for (
							var r = this[n].children, i = 0;
							i < r.length;
							i += 1
						)
							(e && !M(r[i]).is(e)) || t.push(r[i])
					return M(t)
				},
				filter: function (e) {
					return M(S(this, e))
				},
				remove: function () {
					for (var e = 0; e < this.length; e += 1)
						this[e].parentNode &&
							this[e].parentNode.removeChild(this[e])
					return this
				}
			}
			Object.keys(A).forEach(function (e) {
				Object.defineProperty(M.fn, e, { value: A[e], writable: !0 })
			})
			var O,
				j,
				D,
				N = M
			function I(e, t) {
				return void 0 === t && (t = 0), setTimeout(e, t)
			}
			function q() {
				return Date.now()
			}
			function H(e, t) {
				void 0 === t && (t = 'x')
				var n,
					r,
					i,
					o = b(),
					s = (function (e) {
						var t,
							n = b()
						return (
							n.getComputedStyle && (t = n.getComputedStyle(e, null)),
							!t && e.currentStyle && (t = e.currentStyle),
							t || (t = e.style),
							t
						)
					})(e)
				return (
					o.WebKitCSSMatrix
						? ((r = s.transform || s.webkitTransform).split(',')
								.length > 6 &&
								(r = r
									.split(', ')
									.map(function (e) {
										return e.replace(',', '.')
									})
									.join(', ')),
						  (i = new o.WebKitCSSMatrix('none' === r ? '' : r)))
						: (n = (i =
								s.MozTransform ||
								s.OTransform ||
								s.MsTransform ||
								s.msTransform ||
								s.transform ||
								s
									.getPropertyValue('transform')
									.replace('translate(', 'matrix(1, 0, 0, 1,'))
								.toString()
								.split(',')),
					'x' === t &&
						(r = o.WebKitCSSMatrix
							? i.m41
							: 16 === n.length
							? parseFloat(n[12])
							: parseFloat(n[4])),
					'y' === t &&
						(r = o.WebKitCSSMatrix
							? i.m42
							: 16 === n.length
							? parseFloat(n[13])
							: parseFloat(n[5])),
					r || 0
				)
			}
			function B(e) {
				return (
					'object' == typeof e &&
					null !== e &&
					e.constructor &&
					'Object' === Object.prototype.toString.call(e).slice(8, -1)
				)
			}
			function F() {
				for (
					var e,
						t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
						n = ['__proto__', 'constructor', 'prototype'],
						r = 1;
					r < arguments.length;
					r += 1
				) {
					var i =
						r < 0 || arguments.length <= r ? void 0 : arguments[r]
					if (
						null != i &&
						((e = i),
						!('undefined' != typeof window &&
						void 0 !== window.HTMLElement
							? e instanceof HTMLElement
							: e && (1 === e.nodeType || 11 === e.nodeType)))
					)
						for (
							var o = Object.keys(Object(i)).filter(function (e) {
									return n.indexOf(e) < 0
								}),
								s = 0,
								a = o.length;
							s < a;
							s += 1
						) {
							var l = o[s],
								u = Object.getOwnPropertyDescriptor(i, l)
							void 0 !== u &&
								u.enumerable &&
								(B(t[l]) && B(i[l])
									? i[l].__swiper__
										? (t[l] = i[l])
										: F(t[l], i[l])
									: !B(t[l]) && B(i[l])
									? ((t[l] = {}),
									  i[l].__swiper__ ? (t[l] = i[l]) : F(t[l], i[l]))
									: (t[l] = i[l]))
						}
				}
				return t
			}
			function R(e, t) {
				Object.keys(t).forEach(function (n) {
					B(t[n]) &&
						Object.keys(t[n]).forEach(function (r) {
							'function' == typeof t[n][r] &&
								(t[n][r] = t[n][r].bind(e))
						}),
						(e[n] = t[n])
				})
			}
			function z(e) {
				return (
					void 0 === e && (e = ''),
					'.' +
						e
							.trim()
							.replace(/([\.:!\/])/g, '\\$1')
							.replace(/ /g, '.')
				)
			}
			function W(e, t, n, r) {
				var i = y()
				return (
					n &&
						Object.keys(r).forEach(function (n) {
							if (!t[n] && !0 === t.auto) {
								var o = i.createElement('div')
								;(o.className = r[n]), e.append(o), (t[n] = o)
							}
						}),
					t
				)
			}
			function V() {
				return (
					O ||
						(O = (function () {
							var e = b(),
								t = y()
							return {
								touch: !!(
									'ontouchstart' in e ||
									(e.DocumentTouch && t instanceof e.DocumentTouch)
								),
								pointerEvents:
									!!e.PointerEvent &&
									'maxTouchPoints' in e.navigator &&
									e.navigator.maxTouchPoints >= 0,
								observer:
									'MutationObserver' in e ||
									'WebkitMutationObserver' in e,
								passiveListener: (function () {
									var t = !1
									try {
										var n = Object.defineProperty({}, 'passive', {
											get: function () {
												t = !0
											}
										})
										e.addEventListener('testPassiveListener', null, n)
									} catch (e) {}
									return t
								})(),
								gestures: 'ongesturestart' in e
							}
						})()),
					O
				)
			}
			function G(e) {
				return (
					void 0 === e && (e = {}),
					j ||
						(j = (function (e) {
							var t = (void 0 === e ? {} : e).userAgent,
								n = V(),
								r = b(),
								i = r.navigator.platform,
								o = t || r.navigator.userAgent,
								s = { ios: !1, android: !1 },
								a = r.screen.width,
								l = r.screen.height,
								u = o.match(/(Android);?[\s\/]+([\d.]+)?/),
								c = o.match(/(iPad).*OS\s([\d_]+)/),
								d = o.match(/(iPod)(.*OS\s([\d_]+))?/),
								p = !c && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
								f = 'Win32' === i,
								h = 'MacIntel' === i
							return (
								!c &&
									h &&
									n.touch &&
									[
										'1024x1366',
										'1366x1024',
										'834x1194',
										'1194x834',
										'834x1112',
										'1112x834',
										'768x1024',
										'1024x768',
										'820x1180',
										'1180x820',
										'810x1080',
										'1080x810'
									].indexOf(a + 'x' + l) >= 0 &&
									((c = o.match(/(Version)\/([\d.]+)/)) ||
										(c = [0, 1, '13_0_0']),
									(h = !1)),
								u && !f && ((s.os = 'android'), (s.android = !0)),
								(c || p || d) && ((s.os = 'ios'), (s.ios = !0)),
								s
							)
						})(e)),
					j
				)
			}
			function U() {
				return (
					D ||
						(D = (function () {
							var e,
								t = b()
							return {
								isEdge: !!t.navigator.userAgent.match(/Edge/g),
								isSafari:
									((e = t.navigator.userAgent.toLowerCase()),
									e.indexOf('safari') >= 0 &&
										e.indexOf('chrome') < 0 &&
										e.indexOf('android') < 0),
								isWebView:
									/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
										t.navigator.userAgent
									)
							}
						})()),
					D
				)
			}
			var X = {
				name: 'resize',
				create: function () {
					var e = this
					F(e, {
						resize: {
							observer: null,
							createObserver: function () {
								e &&
									!e.destroyed &&
									e.initialized &&
									((e.resize.observer = new ResizeObserver(function (
										t
									) {
										var n = e.width,
											r = e.height,
											i = n,
											o = r
										t.forEach(function (t) {
											var n = t.contentBoxSize,
												r = t.contentRect,
												s = t.target
											;(s && s !== e.el) ||
												((i = r ? r.width : (n[0] || n).inlineSize),
												(o = r ? r.height : (n[0] || n).blockSize))
										}),
											(i === n && o === r) || e.resize.resizeHandler()
									})),
									e.resize.observer.observe(e.el))
							},
							removeObserver: function () {
								e.resize.observer &&
									e.resize.observer.unobserve &&
									e.el &&
									(e.resize.observer.unobserve(e.el),
									(e.resize.observer = null))
							},
							resizeHandler: function () {
								e &&
									!e.destroyed &&
									e.initialized &&
									(e.emit('beforeResize'), e.emit('resize'))
							},
							orientationChangeHandler: function () {
								e &&
									!e.destroyed &&
									e.initialized &&
									e.emit('orientationchange')
							}
						}
					})
				},
				on: {
					init: function (e) {
						var t = b()
						e.params.resizeObserver && void 0 !== b().ResizeObserver
							? e.resize.createObserver()
							: (t.addEventListener('resize', e.resize.resizeHandler),
							  t.addEventListener(
									'orientationchange',
									e.resize.orientationChangeHandler
							  ))
					},
					destroy: function (e) {
						var t = b()
						e.resize.removeObserver(),
							t.removeEventListener('resize', e.resize.resizeHandler),
							t.removeEventListener(
								'orientationchange',
								e.resize.orientationChangeHandler
							)
					}
				}
			}
			function Y() {
				return (
					(Y =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var n = arguments[t]
								for (var r in n)
									Object.prototype.hasOwnProperty.call(n, r) &&
										(e[r] = n[r])
							}
							return e
						}),
					Y.apply(this, arguments)
				)
			}
			var K = {
					attach: function (e, t) {
						void 0 === t && (t = {})
						var n = b(),
							r = this,
							i = new (n.MutationObserver ||
								n.WebkitMutationObserver)(function (e) {
								if (1 !== e.length) {
									var t = function () {
										r.emit('observerUpdate', e[0])
									}
									n.requestAnimationFrame
										? n.requestAnimationFrame(t)
										: n.setTimeout(t, 0)
								} else r.emit('observerUpdate', e[0])
							})
						i.observe(e, {
							attributes: void 0 === t.attributes || t.attributes,
							childList: void 0 === t.childList || t.childList,
							characterData:
								void 0 === t.characterData || t.characterData
						}),
							r.observer.observers.push(i)
					},
					init: function () {
						var e = this
						if (e.support.observer && e.params.observer) {
							if (e.params.observeParents)
								for (
									var t = e.$el.parents(), n = 0;
									n < t.length;
									n += 1
								)
									e.observer.attach(t[n])
							e.observer.attach(e.$el[0], {
								childList: e.params.observeSlideChildren
							}),
								e.observer.attach(e.$wrapperEl[0], { attributes: !1 })
						}
					},
					destroy: function () {
						this.observer.observers.forEach(function (e) {
							e.disconnect()
						}),
							(this.observer.observers = [])
					}
				},
				Q = {
					name: 'observer',
					params: {
						observer: !1,
						observeParents: !1,
						observeSlideChildren: !1
					},
					create: function () {
						R(this, { observer: Y({}, K, { observers: [] }) })
					},
					on: {
						init: function (e) {
							e.observer.init()
						},
						destroy: function (e) {
							e.observer.destroy()
						}
					}
				},
				J = {
					useParams: function (e) {
						var t = this
						t.modules &&
							Object.keys(t.modules).forEach(function (n) {
								var r = t.modules[n]
								r.params && F(e, r.params)
							})
					},
					useModules: function (e) {
						void 0 === e && (e = {})
						var t = this
						t.modules &&
							Object.keys(t.modules).forEach(function (n) {
								var r = t.modules[n],
									i = e[n] || {}
								r.on &&
									t.on &&
									Object.keys(r.on).forEach(function (e) {
										t.on(e, r.on[e])
									}),
									r.create && r.create.bind(t)(i)
							})
					}
				},
				Z = {
					on: function (e, t, n) {
						var r = this
						if ('function' != typeof t) return r
						var i = n ? 'unshift' : 'push'
						return (
							e.split(' ').forEach(function (e) {
								r.eventsListeners[e] || (r.eventsListeners[e] = []),
									r.eventsListeners[e][i](t)
							}),
							r
						)
					},
					once: function (e, t, n) {
						var r = this
						if ('function' != typeof t) return r
						function i() {
							r.off(e, i), i.__emitterProxy && delete i.__emitterProxy
							for (
								var n = arguments.length, o = new Array(n), s = 0;
								s < n;
								s++
							)
								o[s] = arguments[s]
							t.apply(r, o)
						}
						return (i.__emitterProxy = t), r.on(e, i, n)
					},
					onAny: function (e, t) {
						var n = this
						if ('function' != typeof e) return n
						var r = t ? 'unshift' : 'push'
						return (
							n.eventsAnyListeners.indexOf(e) < 0 &&
								n.eventsAnyListeners[r](e),
							n
						)
					},
					offAny: function (e) {
						var t = this
						if (!t.eventsAnyListeners) return t
						var n = t.eventsAnyListeners.indexOf(e)
						return n >= 0 && t.eventsAnyListeners.splice(n, 1), t
					},
					off: function (e, t) {
						var n = this
						return n.eventsListeners
							? (e.split(' ').forEach(function (e) {
									void 0 === t
										? (n.eventsListeners[e] = [])
										: n.eventsListeners[e] &&
										  n.eventsListeners[e].forEach(function (r, i) {
												;(r === t ||
													(r.__emitterProxy &&
														r.__emitterProxy === t)) &&
													n.eventsListeners[e].splice(i, 1)
										  })
							  }),
							  n)
							: n
					},
					emit: function () {
						var e,
							t,
							n,
							r = this
						if (!r.eventsListeners) return r
						for (
							var i = arguments.length, o = new Array(i), s = 0;
							s < i;
							s++
						)
							o[s] = arguments[s]
						return (
							'string' == typeof o[0] || Array.isArray(o[0])
								? ((e = o[0]), (t = o.slice(1, o.length)), (n = r))
								: ((e = o[0].events),
								  (t = o[0].data),
								  (n = o[0].context || r)),
							t.unshift(n),
							(Array.isArray(e) ? e : e.split(' ')).forEach(function (
								e
							) {
								r.eventsAnyListeners &&
									r.eventsAnyListeners.length &&
									r.eventsAnyListeners.forEach(function (r) {
										r.apply(n, [e].concat(t))
									}),
									r.eventsListeners &&
										r.eventsListeners[e] &&
										r.eventsListeners[e].forEach(function (e) {
											e.apply(n, t)
										})
							}),
							r
						)
					}
				}
			var ee = {
				updateSize: function () {
					var e,
						t,
						n = this,
						r = n.$el
					;(e =
						void 0 !== n.params.width && null !== n.params.width
							? n.params.width
							: r[0].clientWidth),
						(t =
							void 0 !== n.params.height && null !== n.params.height
								? n.params.height
								: r[0].clientHeight),
						(0 === e && n.isHorizontal()) ||
							(0 === t && n.isVertical()) ||
							((e =
								e -
								parseInt(r.css('padding-left') || 0, 10) -
								parseInt(r.css('padding-right') || 0, 10)),
							(t =
								t -
								parseInt(r.css('padding-top') || 0, 10) -
								parseInt(r.css('padding-bottom') || 0, 10)),
							Number.isNaN(e) && (e = 0),
							Number.isNaN(t) && (t = 0),
							F(n, {
								width: e,
								height: t,
								size: n.isHorizontal() ? e : t
							}))
				},
				updateSlides: function () {
					var e = this
					function t(t) {
						return e.isHorizontal()
							? t
							: {
									width: 'height',
									'margin-top': 'margin-left',
									'margin-bottom ': 'margin-right',
									'margin-left': 'margin-top',
									'margin-right': 'margin-bottom',
									'padding-left': 'padding-top',
									'padding-right': 'padding-bottom',
									marginRight: 'marginBottom'
							  }[t]
					}
					function n(e, n) {
						return parseFloat(e.getPropertyValue(t(n)) || 0)
					}
					var r = e.params,
						i = e.$wrapperEl,
						o = e.size,
						s = e.rtlTranslate,
						a = e.wrongRTL,
						l = e.virtual && r.virtual.enabled,
						u = l ? e.virtual.slides.length : e.slides.length,
						c = i.children('.' + e.params.slideClass),
						d = l ? e.virtual.slides.length : c.length,
						p = [],
						f = [],
						h = [],
						v = r.slidesOffsetBefore
					'function' == typeof v && (v = r.slidesOffsetBefore.call(e))
					var m = r.slidesOffsetAfter
					'function' == typeof m && (m = r.slidesOffsetAfter.call(e))
					var g = e.snapGrid.length,
						y = e.slidesGrid.length,
						_ = r.spaceBetween,
						b = -v,
						w = 0,
						x = 0
					if (void 0 !== o) {
						var T, C
						'string' == typeof _ &&
							_.indexOf('%') >= 0 &&
							(_ = (parseFloat(_.replace('%', '')) / 100) * o),
							(e.virtualSize = -_),
							s
								? c.css({
										marginLeft: '',
										marginBottom: '',
										marginTop: ''
								  })
								: c.css({
										marginRight: '',
										marginBottom: '',
										marginTop: ''
								  }),
							r.slidesPerColumn > 1 &&
								((T =
									Math.floor(d / r.slidesPerColumn) ===
									d / e.params.slidesPerColumn
										? d
										: Math.ceil(d / r.slidesPerColumn) *
										  r.slidesPerColumn),
								'auto' !== r.slidesPerView &&
									'row' === r.slidesPerColumnFill &&
									(T = Math.max(
										T,
										r.slidesPerView * r.slidesPerColumn
									)))
						for (
							var E,
								k,
								S,
								M = r.slidesPerColumn,
								P = T / M,
								L = Math.floor(d / r.slidesPerColumn),
								A = 0;
							A < d;
							A += 1
						) {
							C = 0
							var O = c.eq(A)
							if (r.slidesPerColumn > 1) {
								var j = void 0,
									$ = void 0,
									D = void 0
								if (
									'row' === r.slidesPerColumnFill &&
									r.slidesPerGroup > 1
								) {
									var N = Math.floor(
											A / (r.slidesPerGroup * r.slidesPerColumn)
										),
										I = A - r.slidesPerColumn * r.slidesPerGroup * N,
										q =
											0 === N
												? r.slidesPerGroup
												: Math.min(
														Math.ceil(
															(d - N * M * r.slidesPerGroup) / M
														),
														r.slidesPerGroup
												  )
									;(j =
										($ =
											I -
											(D = Math.floor(I / q)) * q +
											N * r.slidesPerGroup) +
										(D * T) / M),
										O.css({
											'-webkit-box-ordinal-group': j,
											'-moz-box-ordinal-group': j,
											'-ms-flex-order': j,
											'-webkit-order': j,
											order: j
										})
								} else
									'column' === r.slidesPerColumnFill
										? ((D = A - ($ = Math.floor(A / M)) * M),
										  ($ > L || ($ === L && D === M - 1)) &&
												(D += 1) >= M &&
												((D = 0), ($ += 1)))
										: ($ = A - (D = Math.floor(A / P)) * P)
								O.css(
									t('margin-top'),
									0 !== D
										? r.spaceBetween && r.spaceBetween + 'px'
										: ''
								)
							}
							if ('none' !== O.css('display')) {
								if ('auto' === r.slidesPerView) {
									var H = getComputedStyle(O[0]),
										B = O[0].style.transform,
										R = O[0].style.webkitTransform
									if (
										(B && (O[0].style.transform = 'none'),
										R && (O[0].style.webkitTransform = 'none'),
										r.roundLengths)
									)
										C = e.isHorizontal()
											? O.outerWidth(!0)
											: O.outerHeight(!0)
									else {
										var z = n(H, 'width'),
											W = n(H, 'padding-left'),
											V = n(H, 'padding-right'),
											G = n(H, 'margin-left'),
											U = n(H, 'margin-right'),
											X = H.getPropertyValue('box-sizing')
										if (X && 'border-box' === X) C = z + G + U
										else {
											var Y = O[0],
												K = Y.clientWidth
											C = z + W + V + G + U + (Y.offsetWidth - K)
										}
									}
									B && (O[0].style.transform = B),
										R && (O[0].style.webkitTransform = R),
										r.roundLengths && (C = Math.floor(C))
								} else
									(C =
										(o - (r.slidesPerView - 1) * _) /
										r.slidesPerView),
										r.roundLengths && (C = Math.floor(C)),
										c[A] && (c[A].style[t('width')] = C + 'px')
								c[A] && (c[A].swiperSlideSize = C),
									h.push(C),
									r.centeredSlides
										? ((b = b + C / 2 + w / 2 + _),
										  0 === w && 0 !== A && (b = b - o / 2 - _),
										  0 === A && (b = b - o / 2 - _),
										  Math.abs(b) < 0.001 && (b = 0),
										  r.roundLengths && (b = Math.floor(b)),
										  x % r.slidesPerGroup == 0 && p.push(b),
										  f.push(b))
										: (r.roundLengths && (b = Math.floor(b)),
										  (x - Math.min(e.params.slidesPerGroupSkip, x)) %
												e.params.slidesPerGroup ==
												0 && p.push(b),
										  f.push(b),
										  (b = b + C + _)),
									(e.virtualSize += C + _),
									(w = C),
									(x += 1)
							}
						}
						if (
							((e.virtualSize = Math.max(e.virtualSize, o) + m),
							s &&
								a &&
								('slide' === r.effect || 'coverflow' === r.effect) &&
								i.css({
									width: e.virtualSize + r.spaceBetween + 'px'
								}),
							r.setWrapperSize)
						)
							i.css(
								(((k = {})[t('width')] =
									e.virtualSize + r.spaceBetween + 'px'),
								k)
							)
						if (r.slidesPerColumn > 1)
							if (
								((e.virtualSize = (C + r.spaceBetween) * T),
								(e.virtualSize =
									Math.ceil(e.virtualSize / r.slidesPerColumn) -
									r.spaceBetween),
								i.css(
									(((S = {})[t('width')] =
										e.virtualSize + r.spaceBetween + 'px'),
									S)
								),
								r.centeredSlides)
							) {
								E = []
								for (var Q = 0; Q < p.length; Q += 1) {
									var J = p[Q]
									r.roundLengths && (J = Math.floor(J)),
										p[Q] < e.virtualSize + p[0] && E.push(J)
								}
								p = E
							}
						if (!r.centeredSlides) {
							E = []
							for (var Z = 0; Z < p.length; Z += 1) {
								var ee = p[Z]
								r.roundLengths && (ee = Math.floor(ee)),
									p[Z] <= e.virtualSize - o && E.push(ee)
							}
							;(p = E),
								Math.floor(e.virtualSize - o) -
									Math.floor(p[p.length - 1]) >
									1 && p.push(e.virtualSize - o)
						}
						if ((0 === p.length && (p = [0]), 0 !== r.spaceBetween)) {
							var te,
								ne =
									e.isHorizontal() && s
										? 'marginLeft'
										: t('marginRight')
							c.filter(function (e, t) {
								return !r.cssMode || t !== c.length - 1
							}).css((((te = {})[ne] = _ + 'px'), te))
						}
						if (r.centeredSlides && r.centeredSlidesBounds) {
							var re = 0
							h.forEach(function (e) {
								re += e + (r.spaceBetween ? r.spaceBetween : 0)
							})
							var ie = (re -= r.spaceBetween) - o
							p = p.map(function (e) {
								return e < 0 ? -v : e > ie ? ie + m : e
							})
						}
						if (r.centerInsufficientSlides) {
							var oe = 0
							if (
								(h.forEach(function (e) {
									oe += e + (r.spaceBetween ? r.spaceBetween : 0)
								}),
								(oe -= r.spaceBetween) < o)
							) {
								var se = (o - oe) / 2
								p.forEach(function (e, t) {
									p[t] = e - se
								}),
									f.forEach(function (e, t) {
										f[t] = e + se
									})
							}
						}
						F(e, {
							slides: c,
							snapGrid: p,
							slidesGrid: f,
							slidesSizesGrid: h
						}),
							d !== u && e.emit('slidesLengthChange'),
							p.length !== g &&
								(e.params.watchOverflow && e.checkOverflow(),
								e.emit('snapGridLengthChange')),
							f.length !== y && e.emit('slidesGridLengthChange'),
							(r.watchSlidesProgress || r.watchSlidesVisibility) &&
								e.updateSlidesOffset()
					}
				},
				updateAutoHeight: function (e) {
					var t,
						n = this,
						r = [],
						i = n.virtual && n.params.virtual.enabled,
						o = 0
					'number' == typeof e
						? n.setTransition(e)
						: !0 === e && n.setTransition(n.params.speed)
					var s = function (e) {
						return i
							? n.slides.filter(function (t) {
									return (
										parseInt(
											t.getAttribute('data-swiper-slide-index'),
											10
										) === e
									)
							  })[0]
							: n.slides.eq(e)[0]
					}
					if (
						'auto' !== n.params.slidesPerView &&
						n.params.slidesPerView > 1
					)
						if (n.params.centeredSlides)
							n.visibleSlides.each(function (e) {
								r.push(e)
							})
						else
							for (
								t = 0;
								t < Math.ceil(n.params.slidesPerView);
								t += 1
							) {
								var a = n.activeIndex + t
								if (a > n.slides.length && !i) break
								r.push(s(a))
							}
					else r.push(s(n.activeIndex))
					for (t = 0; t < r.length; t += 1)
						if (void 0 !== r[t]) {
							var l = r[t].offsetHeight
							o = l > o ? l : o
						}
					o && n.$wrapperEl.css('height', o + 'px')
				},
				updateSlidesOffset: function () {
					for (var e = this.slides, t = 0; t < e.length; t += 1)
						e[t].swiperSlideOffset = this.isHorizontal()
							? e[t].offsetLeft
							: e[t].offsetTop
				},
				updateSlidesProgress: function (e) {
					void 0 === e && (e = (this && this.translate) || 0)
					var t = this,
						n = t.params,
						r = t.slides,
						i = t.rtlTranslate
					if (0 !== r.length) {
						void 0 === r[0].swiperSlideOffset &&
							t.updateSlidesOffset()
						var o = -e
						i && (o = e),
							r.removeClass(n.slideVisibleClass),
							(t.visibleSlidesIndexes = []),
							(t.visibleSlides = [])
						for (var s = 0; s < r.length; s += 1) {
							var a = r[s],
								l =
									(o +
										(n.centeredSlides ? t.minTranslate() : 0) -
										a.swiperSlideOffset) /
									(a.swiperSlideSize + n.spaceBetween)
							if (
								n.watchSlidesVisibility ||
								(n.centeredSlides && n.autoHeight)
							) {
								var u = -(o - a.swiperSlideOffset),
									c = u + t.slidesSizesGrid[s]
								;((u >= 0 && u < t.size - 1) ||
									(c > 1 && c <= t.size) ||
									(u <= 0 && c >= t.size)) &&
									(t.visibleSlides.push(a),
									t.visibleSlidesIndexes.push(s),
									r.eq(s).addClass(n.slideVisibleClass))
							}
							a.progress = i ? -l : l
						}
						t.visibleSlides = N(t.visibleSlides)
					}
				},
				updateProgress: function (e) {
					var t = this
					if (void 0 === e) {
						var n = t.rtlTranslate ? -1 : 1
						e = (t && t.translate && t.translate * n) || 0
					}
					var r = t.params,
						i = t.maxTranslate() - t.minTranslate(),
						o = t.progress,
						s = t.isBeginning,
						a = t.isEnd,
						l = s,
						u = a
					0 === i
						? ((o = 0), (s = !0), (a = !0))
						: ((s = (o = (e - t.minTranslate()) / i) <= 0),
						  (a = o >= 1)),
						F(t, { progress: o, isBeginning: s, isEnd: a }),
						(r.watchSlidesProgress ||
							r.watchSlidesVisibility ||
							(r.centeredSlides && r.autoHeight)) &&
							t.updateSlidesProgress(e),
						s && !l && t.emit('reachBeginning toEdge'),
						a && !u && t.emit('reachEnd toEdge'),
						((l && !s) || (u && !a)) && t.emit('fromEdge'),
						t.emit('progress', o)
				},
				updateSlidesClasses: function () {
					var e,
						t = this,
						n = t.slides,
						r = t.params,
						i = t.$wrapperEl,
						o = t.activeIndex,
						s = t.realIndex,
						a = t.virtual && r.virtual.enabled
					n.removeClass(
						r.slideActiveClass +
							' ' +
							r.slideNextClass +
							' ' +
							r.slidePrevClass +
							' ' +
							r.slideDuplicateActiveClass +
							' ' +
							r.slideDuplicateNextClass +
							' ' +
							r.slideDuplicatePrevClass
					),
						(e = a
							? t.$wrapperEl.find(
									'.' +
										r.slideClass +
										'[data-swiper-slide-index="' +
										o +
										'"]'
							  )
							: n.eq(o)).addClass(r.slideActiveClass),
						r.loop &&
							(e.hasClass(r.slideDuplicateClass)
								? i
										.children(
											'.' +
												r.slideClass +
												':not(.' +
												r.slideDuplicateClass +
												')[data-swiper-slide-index="' +
												s +
												'"]'
										)
										.addClass(r.slideDuplicateActiveClass)
								: i
										.children(
											'.' +
												r.slideClass +
												'.' +
												r.slideDuplicateClass +
												'[data-swiper-slide-index="' +
												s +
												'"]'
										)
										.addClass(r.slideDuplicateActiveClass))
					var l = e
						.nextAll('.' + r.slideClass)
						.eq(0)
						.addClass(r.slideNextClass)
					r.loop &&
						0 === l.length &&
						(l = n.eq(0)).addClass(r.slideNextClass)
					var u = e
						.prevAll('.' + r.slideClass)
						.eq(0)
						.addClass(r.slidePrevClass)
					r.loop &&
						0 === u.length &&
						(u = n.eq(-1)).addClass(r.slidePrevClass),
						r.loop &&
							(l.hasClass(r.slideDuplicateClass)
								? i
										.children(
											'.' +
												r.slideClass +
												':not(.' +
												r.slideDuplicateClass +
												')[data-swiper-slide-index="' +
												l.attr('data-swiper-slide-index') +
												'"]'
										)
										.addClass(r.slideDuplicateNextClass)
								: i
										.children(
											'.' +
												r.slideClass +
												'.' +
												r.slideDuplicateClass +
												'[data-swiper-slide-index="' +
												l.attr('data-swiper-slide-index') +
												'"]'
										)
										.addClass(r.slideDuplicateNextClass),
							u.hasClass(r.slideDuplicateClass)
								? i
										.children(
											'.' +
												r.slideClass +
												':not(.' +
												r.slideDuplicateClass +
												')[data-swiper-slide-index="' +
												u.attr('data-swiper-slide-index') +
												'"]'
										)
										.addClass(r.slideDuplicatePrevClass)
								: i
										.children(
											'.' +
												r.slideClass +
												'.' +
												r.slideDuplicateClass +
												'[data-swiper-slide-index="' +
												u.attr('data-swiper-slide-index') +
												'"]'
										)
										.addClass(r.slideDuplicatePrevClass)),
						t.emitSlidesClasses()
				},
				updateActiveIndex: function (e) {
					var t,
						n = this,
						r = n.rtlTranslate ? n.translate : -n.translate,
						i = n.slidesGrid,
						o = n.snapGrid,
						s = n.params,
						a = n.activeIndex,
						l = n.realIndex,
						u = n.snapIndex,
						c = e
					if (void 0 === c) {
						for (var d = 0; d < i.length; d += 1)
							void 0 !== i[d + 1]
								? r >= i[d] && r < i[d + 1] - (i[d + 1] - i[d]) / 2
									? (c = d)
									: r >= i[d] && r < i[d + 1] && (c = d + 1)
								: r >= i[d] && (c = d)
						s.normalizeSlideIndex &&
							(c < 0 || void 0 === c) &&
							(c = 0)
					}
					if (o.indexOf(r) >= 0) t = o.indexOf(r)
					else {
						var p = Math.min(s.slidesPerGroupSkip, c)
						t = p + Math.floor((c - p) / s.slidesPerGroup)
					}
					if ((t >= o.length && (t = o.length - 1), c !== a)) {
						var f = parseInt(
							n.slides.eq(c).attr('data-swiper-slide-index') || c,
							10
						)
						F(n, {
							snapIndex: t,
							realIndex: f,
							previousIndex: a,
							activeIndex: c
						}),
							n.emit('activeIndexChange'),
							n.emit('snapIndexChange'),
							l !== f && n.emit('realIndexChange'),
							(n.initialized || n.params.runCallbacksOnInit) &&
								n.emit('slideChange')
					} else
						t !== u && ((n.snapIndex = t), n.emit('snapIndexChange'))
				},
				updateClickedSlide: function (e) {
					var t,
						n = this,
						r = n.params,
						i = N(e.target).closest('.' + r.slideClass)[0],
						o = !1
					if (i)
						for (var s = 0; s < n.slides.length; s += 1)
							if (n.slides[s] === i) {
								;(o = !0), (t = s)
								break
							}
					if (!i || !o)
						return (
							(n.clickedSlide = void 0),
							void (n.clickedIndex = void 0)
						)
					;(n.clickedSlide = i),
						n.virtual && n.params.virtual.enabled
							? (n.clickedIndex = parseInt(
									N(i).attr('data-swiper-slide-index'),
									10
							  ))
							: (n.clickedIndex = t),
						r.slideToClickedSlide &&
							void 0 !== n.clickedIndex &&
							n.clickedIndex !== n.activeIndex &&
							n.slideToClickedSlide()
				}
			}
			var te = {
				getTranslate: function (e) {
					void 0 === e && (e = this.isHorizontal() ? 'x' : 'y')
					var t = this,
						n = t.params,
						r = t.rtlTranslate,
						i = t.translate,
						o = t.$wrapperEl
					if (n.virtualTranslate) return r ? -i : i
					if (n.cssMode) return i
					var s = H(o[0], e)
					return r && (s = -s), s || 0
				},
				setTranslate: function (e, t) {
					var n = this,
						r = n.rtlTranslate,
						i = n.params,
						o = n.$wrapperEl,
						s = n.wrapperEl,
						a = n.progress,
						l = 0,
						u = 0
					n.isHorizontal() ? (l = r ? -e : e) : (u = e),
						i.roundLengths &&
							((l = Math.floor(l)), (u = Math.floor(u))),
						i.cssMode
							? (s[n.isHorizontal() ? 'scrollLeft' : 'scrollTop'] =
									n.isHorizontal() ? -l : -u)
							: i.virtualTranslate ||
							  o.transform(
									'translate3d(' + l + 'px, ' + u + 'px, 0px)'
							  ),
						(n.previousTranslate = n.translate),
						(n.translate = n.isHorizontal() ? l : u)
					var c = n.maxTranslate() - n.minTranslate()
					;(0 === c ? 0 : (e - n.minTranslate()) / c) !== a &&
						n.updateProgress(e),
						n.emit('setTranslate', n.translate, t)
				},
				minTranslate: function () {
					return -this.snapGrid[0]
				},
				maxTranslate: function () {
					return -this.snapGrid[this.snapGrid.length - 1]
				},
				translateTo: function (e, t, n, r, i) {
					void 0 === e && (e = 0),
						void 0 === t && (t = this.params.speed),
						void 0 === n && (n = !0),
						void 0 === r && (r = !0)
					var o = this,
						s = o.params,
						a = o.wrapperEl
					if (o.animating && s.preventInteractionOnTransition)
						return !1
					var l,
						u = o.minTranslate(),
						c = o.maxTranslate()
					if (
						((l = r && e > u ? u : r && e < c ? c : e),
						o.updateProgress(l),
						s.cssMode)
					) {
						var d,
							p = o.isHorizontal()
						if (0 === t) a[p ? 'scrollLeft' : 'scrollTop'] = -l
						else if (a.scrollTo)
							a.scrollTo(
								(((d = {})[p ? 'left' : 'top'] = -l),
								(d.behavior = 'smooth'),
								d)
							)
						else a[p ? 'scrollLeft' : 'scrollTop'] = -l
						return !0
					}
					return (
						0 === t
							? (o.setTransition(0),
							  o.setTranslate(l),
							  n &&
									(o.emit('beforeTransitionStart', t, i),
									o.emit('transitionEnd')))
							: (o.setTransition(t),
							  o.setTranslate(l),
							  n &&
									(o.emit('beforeTransitionStart', t, i),
									o.emit('transitionStart')),
							  o.animating ||
									((o.animating = !0),
									o.onTranslateToWrapperTransitionEnd ||
										(o.onTranslateToWrapperTransitionEnd = function (
											e
										) {
											o &&
												!o.destroyed &&
												e.target === this &&
												(o.$wrapperEl[0].removeEventListener(
													'transitionend',
													o.onTranslateToWrapperTransitionEnd
												),
												o.$wrapperEl[0].removeEventListener(
													'webkitTransitionEnd',
													o.onTranslateToWrapperTransitionEnd
												),
												(o.onTranslateToWrapperTransitionEnd = null),
												delete o.onTranslateToWrapperTransitionEnd,
												n && o.emit('transitionEnd'))
										}),
									o.$wrapperEl[0].addEventListener(
										'transitionend',
										o.onTranslateToWrapperTransitionEnd
									),
									o.$wrapperEl[0].addEventListener(
										'webkitTransitionEnd',
										o.onTranslateToWrapperTransitionEnd
									))),
						!0
					)
				}
			}
			var ne = {
				slideTo: function (e, t, n, r, i) {
					if (
						(void 0 === e && (e = 0),
						void 0 === t && (t = this.params.speed),
						void 0 === n && (n = !0),
						'number' != typeof e && 'string' != typeof e)
					)
						throw new Error(
							"The 'index' argument cannot have type other than 'number' or 'string'. [" +
								typeof e +
								'] given.'
						)
					if ('string' == typeof e) {
						var o = parseInt(e, 10)
						if (!isFinite(o))
							throw new Error(
								"The passed-in 'index' (string) couldn't be converted to 'number'. [" +
									e +
									'] given.'
							)
						e = o
					}
					var s = this,
						a = e
					a < 0 && (a = 0)
					var l = s.params,
						u = s.snapGrid,
						c = s.slidesGrid,
						d = s.previousIndex,
						p = s.activeIndex,
						f = s.rtlTranslate,
						h = s.wrapperEl,
						v = s.enabled
					if (
						(s.animating && l.preventInteractionOnTransition) ||
						(!v && !r && !i)
					)
						return !1
					var m = Math.min(s.params.slidesPerGroupSkip, a),
						g = m + Math.floor((a - m) / s.params.slidesPerGroup)
					g >= u.length && (g = u.length - 1),
						(p || l.initialSlide || 0) === (d || 0) &&
							n &&
							s.emit('beforeSlideChangeStart')
					var y,
						_ = -u[g]
					if ((s.updateProgress(_), l.normalizeSlideIndex))
						for (var b = 0; b < c.length; b += 1) {
							var w = -Math.floor(100 * _),
								x = Math.floor(100 * c[b]),
								T = Math.floor(100 * c[b + 1])
							void 0 !== c[b + 1]
								? w >= x && w < T - (T - x) / 2
									? (a = b)
									: w >= x && w < T && (a = b + 1)
								: w >= x && (a = b)
						}
					if (s.initialized && a !== p) {
						if (
							!s.allowSlideNext &&
							_ < s.translate &&
							_ < s.minTranslate()
						)
							return !1
						if (
							!s.allowSlidePrev &&
							_ > s.translate &&
							_ > s.maxTranslate() &&
							(p || 0) !== a
						)
							return !1
					}
					if (
						((y = a > p ? 'next' : a < p ? 'prev' : 'reset'),
						(f && -_ === s.translate) || (!f && _ === s.translate))
					)
						return (
							s.updateActiveIndex(a),
							l.autoHeight && s.updateAutoHeight(),
							s.updateSlidesClasses(),
							'slide' !== l.effect && s.setTranslate(_),
							'reset' !== y &&
								(s.transitionStart(n, y), s.transitionEnd(n, y)),
							!1
						)
					if (l.cssMode) {
						var C,
							E = s.isHorizontal(),
							k = -_
						if (
							(f && (k = h.scrollWidth - h.offsetWidth - k), 0 === t)
						)
							h[E ? 'scrollLeft' : 'scrollTop'] = k
						else if (h.scrollTo)
							h.scrollTo(
								(((C = {})[E ? 'left' : 'top'] = k),
								(C.behavior = 'smooth'),
								C)
							)
						else h[E ? 'scrollLeft' : 'scrollTop'] = k
						return !0
					}
					return (
						0 === t
							? (s.setTransition(0),
							  s.setTranslate(_),
							  s.updateActiveIndex(a),
							  s.updateSlidesClasses(),
							  s.emit('beforeTransitionStart', t, r),
							  s.transitionStart(n, y),
							  s.transitionEnd(n, y))
							: (s.setTransition(t),
							  s.setTranslate(_),
							  s.updateActiveIndex(a),
							  s.updateSlidesClasses(),
							  s.emit('beforeTransitionStart', t, r),
							  s.transitionStart(n, y),
							  s.animating ||
									((s.animating = !0),
									s.onSlideToWrapperTransitionEnd ||
										(s.onSlideToWrapperTransitionEnd = function (e) {
											s &&
												!s.destroyed &&
												e.target === this &&
												(s.$wrapperEl[0].removeEventListener(
													'transitionend',
													s.onSlideToWrapperTransitionEnd
												),
												s.$wrapperEl[0].removeEventListener(
													'webkitTransitionEnd',
													s.onSlideToWrapperTransitionEnd
												),
												(s.onSlideToWrapperTransitionEnd = null),
												delete s.onSlideToWrapperTransitionEnd,
												s.transitionEnd(n, y))
										}),
									s.$wrapperEl[0].addEventListener(
										'transitionend',
										s.onSlideToWrapperTransitionEnd
									),
									s.$wrapperEl[0].addEventListener(
										'webkitTransitionEnd',
										s.onSlideToWrapperTransitionEnd
									))),
						!0
					)
				},
				slideToLoop: function (e, t, n, r) {
					void 0 === e && (e = 0),
						void 0 === t && (t = this.params.speed),
						void 0 === n && (n = !0)
					var i = this,
						o = e
					return (
						i.params.loop && (o += i.loopedSlides),
						i.slideTo(o, t, n, r)
					)
				},
				slideNext: function (e, t, n) {
					void 0 === e && (e = this.params.speed),
						void 0 === t && (t = !0)
					var r = this,
						i = r.params,
						o = r.animating
					if (!r.enabled) return r
					var s =
						r.activeIndex < i.slidesPerGroupSkip
							? 1
							: i.slidesPerGroup
					if (i.loop) {
						if (o && i.loopPreventsSlide) return !1
						r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft)
					}
					return r.slideTo(r.activeIndex + s, e, t, n)
				},
				slidePrev: function (e, t, n) {
					void 0 === e && (e = this.params.speed),
						void 0 === t && (t = !0)
					var r = this,
						i = r.params,
						o = r.animating,
						s = r.snapGrid,
						a = r.slidesGrid,
						l = r.rtlTranslate
					if (!r.enabled) return r
					if (i.loop) {
						if (o && i.loopPreventsSlide) return !1
						r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft)
					}
					function u(e) {
						return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
					}
					var c,
						d = u(l ? r.translate : -r.translate),
						p = s.map(function (e) {
							return u(e)
						}),
						f = s[p.indexOf(d) - 1]
					return (
						void 0 === f &&
							i.cssMode &&
							s.forEach(function (e) {
								!f && d >= e && (f = e)
							}),
						void 0 !== f &&
							(c = a.indexOf(f)) < 0 &&
							(c = r.activeIndex - 1),
						r.slideTo(c, e, t, n)
					)
				},
				slideReset: function (e, t, n) {
					return (
						void 0 === e && (e = this.params.speed),
						void 0 === t && (t = !0),
						this.slideTo(this.activeIndex, e, t, n)
					)
				},
				slideToClosest: function (e, t, n, r) {
					void 0 === e && (e = this.params.speed),
						void 0 === t && (t = !0),
						void 0 === r && (r = 0.5)
					var i = this,
						o = i.activeIndex,
						s = Math.min(i.params.slidesPerGroupSkip, o),
						a = s + Math.floor((o - s) / i.params.slidesPerGroup),
						l = i.rtlTranslate ? i.translate : -i.translate
					if (l >= i.snapGrid[a]) {
						var u = i.snapGrid[a]
						l - u > (i.snapGrid[a + 1] - u) * r &&
							(o += i.params.slidesPerGroup)
					} else {
						var c = i.snapGrid[a - 1]
						l - c <= (i.snapGrid[a] - c) * r &&
							(o -= i.params.slidesPerGroup)
					}
					return (
						(o = Math.max(o, 0)),
						(o = Math.min(o, i.slidesGrid.length - 1)),
						i.slideTo(o, e, t, n)
					)
				},
				slideToClickedSlide: function () {
					var e,
						t = this,
						n = t.params,
						r = t.$wrapperEl,
						i =
							'auto' === n.slidesPerView
								? t.slidesPerViewDynamic()
								: n.slidesPerView,
						o = t.clickedIndex
					if (n.loop) {
						if (t.animating) return
						;(e = parseInt(
							N(t.clickedSlide).attr('data-swiper-slide-index'),
							10
						)),
							n.centeredSlides
								? o < t.loopedSlides - i / 2 ||
								  o > t.slides.length - t.loopedSlides + i / 2
									? (t.loopFix(),
									  (o = r
											.children(
												'.' +
													n.slideClass +
													'[data-swiper-slide-index="' +
													e +
													'"]:not(.' +
													n.slideDuplicateClass +
													')'
											)
											.eq(0)
											.index()),
									  I(function () {
											t.slideTo(o)
									  }))
									: t.slideTo(o)
								: o > t.slides.length - i
								? (t.loopFix(),
								  (o = r
										.children(
											'.' +
												n.slideClass +
												'[data-swiper-slide-index="' +
												e +
												'"]:not(.' +
												n.slideDuplicateClass +
												')'
										)
										.eq(0)
										.index()),
								  I(function () {
										t.slideTo(o)
								  }))
								: t.slideTo(o)
					} else t.slideTo(o)
				}
			}
			var re = {
				loopCreate: function () {
					var e = this,
						t = y(),
						n = e.params,
						r = e.$wrapperEl
					r.children(
						'.' + n.slideClass + '.' + n.slideDuplicateClass
					).remove()
					var i = r.children('.' + n.slideClass)
					if (n.loopFillGroupWithBlank) {
						var o = n.slidesPerGroup - (i.length % n.slidesPerGroup)
						if (o !== n.slidesPerGroup) {
							for (var s = 0; s < o; s += 1) {
								var a = N(t.createElement('div')).addClass(
									n.slideClass + ' ' + n.slideBlankClass
								)
								r.append(a)
							}
							i = r.children('.' + n.slideClass)
						}
					}
					'auto' !== n.slidesPerView ||
						n.loopedSlides ||
						(n.loopedSlides = i.length),
						(e.loopedSlides = Math.ceil(
							parseFloat(n.loopedSlides || n.slidesPerView, 10)
						)),
						(e.loopedSlides += n.loopAdditionalSlides),
						e.loopedSlides > i.length && (e.loopedSlides = i.length)
					var l = [],
						u = []
					i.each(function (t, n) {
						var r = N(t)
						n < e.loopedSlides && u.push(t),
							n < i.length &&
								n >= i.length - e.loopedSlides &&
								l.push(t),
							r.attr('data-swiper-slide-index', n)
					})
					for (var c = 0; c < u.length; c += 1)
						r.append(
							N(u[c].cloneNode(!0)).addClass(n.slideDuplicateClass)
						)
					for (var d = l.length - 1; d >= 0; d -= 1)
						r.prepend(
							N(l[d].cloneNode(!0)).addClass(n.slideDuplicateClass)
						)
				},
				loopFix: function () {
					var e = this
					e.emit('beforeLoopFix')
					var t,
						n = e.activeIndex,
						r = e.slides,
						i = e.loopedSlides,
						o = e.allowSlidePrev,
						s = e.allowSlideNext,
						a = e.snapGrid,
						l = e.rtlTranslate
					;(e.allowSlidePrev = !0), (e.allowSlideNext = !0)
					var u = -a[n] - e.getTranslate()
					if (n < i)
						(t = r.length - 3 * i + n),
							(t += i),
							e.slideTo(t, 0, !1, !0) &&
								0 !== u &&
								e.setTranslate((l ? -e.translate : e.translate) - u)
					else if (n >= r.length - i) {
						;(t = -r.length + n + i),
							(t += i),
							e.slideTo(t, 0, !1, !0) &&
								0 !== u &&
								e.setTranslate((l ? -e.translate : e.translate) - u)
					}
					;(e.allowSlidePrev = o),
						(e.allowSlideNext = s),
						e.emit('loopFix')
				},
				loopDestroy: function () {
					var e = this,
						t = e.$wrapperEl,
						n = e.params,
						r = e.slides
					t
						.children(
							'.' +
								n.slideClass +
								'.' +
								n.slideDuplicateClass +
								',.' +
								n.slideClass +
								'.' +
								n.slideBlankClass
						)
						.remove(),
						r.removeAttr('data-swiper-slide-index')
				}
			}
			var ie = {
				appendSlide: function (e) {
					var t = this,
						n = t.$wrapperEl,
						r = t.params
					if (
						(r.loop && t.loopDestroy(),
						'object' == typeof e && 'length' in e)
					)
						for (var i = 0; i < e.length; i += 1)
							e[i] && n.append(e[i])
					else n.append(e)
					r.loop && t.loopCreate(),
						(r.observer && t.support.observer) || t.update()
				},
				prependSlide: function (e) {
					var t = this,
						n = t.params,
						r = t.$wrapperEl,
						i = t.activeIndex
					n.loop && t.loopDestroy()
					var o = i + 1
					if ('object' == typeof e && 'length' in e) {
						for (var s = 0; s < e.length; s += 1)
							e[s] && r.prepend(e[s])
						o = i + e.length
					} else r.prepend(e)
					n.loop && t.loopCreate(),
						(n.observer && t.support.observer) || t.update(),
						t.slideTo(o, 0, !1)
				},
				addSlide: function (e, t) {
					var n = this,
						r = n.$wrapperEl,
						i = n.params,
						o = n.activeIndex
					i.loop &&
						((o -= n.loopedSlides),
						n.loopDestroy(),
						(n.slides = r.children('.' + i.slideClass)))
					var s = n.slides.length
					if (e <= 0) n.prependSlide(t)
					else if (e >= s) n.appendSlide(t)
					else {
						for (
							var a = o > e ? o + 1 : o, l = [], u = s - 1;
							u >= e;
							u -= 1
						) {
							var c = n.slides.eq(u)
							c.remove(), l.unshift(c)
						}
						if ('object' == typeof t && 'length' in t) {
							for (var d = 0; d < t.length; d += 1)
								t[d] && r.append(t[d])
							a = o > e ? o + t.length : o
						} else r.append(t)
						for (var p = 0; p < l.length; p += 1) r.append(l[p])
						i.loop && n.loopCreate(),
							(i.observer && n.support.observer) || n.update(),
							i.loop
								? n.slideTo(a + n.loopedSlides, 0, !1)
								: n.slideTo(a, 0, !1)
					}
				},
				removeSlide: function (e) {
					var t = this,
						n = t.params,
						r = t.$wrapperEl,
						i = t.activeIndex
					n.loop &&
						((i -= t.loopedSlides),
						t.loopDestroy(),
						(t.slides = r.children('.' + n.slideClass)))
					var o,
						s = i
					if ('object' == typeof e && 'length' in e) {
						for (var a = 0; a < e.length; a += 1)
							(o = e[a]),
								t.slides[o] && t.slides.eq(o).remove(),
								o < s && (s -= 1)
						s = Math.max(s, 0)
					} else
						(o = e),
							t.slides[o] && t.slides.eq(o).remove(),
							o < s && (s -= 1),
							(s = Math.max(s, 0))
					n.loop && t.loopCreate(),
						(n.observer && t.support.observer) || t.update(),
						n.loop
							? t.slideTo(s + t.loopedSlides, 0, !1)
							: t.slideTo(s, 0, !1)
				},
				removeAllSlides: function () {
					for (var e = [], t = 0; t < this.slides.length; t += 1)
						e.push(t)
					this.removeSlide(e)
				}
			}
			function oe(e) {
				var t = this,
					n = y(),
					r = b(),
					i = t.touchEventsData,
					o = t.params,
					s = t.touches
				if (
					t.enabled &&
					(!t.animating || !o.preventInteractionOnTransition)
				) {
					var a = e
					a.originalEvent && (a = a.originalEvent)
					var l = N(a.target)
					if (
						('wrapper' !== o.touchEventsTarget ||
							l.closest(t.wrapperEl).length) &&
						((i.isTouchEvent = 'touchstart' === a.type),
						(i.isTouchEvent || !('which' in a) || 3 !== a.which) &&
							!(
								(!i.isTouchEvent && 'button' in a && a.button > 0) ||
								(i.isTouched && i.isMoved)
							))
					) {
						!!o.noSwipingClass &&
							'' !== o.noSwipingClass &&
							a.target &&
							a.target.shadowRoot &&
							e.path &&
							e.path[0] &&
							(l = N(e.path[0]))
						var u = o.noSwipingSelector
								? o.noSwipingSelector
								: '.' + o.noSwipingClass,
							c = !(!a.target || !a.target.shadowRoot)
						if (
							o.noSwiping &&
							(c
								? (function (e, t) {
										return (
											void 0 === t && (t = this),
											(function t(n) {
												return n && n !== y() && n !== b()
													? (n.assignedSlot && (n = n.assignedSlot),
													  n.closest(e) || t(n.getRootNode().host))
													: null
											})(t)
										)
								  })(u, a.target)
								: l.closest(u)[0])
						)
							t.allowClick = !0
						else if (
							!o.swipeHandler ||
							l.closest(o.swipeHandler)[0]
						) {
							;(s.currentX =
								'touchstart' === a.type
									? a.targetTouches[0].pageX
									: a.pageX),
								(s.currentY =
									'touchstart' === a.type
										? a.targetTouches[0].pageY
										: a.pageY)
							var d = s.currentX,
								p = s.currentY,
								f = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
								h = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold
							if (f && (d <= h || d >= r.innerWidth - h)) {
								if ('prevent' !== f) return
								e.preventDefault()
							}
							if (
								(F(i, {
									isTouched: !0,
									isMoved: !1,
									allowTouchCallbacks: !0,
									isScrolling: void 0,
									startMoving: void 0
								}),
								(s.startX = d),
								(s.startY = p),
								(i.touchStartTime = q()),
								(t.allowClick = !0),
								t.updateSize(),
								(t.swipeDirection = void 0),
								o.threshold > 0 && (i.allowThresholdMove = !1),
								'touchstart' !== a.type)
							) {
								var v = !0
								l.is(i.focusableElements) && (v = !1),
									n.activeElement &&
										N(n.activeElement).is(i.focusableElements) &&
										n.activeElement !== l[0] &&
										n.activeElement.blur()
								var m =
									v && t.allowTouchMove && o.touchStartPreventDefault
								;(!o.touchStartForcePreventDefault && !m) ||
									l[0].isContentEditable ||
									a.preventDefault()
							}
							t.emit('touchStart', a)
						}
					}
				}
			}
			function se(e) {
				var t = y(),
					n = this,
					r = n.touchEventsData,
					i = n.params,
					o = n.touches,
					s = n.rtlTranslate
				if (n.enabled) {
					var a = e
					if (
						(a.originalEvent && (a = a.originalEvent), r.isTouched)
					) {
						if (!r.isTouchEvent || 'touchmove' === a.type) {
							var l =
									'touchmove' === a.type &&
									a.targetTouches &&
									(a.targetTouches[0] || a.changedTouches[0]),
								u = 'touchmove' === a.type ? l.pageX : a.pageX,
								c = 'touchmove' === a.type ? l.pageY : a.pageY
							if (a.preventedByNestedSwiper)
								return (o.startX = u), void (o.startY = c)
							if (!n.allowTouchMove)
								return (
									(n.allowClick = !1),
									void (
										r.isTouched &&
										(F(o, {
											startX: u,
											startY: c,
											currentX: u,
											currentY: c
										}),
										(r.touchStartTime = q()))
									)
								)
							if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
								if (n.isVertical()) {
									if (
										(c < o.startY &&
											n.translate <= n.maxTranslate()) ||
										(c > o.startY && n.translate >= n.minTranslate())
									)
										return (r.isTouched = !1), void (r.isMoved = !1)
								} else if (
									(u < o.startX && n.translate <= n.maxTranslate()) ||
									(u > o.startX && n.translate >= n.minTranslate())
								)
									return
							if (
								r.isTouchEvent &&
								t.activeElement &&
								a.target === t.activeElement &&
								N(a.target).is(r.focusableElements)
							)
								return (r.isMoved = !0), void (n.allowClick = !1)
							if (
								(r.allowTouchCallbacks && n.emit('touchMove', a),
								!(a.targetTouches && a.targetTouches.length > 1))
							) {
								;(o.currentX = u), (o.currentY = c)
								var d = o.currentX - o.startX,
									p = o.currentY - o.startY
								if (
									!(
										n.params.threshold &&
										Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) <
											n.params.threshold
									)
								) {
									var f
									if (void 0 === r.isScrolling)
										(n.isHorizontal() && o.currentY === o.startY) ||
										(n.isVertical() && o.currentX === o.startX)
											? (r.isScrolling = !1)
											: d * d + p * p >= 25 &&
											  ((f =
													(180 *
														Math.atan2(Math.abs(p), Math.abs(d))) /
													Math.PI),
											  (r.isScrolling = n.isHorizontal()
													? f > i.touchAngle
													: 90 - f > i.touchAngle))
									if (
										(r.isScrolling && n.emit('touchMoveOpposite', a),
										void 0 === r.startMoving &&
											((o.currentX === o.startX &&
												o.currentY === o.startY) ||
												(r.startMoving = !0)),
										r.isScrolling)
									)
										r.isTouched = !1
									else if (r.startMoving) {
										;(n.allowClick = !1),
											!i.cssMode &&
												a.cancelable &&
												a.preventDefault(),
											i.touchMoveStopPropagation &&
												!i.nested &&
												a.stopPropagation(),
											r.isMoved ||
												(i.loop && n.loopFix(),
												(r.startTranslate = n.getTranslate()),
												n.setTransition(0),
												n.animating &&
													n.$wrapperEl.trigger(
														'webkitTransitionEnd transitionend'
													),
												(r.allowMomentumBounce = !1),
												!i.grabCursor ||
													(!0 !== n.allowSlideNext &&
														!0 !== n.allowSlidePrev) ||
													n.setGrabCursor(!0),
												n.emit('sliderFirstMove', a)),
											n.emit('sliderMove', a),
											(r.isMoved = !0)
										var h = n.isHorizontal() ? d : p
										;(o.diff = h),
											(h *= i.touchRatio),
											s && (h = -h),
											(n.swipeDirection = h > 0 ? 'prev' : 'next'),
											(r.currentTranslate = h + r.startTranslate)
										var v = !0,
											m = i.resistanceRatio
										if (
											(i.touchReleaseOnEdges && (m = 0),
											h > 0 && r.currentTranslate > n.minTranslate()
												? ((v = !1),
												  i.resistance &&
														(r.currentTranslate =
															n.minTranslate() -
															1 +
															Math.pow(
																-n.minTranslate() +
																	r.startTranslate +
																	h,
																m
															)))
												: h < 0 &&
												  r.currentTranslate < n.maxTranslate() &&
												  ((v = !1),
												  i.resistance &&
														(r.currentTranslate =
															n.maxTranslate() +
															1 -
															Math.pow(
																n.maxTranslate() -
																	r.startTranslate -
																	h,
																m
															))),
											v && (a.preventedByNestedSwiper = !0),
											!n.allowSlideNext &&
												'next' === n.swipeDirection &&
												r.currentTranslate < r.startTranslate &&
												(r.currentTranslate = r.startTranslate),
											!n.allowSlidePrev &&
												'prev' === n.swipeDirection &&
												r.currentTranslate > r.startTranslate &&
												(r.currentTranslate = r.startTranslate),
											n.allowSlidePrev ||
												n.allowSlideNext ||
												(r.currentTranslate = r.startTranslate),
											i.threshold > 0)
										) {
											if (
												!(
													Math.abs(h) > i.threshold ||
													r.allowThresholdMove
												)
											)
												return void (r.currentTranslate =
													r.startTranslate)
											if (!r.allowThresholdMove)
												return (
													(r.allowThresholdMove = !0),
													(o.startX = o.currentX),
													(o.startY = o.currentY),
													(r.currentTranslate = r.startTranslate),
													void (o.diff = n.isHorizontal()
														? o.currentX - o.startX
														: o.currentY - o.startY)
												)
										}
										i.followFinger &&
											!i.cssMode &&
											((i.freeMode ||
												i.watchSlidesProgress ||
												i.watchSlidesVisibility) &&
												(n.updateActiveIndex(),
												n.updateSlidesClasses()),
											i.freeMode &&
												(0 === r.velocities.length &&
													r.velocities.push({
														position:
															o[
																n.isHorizontal() ? 'startX' : 'startY'
															],
														time: r.touchStartTime
													}),
												r.velocities.push({
													position:
														o[
															n.isHorizontal()
																? 'currentX'
																: 'currentY'
														],
													time: q()
												})),
											n.updateProgress(r.currentTranslate),
											n.setTranslate(r.currentTranslate))
									}
								}
							}
						}
					} else
						r.startMoving &&
							r.isScrolling &&
							n.emit('touchMoveOpposite', a)
				}
			}
			function ae(e) {
				var t = this,
					n = t.touchEventsData,
					r = t.params,
					i = t.touches,
					o = t.rtlTranslate,
					s = t.$wrapperEl,
					a = t.slidesGrid,
					l = t.snapGrid
				if (t.enabled) {
					var u = e
					if (
						(u.originalEvent && (u = u.originalEvent),
						n.allowTouchCallbacks && t.emit('touchEnd', u),
						(n.allowTouchCallbacks = !1),
						!n.isTouched)
					)
						return (
							n.isMoved && r.grabCursor && t.setGrabCursor(!1),
							(n.isMoved = !1),
							void (n.startMoving = !1)
						)
					r.grabCursor &&
						n.isMoved &&
						n.isTouched &&
						(!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
						t.setGrabCursor(!1)
					var c,
						d = q(),
						p = d - n.touchStartTime
					if (
						(t.allowClick &&
							(t.updateClickedSlide(u),
							t.emit('tap click', u),
							p < 300 &&
								d - n.lastClickTime < 300 &&
								t.emit('doubleTap doubleClick', u)),
						(n.lastClickTime = q()),
						I(function () {
							t.destroyed || (t.allowClick = !0)
						}),
						!n.isTouched ||
							!n.isMoved ||
							!t.swipeDirection ||
							0 === i.diff ||
							n.currentTranslate === n.startTranslate)
					)
						return (
							(n.isTouched = !1),
							(n.isMoved = !1),
							void (n.startMoving = !1)
						)
					if (
						((n.isTouched = !1),
						(n.isMoved = !1),
						(n.startMoving = !1),
						(c = r.followFinger
							? o
								? t.translate
								: -t.translate
							: -n.currentTranslate),
						!r.cssMode)
					)
						if (r.freeMode) {
							if (c < -t.minTranslate())
								return void t.slideTo(t.activeIndex)
							if (c > -t.maxTranslate())
								return void (t.slides.length < l.length
									? t.slideTo(l.length - 1)
									: t.slideTo(t.slides.length - 1))
							if (r.freeModeMomentum) {
								if (n.velocities.length > 1) {
									var f = n.velocities.pop(),
										h = n.velocities.pop(),
										v = f.position - h.position,
										m = f.time - h.time
									;(t.velocity = v / m),
										(t.velocity /= 2),
										Math.abs(t.velocity) <
											r.freeModeMinimumVelocity && (t.velocity = 0),
										(m > 150 || q() - f.time > 300) &&
											(t.velocity = 0)
								} else t.velocity = 0
								;(t.velocity *= r.freeModeMomentumVelocityRatio),
									(n.velocities.length = 0)
								var g = 1e3 * r.freeModeMomentumRatio,
									y = t.velocity * g,
									_ = t.translate + y
								o && (_ = -_)
								var b,
									w,
									x = !1,
									T =
										20 *
										Math.abs(t.velocity) *
										r.freeModeMomentumBounceRatio
								if (_ < t.maxTranslate())
									r.freeModeMomentumBounce
										? (_ + t.maxTranslate() < -T &&
												(_ = t.maxTranslate() - T),
										  (b = t.maxTranslate()),
										  (x = !0),
										  (n.allowMomentumBounce = !0))
										: (_ = t.maxTranslate()),
										r.loop && r.centeredSlides && (w = !0)
								else if (_ > t.minTranslate())
									r.freeModeMomentumBounce
										? (_ - t.minTranslate() > T &&
												(_ = t.minTranslate() + T),
										  (b = t.minTranslate()),
										  (x = !0),
										  (n.allowMomentumBounce = !0))
										: (_ = t.minTranslate()),
										r.loop && r.centeredSlides && (w = !0)
								else if (r.freeModeSticky) {
									for (var C, E = 0; E < l.length; E += 1)
										if (l[E] > -_) {
											C = E
											break
										}
									_ = -(_ =
										Math.abs(l[C] - _) < Math.abs(l[C - 1] - _) ||
										'next' === t.swipeDirection
											? l[C]
											: l[C - 1])
								}
								if (
									(w &&
										t.once('transitionEnd', function () {
											t.loopFix()
										}),
									0 !== t.velocity)
								) {
									if (
										((g = o
											? Math.abs((-_ - t.translate) / t.velocity)
											: Math.abs((_ - t.translate) / t.velocity)),
										r.freeModeSticky)
									) {
										var k = Math.abs((o ? -_ : _) - t.translate),
											S = t.slidesSizesGrid[t.activeIndex]
										g =
											k < S
												? r.speed
												: k < 2 * S
												? 1.5 * r.speed
												: 2.5 * r.speed
									}
								} else if (r.freeModeSticky)
									return void t.slideToClosest()
								r.freeModeMomentumBounce && x
									? (t.updateProgress(b),
									  t.setTransition(g),
									  t.setTranslate(_),
									  t.transitionStart(!0, t.swipeDirection),
									  (t.animating = !0),
									  s.transitionEnd(function () {
											t &&
												!t.destroyed &&
												n.allowMomentumBounce &&
												(t.emit('momentumBounce'),
												t.setTransition(r.speed),
												setTimeout(function () {
													t.setTranslate(b),
														s.transitionEnd(function () {
															t && !t.destroyed && t.transitionEnd()
														})
												}, 0))
									  }))
									: t.velocity
									? (t.updateProgress(_),
									  t.setTransition(g),
									  t.setTranslate(_),
									  t.transitionStart(!0, t.swipeDirection),
									  t.animating ||
											((t.animating = !0),
											s.transitionEnd(function () {
												t && !t.destroyed && t.transitionEnd()
											})))
									: (t.emit('_freeModeNoMomentumRelease'),
									  t.updateProgress(_)),
									t.updateActiveIndex(),
									t.updateSlidesClasses()
							} else {
								if (r.freeModeSticky) return void t.slideToClosest()
								r.freeMode && t.emit('_freeModeNoMomentumRelease')
							}
							;(!r.freeModeMomentum || p >= r.longSwipesMs) &&
								(t.updateProgress(),
								t.updateActiveIndex(),
								t.updateSlidesClasses())
						} else {
							for (
								var M = 0, P = t.slidesSizesGrid[0], L = 0;
								L < a.length;
								L += L < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup
							) {
								var A =
									L < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup
								void 0 !== a[L + A]
									? c >= a[L] &&
									  c < a[L + A] &&
									  ((M = L), (P = a[L + A] - a[L]))
									: c >= a[L] &&
									  ((M = L), (P = a[a.length - 1] - a[a.length - 2]))
							}
							var O = (c - a[M]) / P,
								j =
									M < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup
							if (p > r.longSwipesMs) {
								if (!r.longSwipes)
									return void t.slideTo(t.activeIndex)
								'next' === t.swipeDirection &&
									(O >= r.longSwipesRatio
										? t.slideTo(M + j)
										: t.slideTo(M)),
									'prev' === t.swipeDirection &&
										(O > 1 - r.longSwipesRatio
											? t.slideTo(M + j)
											: t.slideTo(M))
							} else {
								if (!r.shortSwipes)
									return void t.slideTo(t.activeIndex)
								t.navigation &&
								(u.target === t.navigation.nextEl ||
									u.target === t.navigation.prevEl)
									? u.target === t.navigation.nextEl
										? t.slideTo(M + j)
										: t.slideTo(M)
									: ('next' === t.swipeDirection && t.slideTo(M + j),
									  'prev' === t.swipeDirection && t.slideTo(M))
							}
						}
				}
			}
			function le() {
				var e = this,
					t = e.params,
					n = e.el
				if (!n || 0 !== n.offsetWidth) {
					t.breakpoints && e.setBreakpoint()
					var r = e.allowSlideNext,
						i = e.allowSlidePrev,
						o = e.snapGrid
					;(e.allowSlideNext = !0),
						(e.allowSlidePrev = !0),
						e.updateSize(),
						e.updateSlides(),
						e.updateSlidesClasses(),
						('auto' === t.slidesPerView || t.slidesPerView > 1) &&
						e.isEnd &&
						!e.isBeginning &&
						!e.params.centeredSlides
							? e.slideTo(e.slides.length - 1, 0, !1, !0)
							: e.slideTo(e.activeIndex, 0, !1, !0),
						e.autoplay &&
							e.autoplay.running &&
							e.autoplay.paused &&
							e.autoplay.run(),
						(e.allowSlidePrev = i),
						(e.allowSlideNext = r),
						e.params.watchOverflow &&
							o !== e.snapGrid &&
							e.checkOverflow()
				}
			}
			function ue(e) {
				var t = this
				t.enabled &&
					(t.allowClick ||
						(t.params.preventClicks && e.preventDefault(),
						t.params.preventClicksPropagation &&
							t.animating &&
							(e.stopPropagation(), e.stopImmediatePropagation())))
			}
			function ce() {
				var e = this,
					t = e.wrapperEl,
					n = e.rtlTranslate
				if (e.enabled) {
					;(e.previousTranslate = e.translate),
						e.isHorizontal()
							? (e.translate = n
									? t.scrollWidth - t.offsetWidth - t.scrollLeft
									: -t.scrollLeft)
							: (e.translate = -t.scrollTop),
						-0 === e.translate && (e.translate = 0),
						e.updateActiveIndex(),
						e.updateSlidesClasses()
					var r = e.maxTranslate() - e.minTranslate()
					;(0 === r ? 0 : (e.translate - e.minTranslate()) / r) !==
						e.progress &&
						e.updateProgress(n ? -e.translate : e.translate),
						e.emit('setTranslate', e.translate, !1)
				}
			}
			var de = !1
			function pe() {}
			var fe = {
				attachEvents: function () {
					var e = this,
						t = y(),
						n = e.params,
						r = e.touchEvents,
						i = e.el,
						o = e.wrapperEl,
						s = e.device,
						a = e.support
					;(e.onTouchStart = oe.bind(e)),
						(e.onTouchMove = se.bind(e)),
						(e.onTouchEnd = ae.bind(e)),
						n.cssMode && (e.onScroll = ce.bind(e)),
						(e.onClick = ue.bind(e))
					var l = !!n.nested
					if (!a.touch && a.pointerEvents)
						i.addEventListener(r.start, e.onTouchStart, !1),
							t.addEventListener(r.move, e.onTouchMove, l),
							t.addEventListener(r.end, e.onTouchEnd, !1)
					else {
						if (a.touch) {
							var u = !(
								'touchstart' !== r.start ||
								!a.passiveListener ||
								!n.passiveListeners
							) && { passive: !0, capture: !1 }
							i.addEventListener(r.start, e.onTouchStart, u),
								i.addEventListener(
									r.move,
									e.onTouchMove,
									a.passiveListener ? { passive: !1, capture: l } : l
								),
								i.addEventListener(r.end, e.onTouchEnd, u),
								r.cancel &&
									i.addEventListener(r.cancel, e.onTouchEnd, u),
								de ||
									(t.addEventListener('touchstart', pe), (de = !0))
						}
						;((n.simulateTouch && !s.ios && !s.android) ||
							(n.simulateTouch && !a.touch && s.ios)) &&
							(i.addEventListener('mousedown', e.onTouchStart, !1),
							t.addEventListener('mousemove', e.onTouchMove, l),
							t.addEventListener('mouseup', e.onTouchEnd, !1))
					}
					;(n.preventClicks || n.preventClicksPropagation) &&
						i.addEventListener('click', e.onClick, !0),
						n.cssMode && o.addEventListener('scroll', e.onScroll),
						n.updateOnWindowResize
							? e.on(
									s.ios || s.android
										? 'resize orientationchange observerUpdate'
										: 'resize observerUpdate',
									le,
									!0
							  )
							: e.on('observerUpdate', le, !0)
				},
				detachEvents: function () {
					var e = this,
						t = y(),
						n = e.params,
						r = e.touchEvents,
						i = e.el,
						o = e.wrapperEl,
						s = e.device,
						a = e.support,
						l = !!n.nested
					if (!a.touch && a.pointerEvents)
						i.removeEventListener(r.start, e.onTouchStart, !1),
							t.removeEventListener(r.move, e.onTouchMove, l),
							t.removeEventListener(r.end, e.onTouchEnd, !1)
					else {
						if (a.touch) {
							var u = !(
								'onTouchStart' !== r.start ||
								!a.passiveListener ||
								!n.passiveListeners
							) && { passive: !0, capture: !1 }
							i.removeEventListener(r.start, e.onTouchStart, u),
								i.removeEventListener(r.move, e.onTouchMove, l),
								i.removeEventListener(r.end, e.onTouchEnd, u),
								r.cancel &&
									i.removeEventListener(r.cancel, e.onTouchEnd, u)
						}
						;((n.simulateTouch && !s.ios && !s.android) ||
							(n.simulateTouch && !a.touch && s.ios)) &&
							(i.removeEventListener('mousedown', e.onTouchStart, !1),
							t.removeEventListener('mousemove', e.onTouchMove, l),
							t.removeEventListener('mouseup', e.onTouchEnd, !1))
					}
					;(n.preventClicks || n.preventClicksPropagation) &&
						i.removeEventListener('click', e.onClick, !0),
						n.cssMode && o.removeEventListener('scroll', e.onScroll),
						e.off(
							s.ios || s.android
								? 'resize orientationchange observerUpdate'
								: 'resize observerUpdate',
							le
						)
				}
			}
			var he = {
				setBreakpoint: function () {
					var e = this,
						t = e.activeIndex,
						n = e.initialized,
						r = e.loopedSlides,
						i = void 0 === r ? 0 : r,
						o = e.params,
						s = e.$el,
						a = o.breakpoints
					if (a && (!a || 0 !== Object.keys(a).length)) {
						var l = e.getBreakpoint(a, e.params.breakpointsBase, e.el)
						if (l && e.currentBreakpoint !== l) {
							var u = l in a ? a[l] : void 0
							u &&
								[
									'slidesPerView',
									'spaceBetween',
									'slidesPerGroup',
									'slidesPerGroupSkip',
									'slidesPerColumn'
								].forEach(function (e) {
									var t = u[e]
									void 0 !== t &&
										(u[e] =
											'slidesPerView' !== e ||
											('AUTO' !== t && 'auto' !== t)
												? 'slidesPerView' === e
													? parseFloat(t)
													: parseInt(t, 10)
												: 'auto')
								})
							var c = u || e.originalParams,
								d = o.slidesPerColumn > 1,
								p = c.slidesPerColumn > 1,
								f = o.enabled
							d && !p
								? (s.removeClass(
										o.containerModifierClass +
											'multirow ' +
											o.containerModifierClass +
											'multirow-column'
								  ),
								  e.emitContainerClasses())
								: !d &&
								  p &&
								  (s.addClass(o.containerModifierClass + 'multirow'),
								  ((c.slidesPerColumnFill &&
										'column' === c.slidesPerColumnFill) ||
										(!c.slidesPerColumnFill &&
											'column' === o.slidesPerColumnFill)) &&
										s.addClass(
											o.containerModifierClass + 'multirow-column'
										),
								  e.emitContainerClasses())
							var h = c.direction && c.direction !== o.direction,
								v =
									o.loop && (c.slidesPerView !== o.slidesPerView || h)
							h && n && e.changeDirection(), F(e.params, c)
							var m = e.params.enabled
							F(e, {
								allowTouchMove: e.params.allowTouchMove,
								allowSlideNext: e.params.allowSlideNext,
								allowSlidePrev: e.params.allowSlidePrev
							}),
								f && !m ? e.disable() : !f && m && e.enable(),
								(e.currentBreakpoint = l),
								e.emit('_beforeBreakpoint', c),
								v &&
									n &&
									(e.loopDestroy(),
									e.loopCreate(),
									e.updateSlides(),
									e.slideTo(t - i + e.loopedSlides, 0, !1)),
								e.emit('breakpoint', c)
						}
					}
				},
				getBreakpoint: function (e, t, n) {
					if (
						(void 0 === t && (t = 'window'),
						e && ('container' !== t || n))
					) {
						var r = !1,
							i = b(),
							o = 'window' === t ? i.innerHeight : n.clientHeight,
							s = Object.keys(e).map(function (e) {
								if ('string' == typeof e && 0 === e.indexOf('@')) {
									var t = parseFloat(e.substr(1))
									return { value: o * t, point: e }
								}
								return { value: e, point: e }
							})
						s.sort(function (e, t) {
							return parseInt(e.value, 10) - parseInt(t.value, 10)
						})
						for (var a = 0; a < s.length; a += 1) {
							var l = s[a],
								u = l.point,
								c = l.value
							'window' === t
								? i.matchMedia('(min-width: ' + c + 'px)').matches &&
								  (r = u)
								: c <= n.clientWidth && (r = u)
						}
						return r || 'max'
					}
				}
			}
			var ve = {
				addClasses: function () {
					var e,
						t,
						n,
						r = this,
						i = r.classNames,
						o = r.params,
						s = r.rtl,
						a = r.$el,
						l = r.device,
						u = r.support,
						c =
							((e = [
								'initialized',
								o.direction,
								{ 'pointer-events': u.pointerEvents && !u.touch },
								{ 'free-mode': o.freeMode },
								{ autoheight: o.autoHeight },
								{ rtl: s },
								{ multirow: o.slidesPerColumn > 1 },
								{
									'multirow-column':
										o.slidesPerColumn > 1 &&
										'column' === o.slidesPerColumnFill
								},
								{ android: l.android },
								{ ios: l.ios },
								{ 'css-mode': o.cssMode }
							]),
							(t = o.containerModifierClass),
							(n = []),
							e.forEach(function (e) {
								'object' == typeof e
									? Object.keys(e).forEach(function (r) {
											e[r] && n.push(t + r)
									  })
									: 'string' == typeof e && n.push(t + e)
							}),
							n)
					i.push.apply(i, c),
						a.addClass([].concat(i).join(' ')),
						r.emitContainerClasses()
				},
				removeClasses: function () {
					var e = this,
						t = e.$el,
						n = e.classNames
					t.removeClass(n.join(' ')), e.emitContainerClasses()
				}
			}
			var me = {
				loadImage: function (e, t, n, r, i, o) {
					var s,
						a = b()
					function l() {
						o && o()
					}
					N(e).parent('picture')[0] || (e.complete && i)
						? l()
						: t
						? (((s = new a.Image()).onload = l),
						  (s.onerror = l),
						  r && (s.sizes = r),
						  n && (s.srcset = n),
						  t && (s.src = t))
						: l()
				},
				preloadImages: function () {
					var e = this
					function t() {
						null != e &&
							e &&
							!e.destroyed &&
							(void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
							e.imagesLoaded === e.imagesToLoad.length &&
								(e.params.updateOnImagesReady && e.update(),
								e.emit('imagesReady')))
					}
					e.imagesToLoad = e.$el.find('img')
					for (var n = 0; n < e.imagesToLoad.length; n += 1) {
						var r = e.imagesToLoad[n]
						e.loadImage(
							r,
							r.currentSrc || r.getAttribute('src'),
							r.srcset || r.getAttribute('srcset'),
							r.sizes || r.getAttribute('sizes'),
							!0,
							t
						)
					}
				}
			}
			var ge = {
				init: !0,
				direction: 'horizontal',
				touchEventsTarget: 'container',
				initialSlide: 0,
				speed: 300,
				cssMode: !1,
				updateOnWindowResize: !0,
				resizeObserver: !1,
				nested: !1,
				createElements: !1,
				enabled: !0,
				focusableElements:
					'input, select, option, textarea, button, video, label',
				width: null,
				height: null,
				preventInteractionOnTransition: !1,
				userAgent: null,
				url: null,
				edgeSwipeDetection: !1,
				edgeSwipeThreshold: 20,
				freeMode: !1,
				freeModeMomentum: !0,
				freeModeMomentumRatio: 1,
				freeModeMomentumBounce: !0,
				freeModeMomentumBounceRatio: 1,
				freeModeMomentumVelocityRatio: 1,
				freeModeSticky: !1,
				freeModeMinimumVelocity: 0.02,
				autoHeight: !1,
				setWrapperSize: !1,
				virtualTranslate: !1,
				effect: 'slide',
				breakpoints: void 0,
				breakpointsBase: 'window',
				spaceBetween: 0,
				slidesPerView: 1,
				slidesPerColumn: 1,
				slidesPerColumnFill: 'column',
				slidesPerGroup: 1,
				slidesPerGroupSkip: 0,
				centeredSlides: !1,
				centeredSlidesBounds: !1,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				normalizeSlideIndex: !0,
				centerInsufficientSlides: !1,
				watchOverflow: !1,
				roundLengths: !1,
				touchRatio: 1,
				touchAngle: 45,
				simulateTouch: !0,
				shortSwipes: !0,
				longSwipes: !0,
				longSwipesRatio: 0.5,
				longSwipesMs: 300,
				followFinger: !0,
				allowTouchMove: !0,
				threshold: 0,
				touchMoveStopPropagation: !1,
				touchStartPreventDefault: !0,
				touchStartForcePreventDefault: !1,
				touchReleaseOnEdges: !1,
				uniqueNavElements: !0,
				resistance: !0,
				resistanceRatio: 0.85,
				watchSlidesProgress: !1,
				watchSlidesVisibility: !1,
				grabCursor: !1,
				preventClicks: !0,
				preventClicksPropagation: !0,
				slideToClickedSlide: !1,
				preloadImages: !0,
				updateOnImagesReady: !0,
				loop: !1,
				loopAdditionalSlides: 0,
				loopedSlides: null,
				loopFillGroupWithBlank: !1,
				loopPreventsSlide: !0,
				allowSlidePrev: !0,
				allowSlideNext: !0,
				swipeHandler: null,
				noSwiping: !0,
				noSwipingClass: 'swiper-no-swiping',
				noSwipingSelector: null,
				passiveListeners: !0,
				containerModifierClass: 'swiper-container-',
				slideClass: 'swiper-slide',
				slideBlankClass: 'swiper-slide-invisible-blank',
				slideActiveClass: 'swiper-slide-active',
				slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
				slideVisibleClass: 'swiper-slide-visible',
				slideDuplicateClass: 'swiper-slide-duplicate',
				slideNextClass: 'swiper-slide-next',
				slideDuplicateNextClass: 'swiper-slide-duplicate-next',
				slidePrevClass: 'swiper-slide-prev',
				slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
				wrapperClass: 'swiper-wrapper',
				runCallbacksOnInit: !0,
				_emitClasses: !1
			}
			function ye(e, t) {
				for (var n = 0; n < t.length; n++) {
					var r = t[n]
					;(r.enumerable = r.enumerable || !1),
						(r.configurable = !0),
						'value' in r && (r.writable = !0),
						Object.defineProperty(e, r.key, r)
				}
			}
			var _e = {
					modular: J,
					eventsEmitter: Z,
					update: ee,
					translate: te,
					transition: {
						setTransition: function (e, t) {
							var n = this
							n.params.cssMode || n.$wrapperEl.transition(e),
								n.emit('setTransition', e, t)
						},
						transitionStart: function (e, t) {
							void 0 === e && (e = !0)
							var n = this,
								r = n.activeIndex,
								i = n.params,
								o = n.previousIndex
							if (!i.cssMode) {
								i.autoHeight && n.updateAutoHeight()
								var s = t
								if (
									(s ||
										(s = r > o ? 'next' : r < o ? 'prev' : 'reset'),
									n.emit('transitionStart'),
									e && r !== o)
								) {
									if ('reset' === s)
										return void n.emit('slideResetTransitionStart')
									n.emit('slideChangeTransitionStart'),
										'next' === s
											? n.emit('slideNextTransitionStart')
											: n.emit('slidePrevTransitionStart')
								}
							}
						},
						transitionEnd: function (e, t) {
							void 0 === e && (e = !0)
							var n = this,
								r = n.activeIndex,
								i = n.previousIndex,
								o = n.params
							if (((n.animating = !1), !o.cssMode)) {
								n.setTransition(0)
								var s = t
								if (
									(s ||
										(s = r > i ? 'next' : r < i ? 'prev' : 'reset'),
									n.emit('transitionEnd'),
									e && r !== i)
								) {
									if ('reset' === s)
										return void n.emit('slideResetTransitionEnd')
									n.emit('slideChangeTransitionEnd'),
										'next' === s
											? n.emit('slideNextTransitionEnd')
											: n.emit('slidePrevTransitionEnd')
								}
							}
						}
					},
					slide: ne,
					loop: re,
					grabCursor: {
						setGrabCursor: function (e) {
							var t = this
							if (
								!(
									t.support.touch ||
									!t.params.simulateTouch ||
									(t.params.watchOverflow && t.isLocked) ||
									t.params.cssMode
								)
							) {
								var n = t.el
								;(n.style.cursor = 'move'),
									(n.style.cursor = e
										? '-webkit-grabbing'
										: '-webkit-grab'),
									(n.style.cursor = e ? '-moz-grabbin' : '-moz-grab'),
									(n.style.cursor = e ? 'grabbing' : 'grab')
							}
						},
						unsetGrabCursor: function () {
							var e = this
							e.support.touch ||
								(e.params.watchOverflow && e.isLocked) ||
								e.params.cssMode ||
								(e.el.style.cursor = '')
						}
					},
					manipulation: ie,
					events: fe,
					breakpoints: he,
					checkOverflow: {
						checkOverflow: function () {
							var e = this,
								t = e.params,
								n = e.isLocked,
								r =
									e.slides.length > 0 &&
									t.slidesOffsetBefore +
										t.spaceBetween * (e.slides.length - 1) +
										e.slides[0].offsetWidth * e.slides.length
							t.slidesOffsetBefore && t.slidesOffsetAfter && r
								? (e.isLocked = r <= e.size)
								: (e.isLocked = 1 === e.snapGrid.length),
								(e.allowSlideNext = !e.isLocked),
								(e.allowSlidePrev = !e.isLocked),
								n !== e.isLocked &&
									e.emit(e.isLocked ? 'lock' : 'unlock'),
								n &&
									n !== e.isLocked &&
									((e.isEnd = !1),
									e.navigation && e.navigation.update())
						}
					},
					classes: ve,
					images: me
				},
				be = {},
				we = (function () {
					function e() {
						for (
							var t, n, r = arguments.length, i = new Array(r), o = 0;
							o < r;
							o++
						)
							i[o] = arguments[o]
						if (
							(1 === i.length &&
							i[0].constructor &&
							'Object' ===
								Object.prototype.toString.call(i[0]).slice(8, -1)
								? (n = i[0])
								: ((t = i[0]), (n = i[1])),
							n || (n = {}),
							(n = F({}, n)),
							t && !n.el && (n.el = t),
							n.el && N(n.el).length > 1)
						) {
							var s = []
							return (
								N(n.el).each(function (t) {
									var r = F({}, n, { el: t })
									s.push(new e(r))
								}),
								s
							)
						}
						var a = this
						;(a.__swiper__ = !0),
							(a.support = V()),
							(a.device = G({ userAgent: n.userAgent })),
							(a.browser = U()),
							(a.eventsListeners = {}),
							(a.eventsAnyListeners = []),
							void 0 === a.modules && (a.modules = {}),
							Object.keys(a.modules).forEach(function (e) {
								var t = a.modules[e]
								if (t.params) {
									var r = Object.keys(t.params)[0],
										i = t.params[r]
									if ('object' != typeof i || null === i) return
									if (
										([
											'navigation',
											'pagination',
											'scrollbar'
										].indexOf(r) >= 0 &&
											!0 === n[r] &&
											(n[r] = { auto: !0 }),
										!(r in n) || !('enabled' in i))
									)
										return
									!0 === n[r] && (n[r] = { enabled: !0 }),
										'object' != typeof n[r] ||
											'enabled' in n[r] ||
											(n[r].enabled = !0),
										n[r] || (n[r] = { enabled: !1 })
								}
							})
						var l,
							u,
							c = F({}, ge)
						return (
							a.useParams(c),
							(a.params = F({}, c, be, n)),
							(a.originalParams = F({}, a.params)),
							(a.passedParams = F({}, n)),
							a.params &&
								a.params.on &&
								Object.keys(a.params.on).forEach(function (e) {
									a.on(e, a.params.on[e])
								}),
							a.params && a.params.onAny && a.onAny(a.params.onAny),
							(a.$ = N),
							F(a, {
								enabled: a.params.enabled,
								el: t,
								classNames: [],
								slides: N(),
								slidesGrid: [],
								snapGrid: [],
								slidesSizesGrid: [],
								isHorizontal: function () {
									return 'horizontal' === a.params.direction
								},
								isVertical: function () {
									return 'vertical' === a.params.direction
								},
								activeIndex: 0,
								realIndex: 0,
								isBeginning: !0,
								isEnd: !1,
								translate: 0,
								previousTranslate: 0,
								progress: 0,
								velocity: 0,
								animating: !1,
								allowSlideNext: a.params.allowSlideNext,
								allowSlidePrev: a.params.allowSlidePrev,
								touchEvents:
									((l = [
										'touchstart',
										'touchmove',
										'touchend',
										'touchcancel'
									]),
									(u = ['mousedown', 'mousemove', 'mouseup']),
									a.support.pointerEvents &&
										(u = ['pointerdown', 'pointermove', 'pointerup']),
									(a.touchEventsTouch = {
										start: l[0],
										move: l[1],
										end: l[2],
										cancel: l[3]
									}),
									(a.touchEventsDesktop = {
										start: u[0],
										move: u[1],
										end: u[2]
									}),
									a.support.touch || !a.params.simulateTouch
										? a.touchEventsTouch
										: a.touchEventsDesktop),
								touchEventsData: {
									isTouched: void 0,
									isMoved: void 0,
									allowTouchCallbacks: void 0,
									touchStartTime: void 0,
									isScrolling: void 0,
									currentTranslate: void 0,
									startTranslate: void 0,
									allowThresholdMove: void 0,
									focusableElements: a.params.focusableElements,
									lastClickTime: q(),
									clickTimeout: void 0,
									velocities: [],
									allowMomentumBounce: void 0,
									isTouchEvent: void 0,
									startMoving: void 0
								},
								allowClick: !0,
								allowTouchMove: a.params.allowTouchMove,
								touches: {
									startX: 0,
									startY: 0,
									currentX: 0,
									currentY: 0,
									diff: 0
								},
								imagesToLoad: [],
								imagesLoaded: 0
							}),
							a.useModules(),
							a.emit('_swiper'),
							a.params.init && a.init(),
							a
						)
					}
					var t,
						n,
						r,
						i = e.prototype
					return (
						(i.enable = function () {
							var e = this
							e.enabled ||
								((e.enabled = !0),
								e.params.grabCursor && e.setGrabCursor(),
								e.emit('enable'))
						}),
						(i.disable = function () {
							var e = this
							e.enabled &&
								((e.enabled = !1),
								e.params.grabCursor && e.unsetGrabCursor(),
								e.emit('disable'))
						}),
						(i.setProgress = function (e, t) {
							var n = this
							e = Math.min(Math.max(e, 0), 1)
							var r = n.minTranslate(),
								i = (n.maxTranslate() - r) * e + r
							n.translateTo(i, void 0 === t ? 0 : t),
								n.updateActiveIndex(),
								n.updateSlidesClasses()
						}),
						(i.emitContainerClasses = function () {
							var e = this
							if (e.params._emitClasses && e.el) {
								var t = e.el.className
									.split(' ')
									.filter(function (t) {
										return (
											0 === t.indexOf('swiper-container') ||
											0 === t.indexOf(e.params.containerModifierClass)
										)
									})
								e.emit('_containerClasses', t.join(' '))
							}
						}),
						(i.getSlideClasses = function (e) {
							var t = this
							return e.className
								.split(' ')
								.filter(function (e) {
									return (
										0 === e.indexOf('swiper-slide') ||
										0 === e.indexOf(t.params.slideClass)
									)
								})
								.join(' ')
						}),
						(i.emitSlidesClasses = function () {
							var e = this
							if (e.params._emitClasses && e.el) {
								var t = []
								e.slides.each(function (n) {
									var r = e.getSlideClasses(n)
									t.push({ slideEl: n, classNames: r }),
										e.emit('_slideClass', n, r)
								}),
									e.emit('_slideClasses', t)
							}
						}),
						(i.slidesPerViewDynamic = function () {
							var e = this,
								t = e.params,
								n = e.slides,
								r = e.slidesGrid,
								i = e.size,
								o = e.activeIndex,
								s = 1
							if (t.centeredSlides) {
								for (
									var a, l = n[o].swiperSlideSize, u = o + 1;
									u < n.length;
									u += 1
								)
									n[u] &&
										!a &&
										((s += 1),
										(l += n[u].swiperSlideSize) > i && (a = !0))
								for (var c = o - 1; c >= 0; c -= 1)
									n[c] &&
										!a &&
										((s += 1),
										(l += n[c].swiperSlideSize) > i && (a = !0))
							} else
								for (var d = o + 1; d < n.length; d += 1)
									r[d] - r[o] < i && (s += 1)
							return s
						}),
						(i.update = function () {
							var e = this
							if (e && !e.destroyed) {
								var t = e.snapGrid,
									n = e.params
								n.breakpoints && e.setBreakpoint(),
									e.updateSize(),
									e.updateSlides(),
									e.updateProgress(),
									e.updateSlidesClasses(),
									e.params.freeMode
										? (r(),
										  e.params.autoHeight && e.updateAutoHeight())
										: (('auto' === e.params.slidesPerView ||
												e.params.slidesPerView > 1) &&
										  e.isEnd &&
										  !e.params.centeredSlides
												? e.slideTo(e.slides.length - 1, 0, !1, !0)
												: e.slideTo(e.activeIndex, 0, !1, !0)) || r(),
									n.watchOverflow &&
										t !== e.snapGrid &&
										e.checkOverflow(),
									e.emit('update')
							}
							function r() {
								var t = e.rtlTranslate
										? -1 * e.translate
										: e.translate,
									n = Math.min(
										Math.max(t, e.maxTranslate()),
										e.minTranslate()
									)
								e.setTranslate(n),
									e.updateActiveIndex(),
									e.updateSlidesClasses()
							}
						}),
						(i.changeDirection = function (e, t) {
							void 0 === t && (t = !0)
							var n = this,
								r = n.params.direction
							return (
								e ||
									(e =
										'horizontal' === r ? 'vertical' : 'horizontal'),
								e === r ||
									('horizontal' !== e && 'vertical' !== e) ||
									(n.$el
										.removeClass(
											'' + n.params.containerModifierClass + r
										)
										.addClass(
											'' + n.params.containerModifierClass + e
										),
									n.emitContainerClasses(),
									(n.params.direction = e),
									n.slides.each(function (t) {
										'vertical' === e
											? (t.style.width = '')
											: (t.style.height = '')
									}),
									n.emit('changeDirection'),
									t && n.update()),
								n
							)
						}),
						(i.mount = function (e) {
							var t = this
							if (t.mounted) return !0
							var n = N(e || t.params.el)
							if (!(e = n[0])) return !1
							e.swiper = t
							var r = function () {
									return (
										'.' +
										(t.params.wrapperClass || '')
											.trim()
											.split(' ')
											.join('.')
									)
								},
								i = (function () {
									if (
										e &&
										e.shadowRoot &&
										e.shadowRoot.querySelector
									) {
										var t = N(e.shadowRoot.querySelector(r()))
										return (
											(t.children = function (e) {
												return n.children(e)
											}),
											t
										)
									}
									return n.children(r())
								})()
							if (0 === i.length && t.params.createElements) {
								var o = y().createElement('div')
								;(i = N(o)),
									(o.className = t.params.wrapperClass),
									n.append(o),
									n
										.children('.' + t.params.slideClass)
										.each(function (e) {
											i.append(e)
										})
							}
							return (
								F(t, {
									$el: n,
									el: e,
									$wrapperEl: i,
									wrapperEl: i[0],
									mounted: !0,
									rtl:
										'rtl' === e.dir.toLowerCase() ||
										'rtl' === n.css('direction'),
									rtlTranslate:
										'horizontal' === t.params.direction &&
										('rtl' === e.dir.toLowerCase() ||
											'rtl' === n.css('direction')),
									wrongRTL: '-webkit-box' === i.css('display')
								}),
								!0
							)
						}),
						(i.init = function (e) {
							var t = this
							return (
								t.initialized ||
									!1 === t.mount(e) ||
									(t.emit('beforeInit'),
									t.params.breakpoints && t.setBreakpoint(),
									t.addClasses(),
									t.params.loop && t.loopCreate(),
									t.updateSize(),
									t.updateSlides(),
									t.params.watchOverflow && t.checkOverflow(),
									t.params.grabCursor &&
										t.enabled &&
										t.setGrabCursor(),
									t.params.preloadImages && t.preloadImages(),
									t.params.loop
										? t.slideTo(
												t.params.initialSlide + t.loopedSlides,
												0,
												t.params.runCallbacksOnInit,
												!1,
												!0
										  )
										: t.slideTo(
												t.params.initialSlide,
												0,
												t.params.runCallbacksOnInit,
												!1,
												!0
										  ),
									t.attachEvents(),
									(t.initialized = !0),
									t.emit('init'),
									t.emit('afterInit')),
								t
							)
						}),
						(i.destroy = function (e, t) {
							void 0 === e && (e = !0), void 0 === t && (t = !0)
							var n,
								r = this,
								i = r.params,
								o = r.$el,
								s = r.$wrapperEl,
								a = r.slides
							return (
								void 0 === r.params ||
									r.destroyed ||
									(r.emit('beforeDestroy'),
									(r.initialized = !1),
									r.detachEvents(),
									i.loop && r.loopDestroy(),
									t &&
										(r.removeClasses(),
										o.removeAttr('style'),
										s.removeAttr('style'),
										a &&
											a.length &&
											a
												.removeClass(
													[
														i.slideVisibleClass,
														i.slideActiveClass,
														i.slideNextClass,
														i.slidePrevClass
													].join(' ')
												)
												.removeAttr('style')
												.removeAttr('data-swiper-slide-index')),
									r.emit('destroy'),
									Object.keys(r.eventsListeners).forEach(function (
										e
									) {
										r.off(e)
									}),
									!1 !== e &&
										((r.$el[0].swiper = null),
										(n = r),
										Object.keys(n).forEach(function (e) {
											try {
												n[e] = null
											} catch (e) {}
											try {
												delete n[e]
											} catch (e) {}
										})),
									(r.destroyed = !0)),
								null
							)
						}),
						(e.extendDefaults = function (e) {
							F(be, e)
						}),
						(e.installModule = function (t) {
							e.prototype.modules || (e.prototype.modules = {})
							var n =
								t.name ||
								Object.keys(e.prototype.modules).length + '_' + q()
							e.prototype.modules[n] = t
						}),
						(e.use = function (t) {
							return Array.isArray(t)
								? (t.forEach(function (t) {
										return e.installModule(t)
								  }),
								  e)
								: (e.installModule(t), e)
						}),
						(t = e),
						(r = [
							{
								key: 'extendedDefaults',
								get: function () {
									return be
								}
							},
							{
								key: 'defaults',
								get: function () {
									return ge
								}
							}
						]),
						(n = null) && ye(t.prototype, n),
						r && ye(t, r),
						e
					)
				})()
			Object.keys(_e).forEach(function (e) {
				Object.keys(_e[e]).forEach(function (t) {
					we.prototype[t] = _e[e][t]
				})
			}),
				we.use([X, Q])
			var xe = we
			function Te() {
				return (
					(Te =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var n = arguments[t]
								for (var r in n)
									Object.prototype.hasOwnProperty.call(n, r) &&
										(e[r] = n[r])
							}
							return e
						}),
					Te.apply(this, arguments)
				)
			}
			var Ce = {
					toggleEl: function (e, t) {
						e[t ? 'addClass' : 'removeClass'](
							this.params.navigation.disabledClass
						),
							e[0] && 'BUTTON' === e[0].tagName && (e[0].disabled = t)
					},
					update: function () {
						var e = this,
							t = e.params.navigation,
							n = e.navigation.toggleEl
						if (!e.params.loop) {
							var r = e.navigation,
								i = r.$nextEl,
								o = r.$prevEl
							o &&
								o.length > 0 &&
								(e.isBeginning ? n(o, !0) : n(o, !1),
								e.params.watchOverflow &&
									e.enabled &&
									o[e.isLocked ? 'addClass' : 'removeClass'](
										t.lockClass
									)),
								i &&
									i.length > 0 &&
									(e.isEnd ? n(i, !0) : n(i, !1),
									e.params.watchOverflow &&
										e.enabled &&
										i[e.isLocked ? 'addClass' : 'removeClass'](
											t.lockClass
										))
						}
					},
					onPrevClick: function (e) {
						var t = this
						e.preventDefault(),
							(t.isBeginning && !t.params.loop) || t.slidePrev()
					},
					onNextClick: function (e) {
						var t = this
						e.preventDefault(),
							(t.isEnd && !t.params.loop) || t.slideNext()
					},
					init: function () {
						var e,
							t,
							n = this,
							r = n.params.navigation
						;((n.params.navigation = W(
							n.$el,
							n.params.navigation,
							n.params.createElements,
							{
								nextEl: 'swiper-button-next',
								prevEl: 'swiper-button-prev'
							}
						)),
						r.nextEl || r.prevEl) &&
							(r.nextEl &&
								((e = N(r.nextEl)),
								n.params.uniqueNavElements &&
									'string' == typeof r.nextEl &&
									e.length > 1 &&
									1 === n.$el.find(r.nextEl).length &&
									(e = n.$el.find(r.nextEl))),
							r.prevEl &&
								((t = N(r.prevEl)),
								n.params.uniqueNavElements &&
									'string' == typeof r.prevEl &&
									t.length > 1 &&
									1 === n.$el.find(r.prevEl).length &&
									(t = n.$el.find(r.prevEl))),
							e &&
								e.length > 0 &&
								e.on('click', n.navigation.onNextClick),
							t &&
								t.length > 0 &&
								t.on('click', n.navigation.onPrevClick),
							F(n.navigation, {
								$nextEl: e,
								nextEl: e && e[0],
								$prevEl: t,
								prevEl: t && t[0]
							}),
							n.enabled ||
								(e && e.addClass(r.lockClass),
								t && t.addClass(r.lockClass)))
					},
					destroy: function () {
						var e = this,
							t = e.navigation,
							n = t.$nextEl,
							r = t.$prevEl
						n &&
							n.length &&
							(n.off('click', e.navigation.onNextClick),
							n.removeClass(e.params.navigation.disabledClass)),
							r &&
								r.length &&
								(r.off('click', e.navigation.onPrevClick),
								r.removeClass(e.params.navigation.disabledClass))
					}
				},
				Ee = {
					name: 'navigation',
					params: {
						navigation: {
							nextEl: null,
							prevEl: null,
							hideOnClick: !1,
							disabledClass: 'swiper-button-disabled',
							hiddenClass: 'swiper-button-hidden',
							lockClass: 'swiper-button-lock'
						}
					},
					create: function () {
						R(this, { navigation: Te({}, Ce) })
					},
					on: {
						init: function (e) {
							e.navigation.init(), e.navigation.update()
						},
						toEdge: function (e) {
							e.navigation.update()
						},
						fromEdge: function (e) {
							e.navigation.update()
						},
						destroy: function (e) {
							e.navigation.destroy()
						},
						'enable disable': function (e) {
							var t = e.navigation,
								n = t.$nextEl,
								r = t.$prevEl
							n &&
								n[e.enabled ? 'removeClass' : 'addClass'](
									e.params.navigation.lockClass
								),
								r &&
									r[e.enabled ? 'removeClass' : 'addClass'](
										e.params.navigation.lockClass
									)
						},
						click: function (e, t) {
							var n = e.navigation,
								r = n.$nextEl,
								i = n.$prevEl,
								o = t.target
							if (
								e.params.navigation.hideOnClick &&
								!N(o).is(i) &&
								!N(o).is(r)
							) {
								if (
									e.pagination &&
									e.params.pagination &&
									e.params.pagination.clickable &&
									(e.pagination.el === o ||
										e.pagination.el.contains(o))
								)
									return
								var s
								r
									? (s = r.hasClass(e.params.navigation.hiddenClass))
									: i &&
									  (s = i.hasClass(e.params.navigation.hiddenClass)),
									!0 === s
										? e.emit('navigationShow')
										: e.emit('navigationHide'),
									r && r.toggleClass(e.params.navigation.hiddenClass),
									i && i.toggleClass(e.params.navigation.hiddenClass)
							}
						}
					}
				}
			function ke() {
				return (
					(ke =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var n = arguments[t]
								for (var r in n)
									Object.prototype.hasOwnProperty.call(n, r) &&
										(e[r] = n[r])
							}
							return e
						}),
					ke.apply(this, arguments)
				)
			}
			var Se = {
					update: function () {
						var e = this,
							t = e.rtl,
							n = e.params.pagination
						if (
							n.el &&
							e.pagination.el &&
							e.pagination.$el &&
							0 !== e.pagination.$el.length
						) {
							var r,
								i =
									e.virtual && e.params.virtual.enabled
										? e.virtual.slides.length
										: e.slides.length,
								o = e.pagination.$el,
								s = e.params.loop
									? Math.ceil(
											(i - 2 * e.loopedSlides) /
												e.params.slidesPerGroup
									  )
									: e.snapGrid.length
							if (
								(e.params.loop
									? ((r = Math.ceil(
											(e.activeIndex - e.loopedSlides) /
												e.params.slidesPerGroup
									  )) >
											i - 1 - 2 * e.loopedSlides &&
											(r -= i - 2 * e.loopedSlides),
									  r > s - 1 && (r -= s),
									  r < 0 &&
											'bullets' !== e.params.paginationType &&
											(r = s + r))
									: (r =
											void 0 !== e.snapIndex
												? e.snapIndex
												: e.activeIndex || 0),
								'bullets' === n.type &&
									e.pagination.bullets &&
									e.pagination.bullets.length > 0)
							) {
								var a,
									l,
									u,
									c = e.pagination.bullets
								if (
									(n.dynamicBullets &&
										((e.pagination.bulletSize = c
											.eq(0)
											[
												e.isHorizontal()
													? 'outerWidth'
													: 'outerHeight'
											](!0)),
										o.css(
											e.isHorizontal() ? 'width' : 'height',
											e.pagination.bulletSize *
												(n.dynamicMainBullets + 4) +
												'px'
										),
										n.dynamicMainBullets > 1 &&
											void 0 !== e.previousIndex &&
											((e.pagination.dynamicBulletIndex +=
												r - e.previousIndex),
											e.pagination.dynamicBulletIndex >
											n.dynamicMainBullets - 1
												? (e.pagination.dynamicBulletIndex =
														n.dynamicMainBullets - 1)
												: e.pagination.dynamicBulletIndex < 0 &&
												  (e.pagination.dynamicBulletIndex = 0)),
										(a = r - e.pagination.dynamicBulletIndex),
										(u =
											((l =
												a +
												(Math.min(c.length, n.dynamicMainBullets) -
													1)) +
												a) /
											2)),
									c.removeClass(
										n.bulletActiveClass +
											' ' +
											n.bulletActiveClass +
											'-next ' +
											n.bulletActiveClass +
											'-next-next ' +
											n.bulletActiveClass +
											'-prev ' +
											n.bulletActiveClass +
											'-prev-prev ' +
											n.bulletActiveClass +
											'-main'
									),
									o.length > 1)
								)
									c.each(function (e) {
										var t = N(e),
											i = t.index()
										i === r && t.addClass(n.bulletActiveClass),
											n.dynamicBullets &&
												(i >= a &&
													i <= l &&
													t.addClass(n.bulletActiveClass + '-main'),
												i === a &&
													t
														.prev()
														.addClass(n.bulletActiveClass + '-prev')
														.prev()
														.addClass(
															n.bulletActiveClass + '-prev-prev'
														),
												i === l &&
													t
														.next()
														.addClass(n.bulletActiveClass + '-next')
														.next()
														.addClass(
															n.bulletActiveClass + '-next-next'
														))
									})
								else {
									var d = c.eq(r),
										p = d.index()
									if (
										(d.addClass(n.bulletActiveClass),
										n.dynamicBullets)
									) {
										for (
											var f = c.eq(a), h = c.eq(l), v = a;
											v <= l;
											v += 1
										)
											c.eq(v).addClass(n.bulletActiveClass + '-main')
										if (e.params.loop)
											if (p >= c.length - n.dynamicMainBullets) {
												for (
													var m = n.dynamicMainBullets;
													m >= 0;
													m -= 1
												)
													c.eq(c.length - m).addClass(
														n.bulletActiveClass + '-main'
													)
												c.eq(
													c.length - n.dynamicMainBullets - 1
												).addClass(n.bulletActiveClass + '-prev')
											} else
												f
													.prev()
													.addClass(n.bulletActiveClass + '-prev')
													.prev()
													.addClass(
														n.bulletActiveClass + '-prev-prev'
													),
													h
														.next()
														.addClass(n.bulletActiveClass + '-next')
														.next()
														.addClass(
															n.bulletActiveClass + '-next-next'
														)
										else
											f
												.prev()
												.addClass(n.bulletActiveClass + '-prev')
												.prev()
												.addClass(n.bulletActiveClass + '-prev-prev'),
												h
													.next()
													.addClass(n.bulletActiveClass + '-next')
													.next()
													.addClass(
														n.bulletActiveClass + '-next-next'
													)
									}
								}
								if (n.dynamicBullets) {
									var g = Math.min(
											c.length,
											n.dynamicMainBullets + 4
										),
										y =
											(e.pagination.bulletSize * g -
												e.pagination.bulletSize) /
												2 -
											u * e.pagination.bulletSize,
										_ = t ? 'right' : 'left'
									c.css(e.isHorizontal() ? _ : 'top', y + 'px')
								}
							}
							if (
								('fraction' === n.type &&
									(o
										.find(z(n.currentClass))
										.text(n.formatFractionCurrent(r + 1)),
									o
										.find(z(n.totalClass))
										.text(n.formatFractionTotal(s))),
								'progressbar' === n.type)
							) {
								var b
								b = n.progressbarOpposite
									? e.isHorizontal()
										? 'vertical'
										: 'horizontal'
									: e.isHorizontal()
									? 'horizontal'
									: 'vertical'
								var w = (r + 1) / s,
									x = 1,
									T = 1
								'horizontal' === b ? (x = w) : (T = w),
									o
										.find(z(n.progressbarFillClass))
										.transform(
											'translate3d(0,0,0) scaleX(' +
												x +
												') scaleY(' +
												T +
												')'
										)
										.transition(e.params.speed)
							}
							'custom' === n.type && n.renderCustom
								? (o.html(n.renderCustom(e, r + 1, s)),
								  e.emit('paginationRender', o[0]))
								: e.emit('paginationUpdate', o[0]),
								e.params.watchOverflow &&
									e.enabled &&
									o[e.isLocked ? 'addClass' : 'removeClass'](
										n.lockClass
									)
						}
					},
					render: function () {
						var e = this,
							t = e.params.pagination
						if (
							t.el &&
							e.pagination.el &&
							e.pagination.$el &&
							0 !== e.pagination.$el.length
						) {
							var n =
									e.virtual && e.params.virtual.enabled
										? e.virtual.slides.length
										: e.slides.length,
								r = e.pagination.$el,
								i = ''
							if ('bullets' === t.type) {
								var o = e.params.loop
									? Math.ceil(
											(n - 2 * e.loopedSlides) /
												e.params.slidesPerGroup
									  )
									: e.snapGrid.length
								e.params.freeMode &&
									!e.params.loop &&
									o > n &&
									(o = n)
								for (var s = 0; s < o; s += 1)
									t.renderBullet
										? (i += t.renderBullet.call(e, s, t.bulletClass))
										: (i +=
												'<' +
												t.bulletElement +
												' class="' +
												t.bulletClass +
												'"></' +
												t.bulletElement +
												'>')
								r.html(i),
									(e.pagination.bullets = r.find(z(t.bulletClass)))
							}
							'fraction' === t.type &&
								((i = t.renderFraction
									? t.renderFraction.call(
											e,
											t.currentClass,
											t.totalClass
									  )
									: '<span class="' +
									  t.currentClass +
									  '"></span> / <span class="' +
									  t.totalClass +
									  '"></span>'),
								r.html(i)),
								'progressbar' === t.type &&
									((i = t.renderProgressbar
										? t.renderProgressbar.call(
												e,
												t.progressbarFillClass
										  )
										: '<span class="' +
										  t.progressbarFillClass +
										  '"></span>'),
									r.html(i)),
								'custom' !== t.type &&
									e.emit('paginationRender', e.pagination.$el[0])
						}
					},
					init: function () {
						var e = this
						e.params.pagination = W(
							e.$el,
							e.params.pagination,
							e.params.createElements,
							{ el: 'swiper-pagination' }
						)
						var t = e.params.pagination
						if (t.el) {
							var n = N(t.el)
							0 !== n.length &&
								(e.params.uniqueNavElements &&
									'string' == typeof t.el &&
									n.length > 1 &&
									(n = e.$el.find(t.el)),
								'bullets' === t.type &&
									t.clickable &&
									n.addClass(t.clickableClass),
								n.addClass(t.modifierClass + t.type),
								'bullets' === t.type &&
									t.dynamicBullets &&
									(n.addClass(
										'' + t.modifierClass + t.type + '-dynamic'
									),
									(e.pagination.dynamicBulletIndex = 0),
									t.dynamicMainBullets < 1 &&
										(t.dynamicMainBullets = 1)),
								'progressbar' === t.type &&
									t.progressbarOpposite &&
									n.addClass(t.progressbarOppositeClass),
								t.clickable &&
									n.on('click', z(t.bulletClass), function (t) {
										t.preventDefault()
										var n = N(this).index() * e.params.slidesPerGroup
										e.params.loop && (n += e.loopedSlides),
											e.slideTo(n)
									}),
								F(e.pagination, { $el: n, el: n[0] }),
								e.enabled || n.addClass(t.lockClass))
						}
					},
					destroy: function () {
						var e = this,
							t = e.params.pagination
						if (
							t.el &&
							e.pagination.el &&
							e.pagination.$el &&
							0 !== e.pagination.$el.length
						) {
							var n = e.pagination.$el
							n.removeClass(t.hiddenClass),
								n.removeClass(t.modifierClass + t.type),
								e.pagination.bullets &&
									e.pagination.bullets.removeClass(
										t.bulletActiveClass
									),
								t.clickable && n.off('click', z(t.bulletClass))
						}
					}
				},
				Me = {
					name: 'pagination',
					params: {
						pagination: {
							el: null,
							bulletElement: 'span',
							clickable: !1,
							hideOnClick: !1,
							renderBullet: null,
							renderProgressbar: null,
							renderFraction: null,
							renderCustom: null,
							progressbarOpposite: !1,
							type: 'bullets',
							dynamicBullets: !1,
							dynamicMainBullets: 1,
							formatFractionCurrent: function (e) {
								return e
							},
							formatFractionTotal: function (e) {
								return e
							},
							bulletClass: 'swiper-pagination-bullet',
							bulletActiveClass: 'swiper-pagination-bullet-active',
							modifierClass: 'swiper-pagination-',
							currentClass: 'swiper-pagination-current',
							totalClass: 'swiper-pagination-total',
							hiddenClass: 'swiper-pagination-hidden',
							progressbarFillClass:
								'swiper-pagination-progressbar-fill',
							progressbarOppositeClass:
								'swiper-pagination-progressbar-opposite',
							clickableClass: 'swiper-pagination-clickable',
							lockClass: 'swiper-pagination-lock'
						}
					},
					create: function () {
						R(this, { pagination: ke({ dynamicBulletIndex: 0 }, Se) })
					},
					on: {
						init: function (e) {
							e.pagination.init(),
								e.pagination.render(),
								e.pagination.update()
						},
						activeIndexChange: function (e) {
							;(e.params.loop || void 0 === e.snapIndex) &&
								e.pagination.update()
						},
						snapIndexChange: function (e) {
							e.params.loop || e.pagination.update()
						},
						slidesLengthChange: function (e) {
							e.params.loop &&
								(e.pagination.render(), e.pagination.update())
						},
						snapGridLengthChange: function (e) {
							e.params.loop ||
								(e.pagination.render(), e.pagination.update())
						},
						destroy: function (e) {
							e.pagination.destroy()
						},
						'enable disable': function (e) {
							var t = e.pagination.$el
							t &&
								t[e.enabled ? 'removeClass' : 'addClass'](
									e.params.pagination.lockClass
								)
						},
						click: function (e, t) {
							var n = t.target
							if (
								e.params.pagination.el &&
								e.params.pagination.hideOnClick &&
								e.pagination.$el.length > 0 &&
								!N(n).hasClass(e.params.pagination.bulletClass)
							) {
								if (
									e.navigation &&
									((e.navigation.nextEl &&
										n === e.navigation.nextEl) ||
										(e.navigation.prevEl &&
											n === e.navigation.prevEl))
								)
									return
								!0 ===
								e.pagination.$el.hasClass(
									e.params.pagination.hiddenClass
								)
									? e.emit('paginationShow')
									: e.emit('paginationHide'),
									e.pagination.$el.toggleClass(
										e.params.pagination.hiddenClass
									)
							}
						}
					}
				}
			function Pe() {
				return (
					(Pe =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var n = arguments[t]
								for (var r in n)
									Object.prototype.hasOwnProperty.call(n, r) &&
										(e[r] = n[r])
							}
							return e
						}),
					Pe.apply(this, arguments)
				)
			}
			var Le = {
					run: function () {
						var e = this,
							t = e.slides.eq(e.activeIndex),
							n = e.params.autoplay.delay
						t.attr('data-swiper-autoplay') &&
							(n =
								t.attr('data-swiper-autoplay') ||
								e.params.autoplay.delay),
							clearTimeout(e.autoplay.timeout),
							(e.autoplay.timeout = I(function () {
								var t
								e.params.autoplay.reverseDirection
									? e.params.loop
										? (e.loopFix(),
										  (t = e.slidePrev(e.params.speed, !0, !0)),
										  e.emit('autoplay'))
										: e.isBeginning
										? e.params.autoplay.stopOnLastSlide
											? e.autoplay.stop()
											: ((t = e.slideTo(
													e.slides.length - 1,
													e.params.speed,
													!0,
													!0
											  )),
											  e.emit('autoplay'))
										: ((t = e.slidePrev(e.params.speed, !0, !0)),
										  e.emit('autoplay'))
									: e.params.loop
									? (e.loopFix(),
									  (t = e.slideNext(e.params.speed, !0, !0)),
									  e.emit('autoplay'))
									: e.isEnd
									? e.params.autoplay.stopOnLastSlide
										? e.autoplay.stop()
										: ((t = e.slideTo(0, e.params.speed, !0, !0)),
										  e.emit('autoplay'))
									: ((t = e.slideNext(e.params.speed, !0, !0)),
									  e.emit('autoplay')),
									((e.params.cssMode && e.autoplay.running) ||
										!1 === t) &&
										e.autoplay.run()
							}, n))
					},
					start: function () {
						var e = this
						return (
							void 0 === e.autoplay.timeout &&
							!e.autoplay.running &&
							((e.autoplay.running = !0),
							e.emit('autoplayStart'),
							e.autoplay.run(),
							!0)
						)
					},
					stop: function () {
						var e = this
						return (
							!!e.autoplay.running &&
							void 0 !== e.autoplay.timeout &&
							(e.autoplay.timeout &&
								(clearTimeout(e.autoplay.timeout),
								(e.autoplay.timeout = void 0)),
							(e.autoplay.running = !1),
							e.emit('autoplayStop'),
							!0)
						)
					},
					pause: function (e) {
						var t = this
						t.autoplay.running &&
							(t.autoplay.paused ||
								(t.autoplay.timeout &&
									clearTimeout(t.autoplay.timeout),
								(t.autoplay.paused = !0),
								0 !== e && t.params.autoplay.waitForTransition
									? ['transitionend', 'webkitTransitionEnd'].forEach(
											function (e) {
												t.$wrapperEl[0].addEventListener(
													e,
													t.autoplay.onTransitionEnd
												)
											}
									  )
									: ((t.autoplay.paused = !1), t.autoplay.run())))
					},
					onVisibilityChange: function () {
						var e = this,
							t = y()
						'hidden' === t.visibilityState &&
							e.autoplay.running &&
							e.autoplay.pause(),
							'visible' === t.visibilityState &&
								e.autoplay.paused &&
								(e.autoplay.run(), (e.autoplay.paused = !1))
					},
					onTransitionEnd: function (e) {
						var t = this
						t &&
							!t.destroyed &&
							t.$wrapperEl &&
							e.target === t.$wrapperEl[0] &&
							(['transitionend', 'webkitTransitionEnd'].forEach(
								function (e) {
									t.$wrapperEl[0].removeEventListener(
										e,
										t.autoplay.onTransitionEnd
									)
								}
							),
							(t.autoplay.paused = !1),
							t.autoplay.running
								? t.autoplay.run()
								: t.autoplay.stop())
					},
					onMouseEnter: function () {
						var e = this
						e.params.autoplay.disableOnInteraction
							? e.autoplay.stop()
							: e.autoplay.pause(),
							['transitionend', 'webkitTransitionEnd'].forEach(
								function (t) {
									e.$wrapperEl[0].removeEventListener(
										t,
										e.autoplay.onTransitionEnd
									)
								}
							)
					},
					onMouseLeave: function () {
						var e = this
						e.params.autoplay.disableOnInteraction ||
							((e.autoplay.paused = !1), e.autoplay.run())
					},
					attachMouseEvents: function () {
						var e = this
						e.params.autoplay.pauseOnMouseEnter &&
							(e.$el.on('mouseenter', e.autoplay.onMouseEnter),
							e.$el.on('mouseleave', e.autoplay.onMouseLeave))
					},
					detachMouseEvents: function () {
						var e = this
						e.$el.off('mouseenter', e.autoplay.onMouseEnter),
							e.$el.off('mouseleave', e.autoplay.onMouseLeave)
					}
				},
				Ae = {
					name: 'autoplay',
					params: {
						autoplay: {
							enabled: !1,
							delay: 3e3,
							waitForTransition: !0,
							disableOnInteraction: !0,
							stopOnLastSlide: !1,
							reverseDirection: !1,
							pauseOnMouseEnter: !1
						}
					},
					create: function () {
						R(this, {
							autoplay: Pe({}, Le, { running: !1, paused: !1 })
						})
					},
					on: {
						init: function (e) {
							e.params.autoplay.enabled &&
								(e.autoplay.start(),
								y().addEventListener(
									'visibilitychange',
									e.autoplay.onVisibilityChange
								),
								e.autoplay.attachMouseEvents())
						},
						beforeTransitionStart: function (e, t, n) {
							e.autoplay.running &&
								(n || !e.params.autoplay.disableOnInteraction
									? e.autoplay.pause(t)
									: e.autoplay.stop())
						},
						sliderFirstMove: function (e) {
							e.autoplay.running &&
								(e.params.autoplay.disableOnInteraction
									? e.autoplay.stop()
									: e.autoplay.pause())
						},
						touchEnd: function (e) {
							e.params.cssMode &&
								e.autoplay.paused &&
								!e.params.autoplay.disableOnInteraction &&
								e.autoplay.run()
						},
						destroy: function (e) {
							e.autoplay.detachMouseEvents(),
								e.autoplay.running && e.autoplay.stop(),
								y().removeEventListener(
									'visibilitychange',
									e.autoplay.onVisibilityChange
								)
						}
					}
				}
			function Oe() {
				return (
					(Oe =
						Object.assign ||
						function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var n = arguments[t]
								for (var r in n)
									Object.prototype.hasOwnProperty.call(n, r) &&
										(e[r] = n[r])
							}
							return e
						}),
					Oe.apply(this, arguments)
				)
			}
			var je = {
					setTranslate: function () {
						for (
							var e = this, t = e.slides, n = 0;
							n < t.length;
							n += 1
						) {
							var r = e.slides.eq(n),
								i = -r[0].swiperSlideOffset
							e.params.virtualTranslate || (i -= e.translate)
							var o = 0
							e.isHorizontal() || ((o = i), (i = 0))
							var s = e.params.fadeEffect.crossFade
								? Math.max(1 - Math.abs(r[0].progress), 0)
								: 1 + Math.min(Math.max(r[0].progress, -1), 0)
							r.css({ opacity: s }).transform(
								'translate3d(' + i + 'px, ' + o + 'px, 0px)'
							)
						}
					},
					setTransition: function (e) {
						var t = this,
							n = t.slides,
							r = t.$wrapperEl
						if (
							(n.transition(e), t.params.virtualTranslate && 0 !== e)
						) {
							var i = !1
							n.transitionEnd(function () {
								if (!i && t && !t.destroyed) {
									;(i = !0), (t.animating = !1)
									for (
										var e = ['webkitTransitionEnd', 'transitionend'],
											n = 0;
										n < e.length;
										n += 1
									)
										r.trigger(e[n])
								}
							})
						}
					}
				},
				$e = {
					name: 'effect-fade',
					params: { fadeEffect: { crossFade: !1 } },
					create: function () {
						R(this, { fadeEffect: Oe({}, je) })
					},
					on: {
						beforeInit: function (e) {
							if ('fade' === e.params.effect) {
								e.classNames.push(
									e.params.containerModifierClass + 'fade'
								)
								var t = {
									slidesPerView: 1,
									slidesPerColumn: 1,
									slidesPerGroup: 1,
									watchSlidesProgress: !0,
									spaceBetween: 0,
									virtualTranslate: !0
								}
								F(e.params, t), F(e.originalParams, t)
							}
						},
						setTranslate: function (e) {
							'fade' === e.params.effect &&
								e.fadeEffect.setTranslate()
						},
						setTransition: function (e, t) {
							'fade' === e.params.effect &&
								e.fadeEffect.setTransition(t)
						}
					}
				}
			function De(e, t, n) {
				return (
					(t = a(t)),
					s(
						e,
						Ne()
							? Reflect.construct(t, n || [], a(e).constructor)
							: t.apply(e, n)
					)
				)
			}
			function Ne() {
				try {
					var e = !Boolean.prototype.valueOf.call(
						Reflect.construct(Boolean, [], function () {})
					)
				} catch (e) {}
				return (Ne = function () {
					return !!e
				})()
			}
			xe.use([Ee, Me, Ae, $e])
			var Ie = '[data-slideshow]',
				qe = '[data-slideshow-slide]',
				He = '.swiper-slide-duplicate',
				Be = (function (t) {
					function n() {
						var t
						return (
							e(this, n),
							((t = De(this, n)).$container = f()(t)),
							(t.$slideshow = f()(Ie, t.$container)),
							(t.swiperOptions = {
								loop: !0,
								speed: 500,
								spaceBetween:
									Number.parseInt(
										t.$slideshow.data('space-between')
									) || 0,
								slidesPerView:
									Number.parseInt(
										t.$slideshow.data('slides-to-show')
									) || 1,
								slidesPerGroup:
									Number.parseInt(
										t.$slideshow.data('slides-to-scroll')
									) || 1,
								navigation: {
									nextEl: t.$slideshow
										.find('.swiper-arrow--right')
										.get(0),
									prevEl: t.$slideshow
										.find('.swiper-arrow--left')
										.get(0)
								}
							}),
							t.$slideshow.data('autoplay') &&
								(t.swiperOptions.autoplay = {
									delay:
										Number.parseInt(t.$slideshow.data('speed')) || 5e3
								}),
							t.$slideshow.data('dots') &&
								t.$slideshow.find('.swiper-pagination').length &&
								(t.swiperOptions.pagination = {
									el: t.$slideshow.find('.swiper-pagination').get(0),
									type: 'progressbar',
									clickable: !0
								}),
							'fade' === t.$slideshow.data('animation') &&
								((t.swiperOptions.effect = 'fade'),
								(t.swiperOptions.fadeEffect = { crossFade: !0 })),
							t.$slideshow.data('transition-speed') &&
								(t.swiperOptions.speed =
									t.$slideshow.data('transition-speed') || 1e3),
							t.$slideshow.find(
								''.concat(qe, ':not(').concat(He, ')')
							).length > 1 &&
								(t.swiper = new xe(
									t.$slideshow.get(0),
									t.swiperOptions
								)),
							(t.swiper = new xe(
								t.$slideshow.get(0),
								t.swiperOptions
							)),
							f()(document)
								.on('shopify:section:load\t', t.onLoad.bind(t))
								.on('shopify:section:unload\t', t.onUnload.bind(t))
								.on(
									'shopify:section:select',
									t.onSectionSelect.bind(t)
								)
								.on(
									'shopify:section:deselect',
									t.onSectionDeselect.bind(t)
								)
								.on(
									'shopify:section:reorder',
									t.onSectionReorder.bind(t)
								)
								.on('shopify:block:select', t.onBlockSelect.bind(t))
								.on(
									'shopify:block:deselect',
									t.onBlockDeselect.bind(t)
								),
							t
						)
					}
					return (
						u(n, t),
						o(n, [
							{
								key: 'onLoad',
								value: function (e) {
									this.swiper.destroy(),
										(this.swiper = new xe(
											this.$slideshow.get(0),
											this.swiperOptions
										))
								}
							},
							{ key: 'onUnload', value: function (e) {} },
							{ key: 'onSectionSelect', value: function (e) {} },
							{ key: 'onSectionDeselect', value: function (e) {} },
							{ key: 'onSectionReorder', value: function (e) {} },
							{
								key: 'onBlockSelect',
								value: function (e) {
									var t = this.$slideshow.find(
										'[data-block-id="'.concat(e.detail.blockId, '"]')
									)
									if (0 !== t.length) {
										t.first().data('swiper-slide-index')
										this.swiper.slideToLoop(
											t.first().data('swiper-slide-index')
										),
											this.swiper.autoplay.stop()
									}
								}
							},
							{
								key: 'onBlockDeselect',
								value: function (e) {
									this.$slideshow.data('autoplay') &&
										this.swiper.autoplay.start()
								}
							}
						])
					)
				})(d(HTMLElement))
			function Fe(e, t) {
				var n = Object.keys(e)
				if (Object.getOwnPropertySymbols) {
					var r = Object.getOwnPropertySymbols(e)
					t &&
						(r = r.filter(function (t) {
							return Object.getOwnPropertyDescriptor(e, t).enumerable
						})),
						n.push.apply(n, r)
				}
				return n
			}
			function Re(e) {
				for (var t = 1; t < arguments.length; t++) {
					var n = null != arguments[t] ? arguments[t] : {}
					t % 2
						? Fe(Object(n), !0).forEach(function (t) {
								Ye(e, t, n[t])
						  })
						: Object.getOwnPropertyDescriptors
						? Object.defineProperties(
								e,
								Object.getOwnPropertyDescriptors(n)
						  )
						: Fe(Object(n)).forEach(function (t) {
								Object.defineProperty(
									e,
									t,
									Object.getOwnPropertyDescriptor(n, t)
								)
						  })
				}
				return e
			}
			function ze() {
				ze = function () {
					return e
				}
				var e = {},
					t = Object.prototype,
					n = t.hasOwnProperty,
					r =
						Object.defineProperty ||
						function (e, t, n) {
							e[t] = n.value
						},
					i = 'function' == typeof Symbol ? Symbol : {},
					o = i.iterator || '@@iterator',
					s = i.asyncIterator || '@@asyncIterator',
					a = i.toStringTag || '@@toStringTag'
				function l(e, t, n) {
					return (
						Object.defineProperty(e, t, {
							value: n,
							enumerable: !0,
							configurable: !0,
							writable: !0
						}),
						e[t]
					)
				}
				try {
					l({}, '')
				} catch (e) {
					l = function (e, t, n) {
						return (e[t] = n)
					}
				}
				function u(e, t, n, i) {
					var o = t && t.prototype instanceof p ? t : p,
						s = Object.create(o.prototype),
						a = new E(i || [])
					return r(s, '_invoke', { value: w(e, n, a) }), s
				}
				function c(e, t, n) {
					try {
						return { type: 'normal', arg: e.call(t, n) }
					} catch (e) {
						return { type: 'throw', arg: e }
					}
				}
				e.wrap = u
				var d = {}
				function p() {}
				function f() {}
				function h() {}
				var v = {}
				l(v, o, function () {
					return this
				})
				var m = Object.getPrototypeOf,
					g = m && m(m(k([])))
				g && g !== t && n.call(g, o) && (v = g)
				var y = (h.prototype = p.prototype = Object.create(v))
				function _(e) {
					;['next', 'throw', 'return'].forEach(function (t) {
						l(e, t, function (e) {
							return this._invoke(t, e)
						})
					})
				}
				function b(e, t) {
					function i(r, o, s, a) {
						var l = c(e[r], e, o)
						if ('throw' !== l.type) {
							var u = l.arg,
								d = u.value
							return d && 'object' == typeof d && n.call(d, '__await')
								? t.resolve(d.__await).then(
										function (e) {
											i('next', e, s, a)
										},
										function (e) {
											i('throw', e, s, a)
										}
								  )
								: t.resolve(d).then(
										function (e) {
											;(u.value = e), s(u)
										},
										function (e) {
											return i('throw', e, s, a)
										}
								  )
						}
						a(l.arg)
					}
					var o
					r(this, '_invoke', {
						value: function (e, n) {
							function r() {
								return new t(function (t, r) {
									i(e, n, t, r)
								})
							}
							return (o = o ? o.then(r, r) : r())
						}
					})
				}
				function w(e, t, n) {
					var r = 'suspendedStart'
					return function (i, o) {
						if ('executing' === r)
							throw new Error('Generator is already running')
						if ('completed' === r) {
							if ('throw' === i) throw o
							return S()
						}
						for (n.method = i, n.arg = o; ; ) {
							var s = n.delegate
							if (s) {
								var a = x(s, n)
								if (a) {
									if (a === d) continue
									return a
								}
							}
							if ('next' === n.method) n.sent = n._sent = n.arg
							else if ('throw' === n.method) {
								if ('suspendedStart' === r)
									throw ((r = 'completed'), n.arg)
								n.dispatchException(n.arg)
							} else
								'return' === n.method && n.abrupt('return', n.arg)
							r = 'executing'
							var l = c(e, t, n)
							if ('normal' === l.type) {
								if (
									((r = n.done ? 'completed' : 'suspendedYield'),
									l.arg === d)
								)
									continue
								return { value: l.arg, done: n.done }
							}
							'throw' === l.type &&
								((r = 'completed'),
								(n.method = 'throw'),
								(n.arg = l.arg))
						}
					}
				}
				function x(e, t) {
					var n = t.method,
						r = e.iterator[n]
					if (void 0 === r)
						return (
							(t.delegate = null),
							('throw' === n &&
								e.iterator.return &&
								((t.method = 'return'),
								(t.arg = void 0),
								x(e, t),
								'throw' === t.method)) ||
								('return' !== n &&
									((t.method = 'throw'),
									(t.arg = new TypeError(
										"The iterator does not provide a '" +
											n +
											"' method"
									)))),
							d
						)
					var i = c(r, e.iterator, t.arg)
					if ('throw' === i.type)
						return (
							(t.method = 'throw'),
							(t.arg = i.arg),
							(t.delegate = null),
							d
						)
					var o = i.arg
					return o
						? o.done
							? ((t[e.resultName] = o.value),
							  (t.next = e.nextLoc),
							  'return' !== t.method &&
									((t.method = 'next'), (t.arg = void 0)),
							  (t.delegate = null),
							  d)
							: o
						: ((t.method = 'throw'),
						  (t.arg = new TypeError(
								'iterator result is not an object'
						  )),
						  (t.delegate = null),
						  d)
				}
				function T(e) {
					var t = { tryLoc: e[0] }
					1 in e && (t.catchLoc = e[1]),
						2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
						this.tryEntries.push(t)
				}
				function C(e) {
					var t = e.completion || {}
					;(t.type = 'normal'), delete t.arg, (e.completion = t)
				}
				function E(e) {
					;(this.tryEntries = [{ tryLoc: 'root' }]),
						e.forEach(T, this),
						this.reset(!0)
				}
				function k(e) {
					if (e) {
						var t = e[o]
						if (t) return t.call(e)
						if ('function' == typeof e.next) return e
						if (!isNaN(e.length)) {
							var r = -1,
								i = function t() {
									for (; ++r < e.length; )
										if (n.call(e, r))
											return (t.value = e[r]), (t.done = !1), t
									return (t.value = void 0), (t.done = !0), t
								}
							return (i.next = i)
						}
					}
					return { next: S }
				}
				function S() {
					return { value: void 0, done: !0 }
				}
				return (
					(f.prototype = h),
					r(y, 'constructor', { value: h, configurable: !0 }),
					r(h, 'constructor', { value: f, configurable: !0 }),
					(f.displayName = l(h, a, 'GeneratorFunction')),
					(e.isGeneratorFunction = function (e) {
						var t = 'function' == typeof e && e.constructor
						return (
							!!t &&
							(t === f ||
								'GeneratorFunction' === (t.displayName || t.name))
						)
					}),
					(e.mark = function (e) {
						return (
							Object.setPrototypeOf
								? Object.setPrototypeOf(e, h)
								: ((e.__proto__ = h), l(e, a, 'GeneratorFunction')),
							(e.prototype = Object.create(y)),
							e
						)
					}),
					(e.awrap = function (e) {
						return { __await: e }
					}),
					_(b.prototype),
					l(b.prototype, s, function () {
						return this
					}),
					(e.AsyncIterator = b),
					(e.async = function (t, n, r, i, o) {
						void 0 === o && (o = Promise)
						var s = new b(u(t, n, r, i), o)
						return e.isGeneratorFunction(n)
							? s
							: s.next().then(function (e) {
									return e.done ? e.value : s.next()
							  })
					}),
					_(y),
					l(y, a, 'Generator'),
					l(y, o, function () {
						return this
					}),
					l(y, 'toString', function () {
						return '[object Generator]'
					}),
					(e.keys = function (e) {
						var t = Object(e),
							n = []
						for (var r in t) n.push(r)
						return (
							n.reverse(),
							function e() {
								for (; n.length; ) {
									var r = n.pop()
									if (r in t) return (e.value = r), (e.done = !1), e
								}
								return (e.done = !0), e
							}
						)
					}),
					(e.values = k),
					(E.prototype = {
						constructor: E,
						reset: function (e) {
							if (
								((this.prev = 0),
								(this.next = 0),
								(this.sent = this._sent = void 0),
								(this.done = !1),
								(this.delegate = null),
								(this.method = 'next'),
								(this.arg = void 0),
								this.tryEntries.forEach(C),
								!e)
							)
								for (var t in this)
									't' === t.charAt(0) &&
										n.call(this, t) &&
										!isNaN(+t.slice(1)) &&
										(this[t] = void 0)
						},
						stop: function () {
							this.done = !0
							var e = this.tryEntries[0].completion
							if ('throw' === e.type) throw e.arg
							return this.rval
						},
						dispatchException: function (e) {
							if (this.done) throw e
							var t = this
							function r(n, r) {
								return (
									(s.type = 'throw'),
									(s.arg = e),
									(t.next = n),
									r && ((t.method = 'next'), (t.arg = void 0)),
									!!r
								)
							}
							for (var i = this.tryEntries.length - 1; i >= 0; --i) {
								var o = this.tryEntries[i],
									s = o.completion
								if ('root' === o.tryLoc) return r('end')
								if (o.tryLoc <= this.prev) {
									var a = n.call(o, 'catchLoc'),
										l = n.call(o, 'finallyLoc')
									if (a && l) {
										if (this.prev < o.catchLoc)
											return r(o.catchLoc, !0)
										if (this.prev < o.finallyLoc)
											return r(o.finallyLoc)
									} else if (a) {
										if (this.prev < o.catchLoc)
											return r(o.catchLoc, !0)
									} else {
										if (!l)
											throw new Error(
												'try statement without catch or finally'
											)
										if (this.prev < o.finallyLoc)
											return r(o.finallyLoc)
									}
								}
							}
						},
						abrupt: function (e, t) {
							for (var r = this.tryEntries.length - 1; r >= 0; --r) {
								var i = this.tryEntries[r]
								if (
									i.tryLoc <= this.prev &&
									n.call(i, 'finallyLoc') &&
									this.prev < i.finallyLoc
								) {
									var o = i
									break
								}
							}
							o &&
								('break' === e || 'continue' === e) &&
								o.tryLoc <= t &&
								t <= o.finallyLoc &&
								(o = null)
							var s = o ? o.completion : {}
							return (
								(s.type = e),
								(s.arg = t),
								o
									? ((this.method = 'next'),
									  (this.next = o.finallyLoc),
									  d)
									: this.complete(s)
							)
						},
						complete: function (e, t) {
							if ('throw' === e.type) throw e.arg
							return (
								'break' === e.type || 'continue' === e.type
									? (this.next = e.arg)
									: 'return' === e.type
									? ((this.rval = this.arg = e.arg),
									  (this.method = 'return'),
									  (this.next = 'end'))
									: 'normal' === e.type && t && (this.next = t),
								d
							)
						},
						finish: function (e) {
							for (var t = this.tryEntries.length - 1; t >= 0; --t) {
								var n = this.tryEntries[t]
								if (n.finallyLoc === e)
									return (
										this.complete(n.completion, n.afterLoc), C(n), d
									)
							}
						},
						catch: function (e) {
							for (var t = this.tryEntries.length - 1; t >= 0; --t) {
								var n = this.tryEntries[t]
								if (n.tryLoc === e) {
									var r = n.completion
									if ('throw' === r.type) {
										var i = r.arg
										C(n)
									}
									return i
								}
							}
							throw new Error('illegal catch attempt')
						},
						delegateYield: function (e, t, n) {
							return (
								(this.delegate = {
									iterator: k(e),
									resultName: t,
									nextLoc: n
								}),
								'next' === this.method && (this.arg = void 0),
								d
							)
						}
					}),
					e
				)
			}
			function We(e, t, n, r, i, o, s) {
				try {
					var a = e[o](s),
						l = a.value
				} catch (e) {
					return void n(e)
				}
				a.done ? t(l) : Promise.resolve(l).then(r, i)
			}
			function Ve(e) {
				return function () {
					var t = this,
						n = arguments
					return new Promise(function (r, i) {
						var o = e.apply(t, n)
						function s(e) {
							We(o, r, i, s, a, 'next', e)
						}
						function a(e) {
							We(o, r, i, s, a, 'throw', e)
						}
						s(void 0)
					})
				}
			}
			function Ge(e, t) {
				if (!(e instanceof t))
					throw new TypeError('Cannot call a class as a function')
			}
			function Ue(e, t) {
				for (var n = 0; n < t.length; n++) {
					var r = t[n]
					;(r.enumerable = r.enumerable || !1),
						(r.configurable = !0),
						'value' in r && (r.writable = !0),
						Object.defineProperty(e, rt(r.key), r)
				}
			}
			function Xe(e, t, n) {
				return (
					t && Ue(e.prototype, t),
					n && Ue(e, n),
					Object.defineProperty(e, 'prototype', { writable: !1 }),
					e
				)
			}
			function Ye(e, t, n) {
				return (
					(t = rt(t)) in e
						? Object.defineProperty(e, t, {
								value: n,
								enumerable: !0,
								configurable: !0,
								writable: !0
						  })
						: (e[t] = n),
					e
				)
			}
			function Ke(e) {
				return (
					(Ke = Object.setPrototypeOf
						? Object.getPrototypeOf.bind()
						: function (e) {
								return e.__proto__ || Object.getPrototypeOf(e)
						  }),
					Ke(e)
				)
			}
			function Qe(e, t) {
				return (
					(Qe = Object.setPrototypeOf
						? Object.setPrototypeOf.bind()
						: function (e, t) {
								return (e.__proto__ = t), e
						  }),
					Qe(e, t)
				)
			}
			function Je() {
				if ('undefined' == typeof Reflect || !Reflect.construct)
					return !1
				if (Reflect.construct.sham) return !1
				if ('function' == typeof Proxy) return !0
				try {
					return (
						Boolean.prototype.valueOf.call(
							Reflect.construct(Boolean, [], function () {})
						),
						!0
					)
				} catch (e) {
					return !1
				}
			}
			function Ze(e, t, n) {
				return (
					(Ze = Je()
						? Reflect.construct.bind()
						: function (e, t, n) {
								var r = [null]
								r.push.apply(r, t)
								var i = new (Function.bind.apply(e, r))()
								return n && Qe(i, n.prototype), i
						  }),
					Ze.apply(null, arguments)
				)
			}
			function et(e) {
				var t = 'function' == typeof Map ? new Map() : void 0
				return (
					(et = function (e) {
						if (
							null === e ||
							((n = e),
							-1 ===
								Function.toString.call(n).indexOf('[native code]'))
						)
							return e
						var n
						if ('function' != typeof e)
							throw new TypeError(
								'Super expression must either be null or a function'
							)
						if (void 0 !== t) {
							if (t.has(e)) return t.get(e)
							t.set(e, r)
						}
						function r() {
							return Ze(e, arguments, Ke(this).constructor)
						}
						return (
							(r.prototype = Object.create(e.prototype, {
								constructor: {
									value: r,
									enumerable: !1,
									writable: !0,
									configurable: !0
								}
							})),
							Qe(r, e)
						)
					}),
					et(e)
				)
			}
			function tt(e) {
				if (void 0 === e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					)
				return e
			}
			function nt(e) {
				var t = Je()
				return function () {
					var n,
						r = Ke(e)
					if (t) {
						var i = Ke(this).constructor
						n = Reflect.construct(r, arguments, i)
					} else n = r.apply(this, arguments)
					return (function (e, t) {
						if (t && ('object' == typeof t || 'function' == typeof t))
							return t
						if (void 0 !== t)
							throw new TypeError(
								'Derived constructors may only return object or undefined'
							)
						return tt(e)
					})(this, n)
				}
			}
			function rt(e) {
				var t = (function (e, t) {
					if ('object' != typeof e || null === e) return e
					var n = e[Symbol.toPrimitive]
					if (void 0 !== n) {
						var r = n.call(e, t || 'default')
						if ('object' != typeof r) return r
						throw new TypeError(
							'@@toPrimitive must return a primitive value.'
						)
					}
					return ('string' === t ? String : Number)(e)
				})(e, 'string')
				return 'symbol' == typeof t ? t : String(t)
			}
			customElements.define('swiper-slideshow', Be)
			var it =
				void 0 !== n.g && '[object global]' === {}.toString.call(n.g)
			function ot(e, t) {
				return 0 === e.indexOf(t.toLowerCase())
					? e
					: ''
							.concat(t.toLowerCase())
							.concat(e.substr(0, 1).toUpperCase())
							.concat(e.substr(1))
			}
			function st(e) {
				return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.videoji\.hk))(?=$|\/)/.test(
					e
				)
			}
			function at(e) {
				return /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.videoji\.hk))\/video\/\d+/.test(
					e
				)
			}
			function lt() {
				var e =
						arguments.length > 0 && void 0 !== arguments[0]
							? arguments[0]
							: {},
					t = e.id,
					n = e.url,
					r = t || n
				if (!r)
					throw new Error(
						'An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.'
					)
				if (
					(function (e) {
						return (
							!isNaN(parseFloat(e)) &&
							isFinite(e) &&
							Math.floor(e) == e
						)
					})(r)
				)
					return 'https://vimeo.com/'.concat(r)
				if (st(r)) return r.replace('http:', 'https:')
				if (t)
					throw new TypeError(
						'“'.concat(t, '” is not a valid video id.')
					)
				throw new TypeError(
					'“'.concat(r, '” is not a vimeo.com url.')
				)
			}
			var ut = function (e, t, n) {
					var r =
							arguments.length > 3 && void 0 !== arguments[3]
								? arguments[3]
								: 'addEventListener',
						i =
							arguments.length > 4 && void 0 !== arguments[4]
								? arguments[4]
								: 'removeEventListener',
						o = 'string' == typeof t ? [t] : t
					return (
						o.forEach(function (t) {
							e[r](t, n)
						}),
						{
							cancel: function () {
								return o.forEach(function (t) {
									return e[i](t, n)
								})
							}
						}
					)
				},
				ct = void 0 !== Array.prototype.indexOf,
				dt =
					'undefined' != typeof window &&
					void 0 !== window.postMessage
			if (!(it || (ct && dt)))
				throw new Error(
					'Sorry, the Vimeo Player API is not available in this browser.'
				)
			var pt =
				'undefined' != typeof globalThis
					? globalThis
					: 'undefined' != typeof window
					? window
					: void 0 !== n.g
					? n.g
					: 'undefined' != typeof self
					? self
					: {}
			/*!
			 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
			 * https://github.com/polygonplanet/weakmap-polyfill
			 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
			 * @license MIT
			 */
			!(function (e) {
				if (!e.WeakMap) {
					var t = Object.prototype.hasOwnProperty,
						n =
							Object.defineProperty &&
							(function () {
								try {
									return (
										1 ===
										Object.defineProperty({}, 'x', { value: 1 }).x
									)
								} catch (e) {}
							})(),
						r = function (e, t, r) {
							n
								? Object.defineProperty(e, t, {
										configurable: !0,
										writable: !0,
										value: r
								  })
								: (e[t] = r)
						}
					e.WeakMap = (function () {
						function e() {
							if (void 0 === this)
								throw new TypeError(
									"Constructor WeakMap requires 'new'"
								)
							if (
								(r(this, '_id', '_WeakMap' + '_' + o() + '.' + o()),
								arguments.length > 0)
							)
								throw new TypeError(
									'WeakMap iterable is not supported'
								)
						}
						function n(e, n) {
							if (!i(e) || !t.call(e, '_id'))
								throw new TypeError(
									n +
										' method called on incompatible receiver ' +
										typeof e
								)
						}
						function o() {
							return Math.random().toString().substring(2)
						}
						return (
							r(e.prototype, 'delete', function (e) {
								if ((n(this, 'delete'), !i(e))) return !1
								var t = e[this._id]
								return !(!t || t[0] !== e) && (delete e[this._id], !0)
							}),
							r(e.prototype, 'get', function (e) {
								if ((n(this, 'get'), i(e))) {
									var t = e[this._id]
									return t && t[0] === e ? t[1] : void 0
								}
							}),
							r(e.prototype, 'has', function (e) {
								if ((n(this, 'has'), !i(e))) return !1
								var t = e[this._id]
								return !(!t || t[0] !== e)
							}),
							r(e.prototype, 'set', function (e, t) {
								if ((n(this, 'set'), !i(e)))
									throw new TypeError(
										'Invalid value used as weak map key'
									)
								var o = e[this._id]
								return o && o[0] === e
									? ((o[1] = t), this)
									: (r(e, this._id, [e, t]), this)
							}),
							r(e, '_polyfill', !0),
							e
						)
					})()
				}
				function i(e) {
					return Object(e) === e
				}
			})(
				'undefined' != typeof globalThis
					? globalThis
					: 'undefined' != typeof self
					? self
					: 'undefined' != typeof window
					? window
					: pt
			)
			var ft,
				ht,
				vt =
					((ft = function (e) {
						var t, n, r
						;(r = function () {
							var e,
								t,
								n,
								r = Object.prototype.toString,
								i =
									'undefined' != typeof setImmediate
										? function (e) {
												return setImmediate(e)
										  }
										: setTimeout
							try {
								Object.defineProperty({}, 'x', {}),
									(e = function (e, t, n, r) {
										return Object.defineProperty(e, t, {
											value: n,
											writable: !0,
											configurable: !1 !== r
										})
									})
							} catch (t) {
								e = function (e, t, n) {
									return (e[t] = n), e
								}
							}
							function o(e, r) {
								n.add(e, r), t || (t = i(n.drain))
							}
							function s(e) {
								var t,
									n = typeof e
								return (
									null == e ||
										('object' != n && 'function' != n) ||
										(t = e.then),
									'function' == typeof t && t
								)
							}
							function a() {
								for (var e = 0; e < this.chain.length; e++)
									l(
										this,
										1 === this.state
											? this.chain[e].success
											: this.chain[e].failure,
										this.chain[e]
									)
								this.chain.length = 0
							}
							function l(e, t, n) {
								var r, i
								try {
									!1 === t
										? n.reject(e.msg)
										: (r =
												!0 === t ? e.msg : t.call(void 0, e.msg)) ===
										  n.promise
										? n.reject(TypeError('Promise-chain cycle'))
										: (i = s(r))
										? i.call(r, n.resolve, n.reject)
										: n.resolve(r)
								} catch (e) {
									n.reject(e)
								}
							}
							function u(e) {
								var t,
									n = this
								if (!n.triggered) {
									;(n.triggered = !0), n.def && (n = n.def)
									try {
										;(t = s(e))
											? o(function () {
													var r = new p(n)
													try {
														t.call(
															e,
															function () {
																u.apply(r, arguments)
															},
															function () {
																c.apply(r, arguments)
															}
														)
													} catch (e) {
														c.call(r, e)
													}
											  })
											: ((n.msg = e),
											  (n.state = 1),
											  n.chain.length > 0 && o(a, n))
									} catch (e) {
										c.call(new p(n), e)
									}
								}
							}
							function c(e) {
								var t = this
								t.triggered ||
									((t.triggered = !0),
									t.def && (t = t.def),
									(t.msg = e),
									(t.state = 2),
									t.chain.length > 0 && o(a, t))
							}
							function d(e, t, n, r) {
								for (var i = 0; i < t.length; i++)
									!(function (i) {
										e.resolve(t[i]).then(function (e) {
											n(i, e)
										}, r)
									})(i)
							}
							function p(e) {
								;(this.def = e), (this.triggered = !1)
							}
							function f(e) {
								;(this.promise = e),
									(this.state = 0),
									(this.triggered = !1),
									(this.chain = []),
									(this.msg = void 0)
							}
							function h(e) {
								if ('function' != typeof e)
									throw TypeError('Not a function')
								if (0 !== this.__NPO__)
									throw TypeError('Not a promise')
								this.__NPO__ = 1
								var t = new f(this)
								;(this.then = function (e, n) {
									var r = {
										success: 'function' != typeof e || e,
										failure: 'function' == typeof n && n
									}
									return (
										(r.promise = new this.constructor(function (
											e,
											t
										) {
											if (
												'function' != typeof e ||
												'function' != typeof t
											)
												throw TypeError('Not a function')
											;(r.resolve = e), (r.reject = t)
										})),
										t.chain.push(r),
										0 !== t.state && o(a, t),
										r.promise
									)
								}),
									(this.catch = function (e) {
										return this.then(void 0, e)
									})
								try {
									e.call(
										void 0,
										function (e) {
											u.call(t, e)
										},
										function (e) {
											c.call(t, e)
										}
									)
								} catch (e) {
									c.call(t, e)
								}
							}
							n = (function () {
								var e, n, r
								function i(e, t) {
									;(this.fn = e),
										(this.self = t),
										(this.next = void 0)
								}
								return {
									add: function (t, o) {
										;(r = new i(t, o)),
											n ? (n.next = r) : (e = r),
											(n = r),
											(r = void 0)
									},
									drain: function () {
										var r = e
										for (e = n = t = void 0; r; )
											r.fn.call(r.self), (r = r.next)
									}
								}
							})()
							var v = e({}, 'constructor', h, !1)
							return (
								(h.prototype = v),
								e(v, '__NPO__', 0, !1),
								e(h, 'resolve', function (e) {
									return e && 'object' == typeof e && 1 === e.__NPO__
										? e
										: new this(function (t, n) {
												if (
													'function' != typeof t ||
													'function' != typeof n
												)
													throw TypeError('Not a function')
												t(e)
										  })
								}),
								e(h, 'reject', function (e) {
									return new this(function (t, n) {
										if (
											'function' != typeof t ||
											'function' != typeof n
										)
											throw TypeError('Not a function')
										n(e)
									})
								}),
								e(h, 'all', function (e) {
									var t = this
									return '[object Array]' != r.call(e)
										? t.reject(TypeError('Not an array'))
										: 0 === e.length
										? t.resolve([])
										: new t(function (n, r) {
												if (
													'function' != typeof n ||
													'function' != typeof r
												)
													throw TypeError('Not a function')
												var i = e.length,
													o = Array(i),
													s = 0
												d(
													t,
													e,
													function (e, t) {
														;(o[e] = t), ++s === i && n(o)
													},
													r
												)
										  })
								}),
								e(h, 'race', function (e) {
									var t = this
									return '[object Array]' != r.call(e)
										? t.reject(TypeError('Not an array'))
										: new t(function (n, r) {
												if (
													'function' != typeof n ||
													'function' != typeof r
												)
													throw TypeError('Not a function')
												d(
													t,
													e,
													function (e, t) {
														n(t)
													},
													r
												)
										  })
								}),
								h
							)
						}),
							((n = pt)[(t = 'Promise')] = n[t] || r()),
							e.exports && (e.exports = n[t])
					}),
					ft((ht = { exports: {} }), ht.exports),
					ht.exports),
				mt = new WeakMap()
			function gt(e, t, n) {
				var r = mt.get(e.element) || {}
				t in r || (r[t] = []), r[t].push(n), mt.set(e.element, r)
			}
			function yt(e, t) {
				return (mt.get(e.element) || {})[t] || []
			}
			function _t(e, t, n) {
				var r = mt.get(e.element) || {}
				if (!r[t]) return !0
				if (!n) return (r[t] = []), mt.set(e.element, r), !0
				var i = r[t].indexOf(n)
				return (
					-1 !== i && r[t].splice(i, 1),
					mt.set(e.element, r),
					r[t] && 0 === r[t].length
				)
			}
			function bt(e) {
				if ('string' == typeof e)
					try {
						e = JSON.parse(e)
					} catch (e) {
						return console.warn(e), {}
					}
				return e
			}
			function wt(e, t, n) {
				if (
					e.element.contentWindow &&
					e.element.contentWindow.postMessage
				) {
					var r = { method: t }
					void 0 !== n && (r.value = n)
					var i = parseFloat(
						navigator.userAgent
							.toLowerCase()
							.replace(/^.*msie (\d+).*$/, '$1')
					)
					i >= 8 && i < 10 && (r = JSON.stringify(r)),
						e.element.contentWindow.postMessage(r, e.origin)
				}
			}
			function xt(e, t) {
				var n,
					r = []
				if ((t = bt(t)).event) {
					if ('error' === t.event)
						yt(e, t.data.method).forEach(function (n) {
							var r = new Error(t.data.message)
							;(r.name = t.data.name),
								n.reject(r),
								_t(e, t.data.method, n)
						})
					;(r = yt(e, 'event:'.concat(t.event))), (n = t.data)
				} else if (t.method) {
					var i = (function (e, t) {
						var n = yt(e, t)
						if (n.length < 1) return !1
						var r = n.shift()
						return _t(e, t, r), r
					})(e, t.method)
					i && (r.push(i), (n = t.value))
				}
				r.forEach(function (t) {
					try {
						if ('function' == typeof t) return void t.call(e, n)
						t.resolve(n)
					} catch (e) {}
				})
			}
			var Tt = [
				'airplay',
				'audio_tracks',
				'autopause',
				'autoplay',
				'background',
				'byline',
				'cc',
				'chapter_id',
				'chapters',
				'chromecast',
				'color',
				'colors',
				'controls',
				'dnt',
				'end_time',
				'fullscreen',
				'height',
				'id',
				'interactive_params',
				'keyboard',
				'loop',
				'maxheight',
				'maxwidth',
				'muted',
				'play_button_position',
				'playsinline',
				'portrait',
				'progress_bar',
				'quality_selector',
				'responsive',
				'speed',
				'start_time',
				'texttrack',
				'title',
				'transcript',
				'transparent',
				'url',
				'vimeo_logo',
				'volume',
				'watch_full_video',
				'width'
			]
			function Ct(e) {
				var t =
					arguments.length > 1 && void 0 !== arguments[1]
						? arguments[1]
						: {}
				return Tt.reduce(function (t, n) {
					var r = e.getAttribute('data-vimeo-'.concat(n))
					return (r || '' === r) && (t[n] = '' === r ? 1 : r), t
				}, t)
			}
			function Et(e, t) {
				var n = e.html
				if (!t) throw new TypeError('An element must be provided')
				if (null !== t.getAttribute('data-vimeo-initialized'))
					return t.querySelector('iframe')
				var r = document.createElement('div')
				return (
					(r.innerHTML = n),
					t.appendChild(r.firstChild),
					t.setAttribute('data-vimeo-initialized', 'true'),
					t.querySelector('iframe')
				)
			}
			function kt(e) {
				var t =
						arguments.length > 1 && void 0 !== arguments[1]
							? arguments[1]
							: {},
					n = arguments.length > 2 ? arguments[2] : void 0
				return new Promise(function (r, i) {
					if (!st(e))
						throw new TypeError(
							'“'.concat(e, '” is not a vimeo.com url.')
						)
					var o = (function (e) {
							var t = (e || '').match(
									/^(?:https?:)?(?:\/\/)?([^/?]+)/
								),
								n = ((t && t[1]) || '').replace('player.', '')
							return n.endsWith('.videoji.hk') ? n : 'vimeo.com'
						})(e),
						s = 'https://'
							.concat(o, '/api/oembed.json?url=')
							.concat(encodeURIComponent(e))
					for (var a in t)
						t.hasOwnProperty(a) &&
							(s += '&'
								.concat(a, '=')
								.concat(encodeURIComponent(t[a])))
					var l =
						'XDomainRequest' in window
							? new XDomainRequest()
							: new XMLHttpRequest()
					l.open('GET', s, !0),
						(l.onload = function () {
							if (404 !== l.status)
								if (403 !== l.status)
									try {
										var t = JSON.parse(l.responseText)
										if (403 === t.domain_status_code)
											return (
												Et(t, n),
												void i(
													new Error(
														'“'.concat(e, '” is not embeddable.')
													)
												)
											)
										r(t)
									} catch (e) {
										i(e)
									}
								else
									i(new Error('“'.concat(e, '” is not embeddable.')))
							else i(new Error('“'.concat(e, '” was not found.')))
						}),
						(l.onerror = function () {
							var e = l.status ? ' ('.concat(l.status, ')') : ''
							i(
								new Error(
									'There was an error fetching the embed code from Vimeo'.concat(
										e,
										'.'
									)
								)
							)
						}),
						l.send()
				})
			}
			var St = {
					role: 'viewer',
					autoPlayMuted: !0,
					allowedDrift: 0.3,
					maxAllowedDrift: 1,
					minCheckInterval: 0.1,
					maxRateAdjustment: 0.2,
					maxTimeToCatchUp: 1
				},
				Mt = (function (e) {
					!(function (e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function'
							)
						;(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								writable: !0,
								configurable: !0
							}
						})),
							Object.defineProperty(e, 'prototype', { writable: !1 }),
							t && Qe(e, t)
					})(o, e)
					var t,
						n,
						r,
						i = nt(o)
					function o(e, t) {
						var n,
							r =
								arguments.length > 2 && void 0 !== arguments[2]
									? arguments[2]
									: {},
							s = arguments.length > 3 ? arguments[3] : void 0
						return (
							Ge(this, o),
							Ye(tt((n = i.call(this))), 'logger', void 0),
							Ye(tt(n), 'speedAdjustment', 0),
							Ye(
								tt(n),
								'adjustSpeed',
								(function () {
									var e = Ve(
										ze().mark(function e(t, r) {
											var i
											return ze().wrap(function (e) {
												for (;;)
													switch ((e.prev = e.next)) {
														case 0:
															if (n.speedAdjustment !== r) {
																e.next = 2
																break
															}
															return e.abrupt('return')
														case 2:
															return (e.next = 4), t.getPlaybackRate()
														case 4:
															return (
																(e.t0 = e.sent),
																(e.t1 = n.speedAdjustment),
																(e.t2 = e.t0 - e.t1),
																(e.t3 = r),
																(i = e.t2 + e.t3),
																n.log(
																	'New playbackRate:  '.concat(i)
																),
																(e.next = 12),
																t.setPlaybackRate(i)
															)
														case 12:
															n.speedAdjustment = r
														case 13:
														case 'end':
															return e.stop()
													}
											}, e)
										})
									)
									return function (t, n) {
										return e.apply(this, arguments)
									}
								})()
							),
							(n.logger = s),
							n.init(t, e, Re(Re({}, St), r)),
							n
						)
					}
					return (
						Xe(o, [
							{
								key: 'disconnect',
								value: function () {
									this.dispatchEvent(new Event('disconnect'))
								}
							},
							{
								key: 'init',
								value:
									((r = Ve(
										ze().mark(function e(t, n, r) {
											var i,
												o,
												s,
												a = this
											return ze().wrap(
												function (e) {
													for (;;)
														switch ((e.prev = e.next)) {
															case 0:
																return (
																	(e.next = 2),
																	this.waitForTOReadyState(t, 'open')
																)
															case 2:
																if ('viewer' !== r.role) {
																	e.next = 10
																	break
																}
																return (
																	(e.next = 5),
																	this.updatePlayer(t, n, r)
																)
															case 5:
																;(i = ut(t, 'change', function () {
																	return a.updatePlayer(t, n, r)
																})),
																	(o = this.maintainPlaybackPosition(
																		t,
																		n,
																		r
																	)),
																	this.addEventListener(
																		'disconnect',
																		function () {
																			o.cancel(), i.cancel()
																		}
																	),
																	(e.next = 14)
																break
															case 10:
																return (
																	(e.next = 12),
																	this.updateTimingObject(t, n)
																)
															case 12:
																;(s = ut(
																	n,
																	[
																		'seeked',
																		'play',
																		'pause',
																		'ratechange'
																	],
																	function () {
																		return a.updateTimingObject(t, n)
																	},
																	'on',
																	'off'
																)),
																	this.addEventListener(
																		'disconnect',
																		function () {
																			return s.cancel()
																		}
																	)
															case 14:
															case 'end':
																return e.stop()
														}
												},
												e,
												this
											)
										})
									)),
									function (e, t, n) {
										return r.apply(this, arguments)
									})
							},
							{
								key: 'updateTimingObject',
								value:
									((n = Ve(
										ze().mark(function e(t, n) {
											return ze().wrap(function (e) {
												for (;;)
													switch ((e.prev = e.next)) {
														case 0:
															return (
																(e.t0 = t),
																(e.next = 3),
																n.getCurrentTime()
															)
														case 3:
															return (
																(e.t1 = e.sent),
																(e.next = 6),
																n.getPaused()
															)
														case 6:
															if (!e.sent) {
																e.next = 10
																break
															}
															;(e.t2 = 0), (e.next = 13)
															break
														case 10:
															return (
																(e.next = 12), n.getPlaybackRate()
															)
														case 12:
															e.t2 = e.sent
														case 13:
															;(e.t3 = e.t2),
																(e.t4 = {
																	position: e.t1,
																	velocity: e.t3
																}),
																e.t0.update.call(e.t0, e.t4)
														case 16:
														case 'end':
															return e.stop()
													}
											}, e)
										})
									)),
									function (e, t) {
										return n.apply(this, arguments)
									})
							},
							{
								key: 'updatePlayer',
								value:
									((t = Ve(
										ze().mark(function e(t, n, r) {
											var i, o, s
											return ze().wrap(
												function (e) {
													for (;;)
														switch ((e.prev = e.next)) {
															case 0:
																if (
																	((i = t.query()),
																	(o = i.position),
																	(s = i.velocity),
																	'number' == typeof o &&
																		n.setCurrentTime(o),
																	'number' != typeof s)
																) {
																	e.next = 25
																	break
																}
																if (0 !== s) {
																	e.next = 11
																	break
																}
																return (e.next = 6), n.getPaused()
															case 6:
																if (((e.t0 = e.sent), !1 !== e.t0)) {
																	e.next = 9
																	break
																}
																n.pause()
															case 9:
																e.next = 25
																break
															case 11:
																if (!(s > 0)) {
																	e.next = 25
																	break
																}
																return (e.next = 14), n.getPaused()
															case 14:
																if (((e.t1 = e.sent), !0 !== e.t1)) {
																	e.next = 19
																	break
																}
																return (
																	(e.next = 18),
																	n.play().catch(
																		(function () {
																			var e = Ve(
																				ze().mark(function e(t) {
																					return ze().wrap(function (
																						e
																					) {
																						for (;;)
																							switch (
																								(e.prev = e.next)
																							) {
																								case 0:
																									if (
																										'NotAllowedError' !==
																											t.name ||
																										!r.autoPlayMuted
																									) {
																										e.next = 5
																										break
																									}
																									return (
																										(e.next = 3),
																										n.setMuted(!0)
																									)
																								case 3:
																									return (
																										(e.next = 5),
																										n
																											.play()
																											.catch(
																												function (e) {
																													return console.error(
																														"Couldn't play the video from TimingSrcConnector. Error:",
																														e
																													)
																												}
																											)
																									)
																								case 5:
																								case 'end':
																									return e.stop()
																							}
																					},
																					e)
																				})
																			)
																			return function (t) {
																				return e.apply(
																					this,
																					arguments
																				)
																			}
																		})()
																	)
																)
															case 18:
																this.updatePlayer(t, n, r)
															case 19:
																return (
																	(e.next = 21), n.getPlaybackRate()
																)
															case 21:
																if (
																	((e.t2 = e.sent),
																	(e.t3 = s),
																	e.t2 === e.t3)
																) {
																	e.next = 25
																	break
																}
																n.setPlaybackRate(s)
															case 25:
															case 'end':
																return e.stop()
														}
												},
												e,
												this
											)
										})
									)),
									function (e, n, r) {
										return t.apply(this, arguments)
									})
							},
							{
								key: 'maintainPlaybackPosition',
								value: function (e, t, n) {
									var r = this,
										i = n.allowedDrift,
										o = n.maxAllowedDrift,
										s = n.minCheckInterval,
										a = n.maxRateAdjustment,
										l = n.maxTimeToCatchUp,
										u = 1e3 * Math.min(l, Math.max(s, o)),
										c = (function () {
											var n = Ve(
												ze().mark(function n() {
													var s, u, c, d, p
													return ze().wrap(function (n) {
														for (;;)
															switch ((n.prev = n.next)) {
																case 0:
																	if (
																		((n.t0 =
																			0 === e.query().velocity),
																		n.t0)
																	) {
																		n.next = 6
																		break
																	}
																	return (n.next = 4), t.getPaused()
																case 4:
																	;(n.t1 = n.sent),
																		(n.t0 = !0 === n.t1)
																case 6:
																	if (!n.t0) {
																		n.next = 8
																		break
																	}
																	return n.abrupt('return')
																case 8:
																	return (
																		(n.t2 = e.query().position),
																		(n.next = 11),
																		t.getCurrentTime()
																	)
																case 11:
																	if (
																		((n.t3 = n.sent),
																		(s = n.t2 - n.t3),
																		(u = Math.abs(s)),
																		r.log('Drift: '.concat(s)),
																		!(u > o))
																	) {
																		n.next = 22
																		break
																	}
																	return (
																		(n.next = 18), r.adjustSpeed(t, 0)
																	)
																case 18:
																	t.setCurrentTime(
																		e.query().position
																	),
																		r.log('Resync by currentTime'),
																		(n.next = 29)
																	break
																case 22:
																	if (!(u > i)) {
																		n.next = 29
																		break
																	}
																	return (
																		(p =
																			(c = u / l) < (d = a)
																				? (d - c) / 2
																				: d),
																		(n.next = 28),
																		r.adjustSpeed(t, p * Math.sign(s))
																	)
																case 28:
																	r.log('Resync by playbackRate')
																case 29:
																case 'end':
																	return n.stop()
															}
													}, n)
												})
											)
											return function () {
												return n.apply(this, arguments)
											}
										})(),
										d = setInterval(function () {
											return c()
										}, u)
									return {
										cancel: function () {
											return clearInterval(d)
										}
									}
								}
							},
							{
								key: 'log',
								value: function (e) {
									var t
									null === (t = this.logger) ||
										void 0 === t ||
										t.call(this, 'TimingSrcConnector: '.concat(e))
								}
							},
							{
								key: 'waitForTOReadyState',
								value: function (e, t) {
									return new Promise(function (n) {
										!(function r() {
											e.readyState === t
												? n()
												: e.addEventListener('readystatechange', r, {
														once: !0
												  })
										})()
									})
								}
							}
						]),
						o
					)
				})(et(EventTarget)),
				Pt = new WeakMap(),
				Lt = new WeakMap(),
				At = {},
				Ot = (function () {
					function e(t) {
						var n = this,
							r =
								arguments.length > 1 && void 0 !== arguments[1]
									? arguments[1]
									: {}
						if (
							(Ge(this, e),
							window.jQuery &&
								t instanceof jQuery &&
								(t.length > 1 &&
									window.console &&
									console.warn &&
									console.warn(
										'A jQuery object with multiple elements was passed, using the first element.'
									),
								(t = t[0])),
							'undefined' != typeof document &&
								'string' == typeof t &&
								(t = document.getElementById(t)),
							!(function (e) {
								return Boolean(
									e &&
										1 === e.nodeType &&
										'nodeName' in e &&
										e.ownerDocument &&
										e.ownerDocument.defaultView
								)
							})(t))
						)
							throw new TypeError(
								'You must pass either a valid element or a valid id.'
							)
						if ('IFRAME' !== t.nodeName) {
							var i = t.querySelector('iframe')
							i && (t = i)
						}
						if (
							'IFRAME' === t.nodeName &&
							!st(t.getAttribute('src') || '')
						)
							throw new Error(
								'The player element passed isn’t a Vimeo embed.'
							)
						if (Pt.has(t)) return Pt.get(t)
						;(this._window = t.ownerDocument.defaultView),
							(this.element = t),
							(this.origin = '*')
						var o = new vt(function (e, i) {
							if (
								((n._onMessage = function (t) {
									if (
										st(t.origin) &&
										n.element.contentWindow === t.source
									) {
										'*' === n.origin && (n.origin = t.origin)
										var r = bt(t.data)
										if (
											r &&
											'error' === r.event &&
											r.data &&
											'ready' === r.data.method
										) {
											var o = new Error(r.data.message)
											return (o.name = r.data.name), void i(o)
										}
										var s = r && 'ready' === r.event,
											a = r && 'ping' === r.method
										if (s || a)
											return (
												n.element.setAttribute('data-ready', 'true'),
												void e()
											)
										xt(n, r)
									}
								}),
								n._window.addEventListener('message', n._onMessage),
								'IFRAME' !== n.element.nodeName)
							) {
								var o = Ct(t, r)
								kt(lt(o), o, t)
									.then(function (e) {
										var r,
											i,
											o,
											s = Et(e, t)
										return (
											(n.element = s),
											(n._originalElement = t),
											(r = t),
											(i = s),
											(o = mt.get(r)),
											mt.set(i, o),
											mt.delete(r),
											Pt.set(n.element, n),
											e
										)
									})
									.catch(i)
							}
						})
						if (
							(Lt.set(this, o),
							Pt.set(this.element, this),
							'IFRAME' === this.element.nodeName && wt(this, 'ping'),
							At.isEnabled)
						) {
							var s = function () {
								return At.exit()
							}
							;(this.fullscreenchangeHandler = function () {
								At.isFullscreen
									? gt(n, 'event:exitFullscreen', s)
									: _t(n, 'event:exitFullscreen', s),
									n.ready().then(function () {
										wt(n, 'fullscreenchange', At.isFullscreen)
									})
							}),
								At.on(
									'fullscreenchange',
									this.fullscreenchangeHandler
								)
						}
						return this
					}
					var t
					return (
						Xe(e, [
							{
								key: 'callMethod',
								value: function (e) {
									var t = this,
										n =
											arguments.length > 1 && void 0 !== arguments[1]
												? arguments[1]
												: {}
									return new vt(function (r, i) {
										return t
											.ready()
											.then(function () {
												gt(t, e, { resolve: r, reject: i }),
													wt(t, e, n)
											})
											.catch(i)
									})
								}
							},
							{
								key: 'get',
								value: function (e) {
									var t = this
									return new vt(function (n, r) {
										return (
											(e = ot(e, 'get')),
											t
												.ready()
												.then(function () {
													gt(t, e, { resolve: n, reject: r }),
														wt(t, e)
												})
												.catch(r)
										)
									})
								}
							},
							{
								key: 'set',
								value: function (e, t) {
									var n = this
									return new vt(function (r, i) {
										if (((e = ot(e, 'set')), null == t))
											throw new TypeError(
												'There must be a value to set.'
											)
										return n
											.ready()
											.then(function () {
												gt(n, e, { resolve: r, reject: i }),
													wt(n, e, t)
											})
											.catch(i)
									})
								}
							},
							{
								key: 'on',
								value: function (e, t) {
									if (!e)
										throw new TypeError(
											'You must pass an event name.'
										)
									if (!t)
										throw new TypeError(
											'You must pass a callback function.'
										)
									if ('function' != typeof t)
										throw new TypeError(
											'The callback must be a function.'
										)
									0 === yt(this, 'event:'.concat(e)).length &&
										this.callMethod('addEventListener', e).catch(
											function () {}
										),
										gt(this, 'event:'.concat(e), t)
								}
							},
							{
								key: 'off',
								value: function (e, t) {
									if (!e)
										throw new TypeError(
											'You must pass an event name.'
										)
									if (t && 'function' != typeof t)
										throw new TypeError(
											'The callback must be a function.'
										)
									_t(this, 'event:'.concat(e), t) &&
										this.callMethod('removeEventListener', e).catch(
											function (e) {}
										)
								}
							},
							{
								key: 'loadVideo',
								value: function (e) {
									return this.callMethod('loadVideo', e)
								}
							},
							{
								key: 'ready',
								value: function () {
									var e =
										Lt.get(this) ||
										new vt(function (e, t) {
											t(
												new Error(
													'Unknown player. Probably unloaded.'
												)
											)
										})
									return vt.resolve(e)
								}
							},
							{
								key: 'addCuePoint',
								value: function (e) {
									var t =
										arguments.length > 1 && void 0 !== arguments[1]
											? arguments[1]
											: {}
									return this.callMethod('addCuePoint', {
										time: e,
										data: t
									})
								}
							},
							{
								key: 'removeCuePoint',
								value: function (e) {
									return this.callMethod('removeCuePoint', e)
								}
							},
							{
								key: 'enableTextTrack',
								value: function (e, t) {
									if (!e)
										throw new TypeError('You must pass a language.')
									return this.callMethod('enableTextTrack', {
										language: e,
										kind: t
									})
								}
							},
							{
								key: 'disableTextTrack',
								value: function () {
									return this.callMethod('disableTextTrack')
								}
							},
							{
								key: 'pause',
								value: function () {
									return this.callMethod('pause')
								}
							},
							{
								key: 'play',
								value: function () {
									return this.callMethod('play')
								}
							},
							{
								key: 'requestFullscreen',
								value: function () {
									return At.isEnabled
										? At.request(this.element)
										: this.callMethod('requestFullscreen')
								}
							},
							{
								key: 'exitFullscreen',
								value: function () {
									return At.isEnabled
										? At.exit()
										: this.callMethod('exitFullscreen')
								}
							},
							{
								key: 'getFullscreen',
								value: function () {
									return At.isEnabled
										? vt.resolve(At.isFullscreen)
										: this.get('fullscreen')
								}
							},
							{
								key: 'requestPictureInPicture',
								value: function () {
									return this.callMethod('requestPictureInPicture')
								}
							},
							{
								key: 'exitPictureInPicture',
								value: function () {
									return this.callMethod('exitPictureInPicture')
								}
							},
							{
								key: 'getPictureInPicture',
								value: function () {
									return this.get('pictureInPicture')
								}
							},
							{
								key: 'remotePlaybackPrompt',
								value: function () {
									return this.callMethod('remotePlaybackPrompt')
								}
							},
							{
								key: 'unload',
								value: function () {
									return this.callMethod('unload')
								}
							},
							{
								key: 'destroy',
								value: function () {
									var e = this
									return new vt(function (t) {
										if (
											(Lt.delete(e),
											Pt.delete(e.element),
											e._originalElement &&
												(Pt.delete(e._originalElement),
												e._originalElement.removeAttribute(
													'data-vimeo-initialized'
												)),
											e.element &&
												'IFRAME' === e.element.nodeName &&
												e.element.parentNode &&
												(e.element.parentNode.parentNode &&
												e._originalElement &&
												e._originalElement !== e.element.parentNode
													? e.element.parentNode.parentNode.removeChild(
															e.element.parentNode
													  )
													: e.element.parentNode.removeChild(
															e.element
													  )),
											e.element &&
												'DIV' === e.element.nodeName &&
												e.element.parentNode)
										) {
											e.element.removeAttribute(
												'data-vimeo-initialized'
											)
											var n = e.element.querySelector('iframe')
											n &&
												n.parentNode &&
												(n.parentNode.parentNode &&
												e._originalElement &&
												e._originalElement !== n.parentNode
													? n.parentNode.parentNode.removeChild(
															n.parentNode
													  )
													: n.parentNode.removeChild(n))
										}
										e._window.removeEventListener(
											'message',
											e._onMessage
										),
											At.isEnabled &&
												At.off(
													'fullscreenchange',
													e.fullscreenchangeHandler
												),
											t()
									})
								}
							},
							{
								key: 'getAutopause',
								value: function () {
									return this.get('autopause')
								}
							},
							{
								key: 'setAutopause',
								value: function (e) {
									return this.set('autopause', e)
								}
							},
							{
								key: 'getBuffered',
								value: function () {
									return this.get('buffered')
								}
							},
							{
								key: 'getCameraProps',
								value: function () {
									return this.get('cameraProps')
								}
							},
							{
								key: 'setCameraProps',
								value: function (e) {
									return this.set('cameraProps', e)
								}
							},
							{
								key: 'getChapters',
								value: function () {
									return this.get('chapters')
								}
							},
							{
								key: 'getCurrentChapter',
								value: function () {
									return this.get('currentChapter')
								}
							},
							{
								key: 'getColor',
								value: function () {
									return this.get('color')
								}
							},
							{
								key: 'getColors',
								value: function () {
									return vt.all([
										this.get('colorOne'),
										this.get('colorTwo'),
										this.get('colorThree'),
										this.get('colorFour')
									])
								}
							},
							{
								key: 'setColor',
								value: function (e) {
									return this.set('color', e)
								}
							},
							{
								key: 'setColors',
								value: function (e) {
									if (!Array.isArray(e))
										return new vt(function (e, t) {
											return t(
												new TypeError('Argument must be an array.')
											)
										})
									var t = new vt(function (e) {
											return e(null)
										}),
										n = [
											e[0] ? this.set('colorOne', e[0]) : t,
											e[1] ? this.set('colorTwo', e[1]) : t,
											e[2] ? this.set('colorThree', e[2]) : t,
											e[3] ? this.set('colorFour', e[3]) : t
										]
									return vt.all(n)
								}
							},
							{
								key: 'getCuePoints',
								value: function () {
									return this.get('cuePoints')
								}
							},
							{
								key: 'getCurrentTime',
								value: function () {
									return this.get('currentTime')
								}
							},
							{
								key: 'setCurrentTime',
								value: function (e) {
									return this.set('currentTime', e)
								}
							},
							{
								key: 'getDuration',
								value: function () {
									return this.get('duration')
								}
							},
							{
								key: 'getEnded',
								value: function () {
									return this.get('ended')
								}
							},
							{
								key: 'getLoop',
								value: function () {
									return this.get('loop')
								}
							},
							{
								key: 'setLoop',
								value: function (e) {
									return this.set('loop', e)
								}
							},
							{
								key: 'setMuted',
								value: function (e) {
									return this.set('muted', e)
								}
							},
							{
								key: 'getMuted',
								value: function () {
									return this.get('muted')
								}
							},
							{
								key: 'getPaused',
								value: function () {
									return this.get('paused')
								}
							},
							{
								key: 'getPlaybackRate',
								value: function () {
									return this.get('playbackRate')
								}
							},
							{
								key: 'setPlaybackRate',
								value: function (e) {
									return this.set('playbackRate', e)
								}
							},
							{
								key: 'getPlayed',
								value: function () {
									return this.get('played')
								}
							},
							{
								key: 'getQualities',
								value: function () {
									return this.get('qualities')
								}
							},
							{
								key: 'getQuality',
								value: function () {
									return this.get('quality')
								}
							},
							{
								key: 'setQuality',
								value: function (e) {
									return this.set('quality', e)
								}
							},
							{
								key: 'getRemotePlaybackAvailability',
								value: function () {
									return this.get('remotePlaybackAvailability')
								}
							},
							{
								key: 'getRemotePlaybackState',
								value: function () {
									return this.get('remotePlaybackState')
								}
							},
							{
								key: 'getSeekable',
								value: function () {
									return this.get('seekable')
								}
							},
							{
								key: 'getSeeking',
								value: function () {
									return this.get('seeking')
								}
							},
							{
								key: 'getTextTracks',
								value: function () {
									return this.get('textTracks')
								}
							},
							{
								key: 'getVideoEmbedCode',
								value: function () {
									return this.get('videoEmbedCode')
								}
							},
							{
								key: 'getVideoId',
								value: function () {
									return this.get('videoId')
								}
							},
							{
								key: 'getVideoTitle',
								value: function () {
									return this.get('videoTitle')
								}
							},
							{
								key: 'getVideoWidth',
								value: function () {
									return this.get('videoWidth')
								}
							},
							{
								key: 'getVideoHeight',
								value: function () {
									return this.get('videoHeight')
								}
							},
							{
								key: 'getVideoUrl',
								value: function () {
									return this.get('videoUrl')
								}
							},
							{
								key: 'getVolume',
								value: function () {
									return this.get('volume')
								}
							},
							{
								key: 'setVolume',
								value: function (e) {
									return this.set('volume', e)
								}
							},
							{
								key: 'setTimingSrc',
								value:
									((t = Ve(
										ze().mark(function e(t, n) {
											var r,
												i = this
											return ze().wrap(
												function (e) {
													for (;;)
														switch ((e.prev = e.next)) {
															case 0:
																if (t) {
																	e.next = 2
																	break
																}
																throw new TypeError(
																	'A Timing Object must be provided.'
																)
															case 2:
																return (e.next = 4), this.ready()
															case 4:
																return (
																	(r = new Mt(this, t, n)),
																	wt(
																		this,
																		'notifyTimingObjectConnect'
																	),
																	r.addEventListener(
																		'disconnect',
																		function () {
																			return wt(
																				i,
																				'notifyTimingObjectDisconnect'
																			)
																		}
																	),
																	e.abrupt('return', r)
																)
															case 8:
															case 'end':
																return e.stop()
														}
												},
												e,
												this
											)
										})
									)),
									function (e, n) {
										return t.apply(this, arguments)
									})
							}
						]),
						e
					)
				})()
			it ||
				((At = (function () {
					var e = (function () {
							for (
								var e,
									t = [
										[
											'requestFullscreen',
											'exitFullscreen',
											'fullscreenElement',
											'fullscreenEnabled',
											'fullscreenchange',
											'fullscreenerror'
										],
										[
											'webkitRequestFullscreen',
											'webkitExitFullscreen',
											'webkitFullscreenElement',
											'webkitFullscreenEnabled',
											'webkitfullscreenchange',
											'webkitfullscreenerror'
										],
										[
											'webkitRequestFullScreen',
											'webkitCancelFullScreen',
											'webkitCurrentFullScreenElement',
											'webkitCancelFullScreen',
											'webkitfullscreenchange',
											'webkitfullscreenerror'
										],
										[
											'mozRequestFullScreen',
											'mozCancelFullScreen',
											'mozFullScreenElement',
											'mozFullScreenEnabled',
											'mozfullscreenchange',
											'mozfullscreenerror'
										],
										[
											'msRequestFullscreen',
											'msExitFullscreen',
											'msFullscreenElement',
											'msFullscreenEnabled',
											'MSFullscreenChange',
											'MSFullscreenError'
										]
									],
									n = 0,
									r = t.length,
									i = {};
								n < r;
								n++
							)
								if ((e = t[n]) && e[1] in document) {
									for (n = 0; n < e.length; n++) i[t[0][n]] = e[n]
									return i
								}
							return !1
						})(),
						t = {
							fullscreenchange: e.fullscreenchange,
							fullscreenerror: e.fullscreenerror
						},
						n = {
							request: function (t) {
								return new Promise(function (r, i) {
									var o = function e() {
										n.off('fullscreenchange', e), r()
									}
									n.on('fullscreenchange', o)
									var s = (t = t || document.documentElement)[
										e.requestFullscreen
									]()
									s instanceof Promise && s.then(o).catch(i)
								})
							},
							exit: function () {
								return new Promise(function (t, r) {
									if (n.isFullscreen) {
										var i = function e() {
											n.off('fullscreenchange', e), t()
										}
										n.on('fullscreenchange', i)
										var o = document[e.exitFullscreen]()
										o instanceof Promise && o.then(i).catch(r)
									} else t()
								})
							},
							on: function (e, n) {
								var r = t[e]
								r && document.addEventListener(r, n)
							},
							off: function (e, n) {
								var r = t[e]
								r && document.removeEventListener(r, n)
							}
						}
					return (
						Object.defineProperties(n, {
							isFullscreen: {
								get: function () {
									return Boolean(document[e.fullscreenElement])
								}
							},
							element: {
								enumerable: !0,
								get: function () {
									return document[e.fullscreenElement]
								}
							},
							isEnabled: {
								enumerable: !0,
								get: function () {
									return Boolean(document[e.fullscreenEnabled])
								}
							}
						}),
						n
					)
				})()),
				(function () {
					var e =
							arguments.length > 0 && void 0 !== arguments[0]
								? arguments[0]
								: document,
						t = [].slice.call(
							e.querySelectorAll('[data-vimeo-id], [data-vimeo-url]')
						),
						n = function (e) {
							'console' in window &&
								console.error &&
								console.error(
									'There was an error creating an embed: '.concat(e)
								)
						}
					t.forEach(function (e) {
						try {
							if (null !== e.getAttribute('data-vimeo-defer')) return
							var t = Ct(e)
							kt(lt(t), t, e)
								.then(function (t) {
									return Et(t, e)
								})
								.catch(n)
						} catch (e) {
							n(e)
						}
					})
				})(),
				(function () {
					var e =
						arguments.length > 0 && void 0 !== arguments[0]
							? arguments[0]
							: document
					window.VimeoPlayerResizeEmbeds_ ||
						((window.VimeoPlayerResizeEmbeds_ = !0),
						window.addEventListener('message', function (t) {
							if (
								st(t.origin) &&
								t.data &&
								'spacechange' === t.data.event
							)
								for (
									var n = e.querySelectorAll('iframe'), r = 0;
									r < n.length;
									r++
								)
									if (n[r].contentWindow === t.source) {
										n[r].parentElement.style.paddingBottom =
											''.concat(t.data.data[0].bottom, 'px')
										break
									}
						}))
				})(),
				(function () {
					var e =
						arguments.length > 0 && void 0 !== arguments[0]
							? arguments[0]
							: document
					window.VimeoSeoMetadataAppended ||
						((window.VimeoSeoMetadataAppended = !0),
						window.addEventListener('message', function (t) {
							if (st(t.origin)) {
								var n = bt(t.data)
								if (n && 'ready' === n.event)
									for (
										var r = e.querySelectorAll('iframe'), i = 0;
										i < r.length;
										i++
									) {
										var o = r[i],
											s = o.contentWindow === t.source
										at(o.src) &&
											s &&
											new Ot(o).callMethod(
												'appendVideoMetadata',
												window.location.href
											)
									}
							}
						}))
				})(),
				(function () {
					var e =
						arguments.length > 0 && void 0 !== arguments[0]
							? arguments[0]
							: document
					if (!window.VimeoCheckedUrlTimeParam) {
						window.VimeoCheckedUrlTimeParam = !0
						var t = function (e) {
							'console' in window &&
								console.error &&
								console.error(
									'There was an error getting video Id: '.concat(e)
								)
						}
						window.addEventListener('message', function (n) {
							if (st(n.origin)) {
								var r = bt(n.data)
								if (r && 'ready' === r.event)
									for (
										var i = e.querySelectorAll('iframe'),
											o = function () {
												var e = i[s],
													r = e.contentWindow === n.source
												if (at(e.src) && r) {
													var o = new Ot(e)
													o.getVideoId()
														.then(function (e) {
															var t = new RegExp(
																'[?&]vimeo_t_'.concat(e, '=([^&#]*)')
															).exec(window.location.href)
															if (t && t[1]) {
																var n = decodeURI(t[1])
																o.setCurrentTime(n)
															}
														})
														.catch(t)
												}
											},
											s = 0;
										s < i.length;
										s++
									)
										o()
							}
						})
					}
				})())
			n(7895)
			function jt(e, t, n, r) {
				var i,
					o = !1,
					s = 0
				function a() {
					i && clearTimeout(i)
				}
				function l() {
					for (
						var l = arguments.length, u = new Array(l), c = 0;
						c < l;
						c++
					)
						u[c] = arguments[c]
					var d = this,
						p = Date.now() - s
					function f() {
						;(s = Date.now()), n.apply(d, u)
					}
					o ||
						(r && !i && f(),
						a(),
						void 0 === r && p > e
							? f()
							: !0 !== t &&
							  (i = setTimeout(
									r
										? function () {
												i = void 0
										  }
										: f,
									void 0 === r ? e - p : e
							  )))
				}
				return (
					'boolean' != typeof t && ((r = n), (n = t), (t = void 0)),
					(l.cancel = function () {
						a(), (o = !0)
					}),
					l
				)
			}
			function $t(e) {
				var t = e.namespace ? 'focusin.' + e.namespace : 'focusin'
				e.$elementToFocus || (e.$elementToFocus = e.$container),
					e.$container.attr('tabindex', '-1'),
					e.$elementToFocus.focus(),
					f()(document).on(t, function (t) {
						e.$container[0] === t.target ||
							e.$container.has(t.target).length ||
							e.$container.focus()
					})
			}
			function Dt(e) {
				var t = e.namespace ? 'focusin.' + e.namespace : 'focusin'
				e.$container &&
					e.$container.length &&
					e.$container.removeAttr('tabindex'),
					f()(document).off(t)
			}
			function Nt(e, t, n) {
				return (
					(t = a(t)),
					s(
						e,
						It()
							? Reflect.construct(t, n || [], a(e).constructor)
							: t.apply(e, n)
					)
				)
			}
			function It() {
				try {
					var e = !Boolean.prototype.valueOf.call(
						Reflect.construct(Boolean, [], function () {})
					)
				} catch (e) {}
				return (It = function () {
					return !!e
				})()
			}
			var qt = f()(window),
				Ht = f()(document.body),
				Bt = '[data-mega-menu-trigger]',
				Ft = '[data-mega-menu-content]',
				Rt = '[data-mobile-menu-trigger]',
				zt = '[data-mobile-menu]',
				Wt = '[data-mobile-menu-parent]',
				Vt = '[data-mobile-menu-child]',
				Gt = '[data-mobile-menu-grandchild]',
				Ut = '[data-search-icon-trigger]',
				Xt = '[data-search-icon-target]',
				Yt = '.toggle-button',
				Kt = '[data-mega-menu-last-item]',
				Qt = '[data-mega-promo-item]',
				Jt = 'is-active',
				Zt = 'is-open',
				en = 'is-fixed',
				tn = 'site-fixed-header',
				nn = 'is-scrolling',
				rn = 'show-on-scroll',
				on = 'hide-on-scroll',
				sn = 'logo-small',
				an = 'is-fixed',
				ln = 'overflow-hidden',
				un = 'mega-menu-trigger',
				cn = 'mega-menu-content',
				dn = 'scroll',
				pn = (function (t) {
					function n() {
						var t
						e(this, n),
							((t = Nt(this, n)).$container = f()(t)),
							(t.$header = f()(t).find('.header-wrapper')),
							(t.$megaMenuTriggers = f()(Bt, t.$container)),
							(t.$megaMenuContents = f()(Ft, t.$container)),
							(t.$mobileMenuTrigger = f()(Rt, t.$container)),
							(t.$mobileMenuParent = f()(Wt, t.$container)),
							(t.$mobileMenuChild = f()(Vt, t.$container)),
							(t.$mobileGrandChild = f()(Gt, t.$container)),
							(t.$mobileMenu = f()(zt, t.$container)),
							(t.$searchBtn = t.$header.find(
								'.header__search button'
							)),
							(t.$mobileSearchContent =
								t.$header.find('.mobile-content')),
							(t.$mobileSearchInput =
								t.$mobileSearchContent.find('input')),
							(t.closeDropdownTimeout = null),
							(t.closeDropdownTimeoutDuration = 80),
							(t.touchDevice = Modernizr && Modernizr.touchevents),
							(t.initialPosition = 0),
							(t.menuIsOpening = !1),
							(t.$searchIconTrigger = f()(Ut, t.$container)),
							(t.$searchIconTarget = f()(Xt, t.$container)),
							(t.$megaMenuToggle = f()(Yt, t.$container)),
							(t.$megaMenuLastItem = f()(Kt, t.$container)),
							(t.$mobileMenuMegaPromo = f()(Qt, t.$container)),
							t.touchDevice
								? t.$megaMenuTriggers.on(
										'click',
										t.onToggleMegamenu.bind(t)
								  )
								: (t.$megaMenuTriggers.on(
										'mouseenter',
										t.onTriggerMouseEnter.bind(t)
								  ),
								  t.$megaMenuTriggers.on(
										'mouseleave',
										t.onTriggerMouseLeave.bind(t)
								  ),
								  t.$megaMenuContents.on(
										'mouseenter',
										t.onDropdownMouseEnter.bind(t)
								  ),
								  t.$megaMenuContents.on(
										'mouseleave',
										t.onDropdownMouseLeave.bind(t)
								  )),
							t.$mobileMenuTrigger.on(
								'click',
								t.onMobileMenuClick.bind(t)
							),
							t.$mobileMenuParent.on(
								'click',
								t.onMobileParentMenuClick.bind(t)
							),
							t.$mobileMenuChild.on(
								'click',
								t.onMobileChildMenuClick.bind(t)
							),
							t.$mobileGrandChild.on(
								'click',
								t.onMobileGranChildClick.bind(t)
							),
							t.$searchBtn.on(
								'click',
								t.onMobileSearchButtonClick.bind(t)
							)
						var r = t
						return (
							t.$mobileSearchInput.on('keypress', function (e) {
								if (13 == e.keyCode) {
									var t = r.$mobileSearchContent.data('search-action')
									'' != f()(this).val() &&
										(window.location.href = ''
											.concat(t, '?q=')
											.concat(f()(this).val()))
								}
							}),
							Ht.hasClass(tn) &&
								(qt.on(dn, jt(50, t.onScroll.bind(t))), t.onScroll()),
							t.$searchIconTarget.on(
								'keydown',
								t.focusSearchBtn.bind(t)
							),
							t.$searchIconTarget.on(
								'blur',
								t.focusSearchBtn.bind(t)
							),
							t.$searchIconTrigger.on(
								'click',
								t.onSearchIconClick.bind(t)
							),
							t.$megaMenuToggle.on(
								'keydown',
								t.onMegaMenuToggle.bind(t)
							),
							t.$megaMenuLastItem.on(
								'keydown',
								t.onMegaMenuLastItemKeydown.bind(t)
							),
							t.detectClickOutOfMenu(),
							f()('.mega-menu', t.$container).on(
								'keydown',
								t.onMegaMenukeydown.bind(t)
							),
							t
						)
					}
					return (
						u(n, t),
						o(n, [
							{
								key: 'onMobileSearchButtonClick',
								value: function () {
									window.innerWidth > 768 ||
										(this.$mobileMenuTrigger.hasClass(Jt) &&
											(this.$mobileMenuTrigger.removeClass(Jt),
											this.$mobileMenu.slideUp(),
											Ht.removeClass(ln)),
										this.$mobileSearchContent.hasClass(Jt)
											? (this.$mobileSearchContent.removeClass(Jt),
											  this.$mobileSearchInput.blur())
											: (this.$mobileSearchContent.addClass(Jt),
											  this.$mobileSearchInput.focus()))
								}
							},
							{
								key: 'scrollCheck',
								value: function () {
									var e = this,
										t = qt.scrollTop(),
										n = this.$container.offset().top
									requestAnimationFrame(function () {
										t <= n
											? (e.$header.removeClass(en),
											  e.$header.removeClass(nn),
											  e.$header.removeClass(rn),
											  e.$header.removeClass(on),
											  e.$header.removeClass(sn),
											  e.$mobileMenu.removeClass(an),
											  e.$megaMenuContents.removeClass(an))
											: t > n &&
											  (e.$header.addClass(en),
											  e.$header.addClass(nn),
											  e.$header.addClass(sn),
											  e.$mobileMenu.addClass(an),
											  e.$megaMenuContents.addClass(an))
									})
								}
							},
							{
								key: 'positionCheck',
								value: function () {
									var e = this,
										t = qt.scrollTop(),
										n = this.initialPosition
									this.$header.hasClass(nn) &&
										!Ht.hasClass(ln) &&
										requestAnimationFrame(function () {
											t > n
												? (e.$header.removeClass(rn),
												  e.$header.addClass(on),
												  (e.initialPosition = t))
												: t < n &&
												  (e.$header.addClass(rn),
												  e.$header.removeClass(on),
												  (e.initialPosition = t))
										})
								}
							},
							{
								key: 'onScroll',
								value: function () {
									this.scrollCheck(),
										Ht.hasClass('site-header-hide-on-scroll') &&
											this.positionCheck()
								}
							},
							{
								key: 'onMobileMenuClick',
								value: function (e) {
									e.preventDefault(),
										this.$mobileSearchContent.length > 0 &&
											this.$mobileSearchContent.removeClass(Jt),
										this.$mobileMenuTrigger.hasClass(Jt)
											? (this.$mobileMenuTrigger.removeClass(Jt),
											  this.$mobileMenu.slideUp(),
											  Ht.removeClass(ln),
											  Dt({
													$container: this.$mobileMenu,
													$elementToFocus: f()(
														'[data-mobile-menu-trigger][aria-expanded="true"]'
													)
											  }),
											  f()(
													'[data-mobile-menu-trigger][aria-expanded="false"]'
											  ).focus())
											: (this.$mobileMenuMegaPromo.hide(),
											  this.$mobileMenuTrigger.addClass(Jt),
											  this.$mobileMenu.slideDown(),
											  Ht.addClass(ln),
											  $t({
													$container: this.$mobileMenu,
													$elementToFocus: f()(
														'[data-mobile-menu-trigger][aria-expanded="true"]'
													)
											  }))
								}
							},
							{
								key: 'onMobileParentMenuClick',
								value: function (e) {
									f()(e.target)
										.closest('div')
										.hasClass('menu-promo--mega') ||
										(e.preventDefault(),
										e.stopPropagation(),
										(this.$parent = f()(e.currentTarget).find(
											'.mobile__menu__dropdown'
										)),
										(this.$parentItem = f()(e.currentTarget)),
										this.$parent.hasClass(Jt)
											? (this.$parent.removeClass(Jt),
											  this.$parentItem.removeClass(Jt),
											  this.$parent.slideUp(),
											  this.$parent
													.closest('li')
													.siblings()
													.removeClass('hide'),
											  this.$parentItem.hasClass(
													'mobile__menu--mega'
											  ) &&
													(this.$megaMenuLastItem.show(),
													this.$mobileMenuMegaPromo.hide()))
											: (this.$parent.addClass(Jt),
											  this.$parentItem.addClass(Jt),
											  this.$parent.slideDown(),
											  this.$parent
													.closest('li')
													.siblings()
													.addClass('hide'),
											  this.$parentItem.hasClass(
													'mobile__menu--mega'
											  ) &&
													(this.$megaMenuLastItem.hide(),
													this.$mobileMenuMegaPromo.show())))
								}
							},
							{
								key: 'onMobileChildMenuClick',
								value: function (e) {
									e.stopPropagation(),
										(this.$parent = f()(e.currentTarget).find(
											'.mobile__menu__child-dropdown'
										)),
										(this.$plusIcon = f()(e.currentTarget).find(
											'.icon-plus'
										)),
										(this.$minusIcon = f()(e.currentTarget).find(
											'.icon-minus'
										)),
										this.$parent &&
											this.$parent.length > 0 &&
											e.preventDefault(),
										this.$parent.hasClass(Jt)
											? (this.$parent.removeClass(Jt),
											  this.$parent.slideUp(),
											  this.$plusIcon.show(),
											  this.$minusIcon.hide())
											: (this.$parent.addClass(Jt),
											  this.$parent.slideDown(),
											  this.$plusIcon.hide(),
											  this.$minusIcon.show())
								}
							},
							{
								key: 'onMobileGranChildClick',
								value: function (e) {
									e.stopPropagation()
								}
							},
							{
								key: 'onToggleMegamenu',
								value: function (e) {
									var t = this
									e.preventDefault(), e.stopPropagation()
									var n = f()(e.target),
										r = n.data(un),
										i = f()('[data-'.concat(cn, '=').concat(r, ']'))
									i.hasClass(Zt)
										? this.closeAllMenus()
										: ((this.menuIsOpening = !0),
										  n.addClass(Jt),
										  i.addClass(Zt),
										  i.slideDown(300, function () {
												;(t.menuIsOpening = !1),
													$t({ $container: n, $elementToFocus: i })
										  }),
										  Ht.addClass(ln))
								}
							},
							{
								key: 'onTriggerMouseEnter',
								value: function (e) {
									var t = this
									this.stopCloseTimeout()
									var n = f()(e.target),
										r = n.data(un),
										i = f()('[data-'.concat(cn, '=').concat(r, ']'))
									i.hasClass(Zt) ||
										((this.menuIsOpening = !0),
										n.addClass(Jt),
										i.addClass(Zt),
										i.slideDown(300, function () {
											;(t.menuIsOpening = !1),
												$t({ $container: n, $elementToFocus: i })
										}),
										Ht.addClass(ln))
								}
							},
							{
								key: 'onTriggerMouseLeave',
								value: function (e) {
									this.startCloseTimeout()
								}
							},
							{
								key: 'onDropdownMouseEnter',
								value: function (e) {
									this.stopCloseTimeout()
								}
							},
							{
								key: 'onDropdownMouseLeave',
								value: function (e) {
									this.startCloseTimeout()
								}
							},
							{
								key: 'closeAllMenus',
								value: function () {
									var e = this,
										t = f()(Bt, this.$container),
										n = f()(Ft, this.$container)
									this.menuIsOpening ||
										((this.menuIsOpening = !0),
										t.removeClass(Jt),
										n.removeClass(Zt),
										n.slideUp(300, function () {
											;(e.menuIsOpening = !1),
												Dt({ $container: t, $elementToFocus: n })
										}),
										Ht.removeClass(ln))
								}
							},
							{
								key: 'focusSearchBtn',
								value: function (e) {
									var t = this
									'blur' === e.type &&
										setTimeout(function () {
											t.$searchIconTrigger.focus(),
												t.$searchIconTrigger
													.attr('aria-expanded', !1)
													.attr('data-expanded', !1)
										}, 300)
								}
							},
							{
								key: 'onSearchIconClick',
								value: function () {
									var e = this,
										t = f()('#toggle'),
										n =
											'true' ===
												this.$searchIconTrigger.attr(
													'aria-expanded'
												) ||
											!0 ===
												this.$searchIconTrigger.attr('aria-expanded')
									this.$searchIconTrigger.attr('aria-expanded', !n),
										t.attr('data-expanded', !n),
										setTimeout(function () {
											e.$searchIconTarget.focus()
										}, 300)
								}
							},
							{
								key: 'startCloseTimeout',
								value: function () {
									this.closeDropdownTimeout = setTimeout(
										this.closeAllMenus,
										this.closeDropdownTimeoutDuration
									)
								}
							},
							{
								key: 'stopCloseTimeout',
								value: function () {
									clearTimeout(this.closeDropdownTimeout)
								}
							},
							{
								key: 'onMegaMenuToggle',
								value: function (e) {
									13 == e.keyCode &&
										(e.preventDefault(),
										f()(e.target)
											.closest('.dropdown')
											.attr('aria-expanded', function (e, t) {
												return 'true' == t ? 'false' : 'true'
											}))
								}
							},
							{
								key: 'onMegaMenuLastItemKeydown',
								value: function (e) {
									9 == e.keyCode &&
										f()(e.target)
											.closest('.dropdown')
											.attr('aria-expanded', 'false')
								}
							},
							{
								key: 'detectClickOutOfMenu',
								value: function () {
									document.addEventListener('click', function (e) {
										document
											.querySelector('.menu-container')
											.contains(e.target) ||
											f()('.dropdown[aria-expanded="true"]').attr(
												'aria-expanded',
												'false'
											)
									})
								}
							},
							{
								key: 'onMegaMenukeydown',
								value: function (e) {
									27 == e.keyCode &&
										(f()(e.target)
											.closest('.dropdown')
											.attr('aria-expanded', 'false'),
										f()(e.target)
											.closest('.dropdown')
											.find('.toggle-button')
											.focus())
								}
							}
						])
					)
				})(d(HTMLElement))
			function fn(e, t, n) {
				return (
					(t = a(t)),
					s(
						e,
						hn()
							? Reflect.construct(t, n || [], a(e).constructor)
							: t.apply(e, n)
					)
				)
			}
			function hn() {
				try {
					var e = !Boolean.prototype.valueOf.call(
						Reflect.construct(Boolean, [], function () {})
					)
				} catch (e) {}
				return (hn = function () {
					return !!e
				})()
			}
			customElements.define('site-header', pn)
			var vn = f()(document.body),
				mn = '[data-filters-toggle]',
				gn = '[data-filters-drawer]',
				yn = '[data-filters-overlay]',
				_n = 'fixed',
				bn = (function (t) {
					function n() {
						var t
						return (
							e(this, n),
							((t = fn(this, n)).$container = f()(t)),
							(t.$filtersToggle = f()(mn, t.$container)),
							(t.$filtersDrawer = f()(gn, t.$container)),
							(t.$filtersOverlay = f()(yn, t.$container)),
							t.$filtersToggle.on('click', t.toggleFilters.bind(t)),
							t.$filtersOverlay.on('click', t.toggleFilters.bind(t)),
							t
						)
					}
					return (
						u(n, t),
						o(n, [
							{
								key: 'toggleFilters',
								value: function () {
									this.$filtersDrawer.slideToggle(),
										this.$filtersOverlay.fadeToggle('fast'),
										vn.hasClass(_n)
											? vn.removeClass(_n)
											: vn.addClass(_n)
								}
							}
						])
					)
				})(d(HTMLElement))
			customElements.define('site-filters', bn)
			var wn,
				xn,
				Tn,
				Cn,
				En,
				kn,
				Sn,
				Mn,
				Pn,
				Ln,
				An = {},
				On = [],
				jn =
					/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
				$n = Array.isArray
			function Dn(e, t) {
				for (var n in t) e[n] = t[n]
				return e
			}
			function Nn(e) {
				var t = e.parentNode
				t && t.removeChild(e)
			}
			function In(e, t, n, r, i) {
				var o = {
					type: e,
					props: t,
					key: n,
					ref: r,
					__k: null,
					__: null,
					__b: 0,
					__e: null,
					__d: void 0,
					__c: null,
					constructor: void 0,
					__v: null == i ? ++Tn : i,
					__i: -1,
					__u: 0
				}
				return null == i && null != xn.vnode && xn.vnode(o), o
			}
			function qn(e) {
				return e.children
			}
			function Hn(e, t) {
				;(this.props = e), (this.context = t)
			}
			function Bn(e, t) {
				if (null == t) return e.__ ? Bn(e.__, e.__i + 1) : null
				for (var n; t < e.__k.length; t++)
					if (null != (n = e.__k[t]) && null != n.__e) return n.__e
				return 'function' == typeof e.type ? Bn(e) : null
			}
			function Fn(e) {
				var t, n
				if (null != (e = e.__) && null != e.__c) {
					for (
						e.__e = e.__c.base = null, t = 0;
						t < e.__k.length;
						t++
					)
						if (null != (n = e.__k[t]) && null != n.__e) {
							e.__e = e.__c.base = n.__e
							break
						}
					return Fn(e)
				}
			}
			function Rn(e) {
				;((!e.__d && (e.__d = !0) && Cn.push(e) && !zn.__r++) ||
					En !== xn.debounceRendering) &&
					((En = xn.debounceRendering) || kn)(zn)
			}
			function zn() {
				var e, t, n, r, i, o, s, a
				for (Cn.sort(Sn); (e = Cn.shift()); )
					e.__d &&
						((t = Cn.length),
						(r = void 0),
						(o = (i = (n = e).__v).__e),
						(s = []),
						(a = []),
						n.__P &&
							(((r = Dn({}, i)).__v = i.__v + 1),
							xn.vnode && xn.vnode(r),
							Qn(
								n.__P,
								r,
								i,
								n.__n,
								void 0 !== n.__P.ownerSVGElement,
								32 & i.__u ? [o] : null,
								s,
								null == o ? Bn(i) : o,
								!!(32 & i.__u),
								a
							),
							(r.__v = i.__v),
							(r.__.__k[r.__i] = r),
							Jn(s, r, a),
							r.__e != o && Fn(r)),
						Cn.length > t && Cn.sort(Sn))
				zn.__r = 0
			}
			function Wn(e, t, n, r, i, o, s, a, l, u, c) {
				var d,
					p,
					f,
					h,
					v,
					m = (r && r.__k) || On,
					g = t.length
				for (n.__d = l, Vn(n, t, m), l = n.__d, d = 0; d < g; d++)
					null != (f = n.__k[d]) &&
						'boolean' != typeof f &&
						'function' != typeof f &&
						((p = -1 === f.__i ? An : m[f.__i] || An),
						(f.__i = d),
						Qn(e, f, p, i, o, s, a, l, u, c),
						(h = f.__e),
						f.ref &&
							p.ref != f.ref &&
							(p.ref && er(p.ref, null, f),
							c.push(f.ref, f.__c || h, f)),
						null == v && null != h && (v = h),
						65536 & f.__u || p.__k === f.__k
							? (l && !l.isConnected && (l = Bn(p)),
							  (l = Gn(f, l, e)))
							: 'function' == typeof f.type && void 0 !== f.__d
							? (l = f.__d)
							: h && (l = h.nextSibling),
						(f.__d = void 0),
						(f.__u &= -196609))
				;(n.__d = l), (n.__e = v)
			}
			function Vn(e, t, n) {
				var r,
					i,
					o,
					s,
					a,
					l = t.length,
					u = n.length,
					c = u,
					d = 0
				for (e.__k = [], r = 0; r < l; r++)
					(s = r + d),
						null !=
						(i = e.__k[r] =
							null == (i = t[r]) ||
							'boolean' == typeof i ||
							'function' == typeof i
								? null
								: 'string' == typeof i ||
								  'number' == typeof i ||
								  'bigint' == typeof i ||
								  i.constructor == String
								? In(null, i, null, null, null)
								: $n(i)
								? In(qn, { children: i }, null, null, null)
								: void 0 === i.constructor && i.__b > 0
								? In(
										i.type,
										i.props,
										i.key,
										i.ref ? i.ref : null,
										i.__v
								  )
								: i)
							? ((i.__ = e),
							  (i.__b = e.__b + 1),
							  (a = Un(i, n, s, c)),
							  (i.__i = a),
							  (o = null),
							  -1 !== a && (c--, (o = n[a]) && (o.__u |= 131072)),
							  null == o || null === o.__v
									? (-1 == a && d--,
									  'function' != typeof i.type && (i.__u |= 65536))
									: a !== s &&
									  (a === s + 1
											? d++
											: a > s
											? c > l - s
												? (d += a - s)
												: d--
											: a < s
											? a == s - 1 && (d = a - s)
											: (d = 0),
									  a !== r + d && (i.__u |= 65536)))
							: (o = n[s]) &&
							  null == o.key &&
							  o.__e &&
							  !(131072 & o.__u) &&
							  (o.__e == e.__d && (e.__d = Bn(o)),
							  tr(o, o, !1),
							  (n[s] = null),
							  c--)
				if (c)
					for (r = 0; r < u; r++)
						null != (o = n[r]) &&
							!(131072 & o.__u) &&
							(o.__e == e.__d && (e.__d = Bn(o)), tr(o, o))
			}
			function Gn(e, t, n) {
				var r, i
				if ('function' == typeof e.type) {
					for (r = e.__k, i = 0; r && i < r.length; i++)
						r[i] && ((r[i].__ = e), (t = Gn(r[i], t, n)))
					return t
				}
				e.__e != t && (n.insertBefore(e.__e, t || null), (t = e.__e))
				do {
					t = t && t.nextSibling
				} while (null != t && 8 === t.nodeType)
				return t
			}
			function Un(e, t, n, r) {
				var i = e.key,
					o = e.type,
					s = n - 1,
					a = n + 1,
					l = t[n]
				if (
					null === l ||
					(l && i == l.key && o === l.type && !(131072 & l.__u))
				)
					return n
				if (r > (null == l || 131072 & l.__u ? 0 : 1))
					for (; s >= 0 || a < t.length; ) {
						if (s >= 0) {
							if (
								(l = t[s]) &&
								!(131072 & l.__u) &&
								i == l.key &&
								o === l.type
							)
								return s
							s--
						}
						if (a < t.length) {
							if (
								(l = t[a]) &&
								!(131072 & l.__u) &&
								i == l.key &&
								o === l.type
							)
								return a
							a++
						}
					}
				return -1
			}
			function Xn(e, t, n) {
				'-' === t[0]
					? e.setProperty(t, null == n ? '' : n)
					: (e[t] =
							null == n
								? ''
								: 'number' != typeof n || jn.test(t)
								? n
								: n + 'px')
			}
			function Yn(e, t, n, r, i) {
				var o
				e: if ('style' === t)
					if ('string' == typeof n) e.style.cssText = n
					else {
						if (
							('string' == typeof r && (e.style.cssText = r = ''), r)
						)
							for (t in r) (n && t in n) || Xn(e.style, t, '')
						if (n)
							for (t in n)
								(r && n[t] === r[t]) || Xn(e.style, t, n[t])
					}
				else if ('o' === t[0] && 'n' === t[1])
					(o =
						t !==
						(t = t.replace(/(PointerCapture)$|Capture$/i, '$1'))),
						(t =
							t.toLowerCase() in e ||
							'onFocusOut' === t ||
							'onFocusIn' === t
								? t.toLowerCase().slice(2)
								: t.slice(2)),
						e.l || (e.l = {}),
						(e.l[t + o] = n),
						n
							? r
								? (n.u = r.u)
								: ((n.u = Mn), e.addEventListener(t, o ? Ln : Pn, o))
							: e.removeEventListener(t, o ? Ln : Pn, o)
				else {
					if (i)
						t = t.replace(/xlink(H|:h)/, 'h').replace(/sName$/, 's')
					else if (
						'width' != t &&
						'height' != t &&
						'href' != t &&
						'list' != t &&
						'form' != t &&
						'tabIndex' != t &&
						'download' != t &&
						'rowSpan' != t &&
						'colSpan' != t &&
						'role' != t &&
						t in e
					)
						try {
							e[t] = null == n ? '' : n
							break e
						} catch (e) {}
					'function' == typeof n ||
						(null == n || (!1 === n && '-' !== t[4])
							? e.removeAttribute(t)
							: e.setAttribute(t, n))
				}
			}
			function Kn(e) {
				return function (t) {
					if (this.l) {
						var n = this.l[t.type + e]
						if (null == t.t) t.t = Mn++
						else if (t.t < n.u) return
						return n(xn.event ? xn.event(t) : t)
					}
				}
			}
			function Qn(e, t, n, r, i, o, s, a, l, u) {
				var c,
					d,
					p,
					f,
					h,
					v,
					m,
					g,
					y,
					_,
					b,
					w,
					x,
					T,
					C,
					E = t.type
				if (void 0 !== t.constructor) return null
				128 & n.__u &&
					((l = !!(32 & n.__u)), (o = [(a = t.__e = n.__e)])),
					(c = xn.__b) && c(t)
				e: if ('function' == typeof E)
					try {
						if (
							((g = t.props),
							(y = (c = E.contextType) && r[c.__c]),
							(_ = c ? (y ? y.props.value : c.__) : r),
							n.__c
								? (m = (d = t.__c = n.__c).__ = d.__E)
								: ('prototype' in E && E.prototype.render
										? (t.__c = d = new E(g, _))
										: ((t.__c = d = new Hn(g, _)),
										  (d.constructor = E),
										  (d.render = nr)),
								  y && y.sub(d),
								  (d.props = g),
								  d.state || (d.state = {}),
								  (d.context = _),
								  (d.__n = r),
								  (p = d.__d = !0),
								  (d.__h = []),
								  (d._sb = [])),
							null == d.__s && (d.__s = d.state),
							null != E.getDerivedStateFromProps &&
								(d.__s == d.state && (d.__s = Dn({}, d.__s)),
								Dn(d.__s, E.getDerivedStateFromProps(g, d.__s))),
							(f = d.props),
							(h = d.state),
							(d.__v = t),
							p)
						)
							null == E.getDerivedStateFromProps &&
								null != d.componentWillMount &&
								d.componentWillMount(),
								null != d.componentDidMount &&
									d.__h.push(d.componentDidMount)
						else {
							if (
								(null == E.getDerivedStateFromProps &&
									g !== f &&
									null != d.componentWillReceiveProps &&
									d.componentWillReceiveProps(g, _),
								!d.__e &&
									((null != d.shouldComponentUpdate &&
										!1 === d.shouldComponentUpdate(g, d.__s, _)) ||
										t.__v === n.__v))
							) {
								for (
									t.__v !== n.__v &&
										((d.props = g), (d.state = d.__s), (d.__d = !1)),
										t.__e = n.__e,
										t.__k = n.__k,
										t.__k.forEach(function (e) {
											e && (e.__ = t)
										}),
										b = 0;
									b < d._sb.length;
									b++
								)
									d.__h.push(d._sb[b])
								;(d._sb = []), d.__h.length && s.push(d)
								break e
							}
							null != d.componentWillUpdate &&
								d.componentWillUpdate(g, d.__s, _),
								null != d.componentDidUpdate &&
									d.__h.push(function () {
										d.componentDidUpdate(f, h, v)
									})
						}
						if (
							((d.context = _),
							(d.props = g),
							(d.__P = e),
							(d.__e = !1),
							(w = xn.__r),
							(x = 0),
							'prototype' in E && E.prototype.render)
						) {
							for (
								d.state = d.__s,
									d.__d = !1,
									w && w(t),
									c = d.render(d.props, d.state, d.context),
									T = 0;
								T < d._sb.length;
								T++
							)
								d.__h.push(d._sb[T])
							d._sb = []
						} else
							do {
								;(d.__d = !1),
									w && w(t),
									(c = d.render(d.props, d.state, d.context)),
									(d.state = d.__s)
							} while (d.__d && ++x < 25)
						;(d.state = d.__s),
							null != d.getChildContext &&
								(r = Dn(Dn({}, r), d.getChildContext())),
							p ||
								null == d.getSnapshotBeforeUpdate ||
								(v = d.getSnapshotBeforeUpdate(f, h)),
							Wn(
								e,
								$n(
									(C =
										null != c && c.type === qn && null == c.key
											? c.props.children
											: c)
								)
									? C
									: [C],
								t,
								n,
								r,
								i,
								o,
								s,
								a,
								l,
								u
							),
							(d.base = t.__e),
							(t.__u &= -161),
							d.__h.length && s.push(d),
							m && (d.__E = d.__ = null)
					} catch (e) {
						;(t.__v = null),
							l || null != o
								? ((t.__e = a),
								  (t.__u |= l ? 160 : 32),
								  (o[o.indexOf(a)] = null))
								: ((t.__e = n.__e), (t.__k = n.__k)),
							xn.__e(e, t, n)
					}
				else
					null == o && t.__v === n.__v
						? ((t.__k = n.__k), (t.__e = n.__e))
						: (t.__e = Zn(n.__e, t, n, r, i, o, s, l, u))
				;(c = xn.diffed) && c(t)
			}
			function Jn(e, t, n) {
				t.__d = void 0
				for (var r = 0; r < n.length; r++) er(n[r], n[++r], n[++r])
				xn.__c && xn.__c(t, e),
					e.some(function (t) {
						try {
							;(e = t.__h),
								(t.__h = []),
								e.some(function (e) {
									e.call(t)
								})
						} catch (e) {
							xn.__e(e, t.__v)
						}
					})
			}
			function Zn(e, t, n, r, i, o, s, a, l) {
				var u,
					c,
					d,
					p,
					f,
					h,
					v,
					m = n.props,
					g = t.props,
					y = t.type
				if (('svg' === y && (i = !0), null != o))
					for (u = 0; u < o.length; u++)
						if (
							(f = o[u]) &&
							'setAttribute' in f == !!y &&
							(y ? f.localName === y : 3 === f.nodeType)
						) {
							;(e = f), (o[u] = null)
							break
						}
				if (null == e) {
					if (null === y) return document.createTextNode(g)
					;(e = i
						? document.createElementNS(
								'http://www.w3.org/2000/svg',
								y
						  )
						: document.createElement(y, g.is && g)),
						(o = null),
						(a = !1)
				}
				if (null === y) m === g || (a && e.data === g) || (e.data = g)
				else {
					if (
						((o = o && wn.call(e.childNodes)),
						(m = n.props || An),
						!a && null != o)
					)
						for (m = {}, u = 0; u < e.attributes.length; u++)
							m[(f = e.attributes[u]).name] = f.value
					for (u in m)
						if (((f = m[u]), 'children' == u));
						else if ('dangerouslySetInnerHTML' == u) d = f
						else if ('key' !== u && !(u in g)) {
							if (
								('value' == u && 'defaultValue' in g) ||
								('checked' == u && 'defaultChecked' in g)
							)
								continue
							Yn(e, u, null, f, i)
						}
					for (u in g)
						(f = g[u]),
							'children' == u
								? (p = f)
								: 'dangerouslySetInnerHTML' == u
								? (c = f)
								: 'value' == u
								? (h = f)
								: 'checked' == u
								? (v = f)
								: 'key' === u ||
								  (a && 'function' != typeof f) ||
								  m[u] === f ||
								  Yn(e, u, f, m[u], i)
					if (c)
						a ||
							(d &&
								(c.__html === d.__html ||
									c.__html === e.innerHTML)) ||
							(e.innerHTML = c.__html),
							(t.__k = [])
					else if (
						(d && (e.innerHTML = ''),
						Wn(
							e,
							$n(p) ? p : [p],
							t,
							n,
							r,
							i && 'foreignObject' !== y,
							o,
							s,
							o ? o[0] : n.__k && Bn(n, 0),
							a,
							l
						),
						null != o)
					)
						for (u = o.length; u--; ) null != o[u] && Nn(o[u])
					a ||
						((u = 'value'),
						void 0 !== h &&
							(h !== e[u] ||
								('progress' === y && !h) ||
								('option' === y && h !== m[u])) &&
							Yn(e, u, h, m[u], !1),
						(u = 'checked'),
						void 0 !== v && v !== e[u] && Yn(e, u, v, m[u], !1))
				}
				return e
			}
			function er(e, t, n) {
				try {
					'function' == typeof e ? e(t) : (e.current = t)
				} catch (e) {
					xn.__e(e, n)
				}
			}
			function tr(e, t, n) {
				var r, i
				if (
					(xn.unmount && xn.unmount(e),
					(r = e.ref) &&
						((r.current && r.current !== e.__e) || er(r, null, t)),
					null != (r = e.__c))
				) {
					if (r.componentWillUnmount)
						try {
							r.componentWillUnmount()
						} catch (e) {
							xn.__e(e, t)
						}
					r.base = r.__P = null
				}
				if ((r = e.__k))
					for (i = 0; i < r.length; i++)
						r[i] && tr(r[i], t, n || 'function' != typeof e.type)
				n || null == e.__e || Nn(e.__e),
					(e.__c = e.__ = e.__e = e.__d = void 0)
			}
			function nr(e, t, n) {
				return this.constructor(e, n)
			}
			function rr(e, t, n) {
				var r, i, o, s
				xn.__ && xn.__(e, t),
					(i = (r = 'function' == typeof n)
						? null
						: (n && n.__k) || t.__k),
					(o = []),
					(s = []),
					Qn(
						t,
						(e = ((!r && n) || t).__k =
							(function (e, t, n) {
								var r,
									i,
									o,
									s = {}
								for (o in t)
									'key' == o
										? (r = t[o])
										: 'ref' == o
										? (i = t[o])
										: (s[o] = t[o])
								if (
									(arguments.length > 2 &&
										(s.children =
											arguments.length > 3
												? wn.call(arguments, 2)
												: n),
									'function' == typeof e && null != e.defaultProps)
								)
									for (o in e.defaultProps)
										void 0 === s[o] && (s[o] = e.defaultProps[o])
								return In(e, s, r, i, null)
							})(qn, null, [e])),
						i || An,
						An,
						void 0 !== t.ownerSVGElement,
						!r && n
							? [n]
							: i
							? null
							: t.firstChild
							? wn.call(t.childNodes)
							: null,
						o,
						!r && n ? n : i ? i.__e : t.firstChild,
						r,
						s
					),
					Jn(o, e, s)
			}
			function ir(e, t, n, r, i, o, s) {
				try {
					var a = e[o](s),
						l = a.value
				} catch (e) {
					return void n(e)
				}
				a.done ? t(l) : Promise.resolve(l).then(r, i)
			}
			function or(e) {
				return function () {
					var t = this,
						n = arguments
					return new Promise(function (r, i) {
						var o = e.apply(t, n)
						function s(e) {
							ir(o, r, i, s, a, 'next', e)
						}
						function a(e) {
							ir(o, r, i, s, a, 'throw', e)
						}
						s(void 0)
					})
				}
			}
			function sr(e, t) {
				;(null == t || t > e.length) && (t = e.length)
				for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n]
				return r
			}
			function ar(e, t) {
				return (
					(function (e) {
						if (Array.isArray(e)) return e
					})(e) ||
					(function (e, t) {
						var n =
							null == e
								? null
								: ('undefined' != typeof Symbol &&
										e[Symbol.iterator]) ||
								  e['@@iterator']
						if (null != n) {
							var r,
								i,
								o,
								s,
								a = [],
								l = !0,
								u = !1
							try {
								if (((o = (n = n.call(e)).next), 0 === t)) {
									if (Object(n) !== n) return
									l = !1
								} else
									for (
										;
										!(l = (r = o.call(n)).done) &&
										(a.push(r.value), a.length !== t);
										l = !0
									);
							} catch (e) {
								;(u = !0), (i = e)
							} finally {
								try {
									if (
										!l &&
										null != n.return &&
										((s = n.return()), Object(s) !== s)
									)
										return
								} finally {
									if (u) throw i
								}
							}
							return a
						}
					})(e, t) ||
					(function (e, t) {
						if (e) {
							if ('string' == typeof e) return sr(e, t)
							var n = Object.prototype.toString.call(e).slice(8, -1)
							return (
								'Object' === n &&
									e.constructor &&
									(n = e.constructor.name),
								'Map' === n || 'Set' === n
									? Array.from(e)
									: 'Arguments' === n ||
									  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
									? sr(e, t)
									: void 0
							)
						}
					})(e, t) ||
					(function () {
						throw new TypeError(
							'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
						)
					})()
				)
			}
			;(wn = On.slice),
				(xn = {
					__e: function (e, t, n, r) {
						for (var i, o, s; (t = t.__); )
							if ((i = t.__c) && !i.__)
								try {
									if (
										((o = i.constructor) &&
											null != o.getDerivedStateFromError &&
											(i.setState(o.getDerivedStateFromError(e)),
											(s = i.__d)),
										null != i.componentDidCatch &&
											(i.componentDidCatch(e, r || {}), (s = i.__d)),
										s)
									)
										return (i.__E = i)
								} catch (t) {
									e = t
								}
						throw e
					}
				}),
				(Tn = 0),
				(Hn.prototype.setState = function (e, t) {
					var n
					;(n =
						null != this.__s && this.__s !== this.state
							? this.__s
							: (this.__s = Dn({}, this.state))),
						'function' == typeof e && (e = e(Dn({}, n), this.props)),
						e && Dn(n, e),
						null != e && this.__v && (t && this._sb.push(t), Rn(this))
				}),
				(Hn.prototype.forceUpdate = function (e) {
					this.__v &&
						((this.__e = !0), e && this.__h.push(e), Rn(this))
				}),
				(Hn.prototype.render = qn),
				(Cn = []),
				(kn =
					'function' == typeof Promise
						? Promise.prototype.then.bind(Promise.resolve())
						: setTimeout),
				(Sn = function (e, t) {
					return e.__v.__b - t.__v.__b
				}),
				(zn.__r = 0),
				(Mn = 0),
				(Pn = Kn(!1)),
				(Ln = Kn(!0))
			var lr,
				ur,
				cr,
				dr,
				pr = n(4756),
				fr = n.n(pr),
				hr = 0,
				vr = [],
				mr = [],
				gr = xn,
				yr = gr.__b,
				_r = gr.__r,
				br = gr.diffed,
				wr = gr.__c,
				xr = gr.unmount,
				Tr = gr.__
			function Cr(e, t) {
				gr.__h && gr.__h(ur, e, hr || t), (hr = 0)
				var n = ur.__H || (ur.__H = { __: [], __h: [] })
				return e >= n.__.length && n.__.push({ __V: mr }), n.__[e]
			}
			function Er(e) {
				return (
					(hr = 1),
					(function (e, t, n) {
						var r = Cr(lr++, 2)
						if (
							((r.t = e),
							!r.__c &&
								((r.__ = [
									n ? n(t) : Or(void 0, t),
									function (e) {
										var t = r.__N ? r.__N[0] : r.__[0],
											n = r.t(t, e)
										t !== n &&
											((r.__N = [n, r.__[1]]), r.__c.setState({}))
									}
								]),
								(r.__c = ur),
								!ur.u))
						) {
							var i = function (e, t, n) {
								if (!r.__c.__H) return !0
								var i = r.__c.__H.__.filter(function (e) {
									return !!e.__c
								})
								if (
									i.every(function (e) {
										return !e.__N
									})
								)
									return !o || o.call(this, e, t, n)
								var s = !1
								return (
									i.forEach(function (e) {
										if (e.__N) {
											var t = e.__[0]
											;(e.__ = e.__N),
												(e.__N = void 0),
												t !== e.__[0] && (s = !0)
										}
									}),
									!(!s && r.__c.props === e) &&
										(!o || o.call(this, e, t, n))
								)
							}
							ur.u = !0
							var o = ur.shouldComponentUpdate,
								s = ur.componentWillUpdate
							;(ur.componentWillUpdate = function (e, t, n) {
								if (this.__e) {
									var r = o
									;(o = void 0), i(e, t, n), (o = r)
								}
								s && s.call(this, e, t, n)
							}),
								(ur.shouldComponentUpdate = i)
						}
						return r.__N || r.__
					})(Or, e)
				)
			}
			function kr() {
				for (var e; (e = vr.shift()); )
					if (e.__P && e.__H)
						try {
							e.__H.__h.forEach(Pr),
								e.__H.__h.forEach(Lr),
								(e.__H.__h = [])
						} catch (t) {
							;(e.__H.__h = []), gr.__e(t, e.__v)
						}
			}
			;(gr.__b = function (e) {
				;(ur = null), yr && yr(e)
			}),
				(gr.__ = function (e, t) {
					e && t.__k && t.__k.__m && (e.__m = t.__k.__m),
						Tr && Tr(e, t)
				}),
				(gr.__r = function (e) {
					_r && _r(e), (lr = 0)
					var t = (ur = e.__c).__H
					t &&
						(cr === ur
							? ((t.__h = []),
							  (ur.__h = []),
							  t.__.forEach(function (e) {
									e.__N && (e.__ = e.__N),
										(e.__V = mr),
										(e.__N = e.i = void 0)
							  }))
							: (t.__h.forEach(Pr),
							  t.__h.forEach(Lr),
							  (t.__h = []),
							  (lr = 0))),
						(cr = ur)
				}),
				(gr.diffed = function (e) {
					br && br(e)
					var t = e.__c
					t &&
						t.__H &&
						(t.__H.__h.length &&
							((1 !== vr.push(t) &&
								dr === gr.requestAnimationFrame) ||
								((dr = gr.requestAnimationFrame) || Mr)(kr)),
						t.__H.__.forEach(function (e) {
							e.i && (e.__H = e.i),
								e.__V !== mr && (e.__ = e.__V),
								(e.i = void 0),
								(e.__V = mr)
						})),
						(cr = ur = null)
				}),
				(gr.__c = function (e, t) {
					t.some(function (e) {
						try {
							e.__h.forEach(Pr),
								(e.__h = e.__h.filter(function (e) {
									return !e.__ || Lr(e)
								}))
						} catch (n) {
							t.some(function (e) {
								e.__h && (e.__h = [])
							}),
								(t = []),
								gr.__e(n, e.__v)
						}
					}),
						wr && wr(e, t)
				}),
				(gr.unmount = function (e) {
					xr && xr(e)
					var t,
						n = e.__c
					n &&
						n.__H &&
						(n.__H.__.forEach(function (e) {
							try {
								Pr(e)
							} catch (e) {
								t = e
							}
						}),
						(n.__H = void 0),
						t && gr.__e(t, n.__v))
				})
			var Sr = 'function' == typeof requestAnimationFrame
			function Mr(e) {
				var t,
					n = function () {
						clearTimeout(r),
							Sr && cancelAnimationFrame(t),
							setTimeout(e)
					},
					r = setTimeout(n, 100)
				Sr && (t = requestAnimationFrame(n))
			}
			function Pr(e) {
				var t = ur,
					n = e.__c
				'function' == typeof n && ((e.__c = void 0), n()), (ur = t)
			}
			function Lr(e) {
				var t = ur
				;(e.__c = e.__()), (ur = t)
			}
			function Ar(e, t) {
				return (
					!e ||
					e.length !== t.length ||
					t.some(function (t, n) {
						return t !== e[n]
					})
				)
			}
			function Or(e, t) {
				return 'function' == typeof t ? t(e) : t
			}
			var jr = 0
			Array.isArray
			function $r(e, t, n, r, i, o) {
				t || (t = {})
				var s,
					a,
					l = t
				if ('ref' in l)
					for (a in ((l = {}), t))
						'ref' == a ? (s = t[a]) : (l[a] = t[a])
				var u = {
					type: e,
					props: l,
					key: n,
					ref: s,
					__k: null,
					__: null,
					__b: 0,
					__e: null,
					__d: void 0,
					__c: null,
					constructor: void 0,
					__v: --jr,
					__i: -1,
					__u: 0,
					__source: i,
					__self: o
				}
				if ('function' == typeof e && (s = e.defaultProps))
					for (a in s) void 0 === l[a] && (l[a] = s[a])
				return xn.vnode && xn.vnode(u), u
			}
			function Dr(e) {
				e.cartCount
				return $r('div', { className: 'cart-count-bubble' })
			}
			function Nr(e, t) {
				var n = ar(Er(null), 2),
					r = n[0],
					i = n[1],
					o = (function () {
						var e = or(
							fr().mark(function e() {
								var t
								return fr().wrap(
									function (e) {
										for (;;)
											switch ((e.prev = e.next)) {
												case 0:
													return (e.prev = 0), (e.next = 3), h()
												case 3:
													;(t = e.sent), i(t), (e.next = 10)
													break
												case 7:
													;(e.prev = 7),
														(e.t0 = e.catch(0)),
														console.log(
															'Error fetching cart data',
															e.t0
														)
												case 10:
												case 'end':
													return e.stop()
											}
									},
									e,
									null,
									[[0, 7]]
								)
							})
						)
						return function () {
							return e.apply(this, arguments)
						}
					})(),
					s = function () {
						console.log('update cart failed')
					}
				return (
					(function (e, t) {
						var n = Cr(lr++, 3)
						!gr.__s &&
							Ar(n.__H, t) &&
							((n.__ = e), (n.i = t), ur.__H.__h.push(n))
					})(function () {
						return (
							or(
								fr().mark(function e() {
									var t
									return fr().wrap(
										function (e) {
											for (;;)
												switch ((e.prev = e.next)) {
													case 0:
														return (e.prev = 0), (e.next = 3), h()
													case 3:
														;(t = e.sent), i(t), (e.next = 10)
														break
													case 7:
														;(e.prev = 7),
															(e.t0 = e.catch(0)),
															console.log(
																'Error fetching cart data',
																e.t0
															)
													case 10:
													case 'end':
														return e.stop()
												}
										},
										e,
										null,
										[[0, 7]]
									)
								})
							)(),
							window.addEventListener('cartUpdateSuccess', o),
							window.addEventListener('cartUpdateFail', s),
							function () {
								new AbortController().abort(),
									window.removeEventListener('addToCartSuccess', o),
									window.removeEventListener('cartUpdateFail', s)
							}
						)
					}, []),
					$r(qn, {
						children:
							r &&
							$r(qn, {
								children: $r(Dr, { cartCount: r.item_count })
							})
					})
				)
			}
			function Ir(e, t, n) {
				return (
					(t = a(t)),
					s(
						e,
						qr()
							? Reflect.construct(t, n || [], a(e).constructor)
							: t.apply(e, n)
					)
				)
			}
			function qr() {
				try {
					var e = !Boolean.prototype.valueOf.call(
						Reflect.construct(Boolean, [], function () {})
					)
				} catch (e) {}
				return (qr = function () {
					return !!e
				})()
			}
			var Hr = '.cart-count-bubble',
				Br = (function (t) {
					function n() {
						var t
						e(this, n)
						var r = (t = Ir(this, n)).getAttribute('data-iso-code'),
							i = t.getAttribute('data-shop-name')
						return (
							rr($r(Nr, { isoCode: JSON.parse(r), shopName: i }), t),
							t
						)
					}
					return (
						u(n, t),
						o(n, [
							{
								key: 'connectedCallback',
								value: function () {
									f()(Hr).remove()
								}
							}
						])
					)
				})(d(HTMLElement))
			function Fr(e, t, n) {
				return (
					(t = a(t)),
					s(
						e,
						Rr()
							? Reflect.construct(t, n || [], a(e).constructor)
							: t.apply(e, n)
					)
				)
			}
			function Rr() {
				try {
					var e = !Boolean.prototype.valueOf.call(
						Reflect.construct(Boolean, [], function () {})
					)
				} catch (e) {}
				return (Rr = function () {
					return !!e
				})()
			}
			customElements.define('site-mini-cart', Br)
			var zr,
				Wr,
				Vr = f()(document.body),
				Gr = '[data-detail-toggle]',
				Ur = '[data-detail-close]',
				Xr = (function (t) {
					function n() {
						var t
						return (
							e(this, n),
							((t = Fr(this, n)).$detail = f()(t).find('details')),
							(t.$close = f()(Ur, t.$detail)),
							(t.$trigger = f()(Gr, t.$detail)),
							t.$trigger.on('click', t.onTriggerClick.bind(t)),
							t.$close.on('click', t.onCloseSearchClick.bind(t)),
							t.$detail.on('keyup', t.onEscapePress.bind(t)),
							t
						)
					}
					return (
						u(n, t),
						o(n, [
							{ key: 'connectedCallback', value: function () {} },
							{
								key: 'onEscapePress',
								value: function (e) {
									'Escape' == e.key &&
										(Dt({
											$container: this.$detail,
											$elementToFocus: this.$trigger
										}),
										this.$detail.removeAttr('open'),
										Vr.removeClass('overflow-hidden'))
								}
							},
							{
								key: 'onTriggerClick',
								value: function (e) {
									$t({
										$container: this.$detail,
										$elementToFocus: this.$trigger
									}),
										Vr.addClass('overflow-hidden')
								}
							},
							{
								key: 'onCloseSearchClick',
								value: function (e) {
									Dt({
										$container: this.$detail,
										$elementToFocus: this.$trigger
									}),
										this.$detail.removeAttr('open'),
										Vr.removeClass('overflow-hidden')
								}
							}
						])
					)
				})(d(HTMLElement))
			function Yr(e, t, n) {
				return (
					(t = a(t)),
					s(
						e,
						Kr()
							? Reflect.construct(t, n || [], a(e).constructor)
							: t.apply(e, n)
					)
				)
			}
			function Kr() {
				try {
					var e = !Boolean.prototype.valueOf.call(
						Reflect.construct(Boolean, [], function () {})
					)
				} catch (e) {}
				return (Kr = function () {
					return !!e
				})()
			}
			customElements.define('site-search-bar', Xr),
				(Wr = zr ? $('select', zr) : $('select'))
					.not('[data-no-chosen]')
					.chosen({ width: '100%' }),
				Wr.on('change', function () {
					$(this).trigger('chosen:updated')
				})
			var Qr = {}
			function Jr(e) {
				var t =
						arguments.length > 1 && void 0 !== arguments[1]
							? arguments[1]
							: e,
					n = (function (e) {
						return Array.from(
							e.querySelectorAll(
								"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
							)
						)
					})(e),
					r = n[0],
					i = n[n.length - 1]
				Zr(),
					(Qr.focusin = function (t) {
						;(t.target !== e && t.target !== i && t.target !== r) ||
							document.addEventListener('keydown', Qr.keydown)
					}),
					(Qr.focusout = function () {
						document.removeEventListener('keydown', Qr.keydown)
					}),
					(Qr.keydown = function (t) {
						'TAB' === t.code.toUpperCase() &&
							(t.target !== i ||
								t.shiftKey ||
								(t.preventDefault(), r.focus()),
							(t.target !== e && t.target !== r) ||
								!t.shiftKey ||
								(t.preventDefault(), i.focus()))
					}),
					document.addEventListener('focusout', Qr.focusout),
					document.addEventListener('focusin', Qr.focusin),
					t.focus()
			}
			function Zr() {
				var e =
					arguments.length > 0 && void 0 !== arguments[0]
						? arguments[0]
						: null
				document.removeEventListener('focusin', Qr.focusin),
					document.removeEventListener('focusout', Qr.focusout),
					document.removeEventListener('keydown', Qr.keydown),
					e && e.focus()
			}
			var ei = (function (t) {
				function n() {
					var t
					return (
						e(this, n),
						((t = Yr(this, n)).input = t.querySelector('input')),
						(t.changeEvent = new Event('change', { bubbles: !0 })),
						t.querySelectorAll('button').forEach(function (e) {
							return e.addEventListener(
								'click',
								t.onButtonClick.bind(t)
							)
						}),
						t
					)
				}
				return (
					u(n, t),
					o(n, [
						{
							key: 'onButtonClick',
							value: function (e) {
								e.preventDefault()
								var t = this.input.value
								'plus' === e.target.name
									? this.input.stepUp()
									: this.input.stepDown(),
									t !== this.input.value &&
										this.input.dispatchEvent(this.changeEvent)
							}
						}
					])
				)
			})(d(HTMLElement))
			customElements.define('quantity-input', ei)
			void 0 === window.Shopify && (window.Shopify = {}),
				(Shopify.bind = function (e, t) {
					return function () {
						return e.apply(t, arguments)
					}
				}),
				(Shopify.setSelectorByValue = function (e, t) {
					for (var n = 0, r = e.options.length; n < r; n++) {
						var i = e.options[n]
						if (t == i.value || t == i.innerHTML)
							return (e.selectedIndex = n), n
					}
				}),
				(Shopify.addListener = function (e, t, n) {
					e.addEventListener
						? e.addEventListener(t, n, !1)
						: e.attachEvent('on' + t, n)
				}),
				(Shopify.postLink = function (e, t) {
					var n = (t = t || {}).method || 'post',
						r = t.parameters || {},
						i = document.createElement('form')
					for (var o in (i.setAttribute('method', n),
					i.setAttribute('action', e),
					r)) {
						var s = document.createElement('input')
						s.setAttribute('type', 'hidden'),
							s.setAttribute('name', o),
							s.setAttribute('value', r[o]),
							i.appendChild(s)
					}
					document.body.appendChild(i),
						i.submit(),
						document.body.removeChild(i)
				}),
				(Shopify.CountryProvinceSelector = function (e, t, n) {
					;(this.countryEl = document.getElementById(e)),
						(this.provinceEl = document.getElementById(t)),
						(this.provinceContainer = document.getElementById(
							n.hideElement || t
						)),
						Shopify.addListener(
							this.countryEl,
							'change',
							Shopify.bind(this.countryHandler, this)
						),
						this.initCountry(),
						this.initProvince()
				}),
				(Shopify.CountryProvinceSelector.prototype = {
					initCountry: function () {
						var e = this.countryEl.getAttribute('data-default')
						Shopify.setSelectorByValue(this.countryEl, e),
							this.countryHandler()
					},
					initProvince: function () {
						var e = this.provinceEl.getAttribute('data-default')
						e &&
							this.provinceEl.options.length > 0 &&
							Shopify.setSelectorByValue(this.provinceEl, e)
					},
					countryHandler: function (e) {
						var t =
								this.countryEl.options[
									this.countryEl.selectedIndex
								].getAttribute('data-provinces'),
							n = JSON.parse(t)
						;(n = this.removeDuplicates(n)),
							this.clearOptions(this.provinceEl),
							n && 0 == n.length
								? (this.provinceContainer.style.display = 'none')
								: (this.setOptions(this.provinceEl, n),
								  (this.provinceContainer.style.display = ''))
					},
					removeDuplicates: function (e) {
						return e.map(function (e) {
							return e[0]
						})
					},
					clearOptions: function (e) {
						for (; e.firstChild; ) e.removeChild(e.firstChild)
					},
					setOptions: function (e, t) {
						var n = 0
						for (t.length; n < t.length; n++) {
							var r = document.createElement('option')
							;(r.value = t[n]),
								(r.innerHTML = t[n]),
								e.appendChild(r)
						}
					}
				})
			var ti = (function (t) {
				function n() {
					var t
					e(this, n),
						((t = Yr(this, n)).mainDetailsToggle =
							t.querySelector('details'))
					var r = t.querySelectorAll('summary')
					return (
						t.addAccessibilityAttributes(r),
						'iPhone' === navigator.platform &&
							document.documentElement.style.setProperty(
								'--viewport-height',
								''.concat(window.innerHeight, 'px')
							),
						t.addEventListener('keyup', t.onKeyUp.bind(t)),
						t.addEventListener('focusout', t.onFocusOut.bind(t)),
						t.bindEvents(),
						t
					)
				}
				return (
					u(n, t),
					o(n, [
						{
							key: 'bindEvents',
							value: function () {
								var e = this
								this.querySelectorAll('summary').forEach(function (
									t
								) {
									return t.addEventListener(
										'click',
										e.onSummaryClick.bind(e)
									)
								}),
									this.querySelectorAll('button').forEach(function (
										t
									) {
										return t.addEventListener(
											'click',
											e.onCloseButtonClick.bind(e)
										)
									})
							}
						},
						{
							key: 'addAccessibilityAttributes',
							value: function (e) {
								e.forEach(function (e) {
									e.setAttribute('role', 'button'),
										e.setAttribute('aria-expanded', !1),
										e.setAttribute(
											'aria-controls',
											e.nextElementSibling.id
										)
								})
							}
						},
						{
							key: 'onKeyUp',
							value: function (e) {
								if ('ESCAPE' === e.code.toUpperCase()) {
									var t = e.target.closest('details[open]')
									t &&
										(t === this.mainDetailsToggle
											? this.closeMenuDrawer(
													this.mainDetailsToggle.querySelector(
														'summary'
													)
											  )
											: this.closeSubmenu(t))
								}
							}
						},
						{
							key: 'onSummaryClick',
							value: function (e) {
								var t = e.currentTarget,
									n = t.parentNode,
									r = n.hasAttribute('open')
								n === this.mainDetailsToggle
									? (r && e.preventDefault(),
									  r
											? this.closeMenuDrawer(t)
											: this.openMenuDrawer(t))
									: (Jr(
											t.nextElementSibling,
											n.querySelector('button')
									  ),
									  setTimeout(function () {
											n.classList.add('menu-opening')
									  }))
							}
						},
						{
							key: 'openMenuDrawer',
							value: function (e) {
								var t = this
								setTimeout(function () {
									t.mainDetailsToggle.classList.add('menu-opening')
								}),
									e.setAttribute('aria-expanded', !0),
									Jr(this.mainDetailsToggle, e),
									document.body.classList.add(
										'overflow-hidden-'.concat(this.dataset.breakpoint)
									)
							}
						},
						{
							key: 'closeMenuDrawer',
							value: function (e) {
								var t =
									arguments.length > 1 &&
									void 0 !== arguments[1] &&
									arguments[1]
								void 0 !== e &&
									(this.mainDetailsToggle.classList.remove(
										'menu-opening'
									),
									this.mainDetailsToggle
										.querySelectorAll('details')
										.forEach(function (e) {
											e.removeAttribute('open'),
												e.classList.remove('menu-opening')
										}),
									this.mainDetailsToggle
										.querySelector('summary')
										.setAttribute('aria-expanded', !1),
									document.body.classList.remove(
										'overflow-hidden-'.concat(this.dataset.breakpoint)
									),
									Zr(t),
									this.closeAnimation(this.mainDetailsToggle))
							}
						},
						{
							key: 'onFocusOut',
							value: function (e) {
								var t = this
								setTimeout(function () {
									t.mainDetailsToggle.hasAttribute('open') &&
										!t.mainDetailsToggle.contains(
											document.activeElement
										) &&
										t.closeMenuDrawer()
								})
							}
						},
						{
							key: 'onCloseButtonClick',
							value: function (e) {
								var t = e.currentTarget.closest('details')
								this.closeSubmenu(t)
							}
						},
						{
							key: 'closeSubmenu',
							value: function (e) {
								e.classList.remove('menu-opening'),
									Zr(),
									this.closeAnimation(e)
							}
						},
						{
							key: 'closeAnimation',
							value: function (e) {
								var t
								window.requestAnimationFrame(function n(r) {
									void 0 === t && (t = r),
										r - t < 400
											? window.requestAnimationFrame(n)
											: (e.removeAttribute('open'),
											  e.closest('details[open]') &&
													Jr(
														e.closest('details[open]'),
														e.querySelector('summary')
													))
								})
							}
						}
					])
				)
			})(d(HTMLElement))
			customElements.define('menu-drawer', ti)
			var ni = (function (t) {
				function n() {
					return e(this, n), Yr(this, n)
				}
				return (
					u(n, t),
					o(n, [
						{
							key: 'openMenuDrawer',
							value: function (e) {
								var t = this
								;(this.header =
									this.header ||
									document.getElementById('shopify-section-header')),
									(this.borderOffset =
										this.borderOffset ||
										this.closest(
											'.header-wrapper'
										).classList.contains(
											'header-wrapper--border-bottom'
										)
											? 1
											: 0),
									document.documentElement.style.setProperty(
										'--header-bottom-position',
										''.concat(
											parseInt(
												this.header.getBoundingClientRect().bottom -
													this.borderOffset
											),
											'px'
										)
									),
									setTimeout(function () {
										t.mainDetailsToggle.classList.add('menu-opening')
									}),
									e.setAttribute('aria-expanded', !0),
									Jr(this.mainDetailsToggle, e),
									document.body.classList.add(
										'overflow-hidden-'.concat(this.dataset.breakpoint)
									)
							}
						}
					])
				)
			})(ti)
			customElements.define('header-drawer', ni)
			var ri = (function (t) {
				function n() {
					var t
					return (
						e(this, n),
						(t = Yr(this, n))
							.querySelector('[id^="ModalClose-"]')
							.addEventListener('click', t.hide.bind(t)),
						t.addEventListener('click', function (e) {
							'MODAL-DIALOG' === e.target.nodeName && t.hide()
						}),
						t.addEventListener('keyup', function () {
							'ESCAPE' === event.code.toUpperCase() && t.hide()
						}),
						t
					)
				}
				return (
					u(n, t),
					o(n, [
						{
							key: 'show',
							value: function (e) {
								var t
								;(this.openedBy = e),
									document.body.classList.add('overflow-hidden'),
									this.setAttribute('open', ''),
									null ===
										(t = this.querySelector('.template-popup')) ||
										void 0 === t ||
										t.loadContent(),
									Jr(this, this.querySelector('[role="dialog"]'))
							}
						},
						{
							key: 'hide',
							value: function () {
								document.body.classList.remove('overflow-hidden'),
									this.removeAttribute('open'),
									Zr(this.openedBy),
									window.pauseAllMedia()
							}
						}
					])
				)
			})(d(HTMLElement))
			customElements.define('modal-dialog', ri)
			var ii = (function (t) {
				function n() {
					var t
					e(this, n)
					var r = (t = Yr(this, n)).querySelector('button')
					return (
						null == r ||
							r.addEventListener('click', function () {
								var e
								null ===
									(e = document.querySelector(
										t.getAttribute('data-modal')
									)) ||
									void 0 === e ||
									e.show(r)
							}),
						t
					)
				}
				return u(n, t), o(n)
			})(d(HTMLElement))
			customElements.define('modal-opener', ii)
			var oi = (function (t) {
				function n() {
					var t, r
					return (
						e(this, n),
						null ===
							(t = (r = Yr(this, n)).querySelector(
								'[id^="Deferred-Poster-"]'
							)) ||
							void 0 === t ||
							t.addEventListener('click', r.loadContent.bind(r)),
						r
					)
				}
				return (
					u(n, t),
					o(n, [
						{
							key: 'loadContent',
							value: function () {
								if (!this.getAttribute('loaded')) {
									var e = document.createElement('div')
									e.appendChild(
										this.querySelector(
											'template'
										).content.firstElementChild.cloneNode(!0)
									),
										this.setAttribute('loaded', !0),
										window.pauseAllMedia(),
										this.appendChild(
											e.querySelector('video, model-viewer, iframe')
										).focus()
								}
							}
						}
					])
				)
			})(d(HTMLElement))
			customElements.define('deferred-media', oi)
			var si = (function (t) {
				function n() {
					var t
					return (
						e(this, n),
						(t = Yr(this, n)).addEventListener(
							'change',
							t.onVariantChange
						),
						t
					)
				}
				return (
					u(n, t),
					o(n, [
						{
							key: 'onVariantChange',
							value: function () {
								this.updateOptions(),
									this.updateMasterId(),
									this.toggleAddButton(!0, '', !1),
									this.updatePickupAvailability(),
									this.currentVariant
										? (this.updateMedia(),
										  this.updateURL(),
										  this.updateVariantInput(),
										  this.renderProductInfo())
										: (this.toggleAddButton(!0, '', !0),
										  this.setUnavailable())
							}
						},
						{
							key: 'updateOptions',
							value: function () {
								this.options = Array.from(
									this.querySelectorAll('select'),
									function (e) {
										return e.value
									}
								)
							}
						},
						{
							key: 'updateMasterId',
							value: function () {
								var e = this
								this.currentVariant = this.getVariantData().find(
									function (t) {
										return !t.options
											.map(function (t, n) {
												return e.options[n] === t
											})
											.includes(!1)
									}
								)
							}
						},
						{
							key: 'updateMedia',
							value: function () {
								var e
								if (
									this.currentVariant &&
									null !== (e = this.currentVariant) &&
									void 0 !== e &&
									e.featured_media
								) {
									var t = document.querySelector(
										'[data-media-id="'
											.concat(this.dataset.section, '-')
											.concat(
												this.currentVariant.featured_media.id,
												'"]'
											)
									)
									if (t) {
										var n = t.parentElement
										n.prepend(t),
											window.setTimeout(function () {
												n.scroll(0, 0)
											})
									}
								}
							}
						},
						{
							key: 'updateURL',
							value: function () {
								this.currentVariant &&
									window.history.replaceState(
										{},
										'',
										''
											.concat(this.dataset.url, '?variant=')
											.concat(this.currentVariant.id)
									)
							}
						},
						{
							key: 'updateVariantInput',
							value: function () {
								var e = this
								document
									.querySelectorAll(
										'#product-form-'.concat(
											this.dataset.section,
											', #product-form-installment'
										)
									)
									.forEach(function (t) {
										var n = t.querySelector('input[name="id"]')
										;(n.value = e.currentVariant.id),
											n.dispatchEvent(
												new Event('change', { bubbles: !0 })
											)
									})
							}
						},
						{
							key: 'updatePickupAvailability',
							value: function () {
								var e,
									t = document.querySelector('pickup-availability')
								t &&
									(null !== (e = this.currentVariant) &&
									void 0 !== e &&
									e.available
										? t.fetchAvailability(this.currentVariant.id)
										: (t.removeAttribute('available'),
										  (t.innerHTML = '')))
							}
						},
						{
							key: 'renderProductInfo',
							value: function () {
								var e = this
								fetch(
									''
										.concat(this.dataset.url, '?variant=')
										.concat(this.currentVariant.id, '&section_id=')
										.concat(this.dataset.section)
								)
									.then(function (e) {
										return e.text()
									})
									.then(function (t) {
										var n,
											r = 'price-'.concat(e.dataset.section),
											i = new DOMParser().parseFromString(
												t,
												'text/html'
											),
											o = document.getElementById(r),
											s = i.getElementById(r)
										s && o && (o.innerHTML = s.innerHTML),
											null ===
												(n = document.getElementById(
													'price-'.concat(e.dataset.section)
												)) ||
												void 0 === n ||
												n.classList.remove('visibility-hidden'),
											e.toggleAddButton(
												!e.currentVariant.available,
												window.theme.strings.product.variantSoldOut
											)
									})
							}
						},
						{
							key: 'toggleAddButton',
							value: function () {
								var e,
									t =
										!(
											arguments.length > 0 && void 0 !== arguments[0]
										) || arguments[0],
									n = arguments.length > 1 ? arguments[1] : void 0,
									r =
										null ===
											(e = document.getElementById(
												'product-form-'.concat(this.dataset.section)
											)) || void 0 === e
											? void 0
											: e.querySelector('[name="add"]')
								r &&
									(t
										? (r.setAttribute('disabled', !0),
										  n && (r.textContent = n))
										: (r.removeAttribute('disabled'),
										  (r.textContent =
												window.theme.strings.product.variantAddToCart)))
							}
						},
						{
							key: 'setUnavailable',
							value: function () {
								var e,
									t,
									n =
										null ===
											(e = document.getElementById(
												'product-form-'.concat(this.dataset.section)
											)) || void 0 === e
											? void 0
											: e.querySelector('[name="add"]')
								n &&
									((n.textContent =
										window.theme.strings.product.variantUnavailable),
									null ===
										(t = document.getElementById(
											'price-'.concat(this.dataset.section)
										)) ||
										void 0 === t ||
										t.classList.add('visibility-hidden'))
							}
						},
						{
							key: 'getVariantData',
							value: function () {
								return (
									(this.variantData =
										this.variantData ||
										JSON.parse(
											this.querySelector('[type="application/json"]')
												.textContent
										)),
									this.variantData
								)
							}
						}
					])
				)
			})(d(HTMLElement))
			customElements.define('variant-selects', si)
			var ai = (function (t) {
				function n() {
					return e(this, n), Yr(this, n)
				}
				return (
					u(n, t),
					o(n, [
						{
							key: 'updateOptions',
							value: function () {
								var e = Array.from(this.querySelectorAll('fieldset'))
								this.options = e.map(function (e) {
									return Array.from(e.querySelectorAll('input')).find(
										function (e) {
											return e.checked
										}
									).value
								})
							}
						}
					])
				)
			})(si)
			customElements.define('variant-radios', ai)
			var li = (function (t) {
				function n() {
					var t
					e(this, n), (t = Yr(this, n))
					var r = document.querySelector('.scrollToTopBtn'),
						i = document.documentElement
					return (
						r.addEventListener('click', function () {
							i.scrollTo({ top: 0, behavior: 'smooth' })
						}),
						document.addEventListener('scroll', function () {
							var e = i.scrollHeight - i.clientHeight
							i.scrollTop / e > 0.1
								? r.classList.add('showBtn')
								: r.classList.remove('showBtn')
						}),
						t
					)
				}
				return u(n, t), o(n)
			})(d(HTMLElement))
			customElements.define('scroll-to-top', li)
			var ui = (function (t) {
				function n() {
					var t
					e(this, n), (t = Yr(this, n))
					var r = document.querySelectorAll(
							'.location-tab-menu button'
						),
						i = document.querySelectorAll('.locations-list')
					function o(e) {
						var t =
							arguments.length > 1 &&
							void 0 !== arguments[1] &&
							arguments[1]
						null != e &&
							null != e &&
							($(
								".location-tab-menu button[data-label='" + e + "']"
							).attr({ 'aria-selected': 'true', tabindex: 0 }),
							$(
								".location-tab-menu button:not([data-label='" +
									e +
									"'])"
							).attr({ 'aria-selected': 'false', tabindex: -1 }),
							t &&
								$(
									".location-tab-menu button[data-label='" + e + "']"
								).focus(),
							i.forEach(function (t) {
								var n = t.getAttribute('data-toggle')
								e === n
									? t.classList.remove('hide')
									: t.classList.add('hide')
							}))
					}
					return (
						null != r &&
							null != r &&
							r.forEach(function (e, t) {
								var n = e.getAttribute('data-label')
								0 == t && o(n),
									e.addEventListener('click', function (e) {
										o(n)
									}),
									e.addEventListener('keydown', function (e) {
										var t = document.querySelector(
												'.tab[aria-selected="true"]'
											),
											n = Array.prototype.slice.call(r).indexOf(t)
										'ArrowRight' == e.key
											? n < r.length - 1
												? o(r[n + 1].getAttribute('data-label'), !0)
												: o(r[0].getAttribute('data-label'), !0)
											: 'ArrowLeft' == e.key &&
											  o(
													n > 0
														? r[n - 1].getAttribute('data-label')
														: r[r.length - 1].getAttribute(
																'data-label'
														  ),
													!0
											  )
									})
							}),
						t
					)
				}
				return u(n, t), o(n)
			})(d(HTMLElement))
			customElements.define('location-tab-menu', ui)
			var ci = (function (t) {
				function n() {
					var t
					e(this, n), (t = Yr(this, n))
					var r = document.querySelectorAll(
							'.subscription-categories-menu button'
						),
						i = document.querySelectorAll(
							'.subscription-categories-list'
						),
						o = new URLSearchParams(window.location.search).get(
							'category'
						)
					function s(e) {
						var t =
							arguments.length > 1 &&
							void 0 !== arguments[1] &&
							arguments[1]
						if (
							null != e &&
							null != e &&
							($(
								".subscription-categories-menu button[data-label='" +
									e +
									"']"
							).attr({ 'aria-selected': 'true', tabindex: 0 }),
							$(
								".subscription-categories-menu button:not([data-label='" +
									e +
									"'])"
							).attr({ 'aria-selected': 'false', tabindex: -1 }),
							t &&
								$(
									".subscription-categories-menu button[data-label='" +
										e +
										"']"
								).focus(),
							i.forEach(function (t) {
								var n = t.getAttribute('data-toggle')
								e === n
									? t.classList.remove('hide')
									: t.classList.add('hide')
							}),
							'/' !== window.location.pathname)
						) {
							var n = ''
								.concat(window.location.protocol, '//')
								.concat(window.location.host)
								.concat(window.location.pathname, '?category=')
								.concat(e)
							window.history.replaceState({ path: n }, '', n)
						}
					}
					return (
						null != r &&
							null != r &&
							(null !== o &&
								setTimeout(function () {
									s(o)
								}, 300),
							r.forEach(function (e, t) {
								var n = e.getAttribute('data-label')
								0 == t && s(n),
									e.addEventListener('click', function (e) {
										s(n)
									}),
									e.addEventListener('keydown', function (e) {
										var t = document.querySelector(
												'.tab[aria-selected="true"]'
											),
											n = Array.prototype.slice.call(r).indexOf(t)
										'ArrowRight' == e.key
											? n < r.length - 1
												? s(r[n + 1].getAttribute('data-label'), !0)
												: s(r[0].getAttribute('data-label'), !0)
											: 'ArrowLeft' == e.key &&
											  s(
													n > 0
														? r[n - 1].getAttribute('data-label')
														: r[r.length - 1].getAttribute(
																'data-label'
														  ),
													!0
											  )
									})
							})),
						t
					)
				}
				return u(n, t), o(n)
			})(d(HTMLElement))
			customElements.define('subscription-categories-menu', ci)
			var di = (function (t) {
				function n() {
					var t
					e(this, n)
					var r = (t = Yr(this, n)).querySelector(
						'.accordion__header button'
					)
					return (
						r.addEventListener('click', function () {
							var e = 'true' == r.getAttribute('aria-expanded')
							r.setAttribute('aria-expanded', !e),
								$('#' + r.getAttribute('aria-controls')).slideToggle()
						}),
						t
					)
				}
				return u(n, t), o(n)
			})(d(HTMLElement))
			customElements.define('accordion-item', di)
		})()
})()

class PredictiveSearch extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input[type="search"]')
		this.cachedResults = {}
		this.predictiveSearchResults = document.querySelector(
			'[data-predictive-search]'
		)
		this.allPredictiveSearchInstances = document.querySelectorAll(
			'predictive-search'
		)
		this.isOpen = false
		this.abortController = new AbortController()
		this.searchTerm = ''

		this.setupEventListeners()
	}

	setupEventListeners() {
		this.input.form.addEventListener(
			'submit',
			this.onFormSubmit.bind(this)
		)
		this.input.addEventListener(
			'input',
			debounce(event => {
				this.onChange(event)
			}, 300).bind(this)
		)

		this.input.addEventListener('focus', this.onFocus.bind(this))
		//this.addEventListener('focusout', this.onFocusOut.bind(this));
		this.addEventListener('keyup', this.onKeyup.bind(this))
		this.addEventListener('keydown', this.onKeydown.bind(this))
		document.addEventListener('click', e => {
			if (
				!this.contains(e.target) &&
				!this.predictiveSearchResults.contains(e.target)
			)
				this.close()
		})
	}

	getQuery() {
		return this.input.value.trim()
	}

	onChange() {
		const newSearchTerm = this.getQuery()
		if (
			!this.searchTerm ||
			!newSearchTerm.startsWith(this.searchTerm)
		) {
			// Remove the results when they are no longer relevant for the new search term
			// so they don't show up when the dropdown opens again
			this.querySelector(
				'#predictive-search-results-groups-wrapper'
			)?.remove()
		}

		// Update the term asap, don't wait for the predictive search query to finish loading
		this.updateSearchForTerm(this.searchTerm, newSearchTerm)

		this.searchTerm = newSearchTerm

		if (!this.searchTerm.length) {
			this.close(true)
			return
		}

		this.getSearchResults(this.searchTerm)
	}

	onFormSubmit(event) {
		if (
			!this.getQuery().length ||
			this.querySelector('[aria-selected="true"] a')
		)
			event.preventDefault()
	}

	onFormReset(event) {
		super.onFormReset(event)
		if (super.shouldResetForm()) {
			this.searchTerm = ''
			this.abortController.abort()
			this.abortController = new AbortController()
			this.closeResults(true)
		}
	}

	onFocus() {
		const currentSearchTerm = this.getQuery()

		if (!currentSearchTerm.length) return

		if (this.searchTerm !== currentSearchTerm) {
			// Search term was changed from other search input, treat it as a user change
			this.onChange()
		} else if (this.getAttribute('results') === 'true') {
			this.open()
		} else {
			this.getSearchResults(this.searchTerm)
		}
	}

	onFocusOut() {
		setTimeout(() => {
			if (
				this.predictiveSearchResults.contains(document.activeElement)
			)
				return
			if (!this.contains(document.activeElement)) {
				this.close()
			}
		})
	}

	onKeyup(event) {
		if (!this.getQuery().length) this.close(true)
		event.preventDefault()

		switch (event.code) {
			case 'ArrowUp':
				this.switchOption('up')
				break
			case 'ArrowDown':
				this.switchOption('down')
				break
			case 'Enter':
				this.selectOption()
				break
		}
	}

	onKeydown(event) {
		// Prevent the cursor from moving in the input when using the up and down arrow keys
		if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
			event.preventDefault()
		}
	}

	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement = this.querySelector(
			'[data-predictive-search-search-for-text]'
		)
		const currentButtonText = searchForTextElement?.innerText
		if (currentButtonText) {
			if (
				currentButtonText.match(new RegExp(previousTerm, 'g'))
					.length > 1
			) {
				// The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
				return
			}
			const newButtonText = currentButtonText.replace(
				previousTerm,
				newTerm
			)
			searchForTextElement.innerText = newButtonText
		}
	}

	switchOption(direction) {
		if (!this.getAttribute('open')) return

		const moveUp = direction === 'up'
		const selectedElement = this.querySelector(
			'[aria-selected="true"]'
		)

		// Filter out hidden elements (duplicated page and article resources) thanks
		// to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
		const allVisibleElements = Array.from(
			this.querySelectorAll('li, button.predictive-search__item')
		).filter(element => element.offsetParent !== null)
		let activeElementIndex = 0

		if (moveUp && !selectedElement) return

		let selectedElementIndex = -1
		let i = 0

		while (
			selectedElementIndex === -1 &&
			i <= allVisibleElements.length
		) {
			if (allVisibleElements[i] === selectedElement) {
				selectedElementIndex = i
			}
			i++
		}

		this.statusElement.textContent = ''

		if (!moveUp && selectedElement) {
			activeElementIndex =
				selectedElementIndex === allVisibleElements.length - 1
					? 0
					: selectedElementIndex + 1
		} else if (moveUp) {
			activeElementIndex =
				selectedElementIndex === 0
					? allVisibleElements.length - 1
					: selectedElementIndex - 1
		}

		if (activeElementIndex === selectedElementIndex) return

		const activeElement = allVisibleElements[activeElementIndex]

		activeElement.setAttribute('aria-selected', true)
		if (selectedElement)
			selectedElement.setAttribute('aria-selected', false)

		this.input.setAttribute('aria-activedescendant', activeElement.id)
	}

	selectOption() {
		const selectedOption = this.querySelector(
			'[aria-selected="true"] a, button[aria-selected="true"]'
		)

		if (selectedOption) selectedOption.click()
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(' ', '-').toLowerCase()
		// this.setLiveRegionLoadingState();

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey])
			return
		}

		fetch(
			`${routes.predictive_search_url}?q=${encodeURIComponent(
				searchTerm
			)}&section_id=predictive-search`,
			{
				signal: this.abortController.signal
			}
		)
			.then(response => {
				if (!response.ok) {
					var error = new Error(response.status)
					this.close()
					throw error
				}

				return response.text()
			})
			.then(text => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector(
						'#shopify-section-predictive-search'
					).innerHTML
				// Save bandwidth keeping the cache in all instances synced
				this.allPredictiveSearchInstances.forEach(
					predictiveSearchInstance => {
						predictiveSearchInstance.cachedResults[queryKey] =
							resultsMarkup
					}
				)
				this.renderSearchResults(resultsMarkup)
			})
			.catch(error => {
				if (error?.code === 20) {
					// Code 20 means the call was aborted
					return
				}
				this.close()
				throw error
			})
	}

	setLiveRegionLoadingState() {
		this.statusElement =
			this.statusElement ||
			this.querySelector('.predictive-search-status')
		this.loadingText =
			this.loadingText || this.getAttribute('data-loading-text')

		this.setLiveRegionText(this.loadingText)
		this.setAttribute('loading', true)
	}

	setLiveRegionText(statusText) {
		this.statusElement.setAttribute('aria-hidden', 'false')
		this.statusElement.textContent = statusText

		setTimeout(() => {
			this.statusElement.setAttribute('aria-hidden', 'true')
		}, 1000)
	}

	renderSearchResults(resultsMarkup) {
		this.predictiveSearchResults.innerHTML = resultsMarkup
		this.setAttribute('results', true)

		//this.setLiveRegionResults();
		this.open()
	}

	setLiveRegionResults() {
		this.removeAttribute('loading')
		this.setLiveRegionText(
			this.querySelector(
				'[data-predictive-search-live-region-count-value]'
			).textContent
		)
	}

	getResultsMaxHeight() {
		this.resultsMaxHeight =
			window.innerHeight -
			document
				.querySelector('site-header .header')
				.getBoundingClientRect().bottom
		return this.resultsMaxHeight
	}

	open() {
		//this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
		this.setAttribute('open', true)
		this.predictiveSearchResults.setAttribute('open', true)
		this.input.setAttribute('aria-expanded', true)
		this.isOpen = true
	}

	close(clearSearchTerm = false) {
		this.closeResults(clearSearchTerm)
		this.isOpen = false
	}

	closeResults(clearSearchTerm = false) {
		if (clearSearchTerm) {
			this.input.value = ''
			this.removeAttribute('results')
		}
		const selected = this.querySelector('[aria-selected="true"]')

		if (selected) selected.setAttribute('aria-selected', false)

		this.input.setAttribute('aria-activedescendant', '')
		this.removeAttribute('loading')
		this.removeAttribute('open')
		this.input.setAttribute('aria-expanded', false)
		this.resultsMaxHeight = false
		this.predictiveSearchResults.removeAttribute('style')
		this.predictiveSearchResults.removeAttribute('open')
	}
}

customElements.define('predictive-search', PredictiveSearch)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

// FACETS START

class FacetFiltersForm extends HTMLElement {
	constructor() {
		super()
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

		this.debouncedOnSubmit = debounce(event => {
			this.onSubmitHandler(event)
		}, 800)

		const facetForm = this.querySelector('form')
		facetForm.addEventListener(
			'input',
			this.debouncedOnSubmit.bind(this)
		)
		this.trigger = this.querySelector('[facet-drawer-trigger]')
		this.trigger.addEventListener(
			'click',
			this.toggleFacet.bind(this)
		)

		const facetWraper = this.querySelector('#FacetsWrapperDesktop')
		document.addEventListener('click', evt => {
			if (
				(!facetWraper.contains(evt.target) &&
					!this.trigger.contains(evt.target)) ||
				evt.target.classList.contains('facets-overlay') ||
				evt.target.classList.contains('factet_action')
			) {
				this.closeFacet()
			}
		})
	}

	static setListeners() {
		const onHistoryChange = event => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial
			if (searchParams === FacetFiltersForm.searchParamsPrev) return
			FacetFiltersForm.renderPage(searchParams, null, false)
		}
		window.addEventListener('popstate', onHistoryChange)
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach(element => {
			element.classList.toggle('disabled', disable)
		})
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams
		const sections = FacetFiltersForm.getSections()
		const countContainer = document.getElementById('ProductCount')
		const countContainerDesktop = document.getElementById(
			'ProductCountDesktop'
		)
		const loadingSpinners = document.querySelectorAll(
			'.facets-container .loading__spinner, facet-filters-form .loading__spinner'
		)
		loadingSpinners.forEach(spinner =>
			spinner.classList.remove('hidden')
		)
		document
			.getElementById('ProductGridContainer')
			.querySelector('.collection')
			.classList.add('loading')
		if (countContainer) {
			countContainer.classList.add('loading')
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add('loading')
		}

		sections.forEach(section => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
			const filterDataUrl = element => element.url === url

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(
						filterDataUrl,
						event
				  )
				: FacetFiltersForm.renderSectionFromFetch(url, event)
		})

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then(response => response.text())
			.then(responseText => {
				const html = responseText
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url }
				]
				FacetFiltersForm.renderFilters(html, event)
				FacetFiltersForm.renderProductGridContainer(html)
				FacetFiltersForm.renderProductCount(html)
				if (typeof initializeScrollAnimationTrigger === 'function')
					initializeScrollAnimationTrigger(html.innerHTML)
			})
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html
		FacetFiltersForm.renderFilters(html, event)
		FacetFiltersForm.renderProductGridContainer(html)
		FacetFiltersForm.renderProductCount(html)
		if (typeof initializeScrollAnimationTrigger === 'function')
			initializeScrollAnimationTrigger(html.innerHTML)
	}

	static renderProductGridContainer(html) {
		document.getElementById('ProductGridContainer').innerHTML =
			new DOMParser()
				.parseFromString(html, 'text/html')
				.getElementById('ProductGridContainer').innerHTML

		document
			.getElementById('ProductGridContainer')
			.querySelectorAll('.scroll-trigger')
			.forEach(element => {
				element.classList.add('scroll-trigger--cancel')
			})
	}

	static renderProductCount(html) {
		const count = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('ProductCount').innerHTML
		const container = document.getElementById('ProductCount')
		const containerDesktop = document.getElementById(
			'ProductCountDesktop'
		)
		container.innerHTML = count
		container.classList.remove('loading')
		if (containerDesktop) {
			containerDesktop.innerHTML = count
			containerDesktop.classList.remove('loading')
		}
		const loadingSpinners = document.querySelectorAll(
			'.facets-container .loading__spinner, facet-filters-form .loading__spinner'
		)
		loadingSpinners.forEach(spinner =>
			spinner.classList.add('hidden')
		)
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(
			html,
			'text/html'
		)
		const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
			'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
		)
		const facetDetailsElementsFromDom = document.querySelectorAll(
			'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
		)

		// Remove facets that are no longer returned from the server
		Array.from(facetDetailsElementsFromDom).forEach(
			currentElement => {
				if (
					!Array.from(facetDetailsElementsFromFetch).some(
						({ id }) => currentElement.id === id
					)
				) {
					currentElement.remove()
				}
			}
		)

		const matchesId = element => {
			const jsFilter = event
				? event.target.closest('.js-filter')
				: undefined
			return jsFilter ? element.id === jsFilter.id : false
		}

		const facetsToRender = Array.from(
			facetDetailsElementsFromFetch
		).filter(element => !matchesId(element))
		const countsToRender = Array.from(
			facetDetailsElementsFromFetch
		).find(matchesId)

		facetsToRender.forEach((elementToRender, index) => {
			const currentElement = document.getElementById(
				elementToRender.id
			)
			// Element already rendered in the DOM so just update the innerHTML
			if (currentElement) {
				document.getElementById(elementToRender.id).innerHTML =
					elementToRender.innerHTML
			} else {
				if (index > 0) {
					const {
						className: previousElementClassName,
						id: previousElementId
					} = facetsToRender[index - 1]
					// Same facet type (eg horizontal/vertical or drawer/mobile)
					if (
						elementToRender.className === previousElementClassName
					) {
						document
							.getElementById(previousElementId)
							.after(elementToRender)
						return
					}
				}

				if (elementToRender.parentElement) {
					document
						.querySelector(
							`#${elementToRender.parentElement.id} .js-filter`
						)
						.before(elementToRender)
				}
			}
		})

		FacetFiltersForm.renderActiveFacets(parsedHTML)
		FacetFiltersForm.renderAdditionalElements(parsedHTML)

		if (countsToRender) {
			const closestJSFilterID = event.target.closest('.js-filter').id

			if (closestJSFilterID) {
				FacetFiltersForm.renderCounts(
					countsToRender,
					event.target.closest('.js-filter')
				)
				FacetFiltersForm.renderMobileCounts(
					countsToRender,
					document.getElementById(closestJSFilterID)
				)

				const newFacetDetailsElement =
					document.getElementById(closestJSFilterID)
				const newElementSelector =
					newFacetDetailsElement.classList.contains(
						'mobile-facets__details'
					)
						? `.mobile-facets__close-button`
						: `.facets__summary`
				const newElementToActivate =
					newFacetDetailsElement.querySelector(newElementSelector)

				const isTextInput =
					event.target.getAttribute('type') === 'text'

				if (newElementToActivate && !isTextInput)
					newElementToActivate.focus()
			}
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			'.active-facets-mobile',
			'.active-facets-desktop'
		]

		activeFacetElementSelectors.forEach(selector => {
			const activeFacetsElement = html.querySelector(selector)
			if (!activeFacetsElement) return
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML
		})

		FacetFiltersForm.toggleActiveFacets(false)
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			'.mobile-facets__open',
			'.mobile-facets__count',
			'.sorting'
		]

		mobileElementSelectors.forEach(selector => {
			if (!html.querySelector(selector)) return
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML
		})

		//document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
	}

	static renderCounts(source, target) {
		const targetSummary = target.querySelector('.facets__summary')
		const sourceSummary = source.querySelector('.facets__summary')

		if (sourceSummary && targetSummary) {
			targetSummary.outerHTML = sourceSummary.outerHTML
		}

		const targetHeaderElement =
			target.querySelector('.facets__header')
		const sourceHeaderElement =
			source.querySelector('.facets__header')

		if (sourceHeaderElement && targetHeaderElement) {
			targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML
		}

		const targetWrapElement = target.querySelector('.facets-wrap')
		const sourceWrapElement = source.querySelector('.facets-wrap')

		if (sourceWrapElement && targetWrapElement) {
			const isShowingMore = Boolean(
				target.querySelector(
					'show-more-button .label-show-more.hidden'
				)
			)
			if (isShowingMore) {
				sourceWrapElement
					.querySelectorAll('.facets__item.hidden')
					.forEach(hiddenItem =>
						hiddenItem.classList.replace('hidden', 'show-more-item')
					)
			}

			targetWrapElement.outerHTML = sourceWrapElement.outerHTML
		}
	}

	static renderMobileCounts(source, target) {
		const targetFacetsList = target.querySelector(
			'.mobile-facets__list'
		)
		const sourceFacetsList = source.querySelector(
			'.mobile-facets__list'
		)

		if (sourceFacetsList && targetFacetsList) {
			targetFacetsList.outerHTML = sourceFacetsList.outerHTML
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			'',
			`${window.location.pathname}${
				searchParams && '?'.concat(searchParams)
			}`
		)
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id
			}
		]
	}

	createSearchParams(form) {
		const formData = new FormData(form)
		return new URLSearchParams(formData).toString()
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event)
	}

	toggleFacet() {
		if (window.innerWidth >= 768) {
			document.body.classList.toggle('fixed')
		}
		this.classList.toggle('facets-opened')
	}
	closeFacet() {
		if (window.innerWidth >= 768) {
			document.body.classList.remove('fixed')
		}
		this.classList.remove('facets-opened')
	}

	onSubmitHandler(event) {
		event.preventDefault()
		const sortFilterForms = document.querySelectorAll(
			'facet-filters-form form'
		)
		if (event.srcElement.className == 'mobile-facets__checkbox') {
			const searchParams = this.createSearchParams(
				event.target.closest('form')
			)
			this.onSubmitForm(searchParams, event)
		} else {
			const forms = []
			const isMobile =
				event.target.closest('form').id === 'FacetFiltersFormMobile'

			sortFilterForms.forEach(form => {
				if (!isMobile) {
					if (
						form.id === 'FacetSortForm' ||
						form.id === 'FacetFiltersForm' ||
						form.id === 'FacetSortDrawerForm'
					) {
						forms.push(this.createSearchParams(form))
					}
				} else if (form.id === 'FacetFiltersFormMobile') {
					forms.push(this.createSearchParams(form))
				}
			})
			this.onSubmitForm(forms.join('&'), event)
		}
	}

	onActiveFilterClick(event) {
		event.preventDefault()
		FacetFiltersForm.toggleActiveFacets()
		const url =
			event.currentTarget.href.indexOf('?') == -1
				? ''
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf('?') + 1
				  )
		FacetFiltersForm.renderPage(url)
	}
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
	constructor() {
		super()
		this.querySelectorAll('input').forEach(element => {
			element.addEventListener(
				'change',
				this.onRangeChange.bind(this)
			)
			element.addEventListener('keydown', this.onKeyDown.bind(this))
		})
		this.setMinAndMaxValues()
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget)
		this.setMinAndMaxValues()
	}

	onKeyDown(event) {
		if (event.metaKey) return

		const pattern =
			/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/
		if (!event.key.match(pattern)) event.preventDefault()
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input')
		const minInput = inputs[0]
		const maxInput = inputs[1]
		if (maxInput.value)
			minInput.setAttribute('data-max', maxInput.value)
		if (minInput.value)
			maxInput.setAttribute('data-min', minInput.value)
		if (minInput.value === '') maxInput.setAttribute('data-min', 0)
		if (maxInput.value === '')
			minInput.setAttribute(
				'data-max',
				maxInput.getAttribute('data-max')
			)
	}

	adjustToValidValues(input) {
		const value = Number(input.value)
		const min = Number(input.getAttribute('data-min'))
		const max = Number(input.getAttribute('data-max'))

		if (value < min) input.value = min
		if (value > max) input.value = max
	}
}

customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
	constructor() {
		super()
		const facetLink = this.querySelector('a')
		facetLink.setAttribute('role', 'button')
		facetLink.addEventListener('click', this.closeFilter.bind(this))
		facetLink.addEventListener('keyup', event => {
			event.preventDefault()
			if (event.code.toUpperCase() === 'SPACE')
				this.closeFilter(event)
		})
	}

	closeFilter(event) {
		event.preventDefault()
		const form =
			this.closest('facet-filters-form') ||
			document.querySelector('facet-filters-form')
		form.onActiveFilterClick(event)
	}
}

customElements.define('facet-remove', FacetRemove)
